/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.1.3.0 (NJsonSchema v10.0.27.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { ClientBase } from "NSwag/ClientBase";

export class LoginClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    post(request: LoginRequest): Promise<LoginResponse> {
        let url_ = this.baseUrl + "/api/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<LoginResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoginResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoginResponse>(<any>null);
    }
}

export class CctvClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Endpoint to update a OpStatus for a Camera.
     * @param id The id of the specific Camera to update.
     * @return Response for the ChangeCameraStateReq request. Class that represents a changeCameraStateResp.
     */
    patchCameraOpStatus(changeCameraStateReq: ChangeCameraStateReq, id: number): Promise<ChangeCameraStateResp | null> {
        let url_ = this.baseUrl + "/api/Cctv/Camera/{id}/OpStatus";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(changeCameraStateReq);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPatchCameraOpStatus(_response);
        });
    }

    protected processPatchCameraOpStatus(response: Response): Promise<ChangeCameraStateResp | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ChangeCameraStateResp.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ChangeCameraStateResp.fromJS(resultData401) : <any>null;
            return throwException("Response for the ChangeCameraStateReq request. Class that represents a changeCameraStateResp.", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? ChangeCameraStateResp.fromJS(resultData500) : <any>null;
            return throwException("Response for the ChangeCameraStateReq request. Class that represents a changeCameraStateResp.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChangeCameraStateResp | null>(<any>null);
    }

    /**
     * Endpoint to update a FocusPositioning for a Camera.
     * @param id The id of the specific Camera to update.
     * @return Response for the FocusLensReq request. Class that represents a focusLensResp.
     */
    patchCameraFocusPositioning(focusLensReq: FocusLensReq, id: number): Promise<FocusLensResp | null> {
        let url_ = this.baseUrl + "/api/Cctv/Camera/{id}/FocusPositioning";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(focusLensReq);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPatchCameraFocusPositioning(_response);
        });
    }

    protected processPatchCameraFocusPositioning(response: Response): Promise<FocusLensResp | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FocusLensResp.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? FocusLensResp.fromJS(resultData401) : <any>null;
            return throwException("Response for the FocusLensReq request. Class that represents a focusLensResp.", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? FocusLensResp.fromJS(resultData500) : <any>null;
            return throwException("Response for the FocusLensReq request. Class that represents a focusLensResp.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FocusLensResp | null>(<any>null);
    }

    /**
     * Endpoint to update a IrisPositioning for a Camera.
     * @param id The id of the specific Camera to update.
     * @return Response for the IrisLensReq request. Class that represents an irisLensResp.
     */
    patchCameraIrisPositioning(irisLensReq: IrisLensReq, id: number): Promise<IrisLensResp | null> {
        let url_ = this.baseUrl + "/api/Cctv/Camera/{id}/IrisPositioning";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(irisLensReq);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPatchCameraIrisPositioning(_response);
        });
    }

    protected processPatchCameraIrisPositioning(response: Response): Promise<IrisLensResp | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? IrisLensResp.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? IrisLensResp.fromJS(resultData401) : <any>null;
            return throwException("Response for the IrisLensReq request. Class that represents an irisLensResp.", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? IrisLensResp.fromJS(resultData500) : <any>null;
            return throwException("Response for the IrisLensReq request. Class that represents an irisLensResp.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IrisLensResp | null>(<any>null);
    }

    /**
     * Endpoint to update a Preset for a Camera.
     * @param id The id of the specific Camera to update.
     * @return Response for the MoveToPresetPositionReq request. Class that represents a moveToPresetPositionResp.
     */
    patchCameraPreset(moveToPresetPositionReq: MoveToPresetPositionReq, id: number): Promise<MoveToPresetPositionResp | null> {
        let url_ = this.baseUrl + "/api/Cctv/Camera/{id}/Preset";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(moveToPresetPositionReq);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPatchCameraPreset(_response);
        });
    }

    protected processPatchCameraPreset(response: Response): Promise<MoveToPresetPositionResp | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MoveToPresetPositionResp.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? MoveToPresetPositionResp.fromJS(resultData401) : <any>null;
            return throwException("Response for the MoveToPresetPositionReq request. Class that represents a moveToPresetPositionResp.", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? MoveToPresetPositionResp.fromJS(resultData500) : <any>null;
            return throwException("Response for the MoveToPresetPositionReq request. Class that represents a moveToPresetPositionResp.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MoveToPresetPositionResp | null>(<any>null);
    }

    /**
     * Endpoint to update a Positioning for a Camera.
     * @param id The id of the specific Camera to update.
     * @return Response for the PanReq request. Class that represents a panResp.
     */
    patchCameraPan(panReq: PanReq, id: number): Promise<PanResp | null> {
        let url_ = this.baseUrl + "/api/Cctv/Camera/{id}/Pan";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(panReq);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPatchCameraPan(_response);
        });
    }

    protected processPatchCameraPan(response: Response): Promise<PanResp | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PanResp.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? PanResp.fromJS(resultData401) : <any>null;
            return throwException("Response for the PanReq request. Class that represents a panResp.", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? PanResp.fromJS(resultData500) : <any>null;
            return throwException("Response for the PanReq request. Class that represents a panResp.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PanResp | null>(<any>null);
    }

    /**
     * Endpoint to update a Positioning for a Camera.
     * @param id The id of the specific Camera to update.
     * @return Response for the TiltReq request. Class that represents a tiltResp.
     */
    patchCameraTilt(tiltReq: TiltReq, id: number): Promise<TiltResp | null> {
        let url_ = this.baseUrl + "/api/Cctv/Camera/{id}/Tilt";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tiltReq);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPatchCameraTilt(_response);
        });
    }

    protected processPatchCameraTilt(response: Response): Promise<TiltResp | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TiltResp.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? TiltResp.fromJS(resultData401) : <any>null;
            return throwException("Response for the TiltReq request. Class that represents a tiltResp.", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? TiltResp.fromJS(resultData500) : <any>null;
            return throwException("Response for the TiltReq request. Class that represents a tiltResp.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TiltResp | null>(<any>null);
    }

    /**
     * Endpoint to update a ZoomPositioning for a Camera.
     * @param id The id of the specific Camera to update.
     * @return Response for the ZoomLensReq request. Class that represents a zoomLensResp.
     */
    patchCameraZoomPositioning(zoomLensReq: ZoomLensReq, id: number): Promise<ZoomLensResp | null> {
        let url_ = this.baseUrl + "/api/Cctv/Camera/{id}/ZoomPositioning";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(zoomLensReq);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPatchCameraZoomPositioning(_response);
        });
    }

    protected processPatchCameraZoomPositioning(response: Response): Promise<ZoomLensResp | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ZoomLensResp.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ZoomLensResp.fromJS(resultData401) : <any>null;
            return throwException("Response for the ZoomLensReq request. Class that represents a zoomLensResp.", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? ZoomLensResp.fromJS(resultData500) : <any>null;
            return throwException("Response for the ZoomLensReq request. Class that represents a zoomLensResp.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ZoomLensResp | null>(<any>null);
    }

    /**
     * Retrieves Camera object(s) from the Cctv subsystem.
     * @param id (optional) The id of the specific Camera to retrieve.
     * @return Response for a retrieve request for Camera.
     */
    getCamera(id: number | null | undefined): Promise<RetrieveDataResponseOfStringAndCamera | null> {
        let url_ = this.baseUrl + "/api/Cctv/Camera/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCamera(_response);
        });
    }

    protected processGetCamera(response: Response): Promise<RetrieveDataResponseOfStringAndCamera | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RetrieveDataResponseOfStringAndCamera.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? RetrieveDataResponseOfStringAndCamera.fromJS(resultData401) : <any>null;
            return throwException("Response for a retrieve request for Camera. ", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? RetrieveDataResponseOfStringAndCamera.fromJS(resultData500) : <any>null;
            return throwException("Response for a retrieve request for Camera. ", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RetrieveDataResponseOfStringAndCamera | null>(<any>null);
    }

    /**
     * Retrieves CameraPresets object(s) from the Cctv subsystem.
     * @param id (optional) The id of the specific CameraPresets to retrieve.
     * @return Response for a retrieve request for CameraPresets.
     */
    getCameraPresets(id: number | null | undefined): Promise<RetrieveDataResponseOfStringAndCameraPresets | null> {
        let url_ = this.baseUrl + "/api/Cctv/CameraPresets/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCameraPresets(_response);
        });
    }

    protected processGetCameraPresets(response: Response): Promise<RetrieveDataResponseOfStringAndCameraPresets | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RetrieveDataResponseOfStringAndCameraPresets.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? RetrieveDataResponseOfStringAndCameraPresets.fromJS(resultData401) : <any>null;
            return throwException("Response for a retrieve request for CameraPresets. ", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? RetrieveDataResponseOfStringAndCameraPresets.fromJS(resultData500) : <any>null;
            return throwException("Response for a retrieve request for CameraPresets. ", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RetrieveDataResponseOfStringAndCameraPresets | null>(<any>null);
    }
}

export class DmsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Endpoint to update a OpStatus for a Dms.
     * @param id The id of the specific Dms to update.
     * @return Response for the SetOpStatusReq request.
     */
    patchDmsOpStatus(setOpStatusReq: SetOpStatusReq, id: number): Promise<SetOpStatusResp | null> {
        let url_ = this.baseUrl + "/api/Dms/Dms/{id}/OpStatus";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(setOpStatusReq);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPatchDmsOpStatus(_response);
        });
    }

    protected processPatchDmsOpStatus(response: Response): Promise<SetOpStatusResp | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SetOpStatusResp.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? SetOpStatusResp.fromJS(resultData401) : <any>null;
            return throwException("Response for the SetOpStatusReq request. ", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? SetOpStatusResp.fromJS(resultData500) : <any>null;
            return throwException("Response for the SetOpStatusReq request. ", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SetOpStatusResp | null>(<any>null);
    }

    /**
     * Retrieves Dms object(s) from the Dms subsystem.
     * @param id (optional) The id of the specific Dms to retrieve.
     * @return Response for a retrieve request for Dms.
     */
    getDms(id: number | null | undefined): Promise<RetrieveDataResponseOfStringAndDms | null> {
        let url_ = this.baseUrl + "/api/Dms/Dms/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDms(_response);
        });
    }

    protected processGetDms(response: Response): Promise<RetrieveDataResponseOfStringAndDms | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RetrieveDataResponseOfStringAndDms.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? RetrieveDataResponseOfStringAndDms.fromJS(resultData401) : <any>null;
            return throwException("Response for a retrieve request for Dms. ", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? RetrieveDataResponseOfStringAndDms.fromJS(resultData500) : <any>null;
            return throwException("Response for a retrieve request for Dms. ", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RetrieveDataResponseOfStringAndDms | null>(<any>null);
    }

    /**
     * Retrieves Font object(s) from the Dms subsystem.
     * @param id (optional) The id of the specific Font to retrieve.
     * @return Response for a retrieve request for Font.
     */
    getFont(id: number | null | undefined): Promise<RetrieveDataResponseOfStringAndFont | null> {
        let url_ = this.baseUrl + "/api/Dms/Font/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFont(_response);
        });
    }

    protected processGetFont(response: Response): Promise<RetrieveDataResponseOfStringAndFont | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RetrieveDataResponseOfStringAndFont.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? RetrieveDataResponseOfStringAndFont.fromJS(resultData401) : <any>null;
            return throwException("Response for a retrieve request for Font. ", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? RetrieveDataResponseOfStringAndFont.fromJS(resultData500) : <any>null;
            return throwException("Response for a retrieve request for Font. ", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RetrieveDataResponseOfStringAndFont | null>(<any>null);
    }

    /**
     * Retrieves Graphic object(s) from the Dms subsystem.
     * @param id (optional) The id of the specific Graphic to retrieve.
     * @return Response for a retrieve request for Graphic.
     */
    getGraphic(id: number | null | undefined): Promise<RetrieveDataResponseOfStringAndGraphic | null> {
        let url_ = this.baseUrl + "/api/Dms/Graphic/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGraphic(_response);
        });
    }

    protected processGetGraphic(response: Response): Promise<RetrieveDataResponseOfStringAndGraphic | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RetrieveDataResponseOfStringAndGraphic.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? RetrieveDataResponseOfStringAndGraphic.fromJS(resultData401) : <any>null;
            return throwException("Response for a retrieve request for Graphic. ", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? RetrieveDataResponseOfStringAndGraphic.fromJS(resultData500) : <any>null;
            return throwException("Response for a retrieve request for Graphic. ", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RetrieveDataResponseOfStringAndGraphic | null>(<any>null);
    }
}

export class MasClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Endpoint to create a MultiMsg for a Queue.
     * @param id The id of the specific Queue to create.
     * @return Response for the AddMsgReq request. Response data containing the message added to a device's queue.
     */
    postQueueMultiMsg(addMsgReq: AddMsgReq, id: number): Promise<AddMsgResp | null> {
        let url_ = this.baseUrl + "/api/Mas/Queue/{id}/MultiMsg";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addMsgReq);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPostQueueMultiMsg(_response);
        });
    }

    protected processPostQueueMultiMsg(response: Response): Promise<AddMsgResp | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AddMsgResp.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? AddMsgResp.fromJS(resultData401) : <any>null;
            return throwException("Response for the AddMsgReq request. Response data containing the message added to a device\'s queue.", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? AddMsgResp.fromJS(resultData500) : <any>null;
            return throwException("Response for the AddMsgReq request. Response data containing the message added to a device\'s queue.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddMsgResp | null>(<any>null);
    }

    /**
     * Endpoint to update a MultiMsg for a Queue.
     * @param id The id of the specific Queue to create.
     * @return Response for the ModifyMsgReq request. Response containing the message to be modified in a device's queue.
     */
    putQueueMultiMsg(modifyMsgReq: ModifyMsgReq, id: number): Promise<ModifyMsgResp | null> {
        let url_ = this.baseUrl + "/api/Mas/Queue/{id}/MultiMsg";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(modifyMsgReq);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPutQueueMultiMsg(_response);
        });
    }

    protected processPutQueueMultiMsg(response: Response): Promise<ModifyMsgResp | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ModifyMsgResp.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ModifyMsgResp.fromJS(resultData401) : <any>null;
            return throwException("Response for the ModifyMsgReq request. Response containing the message to be modified in a device\'s queue.", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? ModifyMsgResp.fromJS(resultData500) : <any>null;
            return throwException("Response for the ModifyMsgReq request. Response containing the message to be modified in a device\'s queue.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModifyMsgResp | null>(<any>null);
    }

    /**
     * Endpoint to remove a MultiMsg for a Queue.
     * @param id The id of the specific Queue to create.
     * @return Response for the RemoveMsgReq request. Response containing the device id and the id of the removed message.
     */
    deleteQueueMultiMsg(removeMsgReq: RemoveMsgReq, id: number): Promise<RemoveMsgResp | null> {
        let url_ = this.baseUrl + "/api/Mas/Queue/{id}/MultiMsg";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(removeMsgReq);

        let options_ = <RequestInit>{
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteQueueMultiMsg(_response);
        });
    }

    protected processDeleteQueueMultiMsg(response: Response): Promise<RemoveMsgResp | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RemoveMsgResp.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? RemoveMsgResp.fromJS(resultData401) : <any>null;
            return throwException("Response for the RemoveMsgReq request. Response containing the device id and the id of the removed message.", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? RemoveMsgResp.fromJS(resultData500) : <any>null;
            return throwException("Response for the RemoveMsgReq request. Response containing the device id and the id of the removed message.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RemoveMsgResp | null>(<any>null);
    }

    /**
     * Endpoint to update a MsgId for a Queue.
     * @param id The id of the specific Queue to update.
     * @return Response for the ChangeMsgPriorityReq request. Response containing the message whose priority was modified.
     */
    patchQueuepriority(changeMsgPriorityReq: ChangeMsgPriorityReq, id: number): Promise<ChangeMsgPriorityResp | null> {
        let url_ = this.baseUrl + "/api/Mas/Queue/{id}/priority";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(changeMsgPriorityReq);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPatchQueuepriority(_response);
        });
    }

    protected processPatchQueuepriority(response: Response): Promise<ChangeMsgPriorityResp | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ChangeMsgPriorityResp.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? ChangeMsgPriorityResp.fromJS(resultData401) : <any>null;
            return throwException("Response for the ChangeMsgPriorityReq request. Response containing the message whose priority was modified.", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? ChangeMsgPriorityResp.fromJS(resultData500) : <any>null;
            return throwException("Response for the ChangeMsgPriorityReq request. Response containing the message whose priority was modified.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChangeMsgPriorityResp | null>(<any>null);
    }

    /**
     * Retrieves Queue object(s) from the Mas subsystem.
     * @param id (optional) The id of the specific Queue to retrieve.
     * @return Response for a retrieve request for Queue.
     */
    getQueue(id: number | null | undefined): Promise<RetrieveDataResponseOfStringAndQueue | null> {
        let url_ = this.baseUrl + "/api/Mas/Queue/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetQueue(_response);
        });
    }

    protected processGetQueue(response: Response): Promise<RetrieveDataResponseOfStringAndQueue | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RetrieveDataResponseOfStringAndQueue.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? RetrieveDataResponseOfStringAndQueue.fromJS(resultData401) : <any>null;
            return throwException("Response for a retrieve request for Queue. ", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? RetrieveDataResponseOfStringAndQueue.fromJS(resultData500) : <any>null;
            return throwException("Response for a retrieve request for Queue. ", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RetrieveDataResponseOfStringAndQueue | null>(<any>null);
    }
}

export class SasClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Endpoint to update a ActionList for a Schedule.
     * @param id The id of the specific Schedule to update.
     * @return Response for the AddActionListReq request. Class that represents an addActionList response.
     */
    patchScheduleActionList(addActionListReq: AddActionListReq, id: number): Promise<AddActionListResp | null> {
        let url_ = this.baseUrl + "/api/Sas/Schedule/{id}/ActionList";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addActionListReq);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPatchScheduleActionList(_response);
        });
    }

    protected processPatchScheduleActionList(response: Response): Promise<AddActionListResp | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AddActionListResp.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? AddActionListResp.fromJS(resultData401) : <any>null;
            return throwException("Response for the AddActionListReq request. Class that represents an addActionList response.", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? AddActionListResp.fromJS(resultData500) : <any>null;
            return throwException("Response for the AddActionListReq request. Class that represents an addActionList response.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddActionListResp | null>(<any>null);
    }

    /**
     * Endpoint to update a ScheduledItem for a Schedule.
     * @param id The id of the specific Schedule to update.
     * @return Response for the AddScheduledItemReq request. Class that represents an addScheduledItem response.
     */
    patchScheduleScheduledItem(addScheduledItemReq: AddScheduledItemReq, id: number): Promise<AddScheduledItemResp | null> {
        let url_ = this.baseUrl + "/api/Sas/Schedule/{id}/ScheduledItem";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addScheduledItemReq);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPatchScheduleScheduledItem(_response);
        });
    }

    protected processPatchScheduleScheduledItem(response: Response): Promise<AddScheduledItemResp | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AddScheduledItemResp.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? AddScheduledItemResp.fromJS(resultData401) : <any>null;
            return throwException("Response for the AddScheduledItemReq request. Class that represents an addScheduledItem response.", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? AddScheduledItemResp.fromJS(resultData500) : <any>null;
            return throwException("Response for the AddScheduledItemReq request. Class that represents an addScheduledItem response.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddScheduledItemResp | null>(<any>null);
    }

    /**
     * Endpoint to update a ScheduleStatus for a Schedule.
     * @param id The id of the specific Schedule to update.
     * @return Response for the SetScheduleStatusReq request. Class that represents an setScheduleState response.
     */
    patchScheduleScheduleStatus(setScheduleStatusReq: SetScheduleStatusReq, id: number): Promise<SetScheduleStatusResp | null> {
        let url_ = this.baseUrl + "/api/Sas/Schedule/{id}/ScheduleStatus";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(setScheduleStatusReq);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPatchScheduleScheduleStatus(_response);
        });
    }

    protected processPatchScheduleScheduleStatus(response: Response): Promise<SetScheduleStatusResp | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SetScheduleStatusResp.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? SetScheduleStatusResp.fromJS(resultData401) : <any>null;
            return throwException("Response for the SetScheduleStatusReq request. Class that represents an setScheduleState response.", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? SetScheduleStatusResp.fromJS(resultData500) : <any>null;
            return throwException("Response for the SetScheduleStatusReq request. Class that represents an setScheduleState response.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SetScheduleStatusResp | null>(<any>null);
    }

    /**
     * Retrieves Schedule object(s) from the Sas subsystem.
     * @param id (optional) The id of the specific Schedule to retrieve.
     * @return Response for a retrieve request for Schedule.
     */
    getSchedule(id: number | null | undefined): Promise<RetrieveDataResponseOfStringAndSchedule | null> {
        let url_ = this.baseUrl + "/api/Sas/Schedule/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSchedule(_response);
        });
    }

    protected processGetSchedule(response: Response): Promise<RetrieveDataResponseOfStringAndSchedule | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RetrieveDataResponseOfStringAndSchedule.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? RetrieveDataResponseOfStringAndSchedule.fromJS(resultData401) : <any>null;
            return throwException("Response for a retrieve request for Schedule. ", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? RetrieveDataResponseOfStringAndSchedule.fromJS(resultData500) : <any>null;
            return throwException("Response for a retrieve request for Schedule. ", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RetrieveDataResponseOfStringAndSchedule | null>(<any>null);
    }

    /**
     * Retrieves ScheduledItem object(s) from the Sas subsystem.
     * @param id (optional) The id of the specific ScheduledItem to retrieve.
     * @return Response for a retrieve request for ScheduledItem.
     */
    getScheduledItem(id: number | null | undefined): Promise<RetrieveDataResponseOfStringAndScheduledItem | null> {
        let url_ = this.baseUrl + "/api/Sas/ScheduledItem/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetScheduledItem(_response);
        });
    }

    protected processGetScheduledItem(response: Response): Promise<RetrieveDataResponseOfStringAndScheduledItem | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RetrieveDataResponseOfStringAndScheduledItem.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? RetrieveDataResponseOfStringAndScheduledItem.fromJS(resultData401) : <any>null;
            return throwException("Response for a retrieve request for ScheduledItem. ", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? RetrieveDataResponseOfStringAndScheduledItem.fromJS(resultData500) : <any>null;
            return throwException("Response for a retrieve request for ScheduledItem. ", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RetrieveDataResponseOfStringAndScheduledItem | null>(<any>null);
    }

    /**
     * Retrieves Device object(s) from the Sas subsystem.
     * @param id (optional) The id of the specific Device to retrieve.
     * @return Response for a retrieve request for Device.
     */
    getDevice(id: number | null | undefined): Promise<RetrieveDataResponseOfStringAndDevice | null> {
        let url_ = this.baseUrl + "/api/Sas/Device/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDevice(_response);
        });
    }

    protected processGetDevice(response: Response): Promise<RetrieveDataResponseOfStringAndDevice | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RetrieveDataResponseOfStringAndDevice.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? RetrieveDataResponseOfStringAndDevice.fromJS(resultData401) : <any>null;
            return throwException("Response for a retrieve request for Device. ", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? RetrieveDataResponseOfStringAndDevice.fromJS(resultData500) : <any>null;
            return throwException("Response for a retrieve request for Device. ", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RetrieveDataResponseOfStringAndDevice | null>(<any>null);
    }
}

export class EmClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Retrieves IdAndStatus`1 object(s) from the Em subsystem.
     * @param id (optional) The id of the specific IdAndStatus`1 to retrieve.
     * @return Response for a retrieve request for IdAndStatus`1.
     */
    getshortEventStatus(id: number | null | undefined): Promise<RetrieveDataResponseOfStringAndIdAndStatusOfShortEventStatus | null> {
        let url_ = this.baseUrl + "/api/Em/shortEventStatus/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetshortEventStatus(_response);
        });
    }

    protected processGetshortEventStatus(response: Response): Promise<RetrieveDataResponseOfStringAndIdAndStatusOfShortEventStatus | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RetrieveDataResponseOfStringAndIdAndStatusOfShortEventStatus.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? RetrieveDataResponseOfStringAndIdAndStatusOfShortEventStatus.fromJS(resultData401) : <any>null;
            return throwException("Response for a retrieve request for IdAndStatus`1. ", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? RetrieveDataResponseOfStringAndIdAndStatusOfShortEventStatus.fromJS(resultData500) : <any>null;
            return throwException("Response for a retrieve request for IdAndStatus`1. ", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RetrieveDataResponseOfStringAndIdAndStatusOfShortEventStatus | null>(<any>null);
    }
}

export class RwisClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Retrieves Station object(s) from the Rwis subsystem.
     * @param id (optional) The id of the specific Station to retrieve.
     * @return Response for a retrieve request for Station.
     */
    getStation(id: number | null | undefined): Promise<RetrieveDataResponseOfStringAndStation | null> {
        let url_ = this.baseUrl + "/api/Rwis/Station/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetStation(_response);
        });
    }

    protected processGetStation(response: Response): Promise<RetrieveDataResponseOfStringAndStation | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RetrieveDataResponseOfStringAndStation.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? RetrieveDataResponseOfStringAndStation.fromJS(resultData401) : <any>null;
            return throwException("Response for a retrieve request for Station. ", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? RetrieveDataResponseOfStringAndStation.fromJS(resultData500) : <any>null;
            return throwException("Response for a retrieve request for Station. ", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RetrieveDataResponseOfStringAndStation | null>(<any>null);
    }
}

export class TssClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Retrieves DetectorMap object(s) from the Tss subsystem.
     * @param id (optional) The id of the specific DetectorMap to retrieve.
     * @return Response for a retrieve request for DetectorMap.
     */
    getDetectorMap(id: number | null | undefined): Promise<RetrieveDataResponseOfStringAndDetectorMap | null> {
        let url_ = this.baseUrl + "/api/Tss/DetectorMap/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDetectorMap(_response);
        });
    }

    protected processGetDetectorMap(response: Response): Promise<RetrieveDataResponseOfStringAndDetectorMap | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RetrieveDataResponseOfStringAndDetectorMap.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? RetrieveDataResponseOfStringAndDetectorMap.fromJS(resultData401) : <any>null;
            return throwException("Response for a retrieve request for DetectorMap. ", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? RetrieveDataResponseOfStringAndDetectorMap.fromJS(resultData500) : <any>null;
            return throwException("Response for a retrieve request for DetectorMap. ", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RetrieveDataResponseOfStringAndDetectorMap | null>(<any>null);
    }

    /**
     * Retrieves Node object(s) from the Tss subsystem.
     * @param id (optional) The id of the specific Node to retrieve.
     * @return Response for a retrieve request for Node.
     */
    getNode(id: number | null | undefined): Promise<RetrieveDataResponseOfStringAndNode | null> {
        let url_ = this.baseUrl + "/api/Tss/Node/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetNode(_response);
        });
    }

    protected processGetNode(response: Response): Promise<RetrieveDataResponseOfStringAndNode | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RetrieveDataResponseOfStringAndNode.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? RetrieveDataResponseOfStringAndNode.fromJS(resultData401) : <any>null;
            return throwException("Response for a retrieve request for Node. ", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? RetrieveDataResponseOfStringAndNode.fromJS(resultData500) : <any>null;
            return throwException("Response for a retrieve request for Node. ", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RetrieveDataResponseOfStringAndNode | null>(<any>null);
    }

    /**
     * Retrieves LinkGeometry object(s) from the Tss subsystem.
     * @param id (optional) The id of the specific LinkGeometry to retrieve.
     * @return Response for a retrieve request for LinkGeometry.
     */
    getLinkGeometry(id: number | null | undefined): Promise<RetrieveDataResponseOfStringAndLinkGeometry | null> {
        let url_ = this.baseUrl + "/api/Tss/LinkGeometry/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLinkGeometry(_response);
        });
    }

    protected processGetLinkGeometry(response: Response): Promise<RetrieveDataResponseOfStringAndLinkGeometry | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RetrieveDataResponseOfStringAndLinkGeometry.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? RetrieveDataResponseOfStringAndLinkGeometry.fromJS(resultData401) : <any>null;
            return throwException("Response for a retrieve request for LinkGeometry. ", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? RetrieveDataResponseOfStringAndLinkGeometry.fromJS(resultData500) : <any>null;
            return throwException("Response for a retrieve request for LinkGeometry. ", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RetrieveDataResponseOfStringAndLinkGeometry | null>(<any>null);
    }

    /**
     * Retrieves IdAndStatus`1 object(s) from the Tss subsystem.
     * @param id (optional) The id of the specific IdAndStatus`1 to retrieve.
     * @return Response for a retrieve request for IdAndStatus`1.
     */
    getlinkPollStatus(id: number | null | undefined): Promise<RetrieveDataResponseOfStringAndIdAndStatusOfLinkPollStatus | null> {
        let url_ = this.baseUrl + "/api/Tss/linkPollStatus/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetlinkPollStatus(_response);
        });
    }

    protected processGetlinkPollStatus(response: Response): Promise<RetrieveDataResponseOfStringAndIdAndStatusOfLinkPollStatus | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RetrieveDataResponseOfStringAndIdAndStatusOfLinkPollStatus.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? RetrieveDataResponseOfStringAndIdAndStatusOfLinkPollStatus.fromJS(resultData401) : <any>null;
            return throwException("Response for a retrieve request for IdAndStatus`1. ", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? RetrieveDataResponseOfStringAndIdAndStatusOfLinkPollStatus.fromJS(resultData500) : <any>null;
            return throwException("Response for a retrieve request for IdAndStatus`1. ", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RetrieveDataResponseOfStringAndIdAndStatusOfLinkPollStatus | null>(<any>null);
    }

    /**
     * Retrieves DetectorConfig object(s) from the Tss subsystem.
     * @param id (optional) The id of the specific DetectorConfig to retrieve.
     * @return Response for a retrieve request for DetectorConfig.
     */
    getDetectorConfig(id: number | null | undefined): Promise<RetrieveDataResponseOfStringAndDetectorConfig | null> {
        let url_ = this.baseUrl + "/api/Tss/DetectorConfig/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDetectorConfig(_response);
        });
    }

    protected processGetDetectorConfig(response: Response): Promise<RetrieveDataResponseOfStringAndDetectorConfig | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RetrieveDataResponseOfStringAndDetectorConfig.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = resultData401 ? RetrieveDataResponseOfStringAndDetectorConfig.fromJS(resultData401) : <any>null;
            return throwException("Response for a retrieve request for DetectorConfig. ", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? RetrieveDataResponseOfStringAndDetectorConfig.fromJS(resultData500) : <any>null;
            return throwException("Response for a retrieve request for DetectorConfig. ", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RetrieveDataResponseOfStringAndDetectorConfig | null>(<any>null);
    }
}

export class SaaClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    saveUserPreferences(request: SaveUserPreferenceRequest): Promise<SaveUserPreferencesResponse> {
        let url_ = this.baseUrl + "/api/saa/SavePreference";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveUserPreferences(_response);
        });
    }

    protected processSaveUserPreferences(response: Response): Promise<SaveUserPreferencesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveUserPreferencesResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveUserPreferencesResponse>(<any>null);
    }

    getUserPreferences(request: GetUserPreferenceRequest): Promise<RetrieveDataResponseOfString> {
        let url_ = this.baseUrl + "/api/saa/GetPreference";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserPreferences(_response);
        });
    }

    protected processGetUserPreferences(response: Response): Promise<RetrieveDataResponseOfString> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RetrieveDataResponseOfString.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RetrieveDataResponseOfString>(<any>null);
    }

    getPermissionData(): Promise<RetrievePermissionsResponse> {
        let url_ = this.baseUrl + "/api/saa/Permissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPermissionData(_response);
        });
    }

    protected processGetPermissionData(response: Response): Promise<RetrievePermissionsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RetrievePermissionsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RetrievePermissionsResponse>(<any>null);
    }
}

export abstract class BaseResponse implements IBaseResponse {
    validationErrors?: { [key: string]: string; } | undefined;
    error?: string | undefined;
    hasError!: boolean;

    constructor(data?: IBaseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["validationErrors"]) {
                this.validationErrors = {} as any;
                for (let key in _data["validationErrors"]) {
                    if (_data["validationErrors"].hasOwnProperty(key))
                        this.validationErrors![key] = _data["validationErrors"][key];
                }
            }
            this.error = _data["error"];
            this.hasError = _data["hasError"];
        }
    }

    static fromJS(data: any): BaseResponse {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseResponse' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.validationErrors) {
            data["validationErrors"] = {};
            for (let key in this.validationErrors) {
                if (this.validationErrors.hasOwnProperty(key))
                    data["validationErrors"][key] = this.validationErrors[key];
            }
        }
        data["error"] = this.error;
        data["hasError"] = this.hasError;
        return data; 
    }
}

export interface IBaseResponse {
    validationErrors?: { [key: string]: string; } | undefined;
    error?: string | undefined;
    hasError: boolean;
}

export class LoginResponse extends BaseResponse implements ILoginResponse {
    jwt?: string | undefined;
    districtId?: string | undefined;

    constructor(data?: ILoginResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.jwt = _data["jwt"];
            this.districtId = _data["districtId"];
        }
    }

    static fromJS(data: any): LoginResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LoginResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jwt"] = this.jwt;
        data["districtId"] = this.districtId;
        super.toJSON(data);
        return data; 
    }
}

export interface ILoginResponse extends IBaseResponse {
    jwt?: string | undefined;
    districtId?: string | undefined;
}

export abstract class Request implements IRequest {

    constructor(data?: IRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Request {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'Request' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }
}

export interface IRequest {
}

export class LoginRequest extends Request implements ILoginRequest {
    username?: string | undefined;
    password?: string | undefined;

    constructor(data?: ILoginRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LoginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LoginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        super.toJSON(data);
        return data; 
    }
}

export interface ILoginRequest extends IRequest {
    username?: string | undefined;
    password?: string | undefined;
}

export enum Provider {
    Cctv = "Cctv",
    Dms = "Dms",
    Em = "Em",
    Mas = "Mas",
    Rwis = "Rwis",
    Saa = "Saa",
    Sas = "Sas",
    Tss = "Tss",
}

export abstract class NotifyPropertyChangedObject implements INotifyPropertyChangedObject {

    constructor(data?: INotifyPropertyChangedObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): NotifyPropertyChangedObject {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'NotifyPropertyChangedObject' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }
}

export interface INotifyPropertyChangedObject {
}

/** Serves as the base for classes which need to be serialized/deserialized. The serialization mechanism is the XmlSerializer generated by the .NET framework. This was designed to be used primarily by the request/response/message objects and their subclasses. It's methods are not called recursively by the XmlSerializer. */
export class XmlBase extends NotifyPropertyChangedObject implements IXmlBase {

    constructor(data?: IXmlBase) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): XmlBase {
        data = typeof data === 'object' ? data : {};
        let result = new XmlBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

/** Serves as the base for classes which need to be serialized/deserialized. The serialization mechanism is the XmlSerializer generated by the .NET framework. This was designed to be used primarily by the request/response/message objects and their subclasses. It's methods are not called recursively by the XmlSerializer. */
export interface IXmlBase extends INotifyPropertyChangedObject {
}

/** TODO: Update summary. */
export class XmlObject extends XmlBase implements IXmlObject {

    constructor(data?: IXmlObject) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): XmlObject {
        data = typeof data === 'object' ? data : {};
        let result = new XmlObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

/** TODO: Update summary. */
export interface IXmlObject extends IXmlBase {
}

/** Models the transaction class from the common schemas. */
export abstract class Transaction extends XmlObject implements ITransaction {
    /** Gets or sets the provider name. */
    providerName?: string | undefined;
    /** Gets or sets the provider type. */
    providerType?: string | undefined;
    /** Gets or sets the trace parent. */
    traceParent?: string | undefined;
    /** Gets or sets the reference ID. */
    refId?: string | undefined;
    /** Gets or sets the ICD version. */
    icdVersion?: string | undefined;
    /** Gets the tag used for the transaction root. */
    tag?: string | undefined;
    /** Gets or sets the provider center identifier. */
    providerCenterId?: string | undefined;

    constructor(data?: ITransaction) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.providerName = _data["providerName"];
            this.providerType = _data["providerType"];
            this.traceParent = _data["traceParent"];
            this.refId = _data["refId"];
            this.icdVersion = _data["icdVersion"];
            this.tag = _data["tag"];
            this.providerCenterId = _data["providerCenterId"];
        }
    }

    static fromJS(data: any): Transaction {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'Transaction' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerName"] = this.providerName;
        data["providerType"] = this.providerType;
        data["traceParent"] = this.traceParent;
        data["refId"] = this.refId;
        data["icdVersion"] = this.icdVersion;
        data["tag"] = this.tag;
        data["providerCenterId"] = this.providerCenterId;
        super.toJSON(data);
        return data; 
    }
}

/** Models the transaction class from the common schemas. */
export interface ITransaction extends IXmlObject {
    /** Gets or sets the provider name. */
    providerName?: string | undefined;
    /** Gets or sets the provider type. */
    providerType?: string | undefined;
    /** Gets or sets the trace parent. */
    traceParent?: string | undefined;
    /** Gets or sets the reference ID. */
    refId?: string | undefined;
    /** Gets or sets the ICD version. */
    icdVersion?: string | undefined;
    /** Gets the tag used for the transaction root. */
    tag?: string | undefined;
    /** Gets or sets the provider center identifier. */
    providerCenterId?: string | undefined;
}

export abstract class RequestOfChangeCameraStateResp extends Transaction implements IRequestOfChangeCameraStateResp {
    username?: string | undefined;
    securityToken?: string | undefined;
    callback?: ActionOfChangeCameraStateResp | undefined;

    constructor(data?: IRequestOfChangeCameraStateResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.username = _data["username"];
            this.securityToken = _data["securityToken"];
            this.callback = _data["callback"] ? ActionOfChangeCameraStateResp.fromJS(_data["callback"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RequestOfChangeCameraStateResp {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'RequestOfChangeCameraStateResp' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["securityToken"] = this.securityToken;
        data["callback"] = this.callback ? this.callback.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IRequestOfChangeCameraStateResp extends ITransaction {
    username?: string | undefined;
    securityToken?: string | undefined;
    callback?: ActionOfChangeCameraStateResp | undefined;
}

export class CctvRequestOfChangeCameraStateResp extends RequestOfChangeCameraStateResp implements ICctvRequestOfChangeCameraStateResp {

    constructor(data?: ICctvRequestOfChangeCameraStateResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CctvRequestOfChangeCameraStateResp {
        data = typeof data === 'object' ? data : {};
        let result = new CctvRequestOfChangeCameraStateResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface ICctvRequestOfChangeCameraStateResp extends IRequestOfChangeCameraStateResp {
}

/** Class that represents a changeCameraStateReq */
export class ChangeCameraStateReq extends CctvRequestOfChangeCameraStateResp implements IChangeCameraStateReq {
    /** The id used to change the camera state */
    idValue?: any | undefined;
    /** The opStatus of the camera to change the state of */
    opStatus!: OpStatus;
    idType!: IdType;
    id?: Id | undefined;
    groupId?: string | undefined;

    constructor(data?: IChangeCameraStateReq) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idValue = _data["idValue"];
            this.opStatus = _data["opStatus"];
            this.idType = _data["idType"];
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            this.groupId = _data["groupId"];
        }
    }

    static fromJS(data: any): ChangeCameraStateReq {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeCameraStateReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idValue"] = this.idValue;
        data["opStatus"] = this.opStatus;
        data["idType"] = this.idType;
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["groupId"] = this.groupId;
        super.toJSON(data);
        return data; 
    }
}

/** Class that represents a changeCameraStateReq */
export interface IChangeCameraStateReq extends ICctvRequestOfChangeCameraStateResp {
    /** The id used to change the camera state */
    idValue?: any | undefined;
    /** The opStatus of the camera to change the state of */
    opStatus: OpStatus;
    idType: IdType;
    id?: Id | undefined;
    groupId?: string | undefined;
}

/** This field contains an enumeration of a device's possible operational status */
export enum OpStatus {
    NotSet = 0,
    Active = 1,
    Error = 2,
    Failed = 3,
    OutOfService = 4,
    NULL = -1,
}

export enum IdType {
    Id = 0,
    GroupId = 1,
}

export class Id extends XmlObject implements IId {
    /** Gets or sets the name identifier of the object. */
    name!: string;
    /** Gets or sets the name of the provider of the object. */
    providerName!: string;
    /** Gets or sets the resource type of the object. */
    resourceType!: string;
    /** Gets or sets the center ID of the object. */
    centerId!: string;
    /** Gets or sets the name of the remote provider of the object. */
    remoteProviderName?: string | undefined;

    constructor(data?: IId) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.providerName = _data["providerName"];
            this.resourceType = _data["resourceType"];
            this.centerId = _data["centerId"];
            this.remoteProviderName = _data["remoteProviderName"];
        }
    }

    static fromJS(data: any): Id {
        data = typeof data === 'object' ? data : {};
        let result = new Id();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["providerName"] = this.providerName;
        data["resourceType"] = this.resourceType;
        data["centerId"] = this.centerId;
        data["remoteProviderName"] = this.remoteProviderName;
        super.toJSON(data);
        return data; 
    }
}

export interface IId extends IXmlObject {
    /** Gets or sets the name identifier of the object. */
    name: string;
    /** Gets or sets the name of the provider of the object. */
    providerName: string;
    /** Gets or sets the resource type of the object. */
    resourceType: string;
    /** Gets or sets the center ID of the object. */
    centerId: string;
    /** Gets or sets the name of the remote provider of the object. */
    remoteProviderName?: string | undefined;
}

export abstract class Delegate implements IDelegate {
    method?: MethodInfo | undefined;
    target?: any | undefined;

    constructor(data?: IDelegate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.method = _data["method"] ? MethodInfo.fromJS(_data["method"]) : <any>undefined;
            this.target = _data["target"];
        }
    }

    static fromJS(data: any): Delegate {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'Delegate' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["method"] = this.method ? this.method.toJSON() : <any>undefined;
        data["target"] = this.target;
        return data; 
    }
}

export interface IDelegate {
    method?: MethodInfo | undefined;
    target?: any | undefined;
}

export abstract class MulticastDelegate extends Delegate implements IMulticastDelegate {

    constructor(data?: IMulticastDelegate) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): MulticastDelegate {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MulticastDelegate' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IMulticastDelegate extends IDelegate {
}

export class ActionOfChangeCameraStateResp extends MulticastDelegate implements IActionOfChangeCameraStateResp {

    constructor(data?: IActionOfChangeCameraStateResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ActionOfChangeCameraStateResp {
        data = typeof data === 'object' ? data : {};
        let result = new ActionOfChangeCameraStateResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IActionOfChangeCameraStateResp extends IMulticastDelegate {
}

export abstract class MemberInfo implements IMemberInfo {
    module?: Module | undefined;
    customAttributes?: CustomAttributeData[] | undefined;
    metadataToken!: number;

    constructor(data?: IMemberInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                this.customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    this.customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            this.metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): MemberInfo {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MemberInfo' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["metadataToken"] = this.metadataToken;
        return data; 
    }
}

export interface IMemberInfo {
    module?: Module | undefined;
    customAttributes?: CustomAttributeData[] | undefined;
    metadataToken: number;
}

export abstract class MethodBase extends MemberInfo implements IMethodBase {
    methodImplementationFlags!: MethodImplAttributes;
    callingConvention!: CallingConventions;
    isAbstract!: boolean;
    isConstructor!: boolean;
    isFinal!: boolean;
    isHideBySig!: boolean;
    isSpecialName!: boolean;
    isStatic!: boolean;
    isVirtual!: boolean;
    isAssembly!: boolean;
    isFamily!: boolean;
    isFamilyAndAssembly!: boolean;
    isFamilyOrAssembly!: boolean;
    isPrivate!: boolean;
    isPublic!: boolean;
    isConstructedGenericMethod!: boolean;
    isGenericMethod!: boolean;
    isGenericMethodDefinition!: boolean;
    containsGenericParameters!: boolean;
    isSecurityCritical!: boolean;
    isSecuritySafeCritical!: boolean;
    isSecurityTransparent!: boolean;

    constructor(data?: IMethodBase) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.methodImplementationFlags = _data["methodImplementationFlags"];
            this.callingConvention = _data["callingConvention"];
            this.isAbstract = _data["isAbstract"];
            this.isConstructor = _data["isConstructor"];
            this.isFinal = _data["isFinal"];
            this.isHideBySig = _data["isHideBySig"];
            this.isSpecialName = _data["isSpecialName"];
            this.isStatic = _data["isStatic"];
            this.isVirtual = _data["isVirtual"];
            this.isAssembly = _data["isAssembly"];
            this.isFamily = _data["isFamily"];
            this.isFamilyAndAssembly = _data["isFamilyAndAssembly"];
            this.isFamilyOrAssembly = _data["isFamilyOrAssembly"];
            this.isPrivate = _data["isPrivate"];
            this.isPublic = _data["isPublic"];
            this.isConstructedGenericMethod = _data["isConstructedGenericMethod"];
            this.isGenericMethod = _data["isGenericMethod"];
            this.isGenericMethodDefinition = _data["isGenericMethodDefinition"];
            this.containsGenericParameters = _data["containsGenericParameters"];
            this.isSecurityCritical = _data["isSecurityCritical"];
            this.isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            this.isSecurityTransparent = _data["isSecurityTransparent"];
        }
    }

    static fromJS(data: any): MethodBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MethodBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["methodImplementationFlags"] = this.methodImplementationFlags;
        data["callingConvention"] = this.callingConvention;
        data["isAbstract"] = this.isAbstract;
        data["isConstructor"] = this.isConstructor;
        data["isFinal"] = this.isFinal;
        data["isHideBySig"] = this.isHideBySig;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isVirtual"] = this.isVirtual;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isConstructedGenericMethod"] = this.isConstructedGenericMethod;
        data["isGenericMethod"] = this.isGenericMethod;
        data["isGenericMethodDefinition"] = this.isGenericMethodDefinition;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        super.toJSON(data);
        return data; 
    }
}

export interface IMethodBase extends IMemberInfo {
    methodImplementationFlags: MethodImplAttributes;
    callingConvention: CallingConventions;
    isAbstract: boolean;
    isConstructor: boolean;
    isFinal: boolean;
    isHideBySig: boolean;
    isSpecialName: boolean;
    isStatic: boolean;
    isVirtual: boolean;
    isAssembly: boolean;
    isFamily: boolean;
    isFamilyAndAssembly: boolean;
    isFamilyOrAssembly: boolean;
    isPrivate: boolean;
    isPublic: boolean;
    isConstructedGenericMethod: boolean;
    isGenericMethod: boolean;
    isGenericMethodDefinition: boolean;
    containsGenericParameters: boolean;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
}

export abstract class MethodInfo extends MethodBase implements IMethodInfo {
    memberType!: MemberTypes;
    returnParameter?: ParameterInfo | undefined;
    returnType?: string | undefined;

    constructor(data?: IMethodInfo) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.memberType = _data["memberType"];
            this.returnParameter = _data["returnParameter"] ? ParameterInfo.fromJS(_data["returnParameter"]) : <any>undefined;
            this.returnType = _data["returnType"];
        }
    }

    static fromJS(data: any): MethodInfo {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MethodInfo' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        data["returnParameter"] = this.returnParameter ? this.returnParameter.toJSON() : <any>undefined;
        data["returnType"] = this.returnType;
        super.toJSON(data);
        return data; 
    }
}

export interface IMethodInfo extends IMethodBase {
    memberType: MemberTypes;
    returnParameter?: ParameterInfo | undefined;
    returnType?: string | undefined;
}

export enum MemberTypes {
    Constructor = 1,
    Event = 2,
    Field = 4,
    Method = 8,
    Property = 16,
    TypeInfo = 32,
    Custom = 64,
    NestedType = 128,
    All = 191,
}

export class ParameterInfo implements IParameterInfo {
    attributes!: ParameterAttributes;
    member?: MemberInfo | undefined;
    name?: string | undefined;
    parameterType?: string | undefined;
    position!: number;
    isIn!: boolean;
    isLcid!: boolean;
    isOptional!: boolean;
    isOut!: boolean;
    isRetval!: boolean;
    defaultValue?: any | undefined;
    rawDefaultValue?: any | undefined;
    hasDefaultValue!: boolean;
    customAttributes?: CustomAttributeData[] | undefined;
    metadataToken!: number;

    constructor(data?: IParameterInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attributes = _data["attributes"];
            this.member = _data["member"] ? MemberInfo.fromJS(_data["member"]) : <any>undefined;
            this.name = _data["name"];
            this.parameterType = _data["parameterType"];
            this.position = _data["position"];
            this.isIn = _data["isIn"];
            this.isLcid = _data["isLcid"];
            this.isOptional = _data["isOptional"];
            this.isOut = _data["isOut"];
            this.isRetval = _data["isRetval"];
            this.defaultValue = _data["defaultValue"];
            this.rawDefaultValue = _data["rawDefaultValue"];
            this.hasDefaultValue = _data["hasDefaultValue"];
            if (Array.isArray(_data["customAttributes"])) {
                this.customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    this.customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            this.metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): ParameterInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributes"] = this.attributes;
        data["member"] = this.member ? this.member.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["parameterType"] = this.parameterType;
        data["position"] = this.position;
        data["isIn"] = this.isIn;
        data["isLcid"] = this.isLcid;
        data["isOptional"] = this.isOptional;
        data["isOut"] = this.isOut;
        data["isRetval"] = this.isRetval;
        data["defaultValue"] = this.defaultValue;
        data["rawDefaultValue"] = this.rawDefaultValue;
        data["hasDefaultValue"] = this.hasDefaultValue;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["metadataToken"] = this.metadataToken;
        return data; 
    }
}

export interface IParameterInfo {
    attributes: ParameterAttributes;
    member?: MemberInfo | undefined;
    name?: string | undefined;
    parameterType?: string | undefined;
    position: number;
    isIn: boolean;
    isLcid: boolean;
    isOptional: boolean;
    isOut: boolean;
    isRetval: boolean;
    defaultValue?: any | undefined;
    rawDefaultValue?: any | undefined;
    hasDefaultValue: boolean;
    customAttributes?: CustomAttributeData[] | undefined;
    metadataToken: number;
}

export enum ParameterAttributes {
    None = 0,
    In = 1,
    Out = 2,
    Lcid = 4,
    Retval = 8,
    Optional = 16,
    HasDefault = 4096,
    HasFieldMarshal = 8192,
    Reserved3 = 16384,
    Reserved4 = 32768,
    ReservedMask = 61440,
}

export abstract class Module implements IModule {
    assembly?: Assembly | undefined;
    fullyQualifiedName?: string | undefined;
    name?: string | undefined;
    mdStreamVersion!: number;
    moduleVersionId!: string;
    scopeName?: string | undefined;
    moduleHandle!: ModuleHandle;
    customAttributes?: CustomAttributeData[] | undefined;
    metadataToken!: number;

    constructor(data?: IModule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.moduleHandle = new ModuleHandle();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assembly = _data["assembly"] ? Assembly.fromJS(_data["assembly"]) : <any>undefined;
            this.fullyQualifiedName = _data["fullyQualifiedName"];
            this.name = _data["name"];
            this.mdStreamVersion = _data["mdStreamVersion"];
            this.moduleVersionId = _data["moduleVersionId"];
            this.scopeName = _data["scopeName"];
            this.moduleHandle = _data["moduleHandle"] ? ModuleHandle.fromJS(_data["moduleHandle"]) : new ModuleHandle();
            if (Array.isArray(_data["customAttributes"])) {
                this.customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    this.customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            this.metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): Module {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'Module' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assembly"] = this.assembly ? this.assembly.toJSON() : <any>undefined;
        data["fullyQualifiedName"] = this.fullyQualifiedName;
        data["name"] = this.name;
        data["mdStreamVersion"] = this.mdStreamVersion;
        data["moduleVersionId"] = this.moduleVersionId;
        data["scopeName"] = this.scopeName;
        data["moduleHandle"] = this.moduleHandle ? this.moduleHandle.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["metadataToken"] = this.metadataToken;
        return data; 
    }
}

export interface IModule {
    assembly?: Assembly | undefined;
    fullyQualifiedName?: string | undefined;
    name?: string | undefined;
    mdStreamVersion: number;
    moduleVersionId: string;
    scopeName?: string | undefined;
    moduleHandle: ModuleHandle;
    customAttributes?: CustomAttributeData[] | undefined;
    metadataToken: number;
}

export abstract class Assembly implements IAssembly {
    definedTypes?: string[] | undefined;
    exportedTypes?: string[] | undefined;
    codeBase?: string | undefined;
    entryPoint?: MethodInfo | undefined;
    fullName?: string | undefined;
    imageRuntimeVersion?: string | undefined;
    isDynamic!: boolean;
    location?: string | undefined;
    reflectionOnly!: boolean;
    isFullyTrusted!: boolean;
    customAttributes?: CustomAttributeData[] | undefined;
    escapedCodeBase?: string | undefined;
    manifestModule?: Module | undefined;
    modules?: Module[] | undefined;
    globalAssemblyCache!: boolean;
    hostContext!: number;
    securityRuleSet!: SecurityRuleSet;

    constructor(data?: IAssembly) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["definedTypes"])) {
                this.definedTypes = [] as any;
                for (let item of _data["definedTypes"])
                    this.definedTypes!.push(item);
            }
            if (Array.isArray(_data["exportedTypes"])) {
                this.exportedTypes = [] as any;
                for (let item of _data["exportedTypes"])
                    this.exportedTypes!.push(item);
            }
            this.codeBase = _data["codeBase"];
            this.entryPoint = _data["entryPoint"] ? MethodInfo.fromJS(_data["entryPoint"]) : <any>undefined;
            this.fullName = _data["fullName"];
            this.imageRuntimeVersion = _data["imageRuntimeVersion"];
            this.isDynamic = _data["isDynamic"];
            this.location = _data["location"];
            this.reflectionOnly = _data["reflectionOnly"];
            this.isFullyTrusted = _data["isFullyTrusted"];
            if (Array.isArray(_data["customAttributes"])) {
                this.customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    this.customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            this.escapedCodeBase = _data["escapedCodeBase"];
            this.manifestModule = _data["manifestModule"] ? Module.fromJS(_data["manifestModule"]) : <any>undefined;
            if (Array.isArray(_data["modules"])) {
                this.modules = [] as any;
                for (let item of _data["modules"])
                    this.modules!.push(Module.fromJS(item));
            }
            this.globalAssemblyCache = _data["globalAssemblyCache"];
            this.hostContext = _data["hostContext"];
            this.securityRuleSet = _data["securityRuleSet"];
        }
    }

    static fromJS(data: any): Assembly {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'Assembly' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.definedTypes)) {
            data["definedTypes"] = [];
            for (let item of this.definedTypes)
                data["definedTypes"].push(item);
        }
        if (Array.isArray(this.exportedTypes)) {
            data["exportedTypes"] = [];
            for (let item of this.exportedTypes)
                data["exportedTypes"].push(item);
        }
        data["codeBase"] = this.codeBase;
        data["entryPoint"] = this.entryPoint ? this.entryPoint.toJSON() : <any>undefined;
        data["fullName"] = this.fullName;
        data["imageRuntimeVersion"] = this.imageRuntimeVersion;
        data["isDynamic"] = this.isDynamic;
        data["location"] = this.location;
        data["reflectionOnly"] = this.reflectionOnly;
        data["isFullyTrusted"] = this.isFullyTrusted;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["escapedCodeBase"] = this.escapedCodeBase;
        data["manifestModule"] = this.manifestModule ? this.manifestModule.toJSON() : <any>undefined;
        if (Array.isArray(this.modules)) {
            data["modules"] = [];
            for (let item of this.modules)
                data["modules"].push(item.toJSON());
        }
        data["globalAssemblyCache"] = this.globalAssemblyCache;
        data["hostContext"] = this.hostContext;
        data["securityRuleSet"] = this.securityRuleSet;
        return data; 
    }
}

export interface IAssembly {
    definedTypes?: string[] | undefined;
    exportedTypes?: string[] | undefined;
    codeBase?: string | undefined;
    entryPoint?: MethodInfo | undefined;
    fullName?: string | undefined;
    imageRuntimeVersion?: string | undefined;
    isDynamic: boolean;
    location?: string | undefined;
    reflectionOnly: boolean;
    isFullyTrusted: boolean;
    customAttributes?: CustomAttributeData[] | undefined;
    escapedCodeBase?: string | undefined;
    manifestModule?: Module | undefined;
    modules?: Module[] | undefined;
    globalAssemblyCache: boolean;
    hostContext: number;
    securityRuleSet: SecurityRuleSet;
}

export class CustomAttributeData implements ICustomAttributeData {
    attributeType?: string | undefined;
    constructor_?: ConstructorInfo | undefined;
    constructorArguments?: CustomAttributeTypedArgument[] | undefined;
    namedArguments?: CustomAttributeNamedArgument[] | undefined;

    constructor(data?: ICustomAttributeData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attributeType = _data["attributeType"];
            this.constructor_ = _data["constructor"] ? ConstructorInfo.fromJS(_data["constructor"]) : <any>undefined;
            if (Array.isArray(_data["constructorArguments"])) {
                this.constructorArguments = [] as any;
                for (let item of _data["constructorArguments"])
                    this.constructorArguments!.push(CustomAttributeTypedArgument.fromJS(item));
            }
            if (Array.isArray(_data["namedArguments"])) {
                this.namedArguments = [] as any;
                for (let item of _data["namedArguments"])
                    this.namedArguments!.push(CustomAttributeNamedArgument.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomAttributeData {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributeType"] = this.attributeType;
        data["constructor"] = this.constructor_ ? this.constructor_.toJSON() : <any>undefined;
        if (Array.isArray(this.constructorArguments)) {
            data["constructorArguments"] = [];
            for (let item of this.constructorArguments)
                data["constructorArguments"].push(item.toJSON());
        }
        if (Array.isArray(this.namedArguments)) {
            data["namedArguments"] = [];
            for (let item of this.namedArguments)
                data["namedArguments"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICustomAttributeData {
    attributeType?: string | undefined;
    constructor_?: ConstructorInfo | undefined;
    constructorArguments?: CustomAttributeTypedArgument[] | undefined;
    namedArguments?: CustomAttributeNamedArgument[] | undefined;
}

export abstract class ConstructorInfo extends MethodBase implements IConstructorInfo {
    memberType!: MemberTypes;

    constructor(data?: IConstructorInfo) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.memberType = _data["memberType"];
        }
    }

    static fromJS(data: any): ConstructorInfo {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ConstructorInfo' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        super.toJSON(data);
        return data; 
    }
}

export interface IConstructorInfo extends IMethodBase {
    memberType: MemberTypes;
}

export enum MethodImplAttributes {
    Managed = 0,
    IL = 0,
    Native = 1,
    OPTIL = 2,
    Runtime = 3,
    CodeTypeMask = 3,
    Unmanaged = 4,
    ManagedMask = 4,
    NoInlining = 8,
    ForwardRef = 16,
    Synchronized = 32,
    NoOptimization = 64,
    PreserveSig = 128,
    AggressiveInlining = 256,
    InternalCall = 4096,
    MaxMethodImplVal = 65535,
}

export enum CallingConventions {
    Standard = 1,
    VarArgs = 2,
    Any = 3,
    HasThis = 32,
    ExplicitThis = 64,
}

export class CustomAttributeTypedArgument implements ICustomAttributeTypedArgument {
    argumentType?: string | undefined;
    value?: any | undefined;

    constructor(data?: ICustomAttributeTypedArgument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.argumentType = _data["argumentType"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CustomAttributeTypedArgument {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeTypedArgument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["argumentType"] = this.argumentType;
        data["value"] = this.value;
        return data; 
    }
}

export interface ICustomAttributeTypedArgument {
    argumentType?: string | undefined;
    value?: any | undefined;
}

export class CustomAttributeNamedArgument implements ICustomAttributeNamedArgument {
    memberInfo?: MemberInfo | undefined;
    typedValue!: CustomAttributeTypedArgument;
    memberName?: string | undefined;
    isField!: boolean;

    constructor(data?: ICustomAttributeNamedArgument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.typedValue = new CustomAttributeTypedArgument();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberInfo = _data["memberInfo"] ? MemberInfo.fromJS(_data["memberInfo"]) : <any>undefined;
            this.typedValue = _data["typedValue"] ? CustomAttributeTypedArgument.fromJS(_data["typedValue"]) : new CustomAttributeTypedArgument();
            this.memberName = _data["memberName"];
            this.isField = _data["isField"];
        }
    }

    static fromJS(data: any): CustomAttributeNamedArgument {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeNamedArgument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberInfo"] = this.memberInfo ? this.memberInfo.toJSON() : <any>undefined;
        data["typedValue"] = this.typedValue ? this.typedValue.toJSON() : <any>undefined;
        data["memberName"] = this.memberName;
        data["isField"] = this.isField;
        return data; 
    }
}

export interface ICustomAttributeNamedArgument {
    memberInfo?: MemberInfo | undefined;
    typedValue: CustomAttributeTypedArgument;
    memberName?: string | undefined;
    isField: boolean;
}

export enum SecurityRuleSet {
    None = 0,
    Level1 = 1,
    Level2 = 2,
}

export class ModuleHandle implements IModuleHandle {
    mdStreamVersion!: number;

    constructor(data?: IModuleHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mdStreamVersion = _data["mdStreamVersion"];
        }
    }

    static fromJS(data: any): ModuleHandle {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mdStreamVersion"] = this.mdStreamVersion;
        return data; 
    }
}

export interface IModuleHandle {
    mdStreamVersion: number;
}

export abstract class ResponseOfChangeCameraData extends Transaction implements IResponseOfChangeCameraData {
    securityToken?: string | undefined;
    error?: ErrorDto | undefined;
    data?: ChangeCameraData | undefined;
    isErrorResponse!: boolean;

    constructor(data?: IResponseOfChangeCameraData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.securityToken = _data["securityToken"];
            this.error = _data["error"] ? ErrorDto.fromJS(_data["error"]) : <any>undefined;
            this.data = _data["data"] ? ChangeCameraData.fromJS(_data["data"]) : <any>undefined;
            this.isErrorResponse = _data["isErrorResponse"];
        }
    }

    static fromJS(data: any): ResponseOfChangeCameraData {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ResponseOfChangeCameraData' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securityToken"] = this.securityToken;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["isErrorResponse"] = this.isErrorResponse;
        super.toJSON(data);
        return data; 
    }
}

export interface IResponseOfChangeCameraData extends ITransaction {
    securityToken?: string | undefined;
    error?: ErrorDto | undefined;
    data?: ChangeCameraData | undefined;
    isErrorResponse: boolean;
}

export class CctvResponseOfChangeCameraData extends ResponseOfChangeCameraData implements ICctvResponseOfChangeCameraData {

    constructor(data?: ICctvResponseOfChangeCameraData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CctvResponseOfChangeCameraData {
        data = typeof data === 'object' ? data : {};
        let result = new CctvResponseOfChangeCameraData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface ICctvResponseOfChangeCameraData extends IResponseOfChangeCameraData {
}

/** Class that represents a changeCameraStateResp. */
export class ChangeCameraStateResp extends CctvResponseOfChangeCameraData implements IChangeCameraStateResp {

    constructor(data?: IChangeCameraStateResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ChangeCameraStateResp {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeCameraStateResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

/** Class that represents a changeCameraStateResp. */
export interface IChangeCameraStateResp extends ICctvResponseOfChangeCameraData {
}

export class ErrorDto extends XmlObject implements IErrorDto {
    errorCode?: number | undefined;
    errorMap?: string | undefined;
    errorString?: string | undefined;
    errorData?: string | undefined;
    equipmentId?: string | undefined;
    errorCodeSpecified!: boolean;

    constructor(data?: IErrorDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.errorCode = _data["errorCode"];
            this.errorMap = _data["errorMap"];
            this.errorString = _data["errorString"];
            this.errorData = _data["errorData"];
            this.equipmentId = _data["equipmentId"];
            this.errorCodeSpecified = _data["errorCodeSpecified"];
        }
    }

    static fromJS(data: any): ErrorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorCode"] = this.errorCode;
        data["errorMap"] = this.errorMap;
        data["errorString"] = this.errorString;
        data["errorData"] = this.errorData;
        data["equipmentId"] = this.equipmentId;
        data["errorCodeSpecified"] = this.errorCodeSpecified;
        super.toJSON(data);
        return data; 
    }
}

export interface IErrorDto extends IXmlObject {
    errorCode?: number | undefined;
    errorMap?: string | undefined;
    errorString?: string | undefined;
    errorData?: string | undefined;
    equipmentId?: string | undefined;
    errorCodeSpecified: boolean;
}

/** Base class which models the data element in a response from the common schemas. */
export class ResponseData extends XmlObject implements IResponseData {
    xmlType?: string | undefined;

    constructor(data?: IResponseData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.xmlType = _data["xmlType"];
        }
    }

    static fromJS(data: any): ResponseData {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["xmlType"] = this.xmlType;
        super.toJSON(data);
        return data; 
    }
}

/** Base class which models the data element in a response from the common schemas. */
export interface IResponseData extends IXmlObject {
    xmlType?: string | undefined;
}

export class ChangeCameraData extends ResponseData implements IChangeCameraData {
    id?: Id | undefined;
    opStatus!: OpStatus;

    constructor(data?: IChangeCameraData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            this.opStatus = _data["opStatus"];
        }
    }

    static fromJS(data: any): ChangeCameraData {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeCameraData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["opStatus"] = this.opStatus;
        super.toJSON(data);
        return data; 
    }
}

export interface IChangeCameraData extends IResponseData {
    id?: Id | undefined;
    opStatus: OpStatus;
}

export abstract class RequestOfFocusLensResp extends Transaction implements IRequestOfFocusLensResp {
    username?: string | undefined;
    securityToken?: string | undefined;
    callback?: ActionOfFocusLensResp | undefined;

    constructor(data?: IRequestOfFocusLensResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.username = _data["username"];
            this.securityToken = _data["securityToken"];
            this.callback = _data["callback"] ? ActionOfFocusLensResp.fromJS(_data["callback"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RequestOfFocusLensResp {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'RequestOfFocusLensResp' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["securityToken"] = this.securityToken;
        data["callback"] = this.callback ? this.callback.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IRequestOfFocusLensResp extends ITransaction {
    username?: string | undefined;
    securityToken?: string | undefined;
    callback?: ActionOfFocusLensResp | undefined;
}

export class CctvRequestOfFocusLensResp extends RequestOfFocusLensResp implements ICctvRequestOfFocusLensResp {

    constructor(data?: ICctvRequestOfFocusLensResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CctvRequestOfFocusLensResp {
        data = typeof data === 'object' ? data : {};
        let result = new CctvRequestOfFocusLensResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface ICctvRequestOfFocusLensResp extends IRequestOfFocusLensResp {
}

/** Class that represents a focusLensReq. */
export class FocusLensReq extends CctvRequestOfFocusLensResp implements IFocusLensReq {
    /** Id of the Camera to focus. */
    id?: Id | undefined;
    /** Object containing information on how to focus the camera. */
    positioning?: FocusPositioning | undefined;

    constructor(data?: IFocusLensReq) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            this.positioning = _data["positioning"] ? FocusPositioning.fromJS(_data["positioning"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FocusLensReq {
        data = typeof data === 'object' ? data : {};
        let result = new FocusLensReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["positioning"] = this.positioning ? this.positioning.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

/** Class that represents a focusLensReq. */
export interface IFocusLensReq extends ICctvRequestOfFocusLensResp {
    /** Id of the Camera to focus. */
    id?: Id | undefined;
    /** Object containing information on how to focus the camera. */
    positioning?: FocusPositioning | undefined;
}

export class FocusPositioning extends XmlBase implements IFocusPositioning {
    focusValue?: any | undefined;
    focusType!: FocusPositioningType;
    modeOfOperation?: ModeOfOperation | undefined;
    autoFocus?: boolean | undefined;
    nearFocus?: string | undefined;

    constructor(data?: IFocusPositioning) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.focusValue = _data["focusValue"];
            this.focusType = _data["focusType"];
            this.modeOfOperation = _data["modeOfOperation"] ? ModeOfOperation.fromJS(_data["modeOfOperation"]) : <any>undefined;
            this.autoFocus = _data["autoFocus"];
            this.nearFocus = _data["nearFocus"];
        }
    }

    static fromJS(data: any): FocusPositioning {
        data = typeof data === 'object' ? data : {};
        let result = new FocusPositioning();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["focusValue"] = this.focusValue;
        data["focusType"] = this.focusType;
        data["modeOfOperation"] = this.modeOfOperation ? this.modeOfOperation.toJSON() : <any>undefined;
        data["autoFocus"] = this.autoFocus;
        data["nearFocus"] = this.nearFocus;
        super.toJSON(data);
        return data; 
    }
}

export interface IFocusPositioning extends IXmlBase {
    focusValue?: any | undefined;
    focusType: FocusPositioningType;
    modeOfOperation?: ModeOfOperation | undefined;
    autoFocus?: boolean | undefined;
    nearFocus?: string | undefined;
}

export enum FocusPositioningType {
    ModeOfOperation = 0,
    AutoFocus = 1,
    NearFocus = 2,
}

export class ModeOfOperation extends XmlBase implements IModeOfOperation {
    mode!: PositioningMode;
    speed!: number;
    position?: number | undefined;
    positionSpecified!: boolean;

    constructor(data?: IModeOfOperation) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.mode = _data["mode"];
            this.speed = _data["speed"];
            this.position = _data["position"];
            this.positionSpecified = _data["positionSpecified"];
        }
    }

    static fromJS(data: any): ModeOfOperation {
        data = typeof data === 'object' ? data : {};
        let result = new ModeOfOperation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mode"] = this.mode;
        data["speed"] = this.speed;
        data["position"] = this.position;
        data["positionSpecified"] = this.positionSpecified;
        super.toJSON(data);
        return data; 
    }
}

export interface IModeOfOperation extends IXmlBase {
    mode: PositioningMode;
    speed: number;
    position?: number | undefined;
    positionSpecified: boolean;
}

/** An enumeration of the different positioning modes that can be used by a CCTV camera. */
export enum PositioningMode {
    Absolute = 0,
    Relative = 1,
    Continuous = 2,
    Stop = 3,
}

export class ActionOfFocusLensResp extends MulticastDelegate implements IActionOfFocusLensResp {

    constructor(data?: IActionOfFocusLensResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ActionOfFocusLensResp {
        data = typeof data === 'object' ? data : {};
        let result = new ActionOfFocusLensResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IActionOfFocusLensResp extends IMulticastDelegate {
}

export abstract class ResponseOfFocusLensData extends Transaction implements IResponseOfFocusLensData {
    securityToken?: string | undefined;
    error?: ErrorDto | undefined;
    data?: FocusLensData | undefined;
    isErrorResponse!: boolean;

    constructor(data?: IResponseOfFocusLensData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.securityToken = _data["securityToken"];
            this.error = _data["error"] ? ErrorDto.fromJS(_data["error"]) : <any>undefined;
            this.data = _data["data"] ? FocusLensData.fromJS(_data["data"]) : <any>undefined;
            this.isErrorResponse = _data["isErrorResponse"];
        }
    }

    static fromJS(data: any): ResponseOfFocusLensData {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ResponseOfFocusLensData' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securityToken"] = this.securityToken;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["isErrorResponse"] = this.isErrorResponse;
        super.toJSON(data);
        return data; 
    }
}

export interface IResponseOfFocusLensData extends ITransaction {
    securityToken?: string | undefined;
    error?: ErrorDto | undefined;
    data?: FocusLensData | undefined;
    isErrorResponse: boolean;
}

export class CctvResponseOfFocusLensData extends ResponseOfFocusLensData implements ICctvResponseOfFocusLensData {

    constructor(data?: ICctvResponseOfFocusLensData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CctvResponseOfFocusLensData {
        data = typeof data === 'object' ? data : {};
        let result = new CctvResponseOfFocusLensData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface ICctvResponseOfFocusLensData extends IResponseOfFocusLensData {
}

/** Class that represents a focusLensResp. */
export class FocusLensResp extends CctvResponseOfFocusLensData implements IFocusLensResp {

    constructor(data?: IFocusLensResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): FocusLensResp {
        data = typeof data === 'object' ? data : {};
        let result = new FocusLensResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

/** Class that represents a focusLensResp. */
export interface IFocusLensResp extends ICctvResponseOfFocusLensData {
}

export class FocusLensData extends ResponseData implements IFocusLensData {
    id?: Id | undefined;
    positioning?: FocusPositioning | undefined;

    constructor(data?: IFocusLensData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            this.positioning = _data["positioning"] ? FocusPositioning.fromJS(_data["positioning"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FocusLensData {
        data = typeof data === 'object' ? data : {};
        let result = new FocusLensData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["positioning"] = this.positioning ? this.positioning.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IFocusLensData extends IResponseData {
    id?: Id | undefined;
    positioning?: FocusPositioning | undefined;
}

export abstract class RequestOfIrisLensResp extends Transaction implements IRequestOfIrisLensResp {
    username?: string | undefined;
    securityToken?: string | undefined;
    callback?: ActionOfIrisLensResp | undefined;

    constructor(data?: IRequestOfIrisLensResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.username = _data["username"];
            this.securityToken = _data["securityToken"];
            this.callback = _data["callback"] ? ActionOfIrisLensResp.fromJS(_data["callback"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RequestOfIrisLensResp {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'RequestOfIrisLensResp' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["securityToken"] = this.securityToken;
        data["callback"] = this.callback ? this.callback.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IRequestOfIrisLensResp extends ITransaction {
    username?: string | undefined;
    securityToken?: string | undefined;
    callback?: ActionOfIrisLensResp | undefined;
}

export class CctvRequestOfIrisLensResp extends RequestOfIrisLensResp implements ICctvRequestOfIrisLensResp {

    constructor(data?: ICctvRequestOfIrisLensResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CctvRequestOfIrisLensResp {
        data = typeof data === 'object' ? data : {};
        let result = new CctvRequestOfIrisLensResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface ICctvRequestOfIrisLensResp extends IRequestOfIrisLensResp {
}

/** Class that represents an irisLensReq. */
export class IrisLensReq extends CctvRequestOfIrisLensResp implements IIrisLensReq {
    /** Id of the Camera to perform the operation on. */
    id?: Id | undefined;
    /** Object containing the information on
how the operation should be performed. */
    positioning?: IrisPositioning | undefined;

    constructor(data?: IIrisLensReq) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            this.positioning = _data["positioning"] ? IrisPositioning.fromJS(_data["positioning"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IrisLensReq {
        data = typeof data === 'object' ? data : {};
        let result = new IrisLensReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["positioning"] = this.positioning ? this.positioning.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

/** Class that represents an irisLensReq. */
export interface IIrisLensReq extends ICctvRequestOfIrisLensResp {
    /** Id of the Camera to perform the operation on. */
    id?: Id | undefined;
    /** Object containing the information on
how the operation should be performed. */
    positioning?: IrisPositioning | undefined;
}

export class IrisPositioning extends XmlBase implements IIrisPositioning {
    positionValue?: any | undefined;
    positionType!: IrisPositionType;
    modeOfOperation?: ModeOfOperation | undefined;
    autoIris?: boolean | undefined;

    constructor(data?: IIrisPositioning) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.positionValue = _data["positionValue"];
            this.positionType = _data["positionType"];
            this.modeOfOperation = _data["modeOfOperation"] ? ModeOfOperation.fromJS(_data["modeOfOperation"]) : <any>undefined;
            this.autoIris = _data["autoIris"];
        }
    }

    static fromJS(data: any): IrisPositioning {
        data = typeof data === 'object' ? data : {};
        let result = new IrisPositioning();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["positionValue"] = this.positionValue;
        data["positionType"] = this.positionType;
        data["modeOfOperation"] = this.modeOfOperation ? this.modeOfOperation.toJSON() : <any>undefined;
        data["autoIris"] = this.autoIris;
        super.toJSON(data);
        return data; 
    }
}

export interface IIrisPositioning extends IXmlBase {
    positionValue?: any | undefined;
    positionType: IrisPositionType;
    modeOfOperation?: ModeOfOperation | undefined;
    autoIris?: boolean | undefined;
}

export enum IrisPositionType {
    ModeOfOperation = 0,
    AutoIris = 1,
}

export class ActionOfIrisLensResp extends MulticastDelegate implements IActionOfIrisLensResp {

    constructor(data?: IActionOfIrisLensResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ActionOfIrisLensResp {
        data = typeof data === 'object' ? data : {};
        let result = new ActionOfIrisLensResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IActionOfIrisLensResp extends IMulticastDelegate {
}

export abstract class ResponseOfIrisLensData extends Transaction implements IResponseOfIrisLensData {
    securityToken?: string | undefined;
    error?: ErrorDto | undefined;
    data?: IrisLensData | undefined;
    isErrorResponse!: boolean;

    constructor(data?: IResponseOfIrisLensData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.securityToken = _data["securityToken"];
            this.error = _data["error"] ? ErrorDto.fromJS(_data["error"]) : <any>undefined;
            this.data = _data["data"] ? IrisLensData.fromJS(_data["data"]) : <any>undefined;
            this.isErrorResponse = _data["isErrorResponse"];
        }
    }

    static fromJS(data: any): ResponseOfIrisLensData {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ResponseOfIrisLensData' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securityToken"] = this.securityToken;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["isErrorResponse"] = this.isErrorResponse;
        super.toJSON(data);
        return data; 
    }
}

export interface IResponseOfIrisLensData extends ITransaction {
    securityToken?: string | undefined;
    error?: ErrorDto | undefined;
    data?: IrisLensData | undefined;
    isErrorResponse: boolean;
}

export class CctvResponseOfIrisLensData extends ResponseOfIrisLensData implements ICctvResponseOfIrisLensData {

    constructor(data?: ICctvResponseOfIrisLensData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CctvResponseOfIrisLensData {
        data = typeof data === 'object' ? data : {};
        let result = new CctvResponseOfIrisLensData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface ICctvResponseOfIrisLensData extends IResponseOfIrisLensData {
}

/** Class that represents an irisLensResp. */
export class IrisLensResp extends CctvResponseOfIrisLensData implements IIrisLensResp {

    constructor(data?: IIrisLensResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): IrisLensResp {
        data = typeof data === 'object' ? data : {};
        let result = new IrisLensResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

/** Class that represents an irisLensResp. */
export interface IIrisLensResp extends ICctvResponseOfIrisLensData {
}

export class IrisLensData extends ResponseData implements IIrisLensData {
    id?: Id | undefined;
    positioning?: IrisPositioning | undefined;

    constructor(data?: IIrisLensData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            this.positioning = _data["positioning"] ? IrisPositioning.fromJS(_data["positioning"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IrisLensData {
        data = typeof data === 'object' ? data : {};
        let result = new IrisLensData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["positioning"] = this.positioning ? this.positioning.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IIrisLensData extends IResponseData {
    id?: Id | undefined;
    positioning?: IrisPositioning | undefined;
}

export abstract class RequestOfMoveToPresetPositionResp extends Transaction implements IRequestOfMoveToPresetPositionResp {
    username?: string | undefined;
    securityToken?: string | undefined;
    callback?: ActionOfMoveToPresetPositionResp | undefined;

    constructor(data?: IRequestOfMoveToPresetPositionResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.username = _data["username"];
            this.securityToken = _data["securityToken"];
            this.callback = _data["callback"] ? ActionOfMoveToPresetPositionResp.fromJS(_data["callback"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RequestOfMoveToPresetPositionResp {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'RequestOfMoveToPresetPositionResp' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["securityToken"] = this.securityToken;
        data["callback"] = this.callback ? this.callback.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IRequestOfMoveToPresetPositionResp extends ITransaction {
    username?: string | undefined;
    securityToken?: string | undefined;
    callback?: ActionOfMoveToPresetPositionResp | undefined;
}

export class CctvRequestOfMoveToPresetPositionResp extends RequestOfMoveToPresetPositionResp implements ICctvRequestOfMoveToPresetPositionResp {

    constructor(data?: ICctvRequestOfMoveToPresetPositionResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CctvRequestOfMoveToPresetPositionResp {
        data = typeof data === 'object' ? data : {};
        let result = new CctvRequestOfMoveToPresetPositionResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface ICctvRequestOfMoveToPresetPositionResp extends IRequestOfMoveToPresetPositionResp {
}

/** Class that represents a moveToPresetPositionReq. */
export class MoveToPresetPositionReq extends CctvRequestOfMoveToPresetPositionResp implements IMoveToPresetPositionReq {
    /** Id of the Camera to perform this operation on. */
    id?: Id | undefined;
    /** Preset Number to move the Camera to. */
    presetNumber!: number;

    constructor(data?: IMoveToPresetPositionReq) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            this.presetNumber = _data["presetNumber"];
        }
    }

    static fromJS(data: any): MoveToPresetPositionReq {
        data = typeof data === 'object' ? data : {};
        let result = new MoveToPresetPositionReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["presetNumber"] = this.presetNumber;
        super.toJSON(data);
        return data; 
    }
}

/** Class that represents a moveToPresetPositionReq. */
export interface IMoveToPresetPositionReq extends ICctvRequestOfMoveToPresetPositionResp {
    /** Id of the Camera to perform this operation on. */
    id?: Id | undefined;
    /** Preset Number to move the Camera to. */
    presetNumber: number;
}

export class ActionOfMoveToPresetPositionResp extends MulticastDelegate implements IActionOfMoveToPresetPositionResp {

    constructor(data?: IActionOfMoveToPresetPositionResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ActionOfMoveToPresetPositionResp {
        data = typeof data === 'object' ? data : {};
        let result = new ActionOfMoveToPresetPositionResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IActionOfMoveToPresetPositionResp extends IMulticastDelegate {
}

export abstract class ResponseOfMoveToPresetData extends Transaction implements IResponseOfMoveToPresetData {
    securityToken?: string | undefined;
    error?: ErrorDto | undefined;
    data?: MoveToPresetData | undefined;
    isErrorResponse!: boolean;

    constructor(data?: IResponseOfMoveToPresetData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.securityToken = _data["securityToken"];
            this.error = _data["error"] ? ErrorDto.fromJS(_data["error"]) : <any>undefined;
            this.data = _data["data"] ? MoveToPresetData.fromJS(_data["data"]) : <any>undefined;
            this.isErrorResponse = _data["isErrorResponse"];
        }
    }

    static fromJS(data: any): ResponseOfMoveToPresetData {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ResponseOfMoveToPresetData' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securityToken"] = this.securityToken;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["isErrorResponse"] = this.isErrorResponse;
        super.toJSON(data);
        return data; 
    }
}

export interface IResponseOfMoveToPresetData extends ITransaction {
    securityToken?: string | undefined;
    error?: ErrorDto | undefined;
    data?: MoveToPresetData | undefined;
    isErrorResponse: boolean;
}

export class CctvResponseOfMoveToPresetData extends ResponseOfMoveToPresetData implements ICctvResponseOfMoveToPresetData {

    constructor(data?: ICctvResponseOfMoveToPresetData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CctvResponseOfMoveToPresetData {
        data = typeof data === 'object' ? data : {};
        let result = new CctvResponseOfMoveToPresetData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface ICctvResponseOfMoveToPresetData extends IResponseOfMoveToPresetData {
}

/** Class that represents a moveToPresetPositionResp. */
export class MoveToPresetPositionResp extends CctvResponseOfMoveToPresetData implements IMoveToPresetPositionResp {

    constructor(data?: IMoveToPresetPositionResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): MoveToPresetPositionResp {
        data = typeof data === 'object' ? data : {};
        let result = new MoveToPresetPositionResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

/** Class that represents a moveToPresetPositionResp. */
export interface IMoveToPresetPositionResp extends ICctvResponseOfMoveToPresetData {
}

export class MoveToPresetData extends ResponseData implements IMoveToPresetData {
    id?: Id | undefined;
    preset!: number;

    constructor(data?: IMoveToPresetData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            this.preset = _data["preset"];
        }
    }

    static fromJS(data: any): MoveToPresetData {
        data = typeof data === 'object' ? data : {};
        let result = new MoveToPresetData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["preset"] = this.preset;
        super.toJSON(data);
        return data; 
    }
}

export interface IMoveToPresetData extends IResponseData {
    id?: Id | undefined;
    preset: number;
}

export abstract class RequestOfPanResp extends Transaction implements IRequestOfPanResp {
    username?: string | undefined;
    securityToken?: string | undefined;
    callback?: ActionOfPanResp | undefined;

    constructor(data?: IRequestOfPanResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.username = _data["username"];
            this.securityToken = _data["securityToken"];
            this.callback = _data["callback"] ? ActionOfPanResp.fromJS(_data["callback"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RequestOfPanResp {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'RequestOfPanResp' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["securityToken"] = this.securityToken;
        data["callback"] = this.callback ? this.callback.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IRequestOfPanResp extends ITransaction {
    username?: string | undefined;
    securityToken?: string | undefined;
    callback?: ActionOfPanResp | undefined;
}

export class CctvRequestOfPanResp extends RequestOfPanResp implements ICctvRequestOfPanResp {

    constructor(data?: ICctvRequestOfPanResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CctvRequestOfPanResp {
        data = typeof data === 'object' ? data : {};
        let result = new CctvRequestOfPanResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface ICctvRequestOfPanResp extends IRequestOfPanResp {
}

/** Class that represents a panReq. */
export class PanReq extends CctvRequestOfPanResp implements IPanReq {
    /** Id of the Camera to Pan. */
    id?: Id | undefined;
    /** Object determining how the Camera
should be panned. */
    positioning?: Positioning | undefined;

    constructor(data?: IPanReq) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            this.positioning = _data["positioning"] ? Positioning.fromJS(_data["positioning"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PanReq {
        data = typeof data === 'object' ? data : {};
        let result = new PanReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["positioning"] = this.positioning ? this.positioning.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

/** Class that represents a panReq. */
export interface IPanReq extends ICctvRequestOfPanResp {
    /** Id of the Camera to Pan. */
    id?: Id | undefined;
    /** Object determining how the Camera
should be panned. */
    positioning?: Positioning | undefined;
}

export class Positioning extends XmlBase implements IPositioning {
    operationMode?: ModeOfOperation | undefined;

    constructor(data?: IPositioning) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.operationMode = _data["operationMode"] ? ModeOfOperation.fromJS(_data["operationMode"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Positioning {
        data = typeof data === 'object' ? data : {};
        let result = new Positioning();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operationMode"] = this.operationMode ? this.operationMode.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IPositioning extends IXmlBase {
    operationMode?: ModeOfOperation | undefined;
}

export class ActionOfPanResp extends MulticastDelegate implements IActionOfPanResp {

    constructor(data?: IActionOfPanResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ActionOfPanResp {
        data = typeof data === 'object' ? data : {};
        let result = new ActionOfPanResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IActionOfPanResp extends IMulticastDelegate {
}

export abstract class ResponseOfPanData extends Transaction implements IResponseOfPanData {
    securityToken?: string | undefined;
    error?: ErrorDto | undefined;
    data?: PanData | undefined;
    isErrorResponse!: boolean;

    constructor(data?: IResponseOfPanData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.securityToken = _data["securityToken"];
            this.error = _data["error"] ? ErrorDto.fromJS(_data["error"]) : <any>undefined;
            this.data = _data["data"] ? PanData.fromJS(_data["data"]) : <any>undefined;
            this.isErrorResponse = _data["isErrorResponse"];
        }
    }

    static fromJS(data: any): ResponseOfPanData {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ResponseOfPanData' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securityToken"] = this.securityToken;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["isErrorResponse"] = this.isErrorResponse;
        super.toJSON(data);
        return data; 
    }
}

export interface IResponseOfPanData extends ITransaction {
    securityToken?: string | undefined;
    error?: ErrorDto | undefined;
    data?: PanData | undefined;
    isErrorResponse: boolean;
}

export class CctvResponseOfPanData extends ResponseOfPanData implements ICctvResponseOfPanData {

    constructor(data?: ICctvResponseOfPanData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CctvResponseOfPanData {
        data = typeof data === 'object' ? data : {};
        let result = new CctvResponseOfPanData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface ICctvResponseOfPanData extends IResponseOfPanData {
}

/** Class that represents a panResp. */
export class PanResp extends CctvResponseOfPanData implements IPanResp {

    constructor(data?: IPanResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): PanResp {
        data = typeof data === 'object' ? data : {};
        let result = new PanResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

/** Class that represents a panResp. */
export interface IPanResp extends ICctvResponseOfPanData {
}

export class PanData extends ResponseData implements IPanData {
    id?: Id | undefined;
    positioning?: Positioning | undefined;

    constructor(data?: IPanData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            this.positioning = _data["positioning"] ? Positioning.fromJS(_data["positioning"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PanData {
        data = typeof data === 'object' ? data : {};
        let result = new PanData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["positioning"] = this.positioning ? this.positioning.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IPanData extends IResponseData {
    id?: Id | undefined;
    positioning?: Positioning | undefined;
}

export abstract class RequestOfTiltResp extends Transaction implements IRequestOfTiltResp {
    username?: string | undefined;
    securityToken?: string | undefined;
    callback?: ActionOfTiltResp | undefined;

    constructor(data?: IRequestOfTiltResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.username = _data["username"];
            this.securityToken = _data["securityToken"];
            this.callback = _data["callback"] ? ActionOfTiltResp.fromJS(_data["callback"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RequestOfTiltResp {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'RequestOfTiltResp' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["securityToken"] = this.securityToken;
        data["callback"] = this.callback ? this.callback.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IRequestOfTiltResp extends ITransaction {
    username?: string | undefined;
    securityToken?: string | undefined;
    callback?: ActionOfTiltResp | undefined;
}

export class CctvRequestOfTiltResp extends RequestOfTiltResp implements ICctvRequestOfTiltResp {

    constructor(data?: ICctvRequestOfTiltResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CctvRequestOfTiltResp {
        data = typeof data === 'object' ? data : {};
        let result = new CctvRequestOfTiltResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface ICctvRequestOfTiltResp extends IRequestOfTiltResp {
}

/** Class that represents a tiltReq */
export class TiltReq extends CctvRequestOfTiltResp implements ITiltReq {
    /** Id of the Camera to tilt. */
    id?: Id | undefined;
    /** Object determining how the Camera should be tilted. */
    positioning?: Positioning | undefined;

    constructor(data?: ITiltReq) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            this.positioning = _data["positioning"] ? Positioning.fromJS(_data["positioning"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TiltReq {
        data = typeof data === 'object' ? data : {};
        let result = new TiltReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["positioning"] = this.positioning ? this.positioning.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

/** Class that represents a tiltReq */
export interface ITiltReq extends ICctvRequestOfTiltResp {
    /** Id of the Camera to tilt. */
    id?: Id | undefined;
    /** Object determining how the Camera should be tilted. */
    positioning?: Positioning | undefined;
}

export class ActionOfTiltResp extends MulticastDelegate implements IActionOfTiltResp {

    constructor(data?: IActionOfTiltResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ActionOfTiltResp {
        data = typeof data === 'object' ? data : {};
        let result = new ActionOfTiltResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IActionOfTiltResp extends IMulticastDelegate {
}

export abstract class ResponseOfTiltData extends Transaction implements IResponseOfTiltData {
    securityToken?: string | undefined;
    error?: ErrorDto | undefined;
    data?: TiltData | undefined;
    isErrorResponse!: boolean;

    constructor(data?: IResponseOfTiltData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.securityToken = _data["securityToken"];
            this.error = _data["error"] ? ErrorDto.fromJS(_data["error"]) : <any>undefined;
            this.data = _data["data"] ? TiltData.fromJS(_data["data"]) : <any>undefined;
            this.isErrorResponse = _data["isErrorResponse"];
        }
    }

    static fromJS(data: any): ResponseOfTiltData {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ResponseOfTiltData' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securityToken"] = this.securityToken;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["isErrorResponse"] = this.isErrorResponse;
        super.toJSON(data);
        return data; 
    }
}

export interface IResponseOfTiltData extends ITransaction {
    securityToken?: string | undefined;
    error?: ErrorDto | undefined;
    data?: TiltData | undefined;
    isErrorResponse: boolean;
}

export class CctvResponseOfTiltData extends ResponseOfTiltData implements ICctvResponseOfTiltData {

    constructor(data?: ICctvResponseOfTiltData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CctvResponseOfTiltData {
        data = typeof data === 'object' ? data : {};
        let result = new CctvResponseOfTiltData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface ICctvResponseOfTiltData extends IResponseOfTiltData {
}

/** Class that represents a tiltResp. */
export class TiltResp extends CctvResponseOfTiltData implements ITiltResp {

    constructor(data?: ITiltResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): TiltResp {
        data = typeof data === 'object' ? data : {};
        let result = new TiltResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

/** Class that represents a tiltResp. */
export interface ITiltResp extends ICctvResponseOfTiltData {
}

export class TiltData extends ResponseData implements ITiltData {
    id?: Id | undefined;
    positioning?: Positioning | undefined;

    constructor(data?: ITiltData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            this.positioning = _data["positioning"] ? Positioning.fromJS(_data["positioning"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TiltData {
        data = typeof data === 'object' ? data : {};
        let result = new TiltData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["positioning"] = this.positioning ? this.positioning.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface ITiltData extends IResponseData {
    id?: Id | undefined;
    positioning?: Positioning | undefined;
}

export abstract class RequestOfZoomLensResp extends Transaction implements IRequestOfZoomLensResp {
    username?: string | undefined;
    securityToken?: string | undefined;
    callback?: ActionOfZoomLensResp | undefined;

    constructor(data?: IRequestOfZoomLensResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.username = _data["username"];
            this.securityToken = _data["securityToken"];
            this.callback = _data["callback"] ? ActionOfZoomLensResp.fromJS(_data["callback"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RequestOfZoomLensResp {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'RequestOfZoomLensResp' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["securityToken"] = this.securityToken;
        data["callback"] = this.callback ? this.callback.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IRequestOfZoomLensResp extends ITransaction {
    username?: string | undefined;
    securityToken?: string | undefined;
    callback?: ActionOfZoomLensResp | undefined;
}

export class CctvRequestOfZoomLensResp extends RequestOfZoomLensResp implements ICctvRequestOfZoomLensResp {

    constructor(data?: ICctvRequestOfZoomLensResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CctvRequestOfZoomLensResp {
        data = typeof data === 'object' ? data : {};
        let result = new CctvRequestOfZoomLensResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface ICctvRequestOfZoomLensResp extends IRequestOfZoomLensResp {
}

/** Class that represents a zoomLensReq. */
export class ZoomLensReq extends CctvRequestOfZoomLensResp implements IZoomLensReq {
    /** Id of the Camera to Zoom. */
    id?: Id | undefined;
    /** Object containing information on how the camera should be zoomed. */
    positioning?: ZoomPositioning | undefined;

    constructor(data?: IZoomLensReq) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            this.positioning = _data["positioning"] ? ZoomPositioning.fromJS(_data["positioning"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ZoomLensReq {
        data = typeof data === 'object' ? data : {};
        let result = new ZoomLensReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["positioning"] = this.positioning ? this.positioning.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

/** Class that represents a zoomLensReq. */
export interface IZoomLensReq extends ICctvRequestOfZoomLensResp {
    /** Id of the Camera to Zoom. */
    id?: Id | undefined;
    /** Object containing information on how the camera should be zoomed. */
    positioning?: ZoomPositioning | undefined;
}

/** Class that represents Zoom Positioning. */
export class ZoomPositioning extends XmlBase implements IZoomPositioning {
    /** Position Value that was Received or to be sent.
This object can be an int value or a ModeOfOperation class. */
    positionValue?: any | undefined;
    /** Type of Zoom Position that was received or will be sent. */
    positionType!: ZoomPositionType;
    modeOfOperation?: ModeOfOperation | undefined;
    digitalZoom?: number | undefined;

    constructor(data?: IZoomPositioning) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.positionValue = _data["positionValue"];
            this.positionType = _data["positionType"];
            this.modeOfOperation = _data["modeOfOperation"] ? ModeOfOperation.fromJS(_data["modeOfOperation"]) : <any>undefined;
            this.digitalZoom = _data["digitalZoom"];
        }
    }

    static fromJS(data: any): ZoomPositioning {
        data = typeof data === 'object' ? data : {};
        let result = new ZoomPositioning();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["positionValue"] = this.positionValue;
        data["positionType"] = this.positionType;
        data["modeOfOperation"] = this.modeOfOperation ? this.modeOfOperation.toJSON() : <any>undefined;
        data["digitalZoom"] = this.digitalZoom;
        super.toJSON(data);
        return data; 
    }
}

/** Class that represents Zoom Positioning. */
export interface IZoomPositioning extends IXmlBase {
    /** Position Value that was Received or to be sent.
This object can be an int value or a ModeOfOperation class. */
    positionValue?: any | undefined;
    /** Type of Zoom Position that was received or will be sent. */
    positionType: ZoomPositionType;
    modeOfOperation?: ModeOfOperation | undefined;
    digitalZoom?: number | undefined;
}

/** Type of Zoom Position. */
export enum ZoomPositionType {
    ModeOfOperation = 0,
    DigitalZoom = 1,
}

export class ActionOfZoomLensResp extends MulticastDelegate implements IActionOfZoomLensResp {

    constructor(data?: IActionOfZoomLensResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ActionOfZoomLensResp {
        data = typeof data === 'object' ? data : {};
        let result = new ActionOfZoomLensResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IActionOfZoomLensResp extends IMulticastDelegate {
}

export abstract class ResponseOfZoomLensData extends Transaction implements IResponseOfZoomLensData {
    securityToken?: string | undefined;
    error?: ErrorDto | undefined;
    data?: ZoomLensData | undefined;
    isErrorResponse!: boolean;

    constructor(data?: IResponseOfZoomLensData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.securityToken = _data["securityToken"];
            this.error = _data["error"] ? ErrorDto.fromJS(_data["error"]) : <any>undefined;
            this.data = _data["data"] ? ZoomLensData.fromJS(_data["data"]) : <any>undefined;
            this.isErrorResponse = _data["isErrorResponse"];
        }
    }

    static fromJS(data: any): ResponseOfZoomLensData {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ResponseOfZoomLensData' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securityToken"] = this.securityToken;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["isErrorResponse"] = this.isErrorResponse;
        super.toJSON(data);
        return data; 
    }
}

export interface IResponseOfZoomLensData extends ITransaction {
    securityToken?: string | undefined;
    error?: ErrorDto | undefined;
    data?: ZoomLensData | undefined;
    isErrorResponse: boolean;
}

export class CctvResponseOfZoomLensData extends ResponseOfZoomLensData implements ICctvResponseOfZoomLensData {

    constructor(data?: ICctvResponseOfZoomLensData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CctvResponseOfZoomLensData {
        data = typeof data === 'object' ? data : {};
        let result = new CctvResponseOfZoomLensData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface ICctvResponseOfZoomLensData extends IResponseOfZoomLensData {
}

/** Class that represents a zoomLensResp. */
export class ZoomLensResp extends CctvResponseOfZoomLensData implements IZoomLensResp {

    constructor(data?: IZoomLensResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ZoomLensResp {
        data = typeof data === 'object' ? data : {};
        let result = new ZoomLensResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

/** Class that represents a zoomLensResp. */
export interface IZoomLensResp extends ICctvResponseOfZoomLensData {
}

export class ZoomLensData extends ResponseData implements IZoomLensData {
    id?: Id | undefined;
    positioning?: ZoomPositioning | undefined;

    constructor(data?: IZoomLensData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            this.positioning = _data["positioning"] ? ZoomPositioning.fromJS(_data["positioning"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ZoomLensData {
        data = typeof data === 'object' ? data : {};
        let result = new ZoomLensData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["positioning"] = this.positioning ? this.positioning.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IZoomLensData extends IResponseData {
    id?: Id | undefined;
    positioning?: ZoomPositioning | undefined;
}

export abstract class RequestOfSetOpStatusResp extends Transaction implements IRequestOfSetOpStatusResp {
    username?: string | undefined;
    securityToken?: string | undefined;
    callback?: ActionOfSetOpStatusResp | undefined;

    constructor(data?: IRequestOfSetOpStatusResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.username = _data["username"];
            this.securityToken = _data["securityToken"];
            this.callback = _data["callback"] ? ActionOfSetOpStatusResp.fromJS(_data["callback"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RequestOfSetOpStatusResp {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'RequestOfSetOpStatusResp' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["securityToken"] = this.securityToken;
        data["callback"] = this.callback ? this.callback.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IRequestOfSetOpStatusResp extends ITransaction {
    username?: string | undefined;
    securityToken?: string | undefined;
    callback?: ActionOfSetOpStatusResp | undefined;
}

export class DmsRequestOfSetOpStatusResp extends RequestOfSetOpStatusResp implements IDmsRequestOfSetOpStatusResp {

    constructor(data?: IDmsRequestOfSetOpStatusResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): DmsRequestOfSetOpStatusResp {
        data = typeof data === 'object' ? data : {};
        let result = new DmsRequestOfSetOpStatusResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IDmsRequestOfSetOpStatusResp extends IRequestOfSetOpStatusResp {
}

export class SetOpStatusReq extends DmsRequestOfSetOpStatusResp implements ISetOpStatusReq {
    /** Identifier of the DMS for which to set the operational status */
    id?: Id | undefined;
    /** Operational status of the device (1 = Active; 2 = Failed; 3 = Error; 4 = OutOfService) */
    opStatusInt!: number;
    /** Enum accessible variant of op status, handling DMS order flip */
    opStatus!: OpStatus;

    constructor(data?: ISetOpStatusReq) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            this.opStatusInt = _data["opStatusInt"];
            this.opStatus = _data["opStatus"];
        }
    }

    static fromJS(data: any): SetOpStatusReq {
        data = typeof data === 'object' ? data : {};
        let result = new SetOpStatusReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["opStatusInt"] = this.opStatusInt;
        data["opStatus"] = this.opStatus;
        super.toJSON(data);
        return data; 
    }
}

export interface ISetOpStatusReq extends IDmsRequestOfSetOpStatusResp {
    /** Identifier of the DMS for which to set the operational status */
    id?: Id | undefined;
    /** Operational status of the device (1 = Active; 2 = Failed; 3 = Error; 4 = OutOfService) */
    opStatusInt: number;
    /** Enum accessible variant of op status, handling DMS order flip */
    opStatus: OpStatus;
}

export class ActionOfSetOpStatusResp extends MulticastDelegate implements IActionOfSetOpStatusResp {

    constructor(data?: IActionOfSetOpStatusResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ActionOfSetOpStatusResp {
        data = typeof data === 'object' ? data : {};
        let result = new ActionOfSetOpStatusResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IActionOfSetOpStatusResp extends IMulticastDelegate {
}

export abstract class ResponseOfOpStatusData extends Transaction implements IResponseOfOpStatusData {
    securityToken?: string | undefined;
    error?: ErrorDto | undefined;
    data?: OpStatusData | undefined;
    isErrorResponse!: boolean;

    constructor(data?: IResponseOfOpStatusData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.securityToken = _data["securityToken"];
            this.error = _data["error"] ? ErrorDto.fromJS(_data["error"]) : <any>undefined;
            this.data = _data["data"] ? OpStatusData.fromJS(_data["data"]) : <any>undefined;
            this.isErrorResponse = _data["isErrorResponse"];
        }
    }

    static fromJS(data: any): ResponseOfOpStatusData {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ResponseOfOpStatusData' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securityToken"] = this.securityToken;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["isErrorResponse"] = this.isErrorResponse;
        super.toJSON(data);
        return data; 
    }
}

export interface IResponseOfOpStatusData extends ITransaction {
    securityToken?: string | undefined;
    error?: ErrorDto | undefined;
    data?: OpStatusData | undefined;
    isErrorResponse: boolean;
}

export class DmsResponseOfOpStatusData extends ResponseOfOpStatusData implements IDmsResponseOfOpStatusData {

    constructor(data?: IDmsResponseOfOpStatusData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): DmsResponseOfOpStatusData {
        data = typeof data === 'object' ? data : {};
        let result = new DmsResponseOfOpStatusData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IDmsResponseOfOpStatusData extends IResponseOfOpStatusData {
}

export class SetOpStatusResp extends DmsResponseOfOpStatusData implements ISetOpStatusResp {

    constructor(data?: ISetOpStatusResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SetOpStatusResp {
        data = typeof data === 'object' ? data : {};
        let result = new SetOpStatusResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface ISetOpStatusResp extends IDmsResponseOfOpStatusData {
}

export class OpStatusData extends ResponseData implements IOpStatusData {
    /** The identifier of the DMS */
    id?: Id | undefined;
    /** Operational status of the device (1 = Active; 2 = Failed; 3 = Error; 4  = OutofService) */
    opStatusInt!: number;
    /** Friendly accessor to Op Status value */
    opStatus!: OpStatus;

    constructor(data?: IOpStatusData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            this.opStatusInt = _data["opStatusInt"];
            this.opStatus = _data["opStatus"];
        }
    }

    static fromJS(data: any): OpStatusData {
        data = typeof data === 'object' ? data : {};
        let result = new OpStatusData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["opStatusInt"] = this.opStatusInt;
        data["opStatus"] = this.opStatus;
        super.toJSON(data);
        return data; 
    }
}

export interface IOpStatusData extends IResponseData {
    /** The identifier of the DMS */
    id?: Id | undefined;
    /** Operational status of the device (1 = Active; 2 = Failed; 3 = Error; 4  = OutofService) */
    opStatusInt: number;
    /** Friendly accessor to Op Status value */
    opStatus: OpStatus;
}

export abstract class RequestOfAddMsgResp extends Transaction implements IRequestOfAddMsgResp {
    username?: string | undefined;
    securityToken?: string | undefined;
    callback?: ActionOfAddMsgResp | undefined;

    constructor(data?: IRequestOfAddMsgResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.username = _data["username"];
            this.securityToken = _data["securityToken"];
            this.callback = _data["callback"] ? ActionOfAddMsgResp.fromJS(_data["callback"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RequestOfAddMsgResp {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'RequestOfAddMsgResp' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["securityToken"] = this.securityToken;
        data["callback"] = this.callback ? this.callback.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IRequestOfAddMsgResp extends ITransaction {
    username?: string | undefined;
    securityToken?: string | undefined;
    callback?: ActionOfAddMsgResp | undefined;
}

export class MasRequestOfAddMsgResp extends RequestOfAddMsgResp implements IMasRequestOfAddMsgResp {

    constructor(data?: IMasRequestOfAddMsgResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): MasRequestOfAddMsgResp {
        data = typeof data === 'object' ? data : {};
        let result = new MasRequestOfAddMsgResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IMasRequestOfAddMsgResp extends IRequestOfAddMsgResp {
}

/** Request to add a message to a device's queue. */
export class AddMsgReq extends MasRequestOfAddMsgResp implements IAddMsgReq {
    /** Identifier of the device. */
    id?: Id | undefined;
    /** Message to be sent to the device. Only used for XML generation; use the
appropriately typed getter/setter instead */
    deviceMsg?: DeviceMsg | undefined;
    /** The type of Device Message either received or sent. */
    msgChoice!: DeviceMsgChoice;
    /** Identifier of the event this message is related to, if applicable. */
    eventId?: IdWrapper | undefined;
    /** The center identifier for the sending party. */
    centerId?: string | undefined;
    /** Indicates whether this message may be taken as the first message
and auto-merged with any other message that has AutoMergeSecondary
set. */
    autoMergePrimary!: boolean;
    /** Indicates whether this message may be taken as the second message
and auto-merged with any other message that has AutoMergePrimary
set. */
    autoMergeSecondary!: boolean;
    /** Beacon message to be sent to the device. */
    beaconMsg?: BeaconMsg | undefined;
    /** HAR message to be sent to the device. */
    harMsg?: HarMsg | undefined;
    /** DMS message to be sent to the device. */
    multiMsg?: MultiMsg | undefined;

    constructor(data?: IAddMsgReq) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            this.deviceMsg = _data["deviceMsg"] ? DeviceMsg.fromJS(_data["deviceMsg"]) : <any>undefined;
            this.msgChoice = _data["msgChoice"];
            this.eventId = _data["eventId"] ? IdWrapper.fromJS(_data["eventId"]) : <any>undefined;
            this.centerId = _data["centerId"];
            this.autoMergePrimary = _data["autoMergePrimary"];
            this.autoMergeSecondary = _data["autoMergeSecondary"];
            this.beaconMsg = _data["beaconMsg"] ? BeaconMsg.fromJS(_data["beaconMsg"]) : <any>undefined;
            this.harMsg = _data["harMsg"] ? HarMsg.fromJS(_data["harMsg"]) : <any>undefined;
            this.multiMsg = _data["multiMsg"] ? MultiMsg.fromJS(_data["multiMsg"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddMsgReq {
        data = typeof data === 'object' ? data : {};
        let result = new AddMsgReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["deviceMsg"] = this.deviceMsg ? this.deviceMsg.toJSON() : <any>undefined;
        data["msgChoice"] = this.msgChoice;
        data["eventId"] = this.eventId ? this.eventId.toJSON() : <any>undefined;
        data["centerId"] = this.centerId;
        data["autoMergePrimary"] = this.autoMergePrimary;
        data["autoMergeSecondary"] = this.autoMergeSecondary;
        data["beaconMsg"] = this.beaconMsg ? this.beaconMsg.toJSON() : <any>undefined;
        data["harMsg"] = this.harMsg ? this.harMsg.toJSON() : <any>undefined;
        data["multiMsg"] = this.multiMsg ? this.multiMsg.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

/** Request to add a message to a device's queue. */
export interface IAddMsgReq extends IMasRequestOfAddMsgResp {
    /** Identifier of the device. */
    id?: Id | undefined;
    /** Message to be sent to the device. Only used for XML generation; use the
appropriately typed getter/setter instead */
    deviceMsg?: DeviceMsg | undefined;
    /** The type of Device Message either received or sent. */
    msgChoice: DeviceMsgChoice;
    /** Identifier of the event this message is related to, if applicable. */
    eventId?: IdWrapper | undefined;
    /** The center identifier for the sending party. */
    centerId?: string | undefined;
    /** Indicates whether this message may be taken as the first message
and auto-merged with any other message that has AutoMergeSecondary
set. */
    autoMergePrimary: boolean;
    /** Indicates whether this message may be taken as the second message
and auto-merged with any other message that has AutoMergePrimary
set. */
    autoMergeSecondary: boolean;
    /** Beacon message to be sent to the device. */
    beaconMsg?: BeaconMsg | undefined;
    /** HAR message to be sent to the device. */
    harMsg?: HarMsg | undefined;
    /** DMS message to be sent to the device. */
    multiMsg?: MultiMsg | undefined;
}

/** Message information for sending to a device, must be instantiated by any types of devices to which messages should be sent. */
export abstract class DeviceMsg extends XmlBase implements IDeviceMsg {

    protected _discriminator: string;

    constructor(data?: IDeviceMsg) {
        super(data);
        this._discriminator = "DeviceMsg";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): DeviceMsg {
        data = typeof data === 'object' ? data : {};
        if (data["DeviceMsg"] === "BeaconMsg") {
            let result = new BeaconMsg();
            result.init(data);
            return result;
        }
        if (data["DeviceMsg"] === "HarMsg") {
            let result = new HarMsg();
            result.init(data);
            return result;
        }
        if (data["DeviceMsg"] === "MultiMsg") {
            let result = new MultiMsg();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'DeviceMsg' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DeviceMsg"] = this._discriminator; 
        super.toJSON(data);
        return data; 
    }
}

/** Message information for sending to a device, must be instantiated by any types of devices to which messages should be sent. */
export interface IDeviceMsg extends IXmlBase {
}

/** Stores the HAR message information for a HAR device. */
export class HarMsg extends DeviceMsg implements IHarMsg {
    /** The text of the Message. */
    msgText?: string | undefined;
    /** The owner of the Message. */
    msgOwner?: string | undefined;
    msgDurationInSeconds!: number;
    beaconState!: Beacon_state;
    msgPriority!: number;

    constructor(data?: IHarMsg) {
        super(data);
        this._discriminator = "HarMsg";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.msgText = _data["msgText"];
            this.msgOwner = _data["msgOwner"];
            this.msgDurationInSeconds = _data["msgDurationInSeconds"];
            this.beaconState = _data["beaconState"];
            this.msgPriority = _data["msgPriority"];
        }
    }

    static fromJS(data: any): HarMsg {
        data = typeof data === 'object' ? data : {};
        let result = new HarMsg();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["msgText"] = this.msgText;
        data["msgOwner"] = this.msgOwner;
        data["msgDurationInSeconds"] = this.msgDurationInSeconds;
        data["beaconState"] = this.beaconState;
        data["msgPriority"] = this.msgPriority;
        super.toJSON(data);
        return data; 
    }
}

/** Stores the HAR message information for a HAR device. */
export interface IHarMsg extends IDeviceMsg {
    /** The text of the Message. */
    msgText?: string | undefined;
    /** The owner of the Message. */
    msgOwner?: string | undefined;
    msgDurationInSeconds: number;
    beaconState: Beacon_state;
    msgPriority: number;
}

/** Enum value for the beacon state */
export enum Beacon_state {
    On = 0,
    Off = 1,
}

/** Stores the dms message information for a dms device. */
export class MultiMsg extends DeviceMsg implements IMultiMsg {
    /** The text of the message. */
    msgText?: string | undefined;
    /** The owner of the message. */
    msgOwner?: string | undefined;
    /** Priority of the message. */
    msgPriority!: number;
    /** The duration of this message, in seconds. */
    msgDurationInSeconds!: number;
    /** Specifies whether or not the beacons are active on this device */
    beaconsEnabled!: boolean;
    /** Specifies whether or not the beacons are active on this device */
    pixelServiceEnabled!: boolean;
    /** Id of the event this message belongs to, if any. */
    eventId?: IdWrapper | undefined;
    /** Indicates whether or not to send the multi-text without any additional formatting or processing. */
    sendAsIs?: boolean | undefined;
    sendAsIsSpecified!: boolean;

    constructor(data?: IMultiMsg) {
        super(data);
        this._discriminator = "MultiMsg";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.msgText = _data["msgText"];
            this.msgOwner = _data["msgOwner"];
            this.msgPriority = _data["msgPriority"];
            this.msgDurationInSeconds = _data["msgDurationInSeconds"];
            this.beaconsEnabled = _data["beaconsEnabled"];
            this.pixelServiceEnabled = _data["pixelServiceEnabled"];
            this.eventId = _data["eventId"] ? IdWrapper.fromJS(_data["eventId"]) : <any>undefined;
            this.sendAsIs = _data["sendAsIs"];
            this.sendAsIsSpecified = _data["sendAsIsSpecified"];
        }
    }

    static fromJS(data: any): MultiMsg {
        data = typeof data === 'object' ? data : {};
        let result = new MultiMsg();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["msgText"] = this.msgText;
        data["msgOwner"] = this.msgOwner;
        data["msgPriority"] = this.msgPriority;
        data["msgDurationInSeconds"] = this.msgDurationInSeconds;
        data["beaconsEnabled"] = this.beaconsEnabled;
        data["pixelServiceEnabled"] = this.pixelServiceEnabled;
        data["eventId"] = this.eventId ? this.eventId.toJSON() : <any>undefined;
        data["sendAsIs"] = this.sendAsIs;
        data["sendAsIsSpecified"] = this.sendAsIsSpecified;
        super.toJSON(data);
        return data; 
    }
}

/** Stores the dms message information for a dms device. */
export interface IMultiMsg extends IDeviceMsg {
    /** The text of the message. */
    msgText?: string | undefined;
    /** The owner of the message. */
    msgOwner?: string | undefined;
    /** Priority of the message. */
    msgPriority: number;
    /** The duration of this message, in seconds. */
    msgDurationInSeconds: number;
    /** Specifies whether or not the beacons are active on this device */
    beaconsEnabled: boolean;
    /** Specifies whether or not the beacons are active on this device */
    pixelServiceEnabled: boolean;
    /** Id of the event this message belongs to, if any. */
    eventId?: IdWrapper | undefined;
    /** Indicates whether or not to send the multi-text without any additional formatting or processing. */
    sendAsIs?: boolean | undefined;
    sendAsIsSpecified: boolean;
}

export class IdWrapper extends XmlObject implements IIdWrapper {
    /** Gets or sets the ID. */
    id!: Id;

    constructor(data?: IIdWrapper) {
        super(data);
        if (!data) {
            this.id = new Id();
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : new Id();
        }
    }

    static fromJS(data: any): IdWrapper {
        data = typeof data === 'object' ? data : {};
        let result = new IdWrapper();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IIdWrapper extends IXmlObject {
    /** Gets or sets the ID. */
    id: Id;
}

/** A class representing the XML of a request to MAS for a beacon. */
export class BeaconMsg extends DeviceMsg implements IBeaconMsg {
    /** The text of the message */
    msgText?: string | undefined;
    /** Gets or sets the owner. */
    msgOwner?: string | undefined;
    /** Gets or sets the duration of the messsage. */
    msgDurationInSeconds!: number;
    /** Gets or sets the state of the beacon. */
    beaconState!: BeaconState;
    /** Gets the state of the beacon, as text. */
    beaconStateStr?: string | undefined;
    /** Gets or sets the priority. */
    msgPriority!: number;
    /** Gets or sets the event identifier. */
    eventId?: IdWrapper | undefined;

    constructor(data?: IBeaconMsg) {
        super(data);
        this._discriminator = "BeaconMsg";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.msgText = _data["msgText"];
            this.msgOwner = _data["msgOwner"];
            this.msgDurationInSeconds = _data["msgDurationInSeconds"];
            this.beaconState = _data["beaconState"];
            this.beaconStateStr = _data["beaconStateStr"];
            this.msgPriority = _data["msgPriority"];
            this.eventId = _data["eventId"] ? IdWrapper.fromJS(_data["eventId"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BeaconMsg {
        data = typeof data === 'object' ? data : {};
        let result = new BeaconMsg();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["msgText"] = this.msgText;
        data["msgOwner"] = this.msgOwner;
        data["msgDurationInSeconds"] = this.msgDurationInSeconds;
        data["beaconState"] = this.beaconState;
        data["beaconStateStr"] = this.beaconStateStr;
        data["msgPriority"] = this.msgPriority;
        data["eventId"] = this.eventId ? this.eventId.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

/** A class representing the XML of a request to MAS for a beacon. */
export interface IBeaconMsg extends IDeviceMsg {
    /** The text of the message */
    msgText?: string | undefined;
    /** Gets or sets the owner. */
    msgOwner?: string | undefined;
    /** Gets or sets the duration of the messsage. */
    msgDurationInSeconds: number;
    /** Gets or sets the state of the beacon. */
    beaconState: BeaconState;
    /** Gets the state of the beacon, as text. */
    beaconStateStr?: string | undefined;
    /** Gets or sets the priority. */
    msgPriority: number;
    /** Gets or sets the event identifier. */
    eventId?: IdWrapper | undefined;
}

/** A list of values representing the various states a beacon can be in. */
export enum BeaconState {
    Off = 0,
    On = 1,
}

export enum DeviceMsgChoice {
    HarMsg = 0,
    MultiMsg = 1,
    BeaconMsg = 2,
}

export class ActionOfAddMsgResp extends MulticastDelegate implements IActionOfAddMsgResp {

    constructor(data?: IActionOfAddMsgResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ActionOfAddMsgResp {
        data = typeof data === 'object' ? data : {};
        let result = new ActionOfAddMsgResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IActionOfAddMsgResp extends IMulticastDelegate {
}

export abstract class ResponseOfAddMsgData extends Transaction implements IResponseOfAddMsgData {
    securityToken?: string | undefined;
    error?: ErrorDto | undefined;
    data?: AddMsgData | undefined;
    isErrorResponse!: boolean;

    constructor(data?: IResponseOfAddMsgData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.securityToken = _data["securityToken"];
            this.error = _data["error"] ? ErrorDto.fromJS(_data["error"]) : <any>undefined;
            this.data = _data["data"] ? AddMsgData.fromJS(_data["data"]) : <any>undefined;
            this.isErrorResponse = _data["isErrorResponse"];
        }
    }

    static fromJS(data: any): ResponseOfAddMsgData {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ResponseOfAddMsgData' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securityToken"] = this.securityToken;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["isErrorResponse"] = this.isErrorResponse;
        super.toJSON(data);
        return data; 
    }
}

export interface IResponseOfAddMsgData extends ITransaction {
    securityToken?: string | undefined;
    error?: ErrorDto | undefined;
    data?: AddMsgData | undefined;
    isErrorResponse: boolean;
}

export class MasResponseOfAddMsgData extends ResponseOfAddMsgData implements IMasResponseOfAddMsgData {

    constructor(data?: IMasResponseOfAddMsgData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): MasResponseOfAddMsgData {
        data = typeof data === 'object' ? data : {};
        let result = new MasResponseOfAddMsgData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IMasResponseOfAddMsgData extends IResponseOfAddMsgData {
}

/** Response data containing the message added to a device's queue. */
export class AddMsgResp extends MasResponseOfAddMsgData implements IAddMsgResp {

    constructor(data?: IAddMsgResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): AddMsgResp {
        data = typeof data === 'object' ? data : {};
        let result = new AddMsgResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

/** Response data containing the message added to a device's queue. */
export interface IAddMsgResp extends IMasResponseOfAddMsgData {
}

/** Response data containing the message added to a device's queue. */
export class AddMsgData extends ResponseData implements IAddMsgData {
    /** Identifier of the device the message was sent to. */
    id?: Id | undefined;
    /** Identifier of the message that was sent. */
    msgId?: MsgId | undefined;

    constructor(data?: IAddMsgData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            this.msgId = _data["msgId"] ? MsgId.fromJS(_data["msgId"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddMsgData {
        data = typeof data === 'object' ? data : {};
        let result = new AddMsgData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["msgId"] = this.msgId ? this.msgId.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

/** Response data containing the message added to a device's queue. */
export interface IAddMsgData extends IResponseData {
    /** Identifier of the device the message was sent to. */
    id?: Id | undefined;
    /** Identifier of the message that was sent. */
    msgId?: MsgId | undefined;
}

/** Message identifier is unique for a device.  This id is used to uniquely identify a particular message in a device's queue for terminating, changing priority, etc. */
export class MsgId extends XmlBase implements IMsgId {
    /** The priority of this message--valid values are from 1-256 with 1 being the highest priority.  This is required to be set for any new message. */
    priority?: number | undefined;
    /** The position of this message at its priority level.  Used when more than one message is at a particular priority level. */
    position?: number | undefined;
    /** Message identifier is unique for a device.  This id is used to uniquely identify a particular message in a device's queue for terminating, changing priority, etc. */
    id?: string | undefined;

    constructor(data?: IMsgId) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.priority = _data["priority"];
            this.position = _data["position"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MsgId {
        data = typeof data === 'object' ? data : {};
        let result = new MsgId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["priority"] = this.priority;
        data["position"] = this.position;
        data["id"] = this.id;
        super.toJSON(data);
        return data; 
    }
}

/** Message identifier is unique for a device.  This id is used to uniquely identify a particular message in a device's queue for terminating, changing priority, etc. */
export interface IMsgId extends IXmlBase {
    /** The priority of this message--valid values are from 1-256 with 1 being the highest priority.  This is required to be set for any new message. */
    priority?: number | undefined;
    /** The position of this message at its priority level.  Used when more than one message is at a particular priority level. */
    position?: number | undefined;
    /** Message identifier is unique for a device.  This id is used to uniquely identify a particular message in a device's queue for terminating, changing priority, etc. */
    id?: string | undefined;
}

export abstract class RequestOfChangeMsgPriorityResp extends Transaction implements IRequestOfChangeMsgPriorityResp {
    username?: string | undefined;
    securityToken?: string | undefined;
    callback?: ActionOfChangeMsgPriorityResp | undefined;

    constructor(data?: IRequestOfChangeMsgPriorityResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.username = _data["username"];
            this.securityToken = _data["securityToken"];
            this.callback = _data["callback"] ? ActionOfChangeMsgPriorityResp.fromJS(_data["callback"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RequestOfChangeMsgPriorityResp {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'RequestOfChangeMsgPriorityResp' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["securityToken"] = this.securityToken;
        data["callback"] = this.callback ? this.callback.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IRequestOfChangeMsgPriorityResp extends ITransaction {
    username?: string | undefined;
    securityToken?: string | undefined;
    callback?: ActionOfChangeMsgPriorityResp | undefined;
}

export class MasRequestOfChangeMsgPriorityResp extends RequestOfChangeMsgPriorityResp implements IMasRequestOfChangeMsgPriorityResp {

    constructor(data?: IMasRequestOfChangeMsgPriorityResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): MasRequestOfChangeMsgPriorityResp {
        data = typeof data === 'object' ? data : {};
        let result = new MasRequestOfChangeMsgPriorityResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IMasRequestOfChangeMsgPriorityResp extends IRequestOfChangeMsgPriorityResp {
}

/** Request to change the priority of a message for a device. */
export class ChangeMsgPriorityReq extends MasRequestOfChangeMsgPriorityResp implements IChangeMsgPriorityReq {
    /** Identifier of the device to change message priority for. */
    id?: Id | undefined;
    /** Message identifier with new priority. */
    msgId?: MsgId | undefined;

    constructor(data?: IChangeMsgPriorityReq) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            this.msgId = _data["msgId"] ? MsgId.fromJS(_data["msgId"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ChangeMsgPriorityReq {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeMsgPriorityReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["msgId"] = this.msgId ? this.msgId.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

/** Request to change the priority of a message for a device. */
export interface IChangeMsgPriorityReq extends IMasRequestOfChangeMsgPriorityResp {
    /** Identifier of the device to change message priority for. */
    id?: Id | undefined;
    /** Message identifier with new priority. */
    msgId?: MsgId | undefined;
}

export class ActionOfChangeMsgPriorityResp extends MulticastDelegate implements IActionOfChangeMsgPriorityResp {

    constructor(data?: IActionOfChangeMsgPriorityResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ActionOfChangeMsgPriorityResp {
        data = typeof data === 'object' ? data : {};
        let result = new ActionOfChangeMsgPriorityResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IActionOfChangeMsgPriorityResp extends IMulticastDelegate {
}

export abstract class ResponseOfChangeMsgPriorityData extends Transaction implements IResponseOfChangeMsgPriorityData {
    securityToken?: string | undefined;
    error?: ErrorDto | undefined;
    data?: ChangeMsgPriorityData | undefined;
    isErrorResponse!: boolean;

    constructor(data?: IResponseOfChangeMsgPriorityData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.securityToken = _data["securityToken"];
            this.error = _data["error"] ? ErrorDto.fromJS(_data["error"]) : <any>undefined;
            this.data = _data["data"] ? ChangeMsgPriorityData.fromJS(_data["data"]) : <any>undefined;
            this.isErrorResponse = _data["isErrorResponse"];
        }
    }

    static fromJS(data: any): ResponseOfChangeMsgPriorityData {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ResponseOfChangeMsgPriorityData' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securityToken"] = this.securityToken;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["isErrorResponse"] = this.isErrorResponse;
        super.toJSON(data);
        return data; 
    }
}

export interface IResponseOfChangeMsgPriorityData extends ITransaction {
    securityToken?: string | undefined;
    error?: ErrorDto | undefined;
    data?: ChangeMsgPriorityData | undefined;
    isErrorResponse: boolean;
}

export class MasResponseOfChangeMsgPriorityData extends ResponseOfChangeMsgPriorityData implements IMasResponseOfChangeMsgPriorityData {

    constructor(data?: IMasResponseOfChangeMsgPriorityData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): MasResponseOfChangeMsgPriorityData {
        data = typeof data === 'object' ? data : {};
        let result = new MasResponseOfChangeMsgPriorityData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IMasResponseOfChangeMsgPriorityData extends IResponseOfChangeMsgPriorityData {
}

/** Response containing the message whose priority was modified. */
export class ChangeMsgPriorityResp extends MasResponseOfChangeMsgPriorityData implements IChangeMsgPriorityResp {

    constructor(data?: IChangeMsgPriorityResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ChangeMsgPriorityResp {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeMsgPriorityResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

/** Response containing the message whose priority was modified. */
export interface IChangeMsgPriorityResp extends IMasResponseOfChangeMsgPriorityData {
}

/** Response data containing the message whose priority was modified. */
export class ChangeMsgPriorityData extends ResponseData implements IChangeMsgPriorityData {
    /** Identifier of the device the message belongs to. */
    id?: Id | undefined;
    /** Identifier of the message whose priority was changed. */
    msgId?: MsgId | undefined;

    constructor(data?: IChangeMsgPriorityData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            this.msgId = _data["msgId"] ? MsgId.fromJS(_data["msgId"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ChangeMsgPriorityData {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeMsgPriorityData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["msgId"] = this.msgId ? this.msgId.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

/** Response data containing the message whose priority was modified. */
export interface IChangeMsgPriorityData extends IResponseData {
    /** Identifier of the device the message belongs to. */
    id?: Id | undefined;
    /** Identifier of the message whose priority was changed. */
    msgId?: MsgId | undefined;
}

export abstract class RequestOfModifyMsgResp extends Transaction implements IRequestOfModifyMsgResp {
    username?: string | undefined;
    securityToken?: string | undefined;
    callback?: ActionOfModifyMsgResp | undefined;

    constructor(data?: IRequestOfModifyMsgResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.username = _data["username"];
            this.securityToken = _data["securityToken"];
            this.callback = _data["callback"] ? ActionOfModifyMsgResp.fromJS(_data["callback"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RequestOfModifyMsgResp {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'RequestOfModifyMsgResp' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["securityToken"] = this.securityToken;
        data["callback"] = this.callback ? this.callback.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IRequestOfModifyMsgResp extends ITransaction {
    username?: string | undefined;
    securityToken?: string | undefined;
    callback?: ActionOfModifyMsgResp | undefined;
}

export class MasRequestOfModifyMsgResp extends RequestOfModifyMsgResp implements IMasRequestOfModifyMsgResp {

    constructor(data?: IMasRequestOfModifyMsgResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): MasRequestOfModifyMsgResp {
        data = typeof data === 'object' ? data : {};
        let result = new MasRequestOfModifyMsgResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IMasRequestOfModifyMsgResp extends IRequestOfModifyMsgResp {
}

/** Request to modify a message in a device's queue. */
export class ModifyMsgReq extends MasRequestOfModifyMsgResp implements IModifyMsgReq {
    /** Identifier of the device. */
    id?: Id | undefined;
    /** Message identifier of the message to modify */
    msgId?: MsgId | undefined;
    /** Message to be sent to the device. Only used for XML generation; use the
appropriately typed getter/setter instead */
    deviceMsg?: DeviceMsg | undefined;
    /** Gets or sets the center identifier for the sending party. */
    centerId?: string | undefined;
    /** Indicates whether this message may be taken as the first message
and auto-merged with any other message that has AutoMergeSecondary
set. */
    autoMergePrimary!: boolean;
    /** Indicates whether this message may be taken as the second message
and auto-merged with any other message that has AutoMergePrimary
set. */
    autoMergeSecondary!: boolean;
    /** The type of Device Message either received or sent. */
    msgChoice!: DeviceMsgChoice;
    /** HAR message to be sent to the device. */
    beaconMsg?: BeaconMsg | undefined;
    /** HAR message to be sent to the device. */
    harMsg?: HarMsg | undefined;
    /** DMS message to be sent to the device. */
    multiMsg?: MultiMsg | undefined;

    constructor(data?: IModifyMsgReq) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            this.msgId = _data["msgId"] ? MsgId.fromJS(_data["msgId"]) : <any>undefined;
            this.deviceMsg = _data["deviceMsg"] ? DeviceMsg.fromJS(_data["deviceMsg"]) : <any>undefined;
            this.centerId = _data["centerId"];
            this.autoMergePrimary = _data["autoMergePrimary"];
            this.autoMergeSecondary = _data["autoMergeSecondary"];
            this.msgChoice = _data["msgChoice"];
            this.beaconMsg = _data["beaconMsg"] ? BeaconMsg.fromJS(_data["beaconMsg"]) : <any>undefined;
            this.harMsg = _data["harMsg"] ? HarMsg.fromJS(_data["harMsg"]) : <any>undefined;
            this.multiMsg = _data["multiMsg"] ? MultiMsg.fromJS(_data["multiMsg"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ModifyMsgReq {
        data = typeof data === 'object' ? data : {};
        let result = new ModifyMsgReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["msgId"] = this.msgId ? this.msgId.toJSON() : <any>undefined;
        data["deviceMsg"] = this.deviceMsg ? this.deviceMsg.toJSON() : <any>undefined;
        data["centerId"] = this.centerId;
        data["autoMergePrimary"] = this.autoMergePrimary;
        data["autoMergeSecondary"] = this.autoMergeSecondary;
        data["msgChoice"] = this.msgChoice;
        data["beaconMsg"] = this.beaconMsg ? this.beaconMsg.toJSON() : <any>undefined;
        data["harMsg"] = this.harMsg ? this.harMsg.toJSON() : <any>undefined;
        data["multiMsg"] = this.multiMsg ? this.multiMsg.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

/** Request to modify a message in a device's queue. */
export interface IModifyMsgReq extends IMasRequestOfModifyMsgResp {
    /** Identifier of the device. */
    id?: Id | undefined;
    /** Message identifier of the message to modify */
    msgId?: MsgId | undefined;
    /** Message to be sent to the device. Only used for XML generation; use the
appropriately typed getter/setter instead */
    deviceMsg?: DeviceMsg | undefined;
    /** Gets or sets the center identifier for the sending party. */
    centerId?: string | undefined;
    /** Indicates whether this message may be taken as the first message
and auto-merged with any other message that has AutoMergeSecondary
set. */
    autoMergePrimary: boolean;
    /** Indicates whether this message may be taken as the second message
and auto-merged with any other message that has AutoMergePrimary
set. */
    autoMergeSecondary: boolean;
    /** The type of Device Message either received or sent. */
    msgChoice: DeviceMsgChoice;
    /** HAR message to be sent to the device. */
    beaconMsg?: BeaconMsg | undefined;
    /** HAR message to be sent to the device. */
    harMsg?: HarMsg | undefined;
    /** DMS message to be sent to the device. */
    multiMsg?: MultiMsg | undefined;
}

export class ActionOfModifyMsgResp extends MulticastDelegate implements IActionOfModifyMsgResp {

    constructor(data?: IActionOfModifyMsgResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ActionOfModifyMsgResp {
        data = typeof data === 'object' ? data : {};
        let result = new ActionOfModifyMsgResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IActionOfModifyMsgResp extends IMulticastDelegate {
}

export abstract class ResponseOfModifyMsgData extends Transaction implements IResponseOfModifyMsgData {
    securityToken?: string | undefined;
    error?: ErrorDto | undefined;
    data?: ModifyMsgData | undefined;
    isErrorResponse!: boolean;

    constructor(data?: IResponseOfModifyMsgData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.securityToken = _data["securityToken"];
            this.error = _data["error"] ? ErrorDto.fromJS(_data["error"]) : <any>undefined;
            this.data = _data["data"] ? ModifyMsgData.fromJS(_data["data"]) : <any>undefined;
            this.isErrorResponse = _data["isErrorResponse"];
        }
    }

    static fromJS(data: any): ResponseOfModifyMsgData {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ResponseOfModifyMsgData' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securityToken"] = this.securityToken;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["isErrorResponse"] = this.isErrorResponse;
        super.toJSON(data);
        return data; 
    }
}

export interface IResponseOfModifyMsgData extends ITransaction {
    securityToken?: string | undefined;
    error?: ErrorDto | undefined;
    data?: ModifyMsgData | undefined;
    isErrorResponse: boolean;
}

export class MasResponseOfModifyMsgData extends ResponseOfModifyMsgData implements IMasResponseOfModifyMsgData {

    constructor(data?: IMasResponseOfModifyMsgData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): MasResponseOfModifyMsgData {
        data = typeof data === 'object' ? data : {};
        let result = new MasResponseOfModifyMsgData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IMasResponseOfModifyMsgData extends IResponseOfModifyMsgData {
}

/** Response containing the message to be modified in a device's queue. */
export class ModifyMsgResp extends MasResponseOfModifyMsgData implements IModifyMsgResp {

    constructor(data?: IModifyMsgResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ModifyMsgResp {
        data = typeof data === 'object' ? data : {};
        let result = new ModifyMsgResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

/** Response containing the message to be modified in a device's queue. */
export interface IModifyMsgResp extends IMasResponseOfModifyMsgData {
}

/** Response data containing the message to be modified in a device's queue. */
export class ModifyMsgData extends ResponseData implements IModifyMsgData {
    /** Identifier of the device to which the message was sent. */
    id?: Id | undefined;
    /** Message identifier unique to the device. */
    msgId?: MsgId | undefined;

    constructor(data?: IModifyMsgData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            this.msgId = _data["msgId"] ? MsgId.fromJS(_data["msgId"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ModifyMsgData {
        data = typeof data === 'object' ? data : {};
        let result = new ModifyMsgData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["msgId"] = this.msgId ? this.msgId.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

/** Response data containing the message to be modified in a device's queue. */
export interface IModifyMsgData extends IResponseData {
    /** Identifier of the device to which the message was sent. */
    id?: Id | undefined;
    /** Message identifier unique to the device. */
    msgId?: MsgId | undefined;
}

export abstract class RequestOfRemoveMsgResp extends Transaction implements IRequestOfRemoveMsgResp {
    username?: string | undefined;
    securityToken?: string | undefined;
    callback?: ActionOfRemoveMsgResp | undefined;

    constructor(data?: IRequestOfRemoveMsgResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.username = _data["username"];
            this.securityToken = _data["securityToken"];
            this.callback = _data["callback"] ? ActionOfRemoveMsgResp.fromJS(_data["callback"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RequestOfRemoveMsgResp {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'RequestOfRemoveMsgResp' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["securityToken"] = this.securityToken;
        data["callback"] = this.callback ? this.callback.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IRequestOfRemoveMsgResp extends ITransaction {
    username?: string | undefined;
    securityToken?: string | undefined;
    callback?: ActionOfRemoveMsgResp | undefined;
}

export class MasRequestOfRemoveMsgResp extends RequestOfRemoveMsgResp implements IMasRequestOfRemoveMsgResp {

    constructor(data?: IMasRequestOfRemoveMsgResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): MasRequestOfRemoveMsgResp {
        data = typeof data === 'object' ? data : {};
        let result = new MasRequestOfRemoveMsgResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IMasRequestOfRemoveMsgResp extends IRequestOfRemoveMsgResp {
}

/** Request to remove a message from a device's queue. */
export class RemoveMsgReq extends MasRequestOfRemoveMsgResp implements IRemoveMsgReq {
    /** Identifier of the device to remove a message from. */
    id?: Id | undefined;
    /** Identifier of the message to remove. */
    msgId?: MsgId | undefined;

    constructor(data?: IRemoveMsgReq) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            this.msgId = _data["msgId"] ? MsgId.fromJS(_data["msgId"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RemoveMsgReq {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveMsgReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["msgId"] = this.msgId ? this.msgId.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

/** Request to remove a message from a device's queue. */
export interface IRemoveMsgReq extends IMasRequestOfRemoveMsgResp {
    /** Identifier of the device to remove a message from. */
    id?: Id | undefined;
    /** Identifier of the message to remove. */
    msgId?: MsgId | undefined;
}

export class ActionOfRemoveMsgResp extends MulticastDelegate implements IActionOfRemoveMsgResp {

    constructor(data?: IActionOfRemoveMsgResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ActionOfRemoveMsgResp {
        data = typeof data === 'object' ? data : {};
        let result = new ActionOfRemoveMsgResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IActionOfRemoveMsgResp extends IMulticastDelegate {
}

export abstract class ResponseOfRemoveMsgData extends Transaction implements IResponseOfRemoveMsgData {
    securityToken?: string | undefined;
    error?: ErrorDto | undefined;
    data?: RemoveMsgData | undefined;
    isErrorResponse!: boolean;

    constructor(data?: IResponseOfRemoveMsgData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.securityToken = _data["securityToken"];
            this.error = _data["error"] ? ErrorDto.fromJS(_data["error"]) : <any>undefined;
            this.data = _data["data"] ? RemoveMsgData.fromJS(_data["data"]) : <any>undefined;
            this.isErrorResponse = _data["isErrorResponse"];
        }
    }

    static fromJS(data: any): ResponseOfRemoveMsgData {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ResponseOfRemoveMsgData' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securityToken"] = this.securityToken;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["isErrorResponse"] = this.isErrorResponse;
        super.toJSON(data);
        return data; 
    }
}

export interface IResponseOfRemoveMsgData extends ITransaction {
    securityToken?: string | undefined;
    error?: ErrorDto | undefined;
    data?: RemoveMsgData | undefined;
    isErrorResponse: boolean;
}

export class MasResponseOfRemoveMsgData extends ResponseOfRemoveMsgData implements IMasResponseOfRemoveMsgData {

    constructor(data?: IMasResponseOfRemoveMsgData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): MasResponseOfRemoveMsgData {
        data = typeof data === 'object' ? data : {};
        let result = new MasResponseOfRemoveMsgData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IMasResponseOfRemoveMsgData extends IResponseOfRemoveMsgData {
}

/** Response containing the device id and the id of the removed message. */
export class RemoveMsgResp extends MasResponseOfRemoveMsgData implements IRemoveMsgResp {

    constructor(data?: IRemoveMsgResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): RemoveMsgResp {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveMsgResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

/** Response containing the device id and the id of the removed message. */
export interface IRemoveMsgResp extends IMasResponseOfRemoveMsgData {
}

/** Response containing the device id and the id of the removed message. */
export class RemoveMsgData extends ResponseData implements IRemoveMsgData {
    /** Identifier of the device to which the message was sent. */
    id?: Id | undefined;
    /** Message identifier unique to the device. */
    msgId?: MsgId | undefined;

    constructor(data?: IRemoveMsgData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            this.msgId = _data["msgId"] ? MsgId.fromJS(_data["msgId"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RemoveMsgData {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveMsgData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["msgId"] = this.msgId ? this.msgId.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

/** Response containing the device id and the id of the removed message. */
export interface IRemoveMsgData extends IResponseData {
    /** Identifier of the device to which the message was sent. */
    id?: Id | undefined;
    /** Message identifier unique to the device. */
    msgId?: MsgId | undefined;
}

export abstract class RequestOfAddActionListResp extends Transaction implements IRequestOfAddActionListResp {
    username?: string | undefined;
    securityToken?: string | undefined;
    callback?: ActionOfAddActionListResp | undefined;

    constructor(data?: IRequestOfAddActionListResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.username = _data["username"];
            this.securityToken = _data["securityToken"];
            this.callback = _data["callback"] ? ActionOfAddActionListResp.fromJS(_data["callback"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RequestOfAddActionListResp {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'RequestOfAddActionListResp' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["securityToken"] = this.securityToken;
        data["callback"] = this.callback ? this.callback.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IRequestOfAddActionListResp extends ITransaction {
    username?: string | undefined;
    securityToken?: string | undefined;
    callback?: ActionOfAddActionListResp | undefined;
}

export class SasRequestOfAddActionListResp extends RequestOfAddActionListResp implements ISasRequestOfAddActionListResp {

    constructor(data?: ISasRequestOfAddActionListResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SasRequestOfAddActionListResp {
        data = typeof data === 'object' ? data : {};
        let result = new SasRequestOfAddActionListResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface ISasRequestOfAddActionListResp extends IRequestOfAddActionListResp {
}

/** An object that represents an addActionList request. */
export class AddActionListReq extends SasRequestOfAddActionListResp implements IAddActionListReq {
    actionListConfig?: ActionListConfig | undefined;

    constructor(data?: IAddActionListReq) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.actionListConfig = _data["actionListConfig"] ? ActionListConfig.fromJS(_data["actionListConfig"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddActionListReq {
        data = typeof data === 'object' ? data : {};
        let result = new AddActionListReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionListConfig"] = this.actionListConfig ? this.actionListConfig.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

/** An object that represents an addActionList request. */
export interface IAddActionListReq extends ISasRequestOfAddActionListResp {
    actionListConfig?: ActionListConfig | undefined;
}

/** Configuration for ActionList */
export class ActionListConfig extends XmlBase implements IActionListConfig {
    name?: string | undefined;
    actions?: Action[] | undefined;

    constructor(data?: IActionListConfig) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(Action.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActionListConfig {
        data = typeof data === 'object' ? data : {};
        let result = new ActionListConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

/** Configuration for ActionList */
export interface IActionListConfig extends IXmlBase {
    name?: string | undefined;
    actions?: Action[] | undefined;
}

/** Something to execute. Several different types. */
export class Action extends XmlBase implements IAction {
    /** Gets or sets the generic action. */
    genericAction?: GenericAction | undefined;
    /** Gets or sets the schedule action. */
    scheduleAction?: ScheduleAction | undefined;
    /** Gets or sets the TVT action. */
    tvtAction?: TvtAction | undefined;
    /** Gets or sets the CCTV action. */
    cctvAction?: CctvAction | undefined;
    /** Gets or sets the DMS action. */
    dmsAction?: DmsAction | undefined;
    /** Gets or sets the RS action. */
    rsAction?: RsAction | undefined;
    /** Gets or sets the EM action. */
    emAction?: EmAction | undefined;
    /** Gets or sets the EM action. */
    rmAction?: RmAction | undefined;
    /** Gets or sets the saa action. */
    groupMembershipAction?: GroupMembershipAction | undefined;
    /** Gets or sets the C2C floodgate action. */
    floodgateAction?: FloodgateAction | undefined;

    constructor(data?: IAction) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.genericAction = _data["genericAction"] ? GenericAction.fromJS(_data["genericAction"]) : <any>undefined;
            this.scheduleAction = _data["scheduleAction"] ? ScheduleAction.fromJS(_data["scheduleAction"]) : <any>undefined;
            this.tvtAction = _data["tvtAction"] ? TvtAction.fromJS(_data["tvtAction"]) : <any>undefined;
            this.cctvAction = _data["cctvAction"] ? CctvAction.fromJS(_data["cctvAction"]) : <any>undefined;
            this.dmsAction = _data["dmsAction"] ? DmsAction.fromJS(_data["dmsAction"]) : <any>undefined;
            this.rsAction = _data["rsAction"] ? RsAction.fromJS(_data["rsAction"]) : <any>undefined;
            this.emAction = _data["emAction"] ? EmAction.fromJS(_data["emAction"]) : <any>undefined;
            this.rmAction = _data["rmAction"] ? RmAction.fromJS(_data["rmAction"]) : <any>undefined;
            this.groupMembershipAction = _data["groupMembershipAction"] ? GroupMembershipAction.fromJS(_data["groupMembershipAction"]) : <any>undefined;
            this.floodgateAction = _data["floodgateAction"] ? FloodgateAction.fromJS(_data["floodgateAction"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Action {
        data = typeof data === 'object' ? data : {};
        let result = new Action();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["genericAction"] = this.genericAction ? this.genericAction.toJSON() : <any>undefined;
        data["scheduleAction"] = this.scheduleAction ? this.scheduleAction.toJSON() : <any>undefined;
        data["tvtAction"] = this.tvtAction ? this.tvtAction.toJSON() : <any>undefined;
        data["cctvAction"] = this.cctvAction ? this.cctvAction.toJSON() : <any>undefined;
        data["dmsAction"] = this.dmsAction ? this.dmsAction.toJSON() : <any>undefined;
        data["rsAction"] = this.rsAction ? this.rsAction.toJSON() : <any>undefined;
        data["emAction"] = this.emAction ? this.emAction.toJSON() : <any>undefined;
        data["rmAction"] = this.rmAction ? this.rmAction.toJSON() : <any>undefined;
        data["groupMembershipAction"] = this.groupMembershipAction ? this.groupMembershipAction.toJSON() : <any>undefined;
        data["floodgateAction"] = this.floodgateAction ? this.floodgateAction.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

/** Something to execute. Several different types. */
export interface IAction extends IXmlBase {
    /** Gets or sets the generic action. */
    genericAction?: GenericAction | undefined;
    /** Gets or sets the schedule action. */
    scheduleAction?: ScheduleAction | undefined;
    /** Gets or sets the TVT action. */
    tvtAction?: TvtAction | undefined;
    /** Gets or sets the CCTV action. */
    cctvAction?: CctvAction | undefined;
    /** Gets or sets the DMS action. */
    dmsAction?: DmsAction | undefined;
    /** Gets or sets the RS action. */
    rsAction?: RsAction | undefined;
    /** Gets or sets the EM action. */
    emAction?: EmAction | undefined;
    /** Gets or sets the EM action. */
    rmAction?: RmAction | undefined;
    /** Gets or sets the saa action. */
    groupMembershipAction?: GroupMembershipAction | undefined;
    /** Gets or sets the C2C floodgate action. */
    floodgateAction?: FloodgateAction | undefined;
}

/** An Action base class that inherits from XmlBase. */
export abstract class GenericAction extends XmlBase implements IGenericAction {

    constructor(data?: IGenericAction) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): GenericAction {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'GenericAction' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

/** An Action base class that inherits from XmlBase. */
export interface IGenericAction extends IXmlBase {
}

/** An action that takes a more managed approach and upon deactivation will execute the command in reverse. */
export abstract class ManagedAction extends GenericAction implements IManagedAction {

    constructor(data?: IManagedAction) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ManagedAction {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ManagedAction' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

/** An action that takes a more managed approach and upon deactivation will execute the command in reverse. */
export interface IManagedAction extends IGenericAction {
}

/** An action to turn on/off a schedule. */
export class ScheduleAction extends ManagedAction implements IScheduleAction {
    /** Gets or sets a value indicating whether to enable or disable a schedule. */
    enabled!: boolean;

    constructor(data?: IScheduleAction) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): ScheduleAction {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        super.toJSON(data);
        return data; 
    }
}

/** An action to turn on/off a schedule. */
export interface IScheduleAction extends IManagedAction {
    /** Gets or sets a value indicating whether to enable or disable a schedule. */
    enabled: boolean;
}

/** An action to turn on/off travel times either across the system or on a particular set of devices. */
export class TvtAction extends ManagedAction implements ITvtAction {
    /** Gets or sets a value indicating whether to enable or disable travel times. */
    enabled!: boolean;

    constructor(data?: ITvtAction) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): TvtAction {
        data = typeof data === 'object' ? data : {};
        let result = new TvtAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        super.toJSON(data);
        return data; 
    }
}

/** An action to turn on/off travel times either across the system or on a particular set of devices. */
export interface ITvtAction extends IManagedAction {
    /** Gets or sets a value indicating whether to enable or disable travel times. */
    enabled: boolean;
}

/** An action that does something directly for a set duration. */
export abstract class DirectAction extends GenericAction implements IDirectAction {
    /** Gets or sets the duration of the action. */
    duration!: string;

    constructor(data?: IDirectAction) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.duration = _data["duration"];
        }
    }

    static fromJS(data: any): DirectAction {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'DirectAction' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["duration"] = this.duration;
        super.toJSON(data);
        return data; 
    }
}

/** An action that does something directly for a set duration. */
export interface IDirectAction extends IGenericAction {
    /** Gets or sets the duration of the action. */
    duration: string;
}

/** A generic CCTV action. */
export class CctvAction extends DirectAction implements ICctvAction {
    /** Gets or sets the zoom action. */
    zoomAction?: ZoomAction | undefined;
    /** Gets or sets the pan action. */
    panAction?: PanAction | undefined;
    /** Gets or sets the tilt action. */
    tiltAction?: TiltAction | undefined;
    /** Gets or sets the dwell action. */
    dwellAction?: DwellAction | undefined;
    /** Gets or sets the preset action. */
    presetAction?: PresetAction | undefined;

    constructor(data?: ICctvAction) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.zoomAction = _data["zoomAction"] ? ZoomAction.fromJS(_data["zoomAction"]) : <any>undefined;
            this.panAction = _data["panAction"] ? PanAction.fromJS(_data["panAction"]) : <any>undefined;
            this.tiltAction = _data["tiltAction"] ? TiltAction.fromJS(_data["tiltAction"]) : <any>undefined;
            this.dwellAction = _data["dwellAction"] ? DwellAction.fromJS(_data["dwellAction"]) : <any>undefined;
            this.presetAction = _data["presetAction"] ? PresetAction.fromJS(_data["presetAction"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CctvAction {
        data = typeof data === 'object' ? data : {};
        let result = new CctvAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zoomAction"] = this.zoomAction ? this.zoomAction.toJSON() : <any>undefined;
        data["panAction"] = this.panAction ? this.panAction.toJSON() : <any>undefined;
        data["tiltAction"] = this.tiltAction ? this.tiltAction.toJSON() : <any>undefined;
        data["dwellAction"] = this.dwellAction ? this.dwellAction.toJSON() : <any>undefined;
        data["presetAction"] = this.presetAction ? this.presetAction.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

/** A generic CCTV action. */
export interface ICctvAction extends IDirectAction {
    /** Gets or sets the zoom action. */
    zoomAction?: ZoomAction | undefined;
    /** Gets or sets the pan action. */
    panAction?: PanAction | undefined;
    /** Gets or sets the tilt action. */
    tiltAction?: TiltAction | undefined;
    /** Gets or sets the dwell action. */
    dwellAction?: DwellAction | undefined;
    /** Gets or sets the preset action. */
    presetAction?: PresetAction | undefined;
}

/** A class that wraps XmlBase to provide some common type for actions within a direct action */
export class IndividualAction extends GenericAction implements IIndividualAction {

    constructor(data?: IIndividualAction) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): IndividualAction {
        data = typeof data === 'object' ? data : {};
        let result = new IndividualAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

/** A class that wraps XmlBase to provide some common type for actions within a direct action */
export interface IIndividualAction extends IGenericAction {
}

/** An action that zooms a CCTV */
export class ZoomAction extends IndividualAction implements IZoomAction {
    /** Gets or sets the zoom positioning. */
    zoomPositioning?: ZoomPositioning | undefined;

    constructor(data?: IZoomAction) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.zoomPositioning = _data["zoomPositioning"] ? ZoomPositioning.fromJS(_data["zoomPositioning"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ZoomAction {
        data = typeof data === 'object' ? data : {};
        let result = new ZoomAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zoomPositioning"] = this.zoomPositioning ? this.zoomPositioning.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

/** An action that zooms a CCTV */
export interface IZoomAction extends IIndividualAction {
    /** Gets or sets the zoom positioning. */
    zoomPositioning?: ZoomPositioning | undefined;
}

/** An action that pans a CCTV */
export class PanAction extends IndividualAction implements IPanAction {
    /** Gets or sets the positioning. */
    positioning?: Positioning | undefined;

    constructor(data?: IPanAction) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.positioning = _data["positioning"] ? Positioning.fromJS(_data["positioning"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PanAction {
        data = typeof data === 'object' ? data : {};
        let result = new PanAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["positioning"] = this.positioning ? this.positioning.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

/** An action that pans a CCTV */
export interface IPanAction extends IIndividualAction {
    /** Gets or sets the positioning. */
    positioning?: Positioning | undefined;
}

/** An action that tilts a CCTV. */
export class TiltAction extends IndividualAction implements ITiltAction {
    /** Gets or sets the positioning. */
    positioning?: Positioning | undefined;

    constructor(data?: ITiltAction) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.positioning = _data["positioning"] ? Positioning.fromJS(_data["positioning"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TiltAction {
        data = typeof data === 'object' ? data : {};
        let result = new TiltAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["positioning"] = this.positioning ? this.positioning.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

/** An action that tilts a CCTV. */
export interface ITiltAction extends IIndividualAction {
    /** Gets or sets the positioning. */
    positioning?: Positioning | undefined;
}

/** An action that pauses execution for a time. */
export class DwellAction extends IndividualAction implements IDwellAction {

    constructor(data?: IDwellAction) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): DwellAction {
        data = typeof data === 'object' ? data : {};
        let result = new DwellAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

/** An action that pauses execution for a time. */
export interface IDwellAction extends IIndividualAction {
}

/** An action that moves the camera to a preset. */
export class PresetAction extends IndividualAction implements IPresetAction {
    /** Gets or sets the preset. */
    preset!: number;

    constructor(data?: IPresetAction) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.preset = _data["preset"];
        }
    }

    static fromJS(data: any): PresetAction {
        data = typeof data === 'object' ? data : {};
        let result = new PresetAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preset"] = this.preset;
        super.toJSON(data);
        return data; 
    }
}

/** An action that moves the camera to a preset. */
export interface IPresetAction extends IIndividualAction {
    /** Gets or sets the preset. */
    preset: number;
}

/** An action to post a message to a particular subset of signs. */
export class DmsAction extends ManagedAction implements IDmsAction {
    /** Gets or sets the multi message. */
    multiMsg?: MultiMsg | undefined;
    /** Gets or sets a value indicating whether to enable auto merge. */
    enableAutoMerge?: boolean | undefined;
    /** Gets or sets the which action. */
    actionType!: ActionType;
    enableAutoMergeSpecified!: boolean;

    constructor(data?: IDmsAction) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.multiMsg = _data["multiMsg"] ? MultiMsg.fromJS(_data["multiMsg"]) : <any>undefined;
            this.enableAutoMerge = _data["enableAutoMerge"];
            this.actionType = _data["actionType"];
            this.enableAutoMergeSpecified = _data["enableAutoMergeSpecified"];
        }
    }

    static fromJS(data: any): DmsAction {
        data = typeof data === 'object' ? data : {};
        let result = new DmsAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["multiMsg"] = this.multiMsg ? this.multiMsg.toJSON() : <any>undefined;
        data["enableAutoMerge"] = this.enableAutoMerge;
        data["actionType"] = this.actionType;
        data["enableAutoMergeSpecified"] = this.enableAutoMergeSpecified;
        super.toJSON(data);
        return data; 
    }
}

/** An action to post a message to a particular subset of signs. */
export interface IDmsAction extends IManagedAction {
    /** Gets or sets the multi message. */
    multiMsg?: MultiMsg | undefined;
    /** Gets or sets a value indicating whether to enable auto merge. */
    enableAutoMerge?: boolean | undefined;
    /** Gets or sets the which action. */
    actionType: ActionType;
    enableAutoMergeSpecified: boolean;
}

/** the enum that describes which em action to take */
export enum ActionType {
    NormalDmsAction = 0,
    PredefinedResponsePlan = 1,
}

/** A scheduled reporting action. */
export class RsAction extends ManagedAction implements IRsAction {
    /** Gets or sets the report filter list. */
    reportFilterList?: ReportParameter[] | undefined;
    /** Gets or sets the ID of the report. */
    reportId?: IdWrapper | undefined;
    /** Gets or sets the report format. */
    reportFormat!: ReportExportFormat;
    /** Gets or sets who to send the email to. */
    emailTo?: string | undefined;
    /** Gets or sets the time span unit. */
    spanUnit!: TimeUnit;

    constructor(data?: IRsAction) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["reportFilterList"])) {
                this.reportFilterList = [] as any;
                for (let item of _data["reportFilterList"])
                    this.reportFilterList!.push(ReportParameter.fromJS(item));
            }
            this.reportId = _data["reportId"] ? IdWrapper.fromJS(_data["reportId"]) : <any>undefined;
            this.reportFormat = _data["reportFormat"];
            this.emailTo = _data["emailTo"];
            this.spanUnit = _data["spanUnit"];
        }
    }

    static fromJS(data: any): RsAction {
        data = typeof data === 'object' ? data : {};
        let result = new RsAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.reportFilterList)) {
            data["reportFilterList"] = [];
            for (let item of this.reportFilterList)
                data["reportFilterList"].push(item.toJSON());
        }
        data["reportId"] = this.reportId ? this.reportId.toJSON() : <any>undefined;
        data["reportFormat"] = this.reportFormat;
        data["emailTo"] = this.emailTo;
        data["spanUnit"] = this.spanUnit;
        super.toJSON(data);
        return data; 
    }
}

/** A scheduled reporting action. */
export interface IRsAction extends IManagedAction {
    /** Gets or sets the report filter list. */
    reportFilterList?: ReportParameter[] | undefined;
    /** Gets or sets the ID of the report. */
    reportId?: IdWrapper | undefined;
    /** Gets or sets the report format. */
    reportFormat: ReportExportFormat;
    /** Gets or sets who to send the email to. */
    emailTo?: string | undefined;
    /** Gets or sets the time span unit. */
    spanUnit: TimeUnit;
}

/** Represents a Report Parameter as defined by the Reporting Subsystem. */
export class ReportParameter extends XmlBase implements IReportParameter {
    /** Gets or sets the short name of this ReportParameter.
(i.e. The Name of the Parameter in the Report). */
    shortName?: string | undefined;
    /** Gets or sets the long name of this ReportParameter
(i.e. The Value of the Parameter to pass into the Report). */
    longName?: string | undefined;

    constructor(data?: IReportParameter) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.shortName = _data["shortName"];
            this.longName = _data["longName"];
        }
    }

    static fromJS(data: any): ReportParameter {
        data = typeof data === 'object' ? data : {};
        let result = new ReportParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shortName"] = this.shortName;
        data["longName"] = this.longName;
        super.toJSON(data);
        return data; 
    }
}

/** Represents a Report Parameter as defined by the Reporting Subsystem. */
export interface IReportParameter extends IXmlBase {
    /** Gets or sets the short name of this ReportParameter.
(i.e. The Name of the Parameter in the Report). */
    shortName?: string | undefined;
    /** Gets or sets the long name of this ReportParameter
(i.e. The Value of the Parameter to pass into the Report). */
    longName?: string | undefined;
}

/** Enumeration of all possible formats a generated Report can be saved as. */
export enum ReportExportFormat {
    Excel = 0,
    Word = 1,
    PDF = 2,
}

/** An enumeration of valid date and time references for scheduled reports. */
export enum TimeUnit {
    Absolute = 0,
    Relative = 1,
    LastWeek = 2,
    LastMonth = 3,
    LastQuarter = 4,
    LastYear = 5,
}

/** A class defining a scheduled action for an EM response plan. */
export class EmAction extends ManagedAction implements IEmAction {
    /** Gets or sets the action to perform for the response plan. */
    action!: ResponsePlanAction;

    constructor(data?: IEmAction) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.action = _data["action"];
        }
    }

    static fromJS(data: any): EmAction {
        data = typeof data === 'object' ? data : {};
        let result = new EmAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action;
        super.toJSON(data);
        return data; 
    }
}

/** A class defining a scheduled action for an EM response plan. */
export interface IEmAction extends IManagedAction {
    /** Gets or sets the action to perform for the response plan. */
    action: ResponsePlanAction;
}

/** A defined list of actions that may be taken for a response plan. */
export enum ResponsePlanAction {
    Activate = 0,
    Terminate = 1,
}

/** An action that adjusts the metering status of a ramp metering controller. */
export class RmAction extends ManagedAction implements IRmAction {
    /** Gets or sets the metering status. */
    meteringStatus!: MeteringStatus;
    /** Gets or sets the metering rate. */
    meteringRate?: number | undefined;
    meteringRateSpecified!: boolean;

    constructor(data?: IRmAction) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.meteringStatus = _data["meteringStatus"];
            this.meteringRate = _data["meteringRate"];
            this.meteringRateSpecified = _data["meteringRateSpecified"];
        }
    }

    static fromJS(data: any): RmAction {
        data = typeof data === 'object' ? data : {};
        let result = new RmAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meteringStatus"] = this.meteringStatus;
        data["meteringRate"] = this.meteringRate;
        data["meteringRateSpecified"] = this.meteringRateSpecified;
        super.toJSON(data);
        return data; 
    }
}

/** An action that adjusts the metering status of a ramp metering controller. */
export interface IRmAction extends IManagedAction {
    /** Gets or sets the metering status. */
    meteringStatus: MeteringStatus;
    /** Gets or sets the metering rate. */
    meteringRate?: number | undefined;
    meteringRateSpecified: boolean;
}

export enum MeteringStatus {
    Off = 0,
    Fuzzy = 1,
    Local = 2,
    Manual = 3,
}

/** The action for adding or removing users to a permission group Implements the ManagedAction */
export class GroupMembershipAction extends ManagedAction implements IGroupMembershipAction {
    /** Gets or sets the permission action. */
    userAction!: GroupPermissionEnum;
    /** Gets or sets the groups to add the devices(users in this case) to. */
    groups?: Id[] | undefined;

    constructor(data?: IGroupMembershipAction) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userAction = _data["userAction"];
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(Id.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GroupMembershipAction {
        data = typeof data === 'object' ? data : {};
        let result = new GroupMembershipAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userAction"] = this.userAction;
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

/** The action for adding or removing users to a permission group Implements the ManagedAction */
export interface IGroupMembershipAction extends IManagedAction {
    /** Gets or sets the permission action. */
    userAction: GroupPermissionEnum;
    /** Gets or sets the groups to add the devices(users in this case) to. */
    groups?: Id[] | undefined;
}

/** Enum that represents whether this scheduled item should add or remove this user from the group */
export enum GroupPermissionEnum {
    Add = 0,
    Remove = 1,
}

/** An action to post a floodgate message to C2C. */
export class FloodgateAction extends ManagedAction implements IFloodgateAction {
    /** Gets or sets the floodgate data. */
    floodgate?: Floodgate | undefined;

    constructor(data?: IFloodgateAction) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.floodgate = _data["floodgate"] ? Floodgate.fromJS(_data["floodgate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FloodgateAction {
        data = typeof data === 'object' ? data : {};
        let result = new FloodgateAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["floodgate"] = this.floodgate ? this.floodgate.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

/** An action to post a floodgate message to C2C. */
export interface IFloodgateAction extends IManagedAction {
    /** Gets or sets the floodgate data. */
    floodgate?: Floodgate | undefined;
}

export class Floodgate extends XmlBase implements IFloodgate {
    severity!: Severity;
    region?: string | undefined;
    county?: string | undefined;
    city?: string | undefined;
    roadway?: string | undefined;
    linkId?: string | undefined;
    language1?: MessageType | undefined;
    language2?: MessageType | undefined;
    duration?: number | undefined;
    priority?: number | undefined;
    allowEndCall?: boolean | undefined;
    allowBargeIn?: boolean | undefined;
    durationSpecified!: boolean;
    prioritySpecified!: boolean;
    allowEndCallSpecified!: boolean;
    allowBargeInSpecified!: boolean;

    constructor(data?: IFloodgate) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.severity = _data["severity"];
            this.region = _data["region"];
            this.county = _data["county"];
            this.city = _data["city"];
            this.roadway = _data["roadway"];
            this.linkId = _data["linkId"];
            this.language1 = _data["language1"] ? MessageType.fromJS(_data["language1"]) : <any>undefined;
            this.language2 = _data["language2"] ? MessageType.fromJS(_data["language2"]) : <any>undefined;
            this.duration = _data["duration"];
            this.priority = _data["priority"];
            this.allowEndCall = _data["allowEndCall"];
            this.allowBargeIn = _data["allowBargeIn"];
            this.durationSpecified = _data["durationSpecified"];
            this.prioritySpecified = _data["prioritySpecified"];
            this.allowEndCallSpecified = _data["allowEndCallSpecified"];
            this.allowBargeInSpecified = _data["allowBargeInSpecified"];
        }
    }

    static fromJS(data: any): Floodgate {
        data = typeof data === 'object' ? data : {};
        let result = new Floodgate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["severity"] = this.severity;
        data["region"] = this.region;
        data["county"] = this.county;
        data["city"] = this.city;
        data["roadway"] = this.roadway;
        data["linkId"] = this.linkId;
        data["language1"] = this.language1 ? this.language1.toJSON() : <any>undefined;
        data["language2"] = this.language2 ? this.language2.toJSON() : <any>undefined;
        data["duration"] = this.duration;
        data["priority"] = this.priority;
        data["allowEndCall"] = this.allowEndCall;
        data["allowBargeIn"] = this.allowBargeIn;
        data["durationSpecified"] = this.durationSpecified;
        data["prioritySpecified"] = this.prioritySpecified;
        data["allowEndCallSpecified"] = this.allowEndCallSpecified;
        data["allowBargeInSpecified"] = this.allowBargeInSpecified;
        super.toJSON(data);
        return data; 
    }
}

export interface IFloodgate extends IXmlBase {
    severity: Severity;
    region?: string | undefined;
    county?: string | undefined;
    city?: string | undefined;
    roadway?: string | undefined;
    linkId?: string | undefined;
    language1?: MessageType | undefined;
    language2?: MessageType | undefined;
    duration?: number | undefined;
    priority?: number | undefined;
    allowEndCall?: boolean | undefined;
    allowBargeIn?: boolean | undefined;
    durationSpecified: boolean;
    prioritySpecified: boolean;
    allowEndCallSpecified: boolean;
    allowBargeInSpecified: boolean;
}

export enum Severity {
    Unknown = 0,
    Minor = 1,
    Intermediate = 2,
    Major = 3,
}

export class MessageType extends XmlBase implements IMessageType {
    language?: LanguageType | undefined;
    bannerText?: string | undefined;
    audioFileFormat?: string | undefined;
    audioFileName?: string | undefined;
    audioData?: string | undefined;
    messageText?: string | undefined;
    commentText?: string | undefined;
    assocEvent?: string | undefined;
    languageSpecified!: boolean;

    constructor(data?: IMessageType) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.language = _data["language"];
            this.bannerText = _data["bannerText"];
            this.audioFileFormat = _data["audioFileFormat"];
            this.audioFileName = _data["audioFileName"];
            this.audioData = _data["audioData"];
            this.messageText = _data["messageText"];
            this.commentText = _data["commentText"];
            this.assocEvent = _data["assocEvent"];
            this.languageSpecified = _data["languageSpecified"];
        }
    }

    static fromJS(data: any): MessageType {
        data = typeof data === 'object' ? data : {};
        let result = new MessageType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language;
        data["bannerText"] = this.bannerText;
        data["audioFileFormat"] = this.audioFileFormat;
        data["audioFileName"] = this.audioFileName;
        data["audioData"] = this.audioData;
        data["messageText"] = this.messageText;
        data["commentText"] = this.commentText;
        data["assocEvent"] = this.assocEvent;
        data["languageSpecified"] = this.languageSpecified;
        super.toJSON(data);
        return data; 
    }
}

export interface IMessageType extends IXmlBase {
    language?: LanguageType | undefined;
    bannerText?: string | undefined;
    audioFileFormat?: string | undefined;
    audioFileName?: string | undefined;
    audioData?: string | undefined;
    messageText?: string | undefined;
    commentText?: string | undefined;
    assocEvent?: string | undefined;
    languageSpecified: boolean;
}

export enum LanguageType {
    English = 0,
    Spanish = 1,
    French = 2,
    German = 3,
}

export class ActionOfAddActionListResp extends MulticastDelegate implements IActionOfAddActionListResp {

    constructor(data?: IActionOfAddActionListResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ActionOfAddActionListResp {
        data = typeof data === 'object' ? data : {};
        let result = new ActionOfAddActionListResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IActionOfAddActionListResp extends IMulticastDelegate {
}

export abstract class ResponseOfActionListData extends Transaction implements IResponseOfActionListData {
    securityToken?: string | undefined;
    error?: ErrorDto | undefined;
    data?: ActionListData | undefined;
    isErrorResponse!: boolean;

    constructor(data?: IResponseOfActionListData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.securityToken = _data["securityToken"];
            this.error = _data["error"] ? ErrorDto.fromJS(_data["error"]) : <any>undefined;
            this.data = _data["data"] ? ActionListData.fromJS(_data["data"]) : <any>undefined;
            this.isErrorResponse = _data["isErrorResponse"];
        }
    }

    static fromJS(data: any): ResponseOfActionListData {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ResponseOfActionListData' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securityToken"] = this.securityToken;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["isErrorResponse"] = this.isErrorResponse;
        super.toJSON(data);
        return data; 
    }
}

export interface IResponseOfActionListData extends ITransaction {
    securityToken?: string | undefined;
    error?: ErrorDto | undefined;
    data?: ActionListData | undefined;
    isErrorResponse: boolean;
}

export class SasResponseOfActionListData extends ResponseOfActionListData implements ISasResponseOfActionListData {

    constructor(data?: ISasResponseOfActionListData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SasResponseOfActionListData {
        data = typeof data === 'object' ? data : {};
        let result = new SasResponseOfActionListData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface ISasResponseOfActionListData extends IResponseOfActionListData {
}

/** Class that represents an addActionList response. */
export class AddActionListResp extends SasResponseOfActionListData implements IAddActionListResp {
    addedObjects?: KeyValuePairOfIdAndActionList[] | undefined;

    constructor(data?: IAddActionListResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["addedObjects"])) {
                this.addedObjects = [] as any;
                for (let item of _data["addedObjects"])
                    this.addedObjects!.push(KeyValuePairOfIdAndActionList.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddActionListResp {
        data = typeof data === 'object' ? data : {};
        let result = new AddActionListResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.addedObjects)) {
            data["addedObjects"] = [];
            for (let item of this.addedObjects)
                data["addedObjects"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

/** Class that represents an addActionList response. */
export interface IAddActionListResp extends ISasResponseOfActionListData {
    addedObjects?: KeyValuePairOfIdAndActionList[] | undefined;
}

export class KeyValuePairOfIdAndActionList implements IKeyValuePairOfIdAndActionList {
    key?: Id | undefined;
    value?: ActionList | undefined;

    constructor(data?: IKeyValuePairOfIdAndActionList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] ? Id.fromJS(_data["key"]) : <any>undefined;
            this.value = _data["value"] ? ActionList.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): KeyValuePairOfIdAndActionList {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValuePairOfIdAndActionList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key ? this.key.toJSON() : <any>undefined;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IKeyValuePairOfIdAndActionList {
    key?: Id | undefined;
    value?: ActionList | undefined;
}

/** A list of actions to do. */
export class ActionList extends XmlBase implements IActionList {
    id?: Id | undefined;
    actionListConfig?: ActionListConfig | undefined;

    constructor(data?: IActionList) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            this.actionListConfig = _data["actionListConfig"] ? ActionListConfig.fromJS(_data["actionListConfig"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ActionList {
        data = typeof data === 'object' ? data : {};
        let result = new ActionList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["actionListConfig"] = this.actionListConfig ? this.actionListConfig.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

/** A list of actions to do. */
export interface IActionList extends IXmlBase {
    id?: Id | undefined;
    actionListConfig?: ActionListConfig | undefined;
}

export class ActionListData extends ResponseData implements IActionListData {
    actionList?: ActionList | undefined;

    constructor(data?: IActionListData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.actionList = _data["actionList"] ? ActionList.fromJS(_data["actionList"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ActionListData {
        data = typeof data === 'object' ? data : {};
        let result = new ActionListData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionList"] = this.actionList ? this.actionList.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IActionListData extends IResponseData {
    actionList?: ActionList | undefined;
}

export abstract class RequestOfAddScheduledItemResp extends Transaction implements IRequestOfAddScheduledItemResp {
    username?: string | undefined;
    securityToken?: string | undefined;
    callback?: ActionOfAddScheduledItemResp | undefined;

    constructor(data?: IRequestOfAddScheduledItemResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.username = _data["username"];
            this.securityToken = _data["securityToken"];
            this.callback = _data["callback"] ? ActionOfAddScheduledItemResp.fromJS(_data["callback"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RequestOfAddScheduledItemResp {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'RequestOfAddScheduledItemResp' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["securityToken"] = this.securityToken;
        data["callback"] = this.callback ? this.callback.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IRequestOfAddScheduledItemResp extends ITransaction {
    username?: string | undefined;
    securityToken?: string | undefined;
    callback?: ActionOfAddScheduledItemResp | undefined;
}

export class SasRequestOfAddScheduledItemResp extends RequestOfAddScheduledItemResp implements ISasRequestOfAddScheduledItemResp {

    constructor(data?: ISasRequestOfAddScheduledItemResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SasRequestOfAddScheduledItemResp {
        data = typeof data === 'object' ? data : {};
        let result = new SasRequestOfAddScheduledItemResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface ISasRequestOfAddScheduledItemResp extends IRequestOfAddScheduledItemResp {
}

/** An object that represents an addScheduledItem request. */
export class AddScheduledItemReq extends SasRequestOfAddScheduledItemResp implements IAddScheduledItemReq {
    scheduledItemConfig?: ScheduledItemConfig | undefined;
    /** Gets or sets the if the item is enabled. */
    itemEnabled?: boolean | undefined;
    itemEnabledSpecified!: boolean;

    constructor(data?: IAddScheduledItemReq) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.scheduledItemConfig = _data["scheduledItemConfig"] ? ScheduledItemConfig.fromJS(_data["scheduledItemConfig"]) : <any>undefined;
            this.itemEnabled = _data["itemEnabled"];
            this.itemEnabledSpecified = _data["itemEnabledSpecified"];
        }
    }

    static fromJS(data: any): AddScheduledItemReq {
        data = typeof data === 'object' ? data : {};
        let result = new AddScheduledItemReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scheduledItemConfig"] = this.scheduledItemConfig ? this.scheduledItemConfig.toJSON() : <any>undefined;
        data["itemEnabled"] = this.itemEnabled;
        data["itemEnabledSpecified"] = this.itemEnabledSpecified;
        super.toJSON(data);
        return data; 
    }
}

/** An object that represents an addScheduledItem request. */
export interface IAddScheduledItemReq extends ISasRequestOfAddScheduledItemResp {
    scheduledItemConfig?: ScheduledItemConfig | undefined;
    /** Gets or sets the if the item is enabled. */
    itemEnabled?: boolean | undefined;
    itemEnabledSpecified: boolean;
}

/** The configuration of a ScheduledItem */
export class ScheduledItemConfig extends XmlBase implements IScheduledItemConfig {
    name?: string | undefined;
    iCalendarString?: string | undefined;
    scheduleId?: IdWrapper | undefined;
    actionListId?: IdWrapper | undefined;
    affectedItem?: AffectedItem | undefined;
    /** Gets or sets the type of the schedule. */
    scheduleType!: ScheduleType;
    /** Gets or sets a value indicating whether the scheduled item can be deprecated */
    canDeprecate!: boolean;
    /** Gets the start date. */
    startDate!: Date;
    /** Gets the end date. */
    endDate!: Date;

    constructor(data?: IScheduledItemConfig) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.iCalendarString = _data["iCalendarString"];
            this.scheduleId = _data["scheduleId"] ? IdWrapper.fromJS(_data["scheduleId"]) : <any>undefined;
            this.actionListId = _data["actionListId"] ? IdWrapper.fromJS(_data["actionListId"]) : <any>undefined;
            this.affectedItem = _data["affectedItem"] ? AffectedItem.fromJS(_data["affectedItem"]) : <any>undefined;
            this.scheduleType = _data["scheduleType"];
            this.canDeprecate = _data["canDeprecate"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ScheduledItemConfig {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduledItemConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["iCalendarString"] = this.iCalendarString;
        data["scheduleId"] = this.scheduleId ? this.scheduleId.toJSON() : <any>undefined;
        data["actionListId"] = this.actionListId ? this.actionListId.toJSON() : <any>undefined;
        data["affectedItem"] = this.affectedItem ? this.affectedItem.toJSON() : <any>undefined;
        data["scheduleType"] = this.scheduleType;
        data["canDeprecate"] = this.canDeprecate;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

/** The configuration of a ScheduledItem */
export interface IScheduledItemConfig extends IXmlBase {
    name?: string | undefined;
    iCalendarString?: string | undefined;
    scheduleId?: IdWrapper | undefined;
    actionListId?: IdWrapper | undefined;
    affectedItem?: AffectedItem | undefined;
    /** Gets or sets the type of the schedule. */
    scheduleType: ScheduleType;
    /** Gets or sets a value indicating whether the scheduled item can be deprecated */
    canDeprecate: boolean;
    /** Gets the start date. */
    startDate: Date;
    /** Gets the end date. */
    endDate: Date;
}

/** The affected item of a scheduled item. Can be either the entire system, or a list of devices. */
export class AffectedItem extends XmlBase implements IAffectedItem {
    entireSystem!: boolean;
    devices?: Id[] | undefined;
    devicesSpecified!: boolean;

    constructor(data?: IAffectedItem) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.entireSystem = _data["entireSystem"];
            if (Array.isArray(_data["devices"])) {
                this.devices = [] as any;
                for (let item of _data["devices"])
                    this.devices!.push(Id.fromJS(item));
            }
            this.devicesSpecified = _data["devicesSpecified"];
        }
    }

    static fromJS(data: any): AffectedItem {
        data = typeof data === 'object' ? data : {};
        let result = new AffectedItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entireSystem"] = this.entireSystem;
        if (Array.isArray(this.devices)) {
            data["devices"] = [];
            for (let item of this.devices)
                data["devices"].push(item.toJSON());
        }
        data["devicesSpecified"] = this.devicesSpecified;
        super.toJSON(data);
        return data; 
    }
}

/** The affected item of a scheduled item. Can be either the entire system, or a list of devices. */
export interface IAffectedItem extends IXmlBase {
    entireSystem: boolean;
    devices?: Id[] | undefined;
    devicesSpecified: boolean;
}

/** Type of schedule being edited */
export enum ScheduleType {
    Cctv = 0,
    Dms = 1,
    DmsGroup = 2,
    Schedule = 3,
    Tvt = 4,
    TvtSystemwide = 5,
    Reports = 6,
    ResponsePlan = 7,
    PredefinedResponsePlan = 8,
    RampMetering = 9,
    Groups = 10,
    Floodgate = 11,
}

export class ActionOfAddScheduledItemResp extends MulticastDelegate implements IActionOfAddScheduledItemResp {

    constructor(data?: IActionOfAddScheduledItemResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ActionOfAddScheduledItemResp {
        data = typeof data === 'object' ? data : {};
        let result = new ActionOfAddScheduledItemResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IActionOfAddScheduledItemResp extends IMulticastDelegate {
}

export abstract class ResponseOfScheduledItemData extends Transaction implements IResponseOfScheduledItemData {
    securityToken?: string | undefined;
    error?: ErrorDto | undefined;
    data?: ScheduledItemData | undefined;
    isErrorResponse!: boolean;

    constructor(data?: IResponseOfScheduledItemData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.securityToken = _data["securityToken"];
            this.error = _data["error"] ? ErrorDto.fromJS(_data["error"]) : <any>undefined;
            this.data = _data["data"] ? ScheduledItemData.fromJS(_data["data"]) : <any>undefined;
            this.isErrorResponse = _data["isErrorResponse"];
        }
    }

    static fromJS(data: any): ResponseOfScheduledItemData {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ResponseOfScheduledItemData' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securityToken"] = this.securityToken;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["isErrorResponse"] = this.isErrorResponse;
        super.toJSON(data);
        return data; 
    }
}

export interface IResponseOfScheduledItemData extends ITransaction {
    securityToken?: string | undefined;
    error?: ErrorDto | undefined;
    data?: ScheduledItemData | undefined;
    isErrorResponse: boolean;
}

export class SasResponseOfScheduledItemData extends ResponseOfScheduledItemData implements ISasResponseOfScheduledItemData {

    constructor(data?: ISasResponseOfScheduledItemData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SasResponseOfScheduledItemData {
        data = typeof data === 'object' ? data : {};
        let result = new SasResponseOfScheduledItemData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface ISasResponseOfScheduledItemData extends IResponseOfScheduledItemData {
}

/** Class that represents an addScheduledItem response. */
export class AddScheduledItemResp extends SasResponseOfScheduledItemData implements IAddScheduledItemResp {
    addedObjects?: KeyValuePairOfIdAndScheduledItem[] | undefined;

    constructor(data?: IAddScheduledItemResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["addedObjects"])) {
                this.addedObjects = [] as any;
                for (let item of _data["addedObjects"])
                    this.addedObjects!.push(KeyValuePairOfIdAndScheduledItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddScheduledItemResp {
        data = typeof data === 'object' ? data : {};
        let result = new AddScheduledItemResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.addedObjects)) {
            data["addedObjects"] = [];
            for (let item of this.addedObjects)
                data["addedObjects"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

/** Class that represents an addScheduledItem response. */
export interface IAddScheduledItemResp extends ISasResponseOfScheduledItemData {
    addedObjects?: KeyValuePairOfIdAndScheduledItem[] | undefined;
}

export class KeyValuePairOfIdAndScheduledItem implements IKeyValuePairOfIdAndScheduledItem {
    key?: Id | undefined;
    value?: ScheduledItem | undefined;

    constructor(data?: IKeyValuePairOfIdAndScheduledItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] ? Id.fromJS(_data["key"]) : <any>undefined;
            this.value = _data["value"] ? ScheduledItem.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): KeyValuePairOfIdAndScheduledItem {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValuePairOfIdAndScheduledItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key ? this.key.toJSON() : <any>undefined;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IKeyValuePairOfIdAndScheduledItem {
    key?: Id | undefined;
    value?: ScheduledItem | undefined;
}

/** An action or list of actions that is executed at a particular time and belongs to a schedule. */
export class ScheduledItem extends XmlBase implements IScheduledItem {
    id?: Id | undefined;
    scheduledItemConfig?: ScheduledItemConfig | undefined;
    scheduledItemStatus?: ScheduledItemStatus | undefined;
    /** Gets the current status of the object */
    status?: ScheduledItemStatus | undefined;

    constructor(data?: IScheduledItem) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            this.scheduledItemConfig = _data["scheduledItemConfig"] ? ScheduledItemConfig.fromJS(_data["scheduledItemConfig"]) : <any>undefined;
            this.scheduledItemStatus = _data["scheduledItemStatus"] ? ScheduledItemStatus.fromJS(_data["scheduledItemStatus"]) : <any>undefined;
            this.status = _data["status"] ? ScheduledItemStatus.fromJS(_data["status"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ScheduledItem {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduledItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["scheduledItemConfig"] = this.scheduledItemConfig ? this.scheduledItemConfig.toJSON() : <any>undefined;
        data["scheduledItemStatus"] = this.scheduledItemStatus ? this.scheduledItemStatus.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

/** An action or list of actions that is executed at a particular time and belongs to a schedule. */
export interface IScheduledItem extends IXmlBase {
    id?: Id | undefined;
    scheduledItemConfig?: ScheduledItemConfig | undefined;
    scheduledItemStatus?: ScheduledItemStatus | undefined;
    /** Gets the current status of the object */
    status?: ScheduledItemStatus | undefined;
}

export abstract class XmlStatusBase extends XmlObject implements IXmlStatusBase {

    constructor(data?: IXmlStatusBase) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): XmlStatusBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'XmlStatusBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IXmlStatusBase extends IXmlObject {
}

/** The status of a ScheduledItem */
export class ScheduledItemStatus extends XmlStatusBase implements IScheduledItemStatus {
    active!: boolean;
    enabled!: boolean;

    constructor(data?: IScheduledItemStatus) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.active = _data["active"];
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): ScheduledItemStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduledItemStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["enabled"] = this.enabled;
        super.toJSON(data);
        return data; 
    }
}

/** The status of a ScheduledItem */
export interface IScheduledItemStatus extends IXmlStatusBase {
    active: boolean;
    enabled: boolean;
}

/** Response data type for scheduledItem */
export class ScheduledItemData extends ResponseData implements IScheduledItemData {
    scheduledItem?: ScheduledItem | undefined;

    constructor(data?: IScheduledItemData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.scheduledItem = _data["scheduledItem"] ? ScheduledItem.fromJS(_data["scheduledItem"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ScheduledItemData {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduledItemData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scheduledItem"] = this.scheduledItem ? this.scheduledItem.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

/** Response data type for scheduledItem */
export interface IScheduledItemData extends IResponseData {
    scheduledItem?: ScheduledItem | undefined;
}

export abstract class RequestOfSetScheduleStatusResp extends Transaction implements IRequestOfSetScheduleStatusResp {
    username?: string | undefined;
    securityToken?: string | undefined;
    callback?: ActionOfSetScheduleStatusResp | undefined;

    constructor(data?: IRequestOfSetScheduleStatusResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.username = _data["username"];
            this.securityToken = _data["securityToken"];
            this.callback = _data["callback"] ? ActionOfSetScheduleStatusResp.fromJS(_data["callback"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RequestOfSetScheduleStatusResp {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'RequestOfSetScheduleStatusResp' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["securityToken"] = this.securityToken;
        data["callback"] = this.callback ? this.callback.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IRequestOfSetScheduleStatusResp extends ITransaction {
    username?: string | undefined;
    securityToken?: string | undefined;
    callback?: ActionOfSetScheduleStatusResp | undefined;
}

export class SasRequestOfSetScheduleStatusResp extends RequestOfSetScheduleStatusResp implements ISasRequestOfSetScheduleStatusResp {

    constructor(data?: ISasRequestOfSetScheduleStatusResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SasRequestOfSetScheduleStatusResp {
        data = typeof data === 'object' ? data : {};
        let result = new SasRequestOfSetScheduleStatusResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface ISasRequestOfSetScheduleStatusResp extends IRequestOfSetScheduleStatusResp {
}

/** An object that represents an SetScheduleStatus request. */
export class SetScheduleStatusReq extends SasRequestOfSetScheduleStatusResp implements ISetScheduleStatusReq {
    id?: Id | undefined;
    enabled!: boolean;

    constructor(data?: ISetScheduleStatusReq) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): SetScheduleStatusReq {
        data = typeof data === 'object' ? data : {};
        let result = new SetScheduleStatusReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["enabled"] = this.enabled;
        super.toJSON(data);
        return data; 
    }
}

/** An object that represents an SetScheduleStatus request. */
export interface ISetScheduleStatusReq extends ISasRequestOfSetScheduleStatusResp {
    id?: Id | undefined;
    enabled: boolean;
}

export class ActionOfSetScheduleStatusResp extends MulticastDelegate implements IActionOfSetScheduleStatusResp {

    constructor(data?: IActionOfSetScheduleStatusResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ActionOfSetScheduleStatusResp {
        data = typeof data === 'object' ? data : {};
        let result = new ActionOfSetScheduleStatusResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IActionOfSetScheduleStatusResp extends IMulticastDelegate {
}

export abstract class ResponseOfScheduleStatusData extends Transaction implements IResponseOfScheduleStatusData {
    securityToken?: string | undefined;
    error?: ErrorDto | undefined;
    data?: ScheduleStatusData | undefined;
    isErrorResponse!: boolean;

    constructor(data?: IResponseOfScheduleStatusData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.securityToken = _data["securityToken"];
            this.error = _data["error"] ? ErrorDto.fromJS(_data["error"]) : <any>undefined;
            this.data = _data["data"] ? ScheduleStatusData.fromJS(_data["data"]) : <any>undefined;
            this.isErrorResponse = _data["isErrorResponse"];
        }
    }

    static fromJS(data: any): ResponseOfScheduleStatusData {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ResponseOfScheduleStatusData' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securityToken"] = this.securityToken;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["isErrorResponse"] = this.isErrorResponse;
        super.toJSON(data);
        return data; 
    }
}

export interface IResponseOfScheduleStatusData extends ITransaction {
    securityToken?: string | undefined;
    error?: ErrorDto | undefined;
    data?: ScheduleStatusData | undefined;
    isErrorResponse: boolean;
}

export class SasResponseOfScheduleStatusData extends ResponseOfScheduleStatusData implements ISasResponseOfScheduleStatusData {

    constructor(data?: ISasResponseOfScheduleStatusData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SasResponseOfScheduleStatusData {
        data = typeof data === 'object' ? data : {};
        let result = new SasResponseOfScheduleStatusData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface ISasResponseOfScheduleStatusData extends IResponseOfScheduleStatusData {
}

/** Class that represents an setScheduleState response. */
export class SetScheduleStatusResp extends SasResponseOfScheduleStatusData implements ISetScheduleStatusResp {

    constructor(data?: ISetScheduleStatusResp) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SetScheduleStatusResp {
        data = typeof data === 'object' ? data : {};
        let result = new SetScheduleStatusResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

/** Class that represents an setScheduleState response. */
export interface ISetScheduleStatusResp extends ISasResponseOfScheduleStatusData {
}

/** Response data type for ScheduleStatus */
export class ScheduleStatusData extends ResponseData implements IScheduleStatusData {
    id?: Id | undefined;
    enabled!: boolean;

    constructor(data?: IScheduleStatusData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): ScheduleStatusData {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleStatusData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["enabled"] = this.enabled;
        super.toJSON(data);
        return data; 
    }
}

/** Response data type for ScheduleStatus */
export interface IScheduleStatusData extends IResponseData {
    id?: Id | undefined;
    enabled: boolean;
}

export class RetrieveDataResponseOfStringAndCamera extends BaseResponse implements IRetrieveDataResponseOfStringAndCamera {
    data?: { [key: string]: Camera; } | undefined;

    constructor(data?: IRetrieveDataResponseOfStringAndCamera) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        this.data![key] = _data["data"][key] ? Camera.fromJS(_data["data"][key]) : new Camera();
                }
            }
        }
    }

    static fromJS(data: any): RetrieveDataResponseOfStringAndCamera {
        data = typeof data === 'object' ? data : {};
        let result = new RetrieveDataResponseOfStringAndCamera();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    data["data"][key] = this.data[key] ? this.data[key].toJSON() : <any>undefined;
            }
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IRetrieveDataResponseOfStringAndCamera extends IBaseResponse {
    data?: { [key: string]: Camera; } | undefined;
}

export class Camera extends XmlBase implements ICamera {
    /** Gets or sets the camera identifier */
    id?: Id | undefined;
    /** Gets the log name for a camera. */
    logName?: string | undefined;
    /** Gets or sets the center identifier formatted for display in the camera blocking dialog. */
    displayCenterId?: string | undefined;
    config?: CameraConfig | undefined;
    cameraComm?: CameraComm | undefined;
    status?: CameraStatus | undefined;

    constructor(data?: ICamera) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            this.logName = _data["logName"];
            this.displayCenterId = _data["displayCenterId"];
            this.config = _data["config"] ? CameraConfig.fromJS(_data["config"]) : <any>undefined;
            this.cameraComm = _data["cameraComm"] ? CameraComm.fromJS(_data["cameraComm"]) : <any>undefined;
            this.status = _data["status"] ? CameraStatus.fromJS(_data["status"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Camera {
        data = typeof data === 'object' ? data : {};
        let result = new Camera();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["logName"] = this.logName;
        data["displayCenterId"] = this.displayCenterId;
        data["config"] = this.config ? this.config.toJSON() : <any>undefined;
        data["cameraComm"] = this.cameraComm ? this.cameraComm.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface ICamera extends IXmlBase {
    /** Gets or sets the camera identifier */
    id?: Id | undefined;
    /** Gets the log name for a camera. */
    logName?: string | undefined;
    /** Gets or sets the center identifier formatted for display in the camera blocking dialog. */
    displayCenterId?: string | undefined;
    config?: CameraConfig | undefined;
    cameraComm?: CameraComm | undefined;
    status?: CameraStatus | undefined;
}

export class CameraConfig extends XmlBase implements ICameraConfig {
    displayName?: string | undefined;
    cameraManufacturer?: string | undefined;
    equipLocation?: EquipmentLocation | undefined;
    canPublish!: boolean;
    disablePTZ!: boolean;
    videoStreams?: VideoStream[] | undefined;
    /** Gets or sets the snapshot URI. */
    snapshotUri?: string | undefined;
    /** Gets or sets the snapshot interval in seconds. */
    snapshotInterval?: number | undefined;
    snapshotIntervalSpecified!: boolean;

    constructor(data?: ICameraConfig) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.displayName = _data["displayName"];
            this.cameraManufacturer = _data["cameraManufacturer"];
            this.equipLocation = _data["equipLocation"] ? EquipmentLocation.fromJS(_data["equipLocation"]) : <any>undefined;
            this.canPublish = _data["canPublish"];
            this.disablePTZ = _data["disablePTZ"];
            if (Array.isArray(_data["videoStreams"])) {
                this.videoStreams = [] as any;
                for (let item of _data["videoStreams"])
                    this.videoStreams!.push(VideoStream.fromJS(item));
            }
            this.snapshotUri = _data["snapshotUri"];
            this.snapshotInterval = _data["snapshotInterval"];
            this.snapshotIntervalSpecified = _data["snapshotIntervalSpecified"];
        }
    }

    static fromJS(data: any): CameraConfig {
        data = typeof data === 'object' ? data : {};
        let result = new CameraConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["cameraManufacturer"] = this.cameraManufacturer;
        data["equipLocation"] = this.equipLocation ? this.equipLocation.toJSON() : <any>undefined;
        data["canPublish"] = this.canPublish;
        data["disablePTZ"] = this.disablePTZ;
        if (Array.isArray(this.videoStreams)) {
            data["videoStreams"] = [];
            for (let item of this.videoStreams)
                data["videoStreams"].push(item.toJSON());
        }
        data["snapshotUri"] = this.snapshotUri;
        data["snapshotInterval"] = this.snapshotInterval;
        data["snapshotIntervalSpecified"] = this.snapshotIntervalSpecified;
        super.toJSON(data);
        return data; 
    }
}

export interface ICameraConfig extends IXmlBase {
    displayName?: string | undefined;
    cameraManufacturer?: string | undefined;
    equipLocation?: EquipmentLocation | undefined;
    canPublish: boolean;
    disablePTZ: boolean;
    videoStreams?: VideoStream[] | undefined;
    /** Gets or sets the snapshot URI. */
    snapshotUri?: string | undefined;
    /** Gets or sets the snapshot interval in seconds. */
    snapshotInterval?: number | undefined;
    snapshotIntervalSpecified: boolean;
}

/** Defines the location for a piece of equipment. */
export class EquipmentLocation extends XmlBase implements IEquipmentLocation {
    /** Name given to the physical location of the equipment. */
    locationDescription?: string | undefined;
    /** Name of the road on which the equipment is located. */
    roadway!: string;
    /** Indicates the direction of traffic the equipment faces. */
    direction!: string;
    crossStreet?: string | undefined;
    /** Shortcut for roadway/direction combination */
    roadwayDir?: string | undefined;
    /** Latitude at the location of the equipment (in microdegrees). */
    latitude!: number;
    /** Longitude at the location of the equipment (in microdegrees). */
    longitude!: number;
    /** Latitude as a double.  This should not typically be used in code, as it is only for handling DMS parsing. */
    latitudeParse?: number | undefined;
    /** Longitude as a double.  This should not typically be used in code, as it is only for handling DMS parsing. */
    longitudeParse?: number | undefined;
    /** Latitude at the location of the equipment (in microdegrees). */
    latitudeDegrees!: number;
    /** Longitude at the location of the equipment (in microdegrees). */
    longitudeDegrees!: number;
    /** Gets or sets the wrapped Id of the county for this location. */
    countyId?: IdWrapper | undefined;

    constructor(data?: IEquipmentLocation) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.locationDescription = _data["locationDescription"];
            this.roadway = _data["roadway"];
            this.direction = _data["direction"];
            this.crossStreet = _data["crossStreet"];
            this.roadwayDir = _data["roadwayDir"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.latitudeParse = _data["latitudeParse"];
            this.longitudeParse = _data["longitudeParse"];
            this.latitudeDegrees = _data["latitudeDegrees"];
            this.longitudeDegrees = _data["longitudeDegrees"];
            this.countyId = _data["countyId"] ? IdWrapper.fromJS(_data["countyId"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EquipmentLocation {
        data = typeof data === 'object' ? data : {};
        let result = new EquipmentLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationDescription"] = this.locationDescription;
        data["roadway"] = this.roadway;
        data["direction"] = this.direction;
        data["crossStreet"] = this.crossStreet;
        data["roadwayDir"] = this.roadwayDir;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["latitudeParse"] = this.latitudeParse;
        data["longitudeParse"] = this.longitudeParse;
        data["latitudeDegrees"] = this.latitudeDegrees;
        data["longitudeDegrees"] = this.longitudeDegrees;
        data["countyId"] = this.countyId ? this.countyId.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

/** Defines the location for a piece of equipment. */
export interface IEquipmentLocation extends IXmlBase {
    /** Name given to the physical location of the equipment. */
    locationDescription?: string | undefined;
    /** Name of the road on which the equipment is located. */
    roadway: string;
    /** Indicates the direction of traffic the equipment faces. */
    direction: string;
    crossStreet?: string | undefined;
    /** Shortcut for roadway/direction combination */
    roadwayDir?: string | undefined;
    /** Latitude at the location of the equipment (in microdegrees). */
    latitude: number;
    /** Longitude at the location of the equipment (in microdegrees). */
    longitude: number;
    /** Latitude as a double.  This should not typically be used in code, as it is only for handling DMS parsing. */
    latitudeParse?: number | undefined;
    /** Longitude as a double.  This should not typically be used in code, as it is only for handling DMS parsing. */
    longitudeParse?: number | undefined;
    /** Latitude at the location of the equipment (in microdegrees). */
    latitudeDegrees: number;
    /** Longitude at the location of the equipment (in microdegrees). */
    longitudeDegrees: number;
    /** Gets or sets the wrapped Id of the county for this location. */
    countyId?: IdWrapper | undefined;
}

export class VideoStream extends XmlBase implements IVideoStream {
    name!: string;
    url!: string;
    height!: number;
    isDefault!: boolean;
    local!: boolean;
    remote!: boolean;
    defaultRemote!: boolean;

    constructor(data?: IVideoStream) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.url = _data["url"];
            this.height = _data["height"];
            this.isDefault = _data["isDefault"];
            this.local = _data["local"];
            this.remote = _data["remote"];
            this.defaultRemote = _data["defaultRemote"];
        }
    }

    static fromJS(data: any): VideoStream {
        data = typeof data === 'object' ? data : {};
        let result = new VideoStream();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["url"] = this.url;
        data["height"] = this.height;
        data["isDefault"] = this.isDefault;
        data["local"] = this.local;
        data["remote"] = this.remote;
        data["defaultRemote"] = this.defaultRemote;
        super.toJSON(data);
        return data; 
    }
}

export interface IVideoStream extends IXmlBase {
    name: string;
    url: string;
    height: number;
    isDefault: boolean;
    local: boolean;
    remote: boolean;
    defaultRemote: boolean;
}

export class CameraComm extends XmlBase implements ICameraComm {
    protocol!: CameraProtocol;
    connectionType!: CameraConnectionType;
    pollProcessName?: string | undefined;
    cameraAddress?: CameraAddress | undefined;
    /** Gets or sets the poll cycle (measured in minutes) */
    pollCycle!: number;

    constructor(data?: ICameraComm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.protocol = _data["protocol"];
            this.connectionType = _data["connectionType"];
            this.pollProcessName = _data["pollProcessName"];
            this.cameraAddress = _data["cameraAddress"] ? CameraAddress.fromJS(_data["cameraAddress"]) : <any>undefined;
            this.pollCycle = _data["pollCycle"];
        }
    }

    static fromJS(data: any): CameraComm {
        data = typeof data === 'object' ? data : {};
        let result = new CameraComm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["protocol"] = this.protocol;
        data["connectionType"] = this.connectionType;
        data["pollProcessName"] = this.pollProcessName;
        data["cameraAddress"] = this.cameraAddress ? this.cameraAddress.toJSON() : <any>undefined;
        data["pollCycle"] = this.pollCycle;
        super.toJSON(data);
        return data; 
    }
}

export interface ICameraComm extends IXmlBase {
    protocol: CameraProtocol;
    connectionType: CameraConnectionType;
    pollProcessName?: string | undefined;
    cameraAddress?: CameraAddress | undefined;
    /** Gets or sets the poll cycle (measured in minutes) */
    pollCycle: number;
}

export enum CameraProtocol {
    SNMP = 0,
    SNMP_PMPP = 1,
    ACTi = 2,
    AmericanDynamics = 3,
    AD_CS536 = 4,
    Axis = 5,
    VC_C50iProtocol = 6,
    Cohu = 7,
    Cohu382x383x = 8,
    Cohu3855 = 9,
    CohuiDomeiViewLcu = 10,
    CohuiDomeiView2Lcu = 11,
    CohuMPCD111 = 12,
    PelcoD = 13,
    QCProtocol = 14,
    Telemetrics = 15,
    Vicon = 16,
}

export enum CameraConnectionType {
    Direct = 0,
}

/** Class containing the Camera Address Data. */
export class CameraAddress extends XmlBase implements ICameraAddress {
    /** Address Value specified which can either be a PmppAddress or CommAddress or HttpAddressClass. */
    address?: XmlBase | undefined;
    /** Type of Address that was the Address property is. */
    addressType!: CameraAddressType;
    httpAddress?: HttpAddressClass | undefined;
    pmppAddress?: PmppAddress | undefined;
    commAddress?: CommAddress | undefined;

    constructor(data?: ICameraAddress) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.address = _data["address"] ? XmlBase.fromJS(_data["address"]) : <any>undefined;
            this.addressType = _data["addressType"];
            this.httpAddress = _data["httpAddress"] ? HttpAddressClass.fromJS(_data["httpAddress"]) : <any>undefined;
            this.pmppAddress = _data["pmppAddress"] ? PmppAddress.fromJS(_data["pmppAddress"]) : <any>undefined;
            this.commAddress = _data["commAddress"] ? CommAddress.fromJS(_data["commAddress"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CameraAddress {
        data = typeof data === 'object' ? data : {};
        let result = new CameraAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["addressType"] = this.addressType;
        data["httpAddress"] = this.httpAddress ? this.httpAddress.toJSON() : <any>undefined;
        data["pmppAddress"] = this.pmppAddress ? this.pmppAddress.toJSON() : <any>undefined;
        data["commAddress"] = this.commAddress ? this.commAddress.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

/** Class containing the Camera Address Data. */
export interface ICameraAddress extends IXmlBase {
    /** Address Value specified which can either be a PmppAddress or CommAddress or HttpAddressClass. */
    address?: XmlBase | undefined;
    /** Type of Address that was the Address property is. */
    addressType: CameraAddressType;
    httpAddress?: HttpAddressClass | undefined;
    pmppAddress?: PmppAddress | undefined;
    commAddress?: CommAddress | undefined;
}

/** Type of Camera Address. */
export enum CameraAddressType {
    PmppAddress = 0,
    CommAddress = 1,
    HttpAddress = 2,
}

export class HttpAddressClass extends XmlBase implements IHttpAddressClass {
    addressValue?: AddressBase | undefined;
    soapUrl?: SoapUrlClass | undefined;
    url?: UrlClass | undefined;

    constructor(data?: IHttpAddressClass) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.addressValue = _data["addressValue"] ? AddressBase.fromJS(_data["addressValue"]) : <any>undefined;
            this.soapUrl = _data["soapUrl"] ? SoapUrlClass.fromJS(_data["soapUrl"]) : <any>undefined;
            this.url = _data["url"] ? UrlClass.fromJS(_data["url"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HttpAddressClass {
        data = typeof data === 'object' ? data : {};
        let result = new HttpAddressClass();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressValue"] = this.addressValue ? this.addressValue.toJSON() : <any>undefined;
        data["soapUrl"] = this.soapUrl ? this.soapUrl.toJSON() : <any>undefined;
        data["url"] = this.url ? this.url.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IHttpAddressClass extends IXmlBase {
    addressValue?: AddressBase | undefined;
    soapUrl?: SoapUrlClass | undefined;
    url?: UrlClass | undefined;
}

export class AddressBase extends XmlBase implements IAddressBase {

    constructor(data?: IAddressBase) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): AddressBase {
        data = typeof data === 'object' ? data : {};
        let result = new AddressBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IAddressBase extends IXmlBase {
}

export class UrlClass extends AddressBase implements IUrlClass {
    address?: number | undefined;
    url?: string | undefined;
    deviceId?: string | undefined;
    /** Gets or sets the Username to use. */
    username?: string | undefined;
    /** Gets or sets the Password to use. */
    password?: string | undefined;
    addressSpecified!: boolean;

    constructor(data?: IUrlClass) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.address = _data["address"];
            this.url = _data["url"];
            this.deviceId = _data["deviceId"];
            this.username = _data["username"];
            this.password = _data["password"];
            this.addressSpecified = _data["addressSpecified"];
        }
    }

    static fromJS(data: any): UrlClass {
        data = typeof data === 'object' ? data : {};
        let result = new UrlClass();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["url"] = this.url;
        data["deviceId"] = this.deviceId;
        data["username"] = this.username;
        data["password"] = this.password;
        data["addressSpecified"] = this.addressSpecified;
        super.toJSON(data);
        return data; 
    }
}

export interface IUrlClass extends IAddressBase {
    address?: number | undefined;
    url?: string | undefined;
    deviceId?: string | undefined;
    /** Gets or sets the Username to use. */
    username?: string | undefined;
    /** Gets or sets the Password to use. */
    password?: string | undefined;
    addressSpecified: boolean;
}

export class SoapUrlClass extends UrlClass implements ISoapUrlClass {
    username?: string | undefined;
    password?: string | undefined;

    constructor(data?: ISoapUrlClass) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): SoapUrlClass {
        data = typeof data === 'object' ? data : {};
        let result = new SoapUrlClass();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        super.toJSON(data);
        return data; 
    }
}

export interface ISoapUrlClass extends IUrlClass {
    username?: string | undefined;
    password?: string | undefined;
}

export class PmppAddress extends XmlBase implements IPmppAddress {
    addressValue?: AddressBase | undefined;
    communityName?: string | undefined;
    writeCommunityName?: string | undefined;
    readCommunityName?: string | undefined;
    communityType!: CommunityType;
    portServerAddress?: PortServerAddressClass | undefined;
    directAddress?: DirectAddressClass | undefined;
    dialupAddress?: DialupAddressClass | undefined;
    portServerUdpAddress?: PortServerUdpAddressClass | undefined;

    constructor(data?: IPmppAddress) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.addressValue = _data["addressValue"] ? AddressBase.fromJS(_data["addressValue"]) : <any>undefined;
            this.communityName = _data["communityName"];
            this.writeCommunityName = _data["writeCommunityName"];
            this.readCommunityName = _data["readCommunityName"];
            this.communityType = _data["communityType"];
            this.portServerAddress = _data["portServerAddress"] ? PortServerAddressClass.fromJS(_data["portServerAddress"]) : <any>undefined;
            this.directAddress = _data["directAddress"] ? DirectAddressClass.fromJS(_data["directAddress"]) : <any>undefined;
            this.dialupAddress = _data["dialupAddress"] ? DialupAddressClass.fromJS(_data["dialupAddress"]) : <any>undefined;
            this.portServerUdpAddress = _data["portServerUdpAddress"] ? PortServerUdpAddressClass.fromJS(_data["portServerUdpAddress"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PmppAddress {
        data = typeof data === 'object' ? data : {};
        let result = new PmppAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressValue"] = this.addressValue ? this.addressValue.toJSON() : <any>undefined;
        data["communityName"] = this.communityName;
        data["writeCommunityName"] = this.writeCommunityName;
        data["readCommunityName"] = this.readCommunityName;
        data["communityType"] = this.communityType;
        data["portServerAddress"] = this.portServerAddress ? this.portServerAddress.toJSON() : <any>undefined;
        data["directAddress"] = this.directAddress ? this.directAddress.toJSON() : <any>undefined;
        data["dialupAddress"] = this.dialupAddress ? this.dialupAddress.toJSON() : <any>undefined;
        data["portServerUdpAddress"] = this.portServerUdpAddress ? this.portServerUdpAddress.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IPmppAddress extends IXmlBase {
    addressValue?: AddressBase | undefined;
    communityName?: string | undefined;
    writeCommunityName?: string | undefined;
    readCommunityName?: string | undefined;
    communityType: CommunityType;
    portServerAddress?: PortServerAddressClass | undefined;
    directAddress?: DirectAddressClass | undefined;
    dialupAddress?: DialupAddressClass | undefined;
    portServerUdpAddress?: PortServerUdpAddressClass | undefined;
}

export enum CommunityType {
    Community = 0,
    ReadWriteCommunity = 1,
}

export class PortServerAddressClass extends AddressBase implements IPortServerAddressClass {
    address?: number | undefined;
    portServerIp!: string;
    portServerPortNumber!: number;
    deviceId?: string | undefined;
    addressSpecified!: boolean;

    constructor(data?: IPortServerAddressClass) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.address = _data["address"];
            this.portServerIp = _data["portServerIp"];
            this.portServerPortNumber = _data["portServerPortNumber"];
            this.deviceId = _data["deviceId"];
            this.addressSpecified = _data["addressSpecified"];
        }
    }

    static fromJS(data: any): PortServerAddressClass {
        data = typeof data === 'object' ? data : {};
        let result = new PortServerAddressClass();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["portServerIp"] = this.portServerIp;
        data["portServerPortNumber"] = this.portServerPortNumber;
        data["deviceId"] = this.deviceId;
        data["addressSpecified"] = this.addressSpecified;
        super.toJSON(data);
        return data; 
    }
}

export interface IPortServerAddressClass extends IAddressBase {
    address?: number | undefined;
    portServerIp: string;
    portServerPortNumber: number;
    deviceId?: string | undefined;
    addressSpecified: boolean;
}

export class DirectAddressClass extends AddressBase implements IDirectAddressClass {
    address!: number;
    comPort?: string | undefined;
    baud?: BaudClass | undefined;
    dataBits!: number;
    stopBits!: number;
    parity!: Parity;

    constructor(data?: IDirectAddressClass) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.address = _data["address"];
            this.comPort = _data["comPort"];
            this.baud = _data["baud"] ? BaudClass.fromJS(_data["baud"]) : <any>undefined;
            this.dataBits = _data["dataBits"];
            this.stopBits = _data["stopBits"];
            this.parity = _data["parity"];
        }
    }

    static fromJS(data: any): DirectAddressClass {
        data = typeof data === 'object' ? data : {};
        let result = new DirectAddressClass();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["comPort"] = this.comPort;
        data["baud"] = this.baud ? this.baud.toJSON() : <any>undefined;
        data["dataBits"] = this.dataBits;
        data["stopBits"] = this.stopBits;
        data["parity"] = this.parity;
        super.toJSON(data);
        return data; 
    }
}

export interface IDirectAddressClass extends IAddressBase {
    address: number;
    comPort?: string | undefined;
    baud?: BaudClass | undefined;
    dataBits: number;
    stopBits: number;
    parity: Parity;
}

export class BaudClass extends XmlBase implements IBaudClass {
    baudRate!: BaudRate;

    constructor(data?: IBaudClass) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.baudRate = _data["baudRate"];
        }
    }

    static fromJS(data: any): BaudClass {
        data = typeof data === 'object' ? data : {};
        let result = new BaudClass();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baudRate"] = this.baudRate;
        super.toJSON(data);
        return data; 
    }
}

export interface IBaudClass extends IXmlBase {
    baudRate: BaudRate;
}

export enum BaudRate {
    Br300 = 300,
    Br1200 = 1200,
    Br2400 = 2400,
    Br4800 = 4800,
    Br9600 = 9600,
    Br14400 = 14400,
    Br19200 = 19200,
    Br28800 = 28800,
}

export enum Parity {
    None = 0,
    Odd = 1,
    Even = 2,
}

export class DialupAddressClass extends AddressBase implements IDialupAddressClass {
    address!: number;
    phoneNumber?: string | undefined;
    baud?: BaudClass | undefined;

    constructor(data?: IDialupAddressClass) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.address = _data["address"];
            this.phoneNumber = _data["phoneNumber"];
            this.baud = _data["baud"] ? BaudClass.fromJS(_data["baud"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DialupAddressClass {
        data = typeof data === 'object' ? data : {};
        let result = new DialupAddressClass();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["phoneNumber"] = this.phoneNumber;
        data["baud"] = this.baud ? this.baud.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IDialupAddressClass extends IAddressBase {
    address: number;
    phoneNumber?: string | undefined;
    baud?: BaudClass | undefined;
}

export class PortServerUdpAddressClass extends AddressBase implements IPortServerUdpAddressClass {
    address?: number | undefined;
    portServerIp?: string | undefined;
    portServerPortNumber!: number;
    deviceId?: string | undefined;
    addressSpecified!: boolean;

    constructor(data?: IPortServerUdpAddressClass) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.address = _data["address"];
            this.portServerIp = _data["portServerIp"];
            this.portServerPortNumber = _data["portServerPortNumber"];
            this.deviceId = _data["deviceId"];
            this.addressSpecified = _data["addressSpecified"];
        }
    }

    static fromJS(data: any): PortServerUdpAddressClass {
        data = typeof data === 'object' ? data : {};
        let result = new PortServerUdpAddressClass();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["portServerIp"] = this.portServerIp;
        data["portServerPortNumber"] = this.portServerPortNumber;
        data["deviceId"] = this.deviceId;
        data["addressSpecified"] = this.addressSpecified;
        super.toJSON(data);
        return data; 
    }
}

export interface IPortServerUdpAddressClass extends IAddressBase {
    address?: number | undefined;
    portServerIp?: string | undefined;
    portServerPortNumber: number;
    deviceId?: string | undefined;
    addressSpecified: boolean;
}

export class CommAddress extends XmlBase implements ICommAddress {
    addressValue?: AddressBase | undefined;
    portServerAddress?: PortServerAddressClass | undefined;
    directAddress?: DirectAddressClass | undefined;
    dialupAddress?: DialupAddressClass | undefined;

    constructor(data?: ICommAddress) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.addressValue = _data["addressValue"] ? AddressBase.fromJS(_data["addressValue"]) : <any>undefined;
            this.portServerAddress = _data["portServerAddress"] ? PortServerAddressClass.fromJS(_data["portServerAddress"]) : <any>undefined;
            this.directAddress = _data["directAddress"] ? DirectAddressClass.fromJS(_data["directAddress"]) : <any>undefined;
            this.dialupAddress = _data["dialupAddress"] ? DialupAddressClass.fromJS(_data["dialupAddress"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CommAddress {
        data = typeof data === 'object' ? data : {};
        let result = new CommAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressValue"] = this.addressValue ? this.addressValue.toJSON() : <any>undefined;
        data["portServerAddress"] = this.portServerAddress ? this.portServerAddress.toJSON() : <any>undefined;
        data["directAddress"] = this.directAddress ? this.directAddress.toJSON() : <any>undefined;
        data["dialupAddress"] = this.dialupAddress ? this.dialupAddress.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface ICommAddress extends IXmlBase {
    addressValue?: AddressBase | undefined;
    portServerAddress?: PortServerAddressClass | undefined;
    directAddress?: DirectAddressClass | undefined;
    dialupAddress?: DialupAddressClass | undefined;
}

/** Represents the status of a camera */
export class CameraStatus extends XmlStatusBase implements ICameraStatus {
    /** Gets or sets the op status. */
    opStatus!: OpStatus;
    /** Gets or sets the lock holder. */
    lockHolder?: LockHolder | undefined;
    /** Gets or sets the container object for the AutoFocus and AutoIris statuses */
    autoStates?: CameraStatusAutoStates | undefined;
    /** Gets or sets the container object for the Camera System Features such as wiper status */
    systemFeatures?: SystemFeatures | undefined;
    /** Gets or sets the blocked status. */
    blockedStatus?: BlockedStatus | undefined;

    constructor(data?: ICameraStatus) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.opStatus = _data["opStatus"];
            this.lockHolder = _data["lockHolder"] ? LockHolder.fromJS(_data["lockHolder"]) : <any>undefined;
            this.autoStates = _data["autoStates"] ? CameraStatusAutoStates.fromJS(_data["autoStates"]) : <any>undefined;
            this.systemFeatures = _data["systemFeatures"] ? SystemFeatures.fromJS(_data["systemFeatures"]) : <any>undefined;
            this.blockedStatus = _data["blockedStatus"] ? BlockedStatus.fromJS(_data["blockedStatus"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CameraStatus {
        data = typeof data === 'object' ? data : {};
        let result = new CameraStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["opStatus"] = this.opStatus;
        data["lockHolder"] = this.lockHolder ? this.lockHolder.toJSON() : <any>undefined;
        data["autoStates"] = this.autoStates ? this.autoStates.toJSON() : <any>undefined;
        data["systemFeatures"] = this.systemFeatures ? this.systemFeatures.toJSON() : <any>undefined;
        data["blockedStatus"] = this.blockedStatus ? this.blockedStatus.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

/** Represents the status of a camera */
export interface ICameraStatus extends IXmlStatusBase {
    /** Gets or sets the op status. */
    opStatus: OpStatus;
    /** Gets or sets the lock holder. */
    lockHolder?: LockHolder | undefined;
    /** Gets or sets the container object for the AutoFocus and AutoIris statuses */
    autoStates?: CameraStatusAutoStates | undefined;
    /** Gets or sets the container object for the Camera System Features such as wiper status */
    systemFeatures?: SystemFeatures | undefined;
    /** Gets or sets the blocked status. */
    blockedStatus?: BlockedStatus | undefined;
}

/** Holds information about the user who has the camera lock. Implements the XmlBase */
export class LockHolder extends XmlBase implements ILockHolder {
    /** Gets or sets the name of the lock holder. */
    lockHolderName?: string | undefined;
    /** Gets the name of the stripped lock holder name. */
    strippedLockHolderName?: string | undefined;
    isManualLock!: boolean;

    constructor(data?: ILockHolder) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.lockHolderName = _data["lockHolderName"];
            this.strippedLockHolderName = _data["strippedLockHolderName"];
            this.isManualLock = _data["isManualLock"];
        }
    }

    static fromJS(data: any): LockHolder {
        data = typeof data === 'object' ? data : {};
        let result = new LockHolder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lockHolderName"] = this.lockHolderName;
        data["strippedLockHolderName"] = this.strippedLockHolderName;
        data["isManualLock"] = this.isManualLock;
        super.toJSON(data);
        return data; 
    }
}

/** Holds information about the user who has the camera lock. Implements the XmlBase */
export interface ILockHolder extends IXmlBase {
    /** Gets or sets the name of the lock holder. */
    lockHolderName?: string | undefined;
    /** Gets the name of the stripped lock holder name. */
    strippedLockHolderName?: string | undefined;
    isManualLock: boolean;
}

/** The container for the auto- state information for a camera */
export class CameraStatusAutoStates extends XmlBase implements ICameraStatusAutoStates {
    /** Gets or sets a value indicating whether auto focus control is supported. */
    supportsAutoFocus!: boolean;
    /** Gets or sets a value indicating whether auto iris control is supported. */
    supportsAutoIris!: boolean;
    /** The auto-focus state */
    autoFocus?: boolean | undefined;
    /** The auto-iris state */
    autoIris?: boolean | undefined;
    autoFocusSpecified!: boolean;
    autoIrisSpecified!: boolean;

    constructor(data?: ICameraStatusAutoStates) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.supportsAutoFocus = _data["supportsAutoFocus"];
            this.supportsAutoIris = _data["supportsAutoIris"];
            this.autoFocus = _data["autoFocus"];
            this.autoIris = _data["autoIris"];
            this.autoFocusSpecified = _data["autoFocusSpecified"];
            this.autoIrisSpecified = _data["autoIrisSpecified"];
        }
    }

    static fromJS(data: any): CameraStatusAutoStates {
        data = typeof data === 'object' ? data : {};
        let result = new CameraStatusAutoStates();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supportsAutoFocus"] = this.supportsAutoFocus;
        data["supportsAutoIris"] = this.supportsAutoIris;
        data["autoFocus"] = this.autoFocus;
        data["autoIris"] = this.autoIris;
        data["autoFocusSpecified"] = this.autoFocusSpecified;
        data["autoIrisSpecified"] = this.autoIrisSpecified;
        super.toJSON(data);
        return data; 
    }
}

/** The container for the auto- state information for a camera */
export interface ICameraStatusAutoStates extends IXmlBase {
    /** Gets or sets a value indicating whether auto focus control is supported. */
    supportsAutoFocus: boolean;
    /** Gets or sets a value indicating whether auto iris control is supported. */
    supportsAutoIris: boolean;
    /** The auto-focus state */
    autoFocus?: boolean | undefined;
    /** The auto-iris state */
    autoIris?: boolean | undefined;
    autoFocusSpecified: boolean;
    autoIrisSpecified: boolean;
}

/** The container for the camera feature status information for a camera, such as wiper status */
export class SystemFeatures extends XmlBase implements ISystemFeatures {
    /** Gets or sets a value indicating whether wiper control is supported. */
    supportsWiper!: boolean;
    /** Gets or sets a value indicating whether washer control is supported. */
    supportsWasher!: boolean;
    /** Gets or sets the wiper state.  If null, wiper status is unknown or camera does not support controlling the wiper */
    wiper?: boolean | undefined;
    /** Gets or sets the washer state.  If null, washer status is unknown or camera does not support controlling washers */
    washer?: boolean | undefined;
    wiperSpecified!: boolean;
    washerSpecified!: boolean;

    constructor(data?: ISystemFeatures) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.supportsWiper = _data["supportsWiper"];
            this.supportsWasher = _data["supportsWasher"];
            this.wiper = _data["wiper"];
            this.washer = _data["washer"];
            this.wiperSpecified = _data["wiperSpecified"];
            this.washerSpecified = _data["washerSpecified"];
        }
    }

    static fromJS(data: any): SystemFeatures {
        data = typeof data === 'object' ? data : {};
        let result = new SystemFeatures();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supportsWiper"] = this.supportsWiper;
        data["supportsWasher"] = this.supportsWasher;
        data["wiper"] = this.wiper;
        data["washer"] = this.washer;
        data["wiperSpecified"] = this.wiperSpecified;
        data["washerSpecified"] = this.washerSpecified;
        super.toJSON(data);
        return data; 
    }
}

/** The container for the camera feature status information for a camera, such as wiper status */
export interface ISystemFeatures extends IXmlBase {
    /** Gets or sets a value indicating whether wiper control is supported. */
    supportsWiper: boolean;
    /** Gets or sets a value indicating whether washer control is supported. */
    supportsWasher: boolean;
    /** Gets or sets the wiper state.  If null, wiper status is unknown or camera does not support controlling the wiper */
    wiper?: boolean | undefined;
    /** Gets or sets the washer state.  If null, washer status is unknown or camera does not support controlling washers */
    washer?: boolean | undefined;
    wiperSpecified: boolean;
    washerSpecified: boolean;
}

/** A class that holds information about the cameras blocked status */
export class BlockedStatus extends XmlBase implements IBlockedStatus {
    /** Gets or sets a value indicating whether this instance is blocked. */
    isBlocked!: boolean;
    /** Gets or sets the restricted timestamp. */
    blockedTimestamp?: Date | undefined;
    /** Gets the blocked minutes. */
    blockedMinutes?: number | undefined;
    /** Gets or sets the user who approved the blocked camera state. */
    blockedApprover?: string | undefined;

    constructor(data?: IBlockedStatus) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isBlocked = _data["isBlocked"];
            this.blockedTimestamp = _data["blockedTimestamp"] ? new Date(_data["blockedTimestamp"].toString()) : <any>undefined;
            this.blockedMinutes = _data["blockedMinutes"];
            this.blockedApprover = _data["blockedApprover"];
        }
    }

    static fromJS(data: any): BlockedStatus {
        data = typeof data === 'object' ? data : {};
        let result = new BlockedStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isBlocked"] = this.isBlocked;
        data["blockedTimestamp"] = this.blockedTimestamp ? this.blockedTimestamp.toISOString() : <any>undefined;
        data["blockedMinutes"] = this.blockedMinutes;
        data["blockedApprover"] = this.blockedApprover;
        super.toJSON(data);
        return data; 
    }
}

/** A class that holds information about the cameras blocked status */
export interface IBlockedStatus extends IXmlBase {
    /** Gets or sets a value indicating whether this instance is blocked. */
    isBlocked: boolean;
    /** Gets or sets the restricted timestamp. */
    blockedTimestamp?: Date | undefined;
    /** Gets the blocked minutes. */
    blockedMinutes?: number | undefined;
    /** Gets or sets the user who approved the blocked camera state. */
    blockedApprover?: string | undefined;
}

export class RetrieveDataResponseOfStringAndCameraPresets extends BaseResponse implements IRetrieveDataResponseOfStringAndCameraPresets {
    data?: { [key: string]: CameraPresets; } | undefined;

    constructor(data?: IRetrieveDataResponseOfStringAndCameraPresets) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        this.data![key] = _data["data"][key] ? CameraPresets.fromJS(_data["data"][key]) : new CameraPresets();
                }
            }
        }
    }

    static fromJS(data: any): RetrieveDataResponseOfStringAndCameraPresets {
        data = typeof data === 'object' ? data : {};
        let result = new RetrieveDataResponseOfStringAndCameraPresets();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    data["data"][key] = this.data[key] ? this.data[key].toJSON() : <any>undefined;
            }
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IRetrieveDataResponseOfStringAndCameraPresets extends IBaseResponse {
    data?: { [key: string]: CameraPresets; } | undefined;
}

export class CameraPresets extends XmlBase implements ICameraPresets {
    id?: Id | undefined;
    keys?: number[] | undefined;
    values?: Preset[] | undefined;
    count!: number;
    isReadOnly!: boolean;

    constructor(data?: ICameraPresets) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            if (Array.isArray(_data["keys"])) {
                this.keys = [] as any;
                for (let item of _data["keys"])
                    this.keys!.push(item);
            }
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(Preset.fromJS(item));
            }
            this.count = _data["count"];
            this.isReadOnly = _data["isReadOnly"];
        }
    }

    static fromJS(data: any): CameraPresets {
        data = typeof data === 'object' ? data : {};
        let result = new CameraPresets();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        if (Array.isArray(this.keys)) {
            data["keys"] = [];
            for (let item of this.keys)
                data["keys"].push(item);
        }
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item.toJSON());
        }
        data["count"] = this.count;
        data["isReadOnly"] = this.isReadOnly;
        super.toJSON(data);
        return data; 
    }
}

export interface ICameraPresets extends IXmlBase {
    id?: Id | undefined;
    keys?: number[] | undefined;
    values?: Preset[] | undefined;
    count: number;
    isReadOnly: boolean;
}

export class Preset extends XmlBase implements IPreset {
    presetNumber!: number;
    description?: string | undefined;
    displayString?: string | undefined;

    constructor(data?: IPreset) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.presetNumber = _data["presetNumber"];
            this.description = _data["description"];
            this.displayString = _data["displayString"];
        }
    }

    static fromJS(data: any): Preset {
        data = typeof data === 'object' ? data : {};
        let result = new Preset();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["presetNumber"] = this.presetNumber;
        data["description"] = this.description;
        data["displayString"] = this.displayString;
        super.toJSON(data);
        return data; 
    }
}

export interface IPreset extends IXmlBase {
    presetNumber: number;
    description?: string | undefined;
    displayString?: string | undefined;
}

export class RetrieveDataResponseOfStringAndDms extends BaseResponse implements IRetrieveDataResponseOfStringAndDms {
    data?: { [key: string]: Dms; } | undefined;

    constructor(data?: IRetrieveDataResponseOfStringAndDms) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        this.data![key] = _data["data"][key] ? Dms.fromJS(_data["data"][key]) : new Dms();
                }
            }
        }
    }

    static fromJS(data: any): RetrieveDataResponseOfStringAndDms {
        data = typeof data === 'object' ? data : {};
        let result = new RetrieveDataResponseOfStringAndDms();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    data["data"][key] = this.data[key] ? this.data[key].toJSON() : <any>undefined;
            }
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IRetrieveDataResponseOfStringAndDms extends IBaseResponse {
    data?: { [key: string]: Dms; } | undefined;
}

/** Configuration and status information for a DMS */
export class Dms extends XmlBase implements IDms {
    /** Gets or sets the identifier of the DMS. */
    id?: Id | undefined;
    /** Gets or sets the center identifier formatted for display */
    displayCenterId?: string | undefined;
    /** Gets or sets the DMS display name. */
    displayName?: string | undefined;
    /** Gets or sets the communication parameters for connecting to the DMS, */
    dmsComm?: DmsComm | undefined;
    /** Gets or sets the configuration data for the DMS. */
    dmsConfig?: DmsConfig | undefined;
    /** Gets or sets the current status of the DMS. */
    status?: DmsStatus | undefined;
    /** Gets the roadway. */
    roadway?: string | undefined;
    /** Gets the direction. */
    direction?: string | undefined;

    constructor(data?: IDms) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            this.displayCenterId = _data["displayCenterId"];
            this.displayName = _data["displayName"];
            this.dmsComm = _data["dmsComm"] ? DmsComm.fromJS(_data["dmsComm"]) : <any>undefined;
            this.dmsConfig = _data["dmsConfig"] ? DmsConfig.fromJS(_data["dmsConfig"]) : <any>undefined;
            this.status = _data["status"] ? DmsStatus.fromJS(_data["status"]) : <any>undefined;
            this.roadway = _data["roadway"];
            this.direction = _data["direction"];
        }
    }

    static fromJS(data: any): Dms {
        data = typeof data === 'object' ? data : {};
        let result = new Dms();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["displayCenterId"] = this.displayCenterId;
        data["displayName"] = this.displayName;
        data["dmsComm"] = this.dmsComm ? this.dmsComm.toJSON() : <any>undefined;
        data["dmsConfig"] = this.dmsConfig ? this.dmsConfig.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["roadway"] = this.roadway;
        data["direction"] = this.direction;
        super.toJSON(data);
        return data; 
    }
}

/** Configuration and status information for a DMS */
export interface IDms extends IXmlBase {
    /** Gets or sets the identifier of the DMS. */
    id?: Id | undefined;
    /** Gets or sets the center identifier formatted for display */
    displayCenterId?: string | undefined;
    /** Gets or sets the DMS display name. */
    displayName?: string | undefined;
    /** Gets or sets the communication parameters for connecting to the DMS, */
    dmsComm?: DmsComm | undefined;
    /** Gets or sets the configuration data for the DMS. */
    dmsConfig?: DmsConfig | undefined;
    /** Gets or sets the current status of the DMS. */
    status?: DmsStatus | undefined;
    /** Gets the roadway. */
    roadway?: string | undefined;
    /** Gets the direction. */
    direction?: string | undefined;
}

/** Communication parameters of the sign */
export class DmsComm extends XmlBase implements IDmsComm {
    /** Communication address of the sign */
    dmsAddress?: DmsAddress | undefined;
    /** Protocol used by the sign */
    protocol!: DmsProtocol;
    /** Driver for the sign */
    pollProcessName?: string | undefined;
    /** Time to wait for the DMS to respond to a packet sent before timing out (in seconds) */
    packetTimeout!: PacketTimeoutValue;
    /** Maximum number of times to retry sending a packet to the DMS when a packet error has been received */
    packetRetryLimit!: number;
    /** Maximum number of times to retry sending the entire command to the DMS when the cmomand has failed */
    commandRetryLimit!: number;
    /** Operational status of the DMS */
    opStatus!: number;
    opStatusEnum!: OpStatus;
    /** Poll cycle for the DMS, in minutes. */
    pollCycle!: number;

    constructor(data?: IDmsComm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dmsAddress = _data["dmsAddress"] ? DmsAddress.fromJS(_data["dmsAddress"]) : <any>undefined;
            this.protocol = _data["protocol"];
            this.pollProcessName = _data["pollProcessName"];
            this.packetTimeout = _data["packetTimeout"];
            this.packetRetryLimit = _data["packetRetryLimit"];
            this.commandRetryLimit = _data["commandRetryLimit"];
            this.opStatus = _data["opStatus"];
            this.opStatusEnum = _data["opStatusEnum"];
            this.pollCycle = _data["pollCycle"];
        }
    }

    static fromJS(data: any): DmsComm {
        data = typeof data === 'object' ? data : {};
        let result = new DmsComm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dmsAddress"] = this.dmsAddress ? this.dmsAddress.toJSON() : <any>undefined;
        data["protocol"] = this.protocol;
        data["pollProcessName"] = this.pollProcessName;
        data["packetTimeout"] = this.packetTimeout;
        data["packetRetryLimit"] = this.packetRetryLimit;
        data["commandRetryLimit"] = this.commandRetryLimit;
        data["opStatus"] = this.opStatus;
        data["opStatusEnum"] = this.opStatusEnum;
        data["pollCycle"] = this.pollCycle;
        super.toJSON(data);
        return data; 
    }
}

/** Communication parameters of the sign */
export interface IDmsComm extends IXmlBase {
    /** Communication address of the sign */
    dmsAddress?: DmsAddress | undefined;
    /** Protocol used by the sign */
    protocol: DmsProtocol;
    /** Driver for the sign */
    pollProcessName?: string | undefined;
    /** Time to wait for the DMS to respond to a packet sent before timing out (in seconds) */
    packetTimeout: PacketTimeoutValue;
    /** Maximum number of times to retry sending a packet to the DMS when a packet error has been received */
    packetRetryLimit: number;
    /** Maximum number of times to retry sending the entire command to the DMS when the cmomand has failed */
    commandRetryLimit: number;
    /** Operational status of the DMS */
    opStatus: number;
    opStatusEnum: OpStatus;
    /** Poll cycle for the DMS, in minutes. */
    pollCycle: number;
}

/** Address for a DMS */
export class DmsAddress extends XmlBase implements IDmsAddress {
    /** Address information if this is a PMPP address */
    pmppAddress?: PmppAddress | undefined;
    /** Address information if this is a SunGuide address */
    sunGuideAddress?: CommAddress | undefined;
    /** Address information if this is a Mark IV address */
    markIVAddress?: CommAddress | undefined;
    /** Address information if this is a Mark IV FTE address */
    markIVFteAddress?: CommAddress | undefined;

    constructor(data?: IDmsAddress) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pmppAddress = _data["pmppAddress"] ? PmppAddress.fromJS(_data["pmppAddress"]) : <any>undefined;
            this.sunGuideAddress = _data["sunGuideAddress"] ? CommAddress.fromJS(_data["sunGuideAddress"]) : <any>undefined;
            this.markIVAddress = _data["markIVAddress"] ? CommAddress.fromJS(_data["markIVAddress"]) : <any>undefined;
            this.markIVFteAddress = _data["markIVFteAddress"] ? CommAddress.fromJS(_data["markIVFteAddress"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DmsAddress {
        data = typeof data === 'object' ? data : {};
        let result = new DmsAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pmppAddress"] = this.pmppAddress ? this.pmppAddress.toJSON() : <any>undefined;
        data["sunGuideAddress"] = this.sunGuideAddress ? this.sunGuideAddress.toJSON() : <any>undefined;
        data["markIVAddress"] = this.markIVAddress ? this.markIVAddress.toJSON() : <any>undefined;
        data["markIVFteAddress"] = this.markIVFteAddress ? this.markIVFteAddress.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

/** Address for a DMS */
export interface IDmsAddress extends IXmlBase {
    /** Address information if this is a PMPP address */
    pmppAddress?: PmppAddress | undefined;
    /** Address information if this is a SunGuide address */
    sunGuideAddress?: CommAddress | undefined;
    /** Address information if this is a Mark IV address */
    markIVAddress?: CommAddress | undefined;
    /** Address information if this is a Mark IV FTE address */
    markIVFteAddress?: CommAddress | undefined;
}

/** Protocols used by DMSs */
export enum DmsProtocol {
    SunGuide = 0,
    MarkIV = 1,
    NtcipVersion1NoPmpp = 2,
    NtcipVersion1 = 3,
    NtcipVersion2NoPmpp = 4,
    NtcipVersion2 = 5,
    MarkIVFte = 6,
}

export enum PacketTimeoutValue {
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _15 = 15,
    _20 = 20,
}

/** The configuration of a DMS. */
export class DmsConfig extends XmlBase implements IDmsConfig {
    /** Gets or sets the mechanical type of the DMS. */
    dmsType!: DmsType;
    /** Gets or sets the DMS manufacturer. */
    dmsMfr!: string;
    /** Gets or sets the number of lines (could represent lines of characters or lines of pixels, depending on sign type. */
    numLines!: number;
    /** Gets or sets the number of columns (could represents characters or pixels, depending on sign type. */
    numColumns!: number;
    /** Gets or sets the beacon settings. */
    hasBeacons?: DmsBeaconAddressWrapper | undefined;
    /** Gets or sets the value used for sign brightness during the day */
    brightnessLevelDay?: BrightnessLevelWrapper | undefined;
    /** Gets or sets the value used for sign brightness during the night */
    brightnessLevelNight?: BrightnessLevelWrapper | undefined;
    /** Gets or sets the location information for the DMS. */
    equipmentLocation?: EquipmentLocation | undefined;
    /** Gets or sets the display type of the sign. */
    signType!: SignType;
    /** Gets or sets the expected use of the sign. */
    signUse!: SignUse;
    /** Gets or sets a value indicating whether the device may be published to third parties via C2C. */
    canPublish!: boolean;
    /** Gets or sets a value indicating whether the DMS supports color messages. */
    colorSupport!: boolean;
    /** Gets or sets a value indicating whether the DMS supports graphics. */
    graphicSupport!: boolean;
    /** Gets or sets a value indicating whether the DMS supports font management */
    fontSupport!: boolean;
    /** Gets or sets a value indicating whether this DMS should force blank on a failure of the device.  This setting is optional. */
    forceBlankOnFailure?: boolean | undefined;
    /** Gets or sets a value indicating whether the DMS will auto-merge messages by default. */
    defaultAutoMerge!: boolean;
    /** Gets or sets the list of available fonts. */
    availableFonts?: FontReference[] | undefined;
    /** Gets or sets a value indicating whether this DMS is designated for arterial use. */
    isArterial!: boolean;
    /** Gets or sets the camera id associated to the sign */
    cameraId?: Id | undefined;
    /** Gets or sets the camera preset. */
    cameraPreset?: number | undefined;
    /** Gets the default font. */
    defaultFont?: FontReference | undefined;
    /** Gets the default page off time. */
    pageOffTime?: number | undefined;
    forceBlankOnFailureSpecified!: boolean;
    cameraPresetSpecified!: boolean;

    constructor(data?: IDmsConfig) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dmsType = _data["dmsType"];
            this.dmsMfr = _data["dmsMfr"];
            this.numLines = _data["numLines"];
            this.numColumns = _data["numColumns"];
            this.hasBeacons = _data["hasBeacons"] ? DmsBeaconAddressWrapper.fromJS(_data["hasBeacons"]) : <any>undefined;
            this.brightnessLevelDay = _data["brightnessLevelDay"] ? BrightnessLevelWrapper.fromJS(_data["brightnessLevelDay"]) : <any>undefined;
            this.brightnessLevelNight = _data["brightnessLevelNight"] ? BrightnessLevelWrapper.fromJS(_data["brightnessLevelNight"]) : <any>undefined;
            this.equipmentLocation = _data["equipmentLocation"] ? EquipmentLocation.fromJS(_data["equipmentLocation"]) : <any>undefined;
            this.signType = _data["signType"];
            this.signUse = _data["signUse"];
            this.canPublish = _data["canPublish"];
            this.colorSupport = _data["colorSupport"];
            this.graphicSupport = _data["graphicSupport"];
            this.fontSupport = _data["fontSupport"];
            this.forceBlankOnFailure = _data["forceBlankOnFailure"];
            this.defaultAutoMerge = _data["defaultAutoMerge"];
            if (Array.isArray(_data["availableFonts"])) {
                this.availableFonts = [] as any;
                for (let item of _data["availableFonts"])
                    this.availableFonts!.push(FontReference.fromJS(item));
            }
            this.isArterial = _data["isArterial"];
            this.cameraId = _data["cameraId"] ? Id.fromJS(_data["cameraId"]) : <any>undefined;
            this.cameraPreset = _data["cameraPreset"];
            this.defaultFont = _data["defaultFont"] ? FontReference.fromJS(_data["defaultFont"]) : <any>undefined;
            this.pageOffTime = _data["pageOffTime"];
            this.forceBlankOnFailureSpecified = _data["forceBlankOnFailureSpecified"];
            this.cameraPresetSpecified = _data["cameraPresetSpecified"];
        }
    }

    static fromJS(data: any): DmsConfig {
        data = typeof data === 'object' ? data : {};
        let result = new DmsConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dmsType"] = this.dmsType;
        data["dmsMfr"] = this.dmsMfr;
        data["numLines"] = this.numLines;
        data["numColumns"] = this.numColumns;
        data["hasBeacons"] = this.hasBeacons ? this.hasBeacons.toJSON() : <any>undefined;
        data["brightnessLevelDay"] = this.brightnessLevelDay ? this.brightnessLevelDay.toJSON() : <any>undefined;
        data["brightnessLevelNight"] = this.brightnessLevelNight ? this.brightnessLevelNight.toJSON() : <any>undefined;
        data["equipmentLocation"] = this.equipmentLocation ? this.equipmentLocation.toJSON() : <any>undefined;
        data["signType"] = this.signType;
        data["signUse"] = this.signUse;
        data["canPublish"] = this.canPublish;
        data["colorSupport"] = this.colorSupport;
        data["graphicSupport"] = this.graphicSupport;
        data["fontSupport"] = this.fontSupport;
        data["forceBlankOnFailure"] = this.forceBlankOnFailure;
        data["defaultAutoMerge"] = this.defaultAutoMerge;
        if (Array.isArray(this.availableFonts)) {
            data["availableFonts"] = [];
            for (let item of this.availableFonts)
                data["availableFonts"].push(item.toJSON());
        }
        data["isArterial"] = this.isArterial;
        data["cameraId"] = this.cameraId ? this.cameraId.toJSON() : <any>undefined;
        data["cameraPreset"] = this.cameraPreset;
        data["defaultFont"] = this.defaultFont ? this.defaultFont.toJSON() : <any>undefined;
        data["pageOffTime"] = this.pageOffTime;
        data["forceBlankOnFailureSpecified"] = this.forceBlankOnFailureSpecified;
        data["cameraPresetSpecified"] = this.cameraPresetSpecified;
        super.toJSON(data);
        return data; 
    }
}

/** The configuration of a DMS. */
export interface IDmsConfig extends IXmlBase {
    /** Gets or sets the mechanical type of the DMS. */
    dmsType: DmsType;
    /** Gets or sets the DMS manufacturer. */
    dmsMfr: string;
    /** Gets or sets the number of lines (could represent lines of characters or lines of pixels, depending on sign type. */
    numLines: number;
    /** Gets or sets the number of columns (could represents characters or pixels, depending on sign type. */
    numColumns: number;
    /** Gets or sets the beacon settings. */
    hasBeacons?: DmsBeaconAddressWrapper | undefined;
    /** Gets or sets the value used for sign brightness during the day */
    brightnessLevelDay?: BrightnessLevelWrapper | undefined;
    /** Gets or sets the value used for sign brightness during the night */
    brightnessLevelNight?: BrightnessLevelWrapper | undefined;
    /** Gets or sets the location information for the DMS. */
    equipmentLocation?: EquipmentLocation | undefined;
    /** Gets or sets the display type of the sign. */
    signType: SignType;
    /** Gets or sets the expected use of the sign. */
    signUse: SignUse;
    /** Gets or sets a value indicating whether the device may be published to third parties via C2C. */
    canPublish: boolean;
    /** Gets or sets a value indicating whether the DMS supports color messages. */
    colorSupport: boolean;
    /** Gets or sets a value indicating whether the DMS supports graphics. */
    graphicSupport: boolean;
    /** Gets or sets a value indicating whether the DMS supports font management */
    fontSupport: boolean;
    /** Gets or sets a value indicating whether this DMS should force blank on a failure of the device.  This setting is optional. */
    forceBlankOnFailure?: boolean | undefined;
    /** Gets or sets a value indicating whether the DMS will auto-merge messages by default. */
    defaultAutoMerge: boolean;
    /** Gets or sets the list of available fonts. */
    availableFonts?: FontReference[] | undefined;
    /** Gets or sets a value indicating whether this DMS is designated for arterial use. */
    isArterial: boolean;
    /** Gets or sets the camera id associated to the sign */
    cameraId?: Id | undefined;
    /** Gets or sets the camera preset. */
    cameraPreset?: number | undefined;
    /** Gets the default font. */
    defaultFont?: FontReference | undefined;
    /** Gets the default page off time. */
    pageOffTime?: number | undefined;
    forceBlankOnFailureSpecified: boolean;
    cameraPresetSpecified: boolean;
}

/** Types of DMSs */
export enum DmsType {
    FiberOptic = 0,
    LED = 1,
    FlipDisk = 2,
    Shutter = 3,
    FullMatrix = 4,
    Bulb = 5,
    Drum = 6,
    Other = 7,
}

export class DmsBeaconAddressWrapper extends XmlBase implements IDmsBeaconAddressWrapper {
    value!: boolean;
    /** Gets or sets the serialized value of Value */
    serializedValue?: string | undefined;
    beaconAddress!: number;

    constructor(data?: IDmsBeaconAddressWrapper) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
            this.serializedValue = _data["serializedValue"];
            this.beaconAddress = _data["beaconAddress"];
        }
    }

    static fromJS(data: any): DmsBeaconAddressWrapper {
        data = typeof data === 'object' ? data : {};
        let result = new DmsBeaconAddressWrapper();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["serializedValue"] = this.serializedValue;
        data["beaconAddress"] = this.beaconAddress;
        super.toJSON(data);
        return data; 
    }
}

export interface IDmsBeaconAddressWrapper extends IXmlBase {
    value: boolean;
    /** Gets or sets the serialized value of Value */
    serializedValue?: string | undefined;
    beaconAddress: number;
}

/** Contains a brightness level setting */
export class BrightnessLevelWrapper extends XmlBase implements IBrightnessLevelWrapper {
    /** The represented brightness level */
    brightnessLevel!: number;

    constructor(data?: IBrightnessLevelWrapper) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.brightnessLevel = _data["brightnessLevel"];
        }
    }

    static fromJS(data: any): BrightnessLevelWrapper {
        data = typeof data === 'object' ? data : {};
        let result = new BrightnessLevelWrapper();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brightnessLevel"] = this.brightnessLevel;
        super.toJSON(data);
        return data; 
    }
}

/** Contains a brightness level setting */
export interface IBrightnessLevelWrapper extends IXmlBase {
    /** The represented brightness level */
    brightnessLevel: number;
}

/** Sign type of DMS */
export enum SignType {
    Char = 0,
    LineMatrix = 1,
    FullMatrix = 2,
    Drum = 3,
}

/** Expected use of a sign */
export enum SignUse {
    General = 0,
    VSL = 1,
    Toll = 2,
    TollLaneStatus = 3,
    TruckParking = 4,
    ManagedLanes = 5,
}

/** A reference to a DMS font. */
export class FontReference extends XmlBase implements IFontReference {
    /** Gets or sets the id of the reference font. */
    id?: Id | undefined;
    /** Gets or sets the sort order. */
    sortOrder!: number;
    /** Gets or sets a value indicating whether this is the sign default font. */
    isDefault!: boolean;
    /** Gets or sets the NTCIP details of this font reference. */
    ntcip?: NtcipFontDetails | undefined;

    constructor(data?: IFontReference) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            this.sortOrder = _data["sortOrder"];
            this.isDefault = _data["isDefault"];
            this.ntcip = _data["ntcip"] ? NtcipFontDetails.fromJS(_data["ntcip"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FontReference {
        data = typeof data === 'object' ? data : {};
        let result = new FontReference();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["sortOrder"] = this.sortOrder;
        data["isDefault"] = this.isDefault;
        data["ntcip"] = this.ntcip ? this.ntcip.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

/** A reference to a DMS font. */
export interface IFontReference extends IXmlBase {
    /** Gets or sets the id of the reference font. */
    id?: Id | undefined;
    /** Gets or sets the sort order. */
    sortOrder: number;
    /** Gets or sets a value indicating whether this is the sign default font. */
    isDefault: boolean;
    /** Gets or sets the NTCIP details of this font reference. */
    ntcip?: NtcipFontDetails | undefined;
}

/** Represents font data within an NTCIP DMS font table. */
export class NtcipFontDetails extends XmlBase implements INtcipFontDetails {
    /** Gets or sets the index (row) of the font table within the device. */
    index!: number;
    /** Gets or sets the font number.
This is the value that is used when referencing a font within MULTI, or the
default font specified by the device. */
    number!: number;
    /** Gets or sets the internal name of the font. */
    name?: string | undefined;
    /** Gets or sets the NTCIP version id.
This is a checksum value in the format "12AB" representing the ushort crc value. */
    crc?: string | undefined;
    /** Gets or sets the Crc that our internal algorithm calculates. */
    calculatedCrc?: string | undefined;
    /** Gets or sets the status of the row in the font table. */
    status?: NtcipFontStatus | undefined;
    statusSpecified!: boolean;

    constructor(data?: INtcipFontDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.index = _data["index"];
            this.number = _data["number"];
            this.name = _data["name"];
            this.crc = _data["crc"];
            this.calculatedCrc = _data["calculatedCrc"];
            this.status = _data["status"];
            this.statusSpecified = _data["statusSpecified"];
        }
    }

    static fromJS(data: any): NtcipFontDetails {
        data = typeof data === 'object' ? data : {};
        let result = new NtcipFontDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index;
        data["number"] = this.number;
        data["name"] = this.name;
        data["crc"] = this.crc;
        data["calculatedCrc"] = this.calculatedCrc;
        data["status"] = this.status;
        data["statusSpecified"] = this.statusSpecified;
        super.toJSON(data);
        return data; 
    }
}

/** Represents font data within an NTCIP DMS font table. */
export interface INtcipFontDetails extends IXmlBase {
    /** Gets or sets the index (row) of the font table within the device. */
    index: number;
    /** Gets or sets the font number.
This is the value that is used when referencing a font within MULTI, or the
default font specified by the device. */
    number: number;
    /** Gets or sets the internal name of the font. */
    name?: string | undefined;
    /** Gets or sets the NTCIP version id.
This is a checksum value in the format "12AB" representing the ushort crc value. */
    crc?: string | undefined;
    /** Gets or sets the Crc that our internal algorithm calculates. */
    calculatedCrc?: string | undefined;
    /** Gets or sets the status of the row in the font table. */
    status?: NtcipFontStatus | undefined;
    statusSpecified: boolean;
}

export enum NtcipFontStatus {
    NotUsed = 1,
    Modifying = 2,
    CalculatingID = 3,
    ReadyForUse = 4,
    InUse = 5,
    Permanent = 6,
    ModifyReq = 7,
    ReadyForUseReq = 8,
    NotUsedReq = 9,
    UnmanagedReq = 10,
    Unmanaged = 11,
}

export class EquipmentStatus extends XmlStatusBase implements IEquipmentStatus {
    intOpStatusSpecified!: boolean;
    opStatusSpecified!: boolean;
    /** Integer accessor for op status; code should use enum version. */
    intOpStatus!: number;
    /** Enumerated version of op status; code should use this verison. */
    opStatus!: OpStatus;

    constructor(data?: IEquipmentStatus) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.intOpStatusSpecified = _data["intOpStatusSpecified"];
            this.opStatusSpecified = _data["opStatusSpecified"];
            this.intOpStatus = _data["intOpStatus"];
            this.opStatus = _data["opStatus"];
        }
    }

    static fromJS(data: any): EquipmentStatus {
        data = typeof data === 'object' ? data : {};
        let result = new EquipmentStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["intOpStatusSpecified"] = this.intOpStatusSpecified;
        data["opStatusSpecified"] = this.opStatusSpecified;
        data["intOpStatus"] = this.intOpStatus;
        data["opStatus"] = this.opStatus;
        super.toJSON(data);
        return data; 
    }
}

export interface IEquipmentStatus extends IXmlStatusBase {
    intOpStatusSpecified: boolean;
    opStatusSpecified: boolean;
    /** Integer accessor for op status; code should use enum version. */
    intOpStatus: number;
    /** Enumerated version of op status; code should use this verison. */
    opStatus: OpStatus;
}

/** Status of a DMS device */
export class DmsStatus extends EquipmentStatus implements IDmsStatus {
    /** Control mode of the DMS */
    controlMode!: ControlMode;
    /** Power status of the DMS */
    powerStatus!: PowerStatus;
    /** Temperature of the DMS controller cabinet in deg C */
    temperature?: DmsStatusTemperature | undefined;
    /** Brightness level of the DMS */
    brightnessLevel!: number;
    /** Brightness mode of the DMS */
    brightnessMode!: BrightnessMode;
    /** Indicates whether any pixels have failed */
    pixelFailure!: boolean;
    /** Indicates whether there are any lamp errors */
    lampError!: boolean;
    /** Any fan errors that have occurred */
    fanStatus?: FanStatus | undefined;
    /** Message being displayed on the sign */
    multiMsg?: MultiMsg | undefined;
    /** The last time a status poll was sent and received for this DMS */
    lastSuccessfulPoll!: Date;
    /** The list time a message or terminate was sent and received for this DMS */
    lastSuccessfulMessage!: Date;
    /** The last time communication (successful OR unsuccessful) was attempted */
    lastCommAttempt!: Date;
    ntcipStatus?: NtcipStatusWrapper | undefined;

    constructor(data?: IDmsStatus) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.controlMode = _data["controlMode"];
            this.powerStatus = _data["powerStatus"];
            this.temperature = _data["temperature"] ? DmsStatusTemperature.fromJS(_data["temperature"]) : <any>undefined;
            this.brightnessLevel = _data["brightnessLevel"];
            this.brightnessMode = _data["brightnessMode"];
            this.pixelFailure = _data["pixelFailure"];
            this.lampError = _data["lampError"];
            this.fanStatus = _data["fanStatus"] ? FanStatus.fromJS(_data["fanStatus"]) : <any>undefined;
            this.multiMsg = _data["multiMsg"] ? MultiMsg.fromJS(_data["multiMsg"]) : <any>undefined;
            this.lastSuccessfulPoll = _data["lastSuccessfulPoll"] ? new Date(_data["lastSuccessfulPoll"].toString()) : <any>undefined;
            this.lastSuccessfulMessage = _data["lastSuccessfulMessage"] ? new Date(_data["lastSuccessfulMessage"].toString()) : <any>undefined;
            this.lastCommAttempt = _data["lastCommAttempt"] ? new Date(_data["lastCommAttempt"].toString()) : <any>undefined;
            this.ntcipStatus = _data["ntcipStatus"] ? NtcipStatusWrapper.fromJS(_data["ntcipStatus"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DmsStatus {
        data = typeof data === 'object' ? data : {};
        let result = new DmsStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["controlMode"] = this.controlMode;
        data["powerStatus"] = this.powerStatus;
        data["temperature"] = this.temperature ? this.temperature.toJSON() : <any>undefined;
        data["brightnessLevel"] = this.brightnessLevel;
        data["brightnessMode"] = this.brightnessMode;
        data["pixelFailure"] = this.pixelFailure;
        data["lampError"] = this.lampError;
        data["fanStatus"] = this.fanStatus ? this.fanStatus.toJSON() : <any>undefined;
        data["multiMsg"] = this.multiMsg ? this.multiMsg.toJSON() : <any>undefined;
        data["lastSuccessfulPoll"] = this.lastSuccessfulPoll ? this.lastSuccessfulPoll.toISOString() : <any>undefined;
        data["lastSuccessfulMessage"] = this.lastSuccessfulMessage ? this.lastSuccessfulMessage.toISOString() : <any>undefined;
        data["lastCommAttempt"] = this.lastCommAttempt ? this.lastCommAttempt.toISOString() : <any>undefined;
        data["ntcipStatus"] = this.ntcipStatus ? this.ntcipStatus.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

/** Status of a DMS device */
export interface IDmsStatus extends IEquipmentStatus {
    /** Control mode of the DMS */
    controlMode: ControlMode;
    /** Power status of the DMS */
    powerStatus: PowerStatus;
    /** Temperature of the DMS controller cabinet in deg C */
    temperature?: DmsStatusTemperature | undefined;
    /** Brightness level of the DMS */
    brightnessLevel: number;
    /** Brightness mode of the DMS */
    brightnessMode: BrightnessMode;
    /** Indicates whether any pixels have failed */
    pixelFailure: boolean;
    /** Indicates whether there are any lamp errors */
    lampError: boolean;
    /** Any fan errors that have occurred */
    fanStatus?: FanStatus | undefined;
    /** Message being displayed on the sign */
    multiMsg?: MultiMsg | undefined;
    /** The last time a status poll was sent and received for this DMS */
    lastSuccessfulPoll: Date;
    /** The list time a message or terminate was sent and received for this DMS */
    lastSuccessfulMessage: Date;
    /** The last time communication (successful OR unsuccessful) was attempted */
    lastCommAttempt: Date;
    ntcipStatus?: NtcipStatusWrapper | undefined;
}

/** Possible control modes for a DMS */
export enum ControlMode {
    Unknown = 0,
    Other = 1,
    Local = 2,
    External = 3,
    Central = 4,
    CentralOverride = 5,
    Simulation = 6,
}

/** Possible power states for a DMS */
export enum PowerStatus {
    Unknown = 0,
    Other = 1,
    PowerShutdown = 2,
    NoSignPower = 3,
    ACLine = 4,
    Generator = 5,
    Solar = 6,
    Battery = 7,
}

/** Temperature status of a DMS */
export class DmsStatusTemperature extends XmlBase implements IDmsStatusTemperature {
    /** Whether an error was encoutered retrieving the temperature */
    temperatureError!: boolean;
    /** Temperature of the DMS controller cabinet in deg C */
    temperature!: number;
    /** Text version of temperature for serialization */
    tempStr?: string | undefined;

    constructor(data?: IDmsStatusTemperature) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.temperatureError = _data["temperatureError"];
            this.temperature = _data["temperature"];
            this.tempStr = _data["tempStr"];
        }
    }

    static fromJS(data: any): DmsStatusTemperature {
        data = typeof data === 'object' ? data : {};
        let result = new DmsStatusTemperature();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["temperatureError"] = this.temperatureError;
        data["temperature"] = this.temperature;
        data["tempStr"] = this.tempStr;
        super.toJSON(data);
        return data; 
    }
}

/** Temperature status of a DMS */
export interface IDmsStatusTemperature extends IXmlBase {
    /** Whether an error was encoutered retrieving the temperature */
    temperatureError: boolean;
    /** Temperature of the DMS controller cabinet in deg C */
    temperature: number;
    /** Text version of temperature for serialization */
    tempStr?: string | undefined;
}

/** Possible brightness modes for a DMS */
export enum BrightnessMode {
    Other = 1,
    Auto = 2,
    Timer = 3,
    Manual = 4,
    Illegal = 5,
}

/** Represents detailed fan status of a DMS */
export class FanStatus extends XmlBase implements IFanStatus {
    /** Whether there is a fan error */
    fanError!: boolean;
    /** Length of the fan status array */
    fanStatusArrayLength!: number;
    /** Fan status of the DMS */
    fanStatusArray?: string | undefined;

    constructor(data?: IFanStatus) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fanError = _data["fanError"];
            this.fanStatusArrayLength = _data["fanStatusArrayLength"];
            this.fanStatusArray = _data["fanStatusArray"];
        }
    }

    static fromJS(data: any): FanStatus {
        data = typeof data === 'object' ? data : {};
        let result = new FanStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fanError"] = this.fanError;
        data["fanStatusArrayLength"] = this.fanStatusArrayLength;
        data["fanStatusArray"] = this.fanStatusArray;
        super.toJSON(data);
        return data; 
    }
}

/** Represents detailed fan status of a DMS */
export interface IFanStatus extends IXmlBase {
    /** Whether there is a fan error */
    fanError: boolean;
    /** Length of the fan status array */
    fanStatusArrayLength: number;
    /** Fan status of the DMS */
    fanStatusArray?: string | undefined;
}

export class NtcipStatusWrapper extends XmlBase implements INtcipStatusWrapper {
    status!: NtcipStatusEnum;
    description?: string | undefined;
    ntcipConfig?: NtcipConfiguration | undefined;

    constructor(data?: INtcipStatusWrapper) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
            this.description = _data["description"];
            this.ntcipConfig = _data["ntcipConfig"] ? NtcipConfiguration.fromJS(_data["ntcipConfig"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NtcipStatusWrapper {
        data = typeof data === 'object' ? data : {};
        let result = new NtcipStatusWrapper();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["description"] = this.description;
        data["ntcipConfig"] = this.ntcipConfig ? this.ntcipConfig.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface INtcipStatusWrapper extends IXmlBase {
    status: NtcipStatusEnum;
    description?: string | undefined;
    ntcipConfig?: NtcipConfiguration | undefined;
}

export enum NtcipStatusEnum {
    OK = 0,
    InitialStatus = 1,
    NoData = 2,
    NoFont = 3,
    ConfigMismatch = 4,
}

/** Represents a selection of NTCIP configuration data for a DMS device. */
export class NtcipConfiguration extends XmlBase implements INtcipConfiguration {
    /** Gets or sets the type of sign. */
    dmsSignType!: DmsSignType;
    /** Gets or sets the DMS sign technologies supported.  Multiple values are supported.
(e.g. "LED FlipDisk Bulb" is a valid value) */
    dmsSignTechnology!: DmsSignTechnology;
    /** Gets or sets the height of a single character in Pixels.
The value zero (0) indicates a variable character height, which implies a full-matrix */
    vmsCharacterHeightPixels!: number;
    /** Gets or sets the width of a single character in Pixels.
The value zero (0) indicates a variable character width, which implies either a full-matrix or line-matrix sign. */
    vmsCharacterWidthPixels!: number;
    /** Gets or sets the number of rows of pixels for the entire sign.
To determine the number of lines for a line matrix or character matrix sign, divide the vmsSignHeightPixels
object value by the vmsCharacterHeightPixels object value. This should result in a whole number, the number of lines in the sign. */
    vmsSignHeightPixels!: number;
    /** Gets or sets the The number of columns of pixels for the entire sign.
To determine the number of characters for a character matrix sign, divide the vmsSignWidthPixels object value by the
vmsCharacterWidthPixels object value. This results in the number of characters per line for the sign. */
    vmsSignWidthPixels!: number;
    /** Gets or sets the color scheme supported by the DMS. */
    dmsColorScheme!: DmsColorScheme;
    /** Gets or sets the maximum number of graphics that the sign can store. */
    dmsGraphicMaxEntries!: number;
    /** Gets or sets the default font number in the sign. */
    defaultFontNumber!: number;
    /** Gets or sets the number of supported fonts. */
    numFonts!: number;
    /** Gets or sets the number of characters per font. */
    maxFontCharacters!: number;
    /** Gets or sets the fonts. */
    fonts?: Font[] | undefined;

    constructor(data?: INtcipConfiguration) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dmsSignType = _data["dmsSignType"];
            this.dmsSignTechnology = _data["dmsSignTechnology"];
            this.vmsCharacterHeightPixels = _data["vmsCharacterHeightPixels"];
            this.vmsCharacterWidthPixels = _data["vmsCharacterWidthPixels"];
            this.vmsSignHeightPixels = _data["vmsSignHeightPixels"];
            this.vmsSignWidthPixels = _data["vmsSignWidthPixels"];
            this.dmsColorScheme = _data["dmsColorScheme"];
            this.dmsGraphicMaxEntries = _data["dmsGraphicMaxEntries"];
            this.defaultFontNumber = _data["defaultFontNumber"];
            this.numFonts = _data["numFonts"];
            this.maxFontCharacters = _data["maxFontCharacters"];
            if (Array.isArray(_data["fonts"])) {
                this.fonts = [] as any;
                for (let item of _data["fonts"])
                    this.fonts!.push(Font.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NtcipConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new NtcipConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dmsSignType"] = this.dmsSignType;
        data["dmsSignTechnology"] = this.dmsSignTechnology;
        data["vmsCharacterHeightPixels"] = this.vmsCharacterHeightPixels;
        data["vmsCharacterWidthPixels"] = this.vmsCharacterWidthPixels;
        data["vmsSignHeightPixels"] = this.vmsSignHeightPixels;
        data["vmsSignWidthPixels"] = this.vmsSignWidthPixels;
        data["dmsColorScheme"] = this.dmsColorScheme;
        data["dmsGraphicMaxEntries"] = this.dmsGraphicMaxEntries;
        data["defaultFontNumber"] = this.defaultFontNumber;
        data["numFonts"] = this.numFonts;
        data["maxFontCharacters"] = this.maxFontCharacters;
        if (Array.isArray(this.fonts)) {
            data["fonts"] = [];
            for (let item of this.fonts)
                data["fonts"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

/** Represents a selection of NTCIP configuration data for a DMS device. */
export interface INtcipConfiguration extends IXmlBase {
    /** Gets or sets the type of sign. */
    dmsSignType: DmsSignType;
    /** Gets or sets the DMS sign technologies supported.  Multiple values are supported.
(e.g. "LED FlipDisk Bulb" is a valid value) */
    dmsSignTechnology: DmsSignTechnology;
    /** Gets or sets the height of a single character in Pixels.
The value zero (0) indicates a variable character height, which implies a full-matrix */
    vmsCharacterHeightPixels: number;
    /** Gets or sets the width of a single character in Pixels.
The value zero (0) indicates a variable character width, which implies either a full-matrix or line-matrix sign. */
    vmsCharacterWidthPixels: number;
    /** Gets or sets the number of rows of pixels for the entire sign.
To determine the number of lines for a line matrix or character matrix sign, divide the vmsSignHeightPixels
object value by the vmsCharacterHeightPixels object value. This should result in a whole number, the number of lines in the sign. */
    vmsSignHeightPixels: number;
    /** Gets or sets the The number of columns of pixels for the entire sign.
To determine the number of characters for a character matrix sign, divide the vmsSignWidthPixels object value by the
vmsCharacterWidthPixels object value. This results in the number of characters per line for the sign. */
    vmsSignWidthPixels: number;
    /** Gets or sets the color scheme supported by the DMS. */
    dmsColorScheme: DmsColorScheme;
    /** Gets or sets the maximum number of graphics that the sign can store. */
    dmsGraphicMaxEntries: number;
    /** Gets or sets the default font number in the sign. */
    defaultFontNumber: number;
    /** Gets or sets the number of supported fonts. */
    numFonts: number;
    /** Gets or sets the number of characters per font. */
    maxFontCharacters: number;
    /** Gets or sets the fonts. */
    fonts?: Font[] | undefined;
}

/** Maps directly to NTCIP 1203 v02.39 Section 5.2.2 Sign Type (page 135) PDF viewer page 153/331 */
export enum DmsSignType {
    Other = 1,
    BlankOut = 2,
    Changeable = 3,
    Char = 4,
    LineMatrix = 5,
    FullMatrix = 6,
    OtherPortable = 129,
    BlankOutPortable = 130,
    ChangeablePortable = 131,
    CharPortable = 132,
    LineMatrixPortable = 133,
    FullMatrixPortable = 134,
}

/** Maps directly to NTCIP 1203 v02.39 Section 5.2.9 Sign Technology (page 138) PDF viewer page 156/331 */
export enum DmsSignTechnology {
    None = 0,
    Other = 1,
    LED = 2,
    FlipDisk = 4,
    FiberOptics = 8,
    Shuttered = 16,
    Bulb = 32,
    Drum = 64,
}

/** Maps directly to NTCIP 1203 v02.39 Section 5.5.22 Color Scheme (page 152) PDF viewer page 170/331 */
export enum DmsColorScheme {
    Monochrome1Bit = 1,
    Monochrome8Bit = 2,
    ColorClassic = 3,
    Color24Bit = 4,
}

/** Represents a font configuration. */
export class Font extends XmlBase implements IFont {
    /** Gets or sets identifier of the font. */
    id?: Id | undefined;
    /** Gets or sets name of the font */
    name?: string | undefined;
    /** Gets or sets width of a non-specified character. */
    width!: number;
    /** Gets or sets line height for this font */
    height!: number;
    /** Gets or sets the number of pixels between characters for this font. */
    charSpacing!: number;
    /** Gets or sets the number of pixels between lines for this font. */
    lineSpacing!: number;
    /** Gets or sets the optional calculated CRC. */
    crc?: string | undefined;
    /** Gets or sets the NTCIP details for this font. */
    ntcip?: NtcipFontDetails | undefined;
    /** Gets or sets information about characters whose widths differ from the default. */
    characters?: Character[] | undefined;

    constructor(data?: IFont) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            this.name = _data["name"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.charSpacing = _data["charSpacing"];
            this.lineSpacing = _data["lineSpacing"];
            this.crc = _data["crc"];
            this.ntcip = _data["ntcip"] ? NtcipFontDetails.fromJS(_data["ntcip"]) : <any>undefined;
            if (Array.isArray(_data["characters"])) {
                this.characters = [] as any;
                for (let item of _data["characters"])
                    this.characters!.push(Character.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Font {
        data = typeof data === 'object' ? data : {};
        let result = new Font();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["width"] = this.width;
        data["height"] = this.height;
        data["charSpacing"] = this.charSpacing;
        data["lineSpacing"] = this.lineSpacing;
        data["crc"] = this.crc;
        data["ntcip"] = this.ntcip ? this.ntcip.toJSON() : <any>undefined;
        if (Array.isArray(this.characters)) {
            data["characters"] = [];
            for (let item of this.characters)
                data["characters"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

/** Represents a font configuration. */
export interface IFont extends IXmlBase {
    /** Gets or sets identifier of the font. */
    id?: Id | undefined;
    /** Gets or sets name of the font */
    name?: string | undefined;
    /** Gets or sets width of a non-specified character. */
    width: number;
    /** Gets or sets line height for this font */
    height: number;
    /** Gets or sets the number of pixels between characters for this font. */
    charSpacing: number;
    /** Gets or sets the number of pixels between lines for this font. */
    lineSpacing: number;
    /** Gets or sets the optional calculated CRC. */
    crc?: string | undefined;
    /** Gets or sets the NTCIP details for this font. */
    ntcip?: NtcipFontDetails | undefined;
    /** Gets or sets information about characters whose widths differ from the default. */
    characters?: Character[] | undefined;
}

/** Represents a font character. */
export class Character extends XmlBase implements ICharacter {
    /** Gets or sets the ASCII code value of the character. */
    number!: number;
    /** Gets or sets character specified as a one character string */
    char?: string | undefined;
    /** Gets or sets width of this character in pixels. */
    width!: number;
    /** Gets or sets the bitmap as bytes. */
    bitmap?: string | undefined;
    /** Gets or sets the bitmap as a hex-string padded with space character. */
    bitmapString?: string | undefined;

    constructor(data?: ICharacter) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.number = _data["number"];
            this.char = _data["char"];
            this.width = _data["width"];
            this.bitmap = _data["bitmap"];
            this.bitmapString = _data["bitmapString"];
        }
    }

    static fromJS(data: any): Character {
        data = typeof data === 'object' ? data : {};
        let result = new Character();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["char"] = this.char;
        data["width"] = this.width;
        data["bitmap"] = this.bitmap;
        data["bitmapString"] = this.bitmapString;
        super.toJSON(data);
        return data; 
    }
}

/** Represents a font character. */
export interface ICharacter extends IXmlBase {
    /** Gets or sets the ASCII code value of the character. */
    number: number;
    /** Gets or sets character specified as a one character string */
    char?: string | undefined;
    /** Gets or sets width of this character in pixels. */
    width: number;
    /** Gets or sets the bitmap as bytes. */
    bitmap?: string | undefined;
    /** Gets or sets the bitmap as a hex-string padded with space character. */
    bitmapString?: string | undefined;
}

export class RetrieveDataResponseOfStringAndFont extends BaseResponse implements IRetrieveDataResponseOfStringAndFont {
    data?: { [key: string]: Font; } | undefined;

    constructor(data?: IRetrieveDataResponseOfStringAndFont) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        this.data![key] = _data["data"][key] ? Font.fromJS(_data["data"][key]) : new Font();
                }
            }
        }
    }

    static fromJS(data: any): RetrieveDataResponseOfStringAndFont {
        data = typeof data === 'object' ? data : {};
        let result = new RetrieveDataResponseOfStringAndFont();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    data["data"][key] = this.data[key] ? this.data[key].toJSON() : <any>undefined;
            }
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IRetrieveDataResponseOfStringAndFont extends IBaseResponse {
    data?: { [key: string]: Font; } | undefined;
}

export class RetrieveDataResponseOfStringAndGraphic extends BaseResponse implements IRetrieveDataResponseOfStringAndGraphic {
    data?: { [key: string]: Graphic; } | undefined;

    constructor(data?: IRetrieveDataResponseOfStringAndGraphic) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        this.data![key] = _data["data"][key] ? Graphic.fromJS(_data["data"][key]) : new Graphic();
                }
            }
        }
    }

    static fromJS(data: any): RetrieveDataResponseOfStringAndGraphic {
        data = typeof data === 'object' ? data : {};
        let result = new RetrieveDataResponseOfStringAndGraphic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    data["data"][key] = this.data[key] ? this.data[key].toJSON() : <any>undefined;
            }
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IRetrieveDataResponseOfStringAndGraphic extends IBaseResponse {
    data?: { [key: string]: Graphic; } | undefined;
}

/** A graphic that can be placed on a sign. */
export class Graphic extends XmlBase implements IGraphic {
    /** Gets or sets the identifier of the graphic */
    id?: Id | undefined;
    /** Gets or sets the name of this graphic. */
    displayName?: string | undefined;
    /** Gets or sets the graphic data. */
    graphicData?: string | undefined;
    /** Gets or sets the width of the image, in pixels. */
    width?: number | undefined;
    /** Gets or sets the height of the image, in pixels. */
    height?: number | undefined;
    /** Gets or sets graphics of the same name with a different size. */
    similarGraphics?: Id[] | undefined;
    widthSpecified!: boolean;
    heightSpecified!: boolean;

    constructor(data?: IGraphic) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            this.displayName = _data["displayName"];
            this.graphicData = _data["graphicData"];
            this.width = _data["width"];
            this.height = _data["height"];
            if (Array.isArray(_data["similarGraphics"])) {
                this.similarGraphics = [] as any;
                for (let item of _data["similarGraphics"])
                    this.similarGraphics!.push(Id.fromJS(item));
            }
            this.widthSpecified = _data["widthSpecified"];
            this.heightSpecified = _data["heightSpecified"];
        }
    }

    static fromJS(data: any): Graphic {
        data = typeof data === 'object' ? data : {};
        let result = new Graphic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["displayName"] = this.displayName;
        data["graphicData"] = this.graphicData;
        data["width"] = this.width;
        data["height"] = this.height;
        if (Array.isArray(this.similarGraphics)) {
            data["similarGraphics"] = [];
            for (let item of this.similarGraphics)
                data["similarGraphics"].push(item.toJSON());
        }
        data["widthSpecified"] = this.widthSpecified;
        data["heightSpecified"] = this.heightSpecified;
        super.toJSON(data);
        return data; 
    }
}

/** A graphic that can be placed on a sign. */
export interface IGraphic extends IXmlBase {
    /** Gets or sets the identifier of the graphic */
    id?: Id | undefined;
    /** Gets or sets the name of this graphic. */
    displayName?: string | undefined;
    /** Gets or sets the graphic data. */
    graphicData?: string | undefined;
    /** Gets or sets the width of the image, in pixels. */
    width?: number | undefined;
    /** Gets or sets the height of the image, in pixels. */
    height?: number | undefined;
    /** Gets or sets graphics of the same name with a different size. */
    similarGraphics?: Id[] | undefined;
    widthSpecified: boolean;
    heightSpecified: boolean;
}

export class RetrieveDataResponseOfStringAndIdAndStatusOfShortEventStatus extends BaseResponse implements IRetrieveDataResponseOfStringAndIdAndStatusOfShortEventStatus {
    data?: { [key: string]: IdAndStatusOfShortEventStatus; } | undefined;

    constructor(data?: IRetrieveDataResponseOfStringAndIdAndStatusOfShortEventStatus) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        this.data![key] = _data["data"][key] ? IdAndStatusOfShortEventStatus.fromJS(_data["data"][key]) : new IdAndStatusOfShortEventStatus();
                }
            }
        }
    }

    static fromJS(data: any): RetrieveDataResponseOfStringAndIdAndStatusOfShortEventStatus {
        data = typeof data === 'object' ? data : {};
        let result = new RetrieveDataResponseOfStringAndIdAndStatusOfShortEventStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    data["data"][key] = this.data[key] ? this.data[key].toJSON() : <any>undefined;
            }
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IRetrieveDataResponseOfStringAndIdAndStatusOfShortEventStatus extends IBaseResponse {
    data?: { [key: string]: IdAndStatusOfShortEventStatus; } | undefined;
}

export abstract class IdAndStatusBase extends XmlObject implements IIdAndStatusBase {
    /** Gets or sets the identifier. */
    id?: Id | undefined;
    /** Gets or sets the status. */
    status?: XmlStatusBase | undefined;

    constructor(data?: IIdAndStatusBase) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            this.status = _data["status"] ? XmlStatusBase.fromJS(_data["status"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IdAndStatusBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IdAndStatusBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IIdAndStatusBase extends IXmlObject {
    /** Gets or sets the identifier. */
    id?: Id | undefined;
    /** Gets or sets the status. */
    status?: XmlStatusBase | undefined;
}

export class IdAndStatusOfShortEventStatus extends IdAndStatusBase implements IIdAndStatusOfShortEventStatus {
    status?: ShortEventStatus | undefined;

    constructor(data?: IIdAndStatusOfShortEventStatus) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"] ? ShortEventStatus.fromJS(_data["status"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IdAndStatusOfShortEventStatus {
        data = typeof data === 'object' ? data : {};
        let result = new IdAndStatusOfShortEventStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IIdAndStatusOfShortEventStatus extends IIdAndStatusBase {
    status?: ShortEventStatus | undefined;
}

export class ShortEventStatus extends XmlStatusBase implements IShortEventStatus {
    id?: Id | undefined;
    name?: string | undefined;
    type?: string | undefined;
    location?: string | undefined;

    constructor(data?: IShortEventStatus) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            this.name = _data["name"];
            this.type = _data["type"];
            this.location = _data["location"];
        }
    }

    static fromJS(data: any): ShortEventStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ShortEventStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["type"] = this.type;
        data["location"] = this.location;
        super.toJSON(data);
        return data; 
    }
}

export interface IShortEventStatus extends IXmlStatusBase {
    id?: Id | undefined;
    name?: string | undefined;
    type?: string | undefined;
    location?: string | undefined;
}

export class RetrieveDataResponseOfStringAndQueue extends BaseResponse implements IRetrieveDataResponseOfStringAndQueue {
    data?: { [key: string]: Queue; } | undefined;

    constructor(data?: IRetrieveDataResponseOfStringAndQueue) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        this.data![key] = _data["data"][key] ? Queue.fromJS(_data["data"][key]) : new Queue();
                }
            }
        }
    }

    static fromJS(data: any): RetrieveDataResponseOfStringAndQueue {
        data = typeof data === 'object' ? data : {};
        let result = new RetrieveDataResponseOfStringAndQueue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    data["data"][key] = this.data[key] ? this.data[key].toJSON() : <any>undefined;
            }
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IRetrieveDataResponseOfStringAndQueue extends IBaseResponse {
    data?: { [key: string]: Queue; } | undefined;
}

/** List of messages for a particular device. */
export class Queue extends XmlBase implements IQueue {
    /** State of the MAS queue */
    state!: QueueState;
    /** The unique identifier */
    id?: Id | undefined;
    /** Message identifiers which are members of the queue */
    messages?: QueueMsg[] | undefined;

    constructor(data?: IQueue) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.state = _data["state"];
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(QueueMsg.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Queue {
        data = typeof data === 'object' ? data : {};
        let result = new Queue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

/** List of messages for a particular device. */
export interface IQueue extends IXmlBase {
    /** State of the MAS queue */
    state: QueueState;
    /** The unique identifier */
    id?: Id | undefined;
    /** Message identifiers which are members of the queue */
    messages?: QueueMsg[] | undefined;
}

/** The current state of the queue.  "pending"=current request is pending, "failed"=current request has failed, "completed"=current request is complete. */
export enum QueueState {
    Completed = 0,
    Failed = 1,
    Pending = 2,
}

/** A message to be placed in a device queue. */
export class QueueMsg extends XmlBase implements IQueueMsg {
    /** Message identifier is unique for a device.  This id is used to uniquely identify a particular message in a device's queue for terminating, changing priority, etc. */
    msgId?: MsgId | undefined;
    /** Message identifier is unique for a device.  This id is used to uniquely identify a particular message in a device's queue that is linked to this message. */
    linkedMsgId?: string | undefined;
    /** Gets or sets a value indicating whether the linked message (if any) was linked using the auto-merge functionality. */
    linkedMsgAutoMerged?: boolean | undefined;
    /** The text of the message, truncated to 200 chars. */
    msgText?: string | undefined;
    /** Date and time this message was received by the subsystem. */
    receivedTime!: Date;
    /** Date and time at which this message will be removed from the queue and any device to which it has been sent. */
    expiration!: Date;
    /** If this message is part of an event, the event id should be set */
    eventId?: IdWrapper | undefined;
    /** The center identifier for the sending party. */
    centerId?: string | undefined;
    /** Message in the queue. Only used for XML generation; use the
appropriately typed getter/setter instead */
    deviceMsg?: DeviceMsg | undefined;
    /** The type of Device Message either received or sent. */
    msgChoice!: DeviceMsgChoice;
    /** HAR message in the queue. */
    harMsg?: HarMsg | undefined;
    /** DMS message in the queue. */
    multiMsg?: MultiMsg | undefined;
    /** Beacon message in the queue. */
    beaconMsg?: BeaconMsg | undefined;
    /** Indicates whether this message may be taken as the first message
and auto-merged with any other message that has AutoMergeSecondary
set. */
    autoMergePrimary!: boolean;
    /** Indicates whether this message may be taken as the second message
and auto-merged with any other message that has AutoMergePrimary
set. */
    autoMergeSecondary!: boolean;
    /** Gets or sets a value indicating whether the message was approved or not. */
    isApproved?: boolean | undefined;
    linkedMsgAutoMergedSpecified!: boolean;
    isApprovedSpecified!: boolean;

    constructor(data?: IQueueMsg) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.msgId = _data["msgId"] ? MsgId.fromJS(_data["msgId"]) : <any>undefined;
            this.linkedMsgId = _data["linkedMsgId"];
            this.linkedMsgAutoMerged = _data["linkedMsgAutoMerged"];
            this.msgText = _data["msgText"];
            this.receivedTime = _data["receivedTime"] ? new Date(_data["receivedTime"].toString()) : <any>undefined;
            this.expiration = _data["expiration"] ? new Date(_data["expiration"].toString()) : <any>undefined;
            this.eventId = _data["eventId"] ? IdWrapper.fromJS(_data["eventId"]) : <any>undefined;
            this.centerId = _data["centerId"];
            this.deviceMsg = _data["deviceMsg"] ? DeviceMsg.fromJS(_data["deviceMsg"]) : <any>undefined;
            this.msgChoice = _data["msgChoice"];
            this.harMsg = _data["harMsg"] ? HarMsg.fromJS(_data["harMsg"]) : <any>undefined;
            this.multiMsg = _data["multiMsg"] ? MultiMsg.fromJS(_data["multiMsg"]) : <any>undefined;
            this.beaconMsg = _data["beaconMsg"] ? BeaconMsg.fromJS(_data["beaconMsg"]) : <any>undefined;
            this.autoMergePrimary = _data["autoMergePrimary"];
            this.autoMergeSecondary = _data["autoMergeSecondary"];
            this.isApproved = _data["isApproved"];
            this.linkedMsgAutoMergedSpecified = _data["linkedMsgAutoMergedSpecified"];
            this.isApprovedSpecified = _data["isApprovedSpecified"];
        }
    }

    static fromJS(data: any): QueueMsg {
        data = typeof data === 'object' ? data : {};
        let result = new QueueMsg();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["msgId"] = this.msgId ? this.msgId.toJSON() : <any>undefined;
        data["linkedMsgId"] = this.linkedMsgId;
        data["linkedMsgAutoMerged"] = this.linkedMsgAutoMerged;
        data["msgText"] = this.msgText;
        data["receivedTime"] = this.receivedTime ? this.receivedTime.toISOString() : <any>undefined;
        data["expiration"] = this.expiration ? this.expiration.toISOString() : <any>undefined;
        data["eventId"] = this.eventId ? this.eventId.toJSON() : <any>undefined;
        data["centerId"] = this.centerId;
        data["deviceMsg"] = this.deviceMsg ? this.deviceMsg.toJSON() : <any>undefined;
        data["msgChoice"] = this.msgChoice;
        data["harMsg"] = this.harMsg ? this.harMsg.toJSON() : <any>undefined;
        data["multiMsg"] = this.multiMsg ? this.multiMsg.toJSON() : <any>undefined;
        data["beaconMsg"] = this.beaconMsg ? this.beaconMsg.toJSON() : <any>undefined;
        data["autoMergePrimary"] = this.autoMergePrimary;
        data["autoMergeSecondary"] = this.autoMergeSecondary;
        data["isApproved"] = this.isApproved;
        data["linkedMsgAutoMergedSpecified"] = this.linkedMsgAutoMergedSpecified;
        data["isApprovedSpecified"] = this.isApprovedSpecified;
        super.toJSON(data);
        return data; 
    }
}

/** A message to be placed in a device queue. */
export interface IQueueMsg extends IXmlBase {
    /** Message identifier is unique for a device.  This id is used to uniquely identify a particular message in a device's queue for terminating, changing priority, etc. */
    msgId?: MsgId | undefined;
    /** Message identifier is unique for a device.  This id is used to uniquely identify a particular message in a device's queue that is linked to this message. */
    linkedMsgId?: string | undefined;
    /** Gets or sets a value indicating whether the linked message (if any) was linked using the auto-merge functionality. */
    linkedMsgAutoMerged?: boolean | undefined;
    /** The text of the message, truncated to 200 chars. */
    msgText?: string | undefined;
    /** Date and time this message was received by the subsystem. */
    receivedTime: Date;
    /** Date and time at which this message will be removed from the queue and any device to which it has been sent. */
    expiration: Date;
    /** If this message is part of an event, the event id should be set */
    eventId?: IdWrapper | undefined;
    /** The center identifier for the sending party. */
    centerId?: string | undefined;
    /** Message in the queue. Only used for XML generation; use the
appropriately typed getter/setter instead */
    deviceMsg?: DeviceMsg | undefined;
    /** The type of Device Message either received or sent. */
    msgChoice: DeviceMsgChoice;
    /** HAR message in the queue. */
    harMsg?: HarMsg | undefined;
    /** DMS message in the queue. */
    multiMsg?: MultiMsg | undefined;
    /** Beacon message in the queue. */
    beaconMsg?: BeaconMsg | undefined;
    /** Indicates whether this message may be taken as the first message
and auto-merged with any other message that has AutoMergeSecondary
set. */
    autoMergePrimary: boolean;
    /** Indicates whether this message may be taken as the second message
and auto-merged with any other message that has AutoMergePrimary
set. */
    autoMergeSecondary: boolean;
    /** Gets or sets a value indicating whether the message was approved or not. */
    isApproved?: boolean | undefined;
    linkedMsgAutoMergedSpecified: boolean;
    isApprovedSpecified: boolean;
}

export class RetrieveDataResponseOfStringAndStation extends BaseResponse implements IRetrieveDataResponseOfStringAndStation {
    data?: { [key: string]: Station; } | undefined;

    constructor(data?: IRetrieveDataResponseOfStringAndStation) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        this.data![key] = _data["data"][key] ? Station.fromJS(_data["data"][key]) : new Station();
                }
            }
        }
    }

    static fromJS(data: any): RetrieveDataResponseOfStringAndStation {
        data = typeof data === 'object' ? data : {};
        let result = new RetrieveDataResponseOfStringAndStation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    data["data"][key] = this.data[key] ? this.data[key].toJSON() : <any>undefined;
            }
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IRetrieveDataResponseOfStringAndStation extends IBaseResponse {
    data?: { [key: string]: Station; } | undefined;
}

/** A class representing the XML making up an RWIS station object. */
export class Station extends XmlBase implements IStation {
    /** Gets or sets the identifier. */
    id?: Id | undefined;
    /** Gets or sets the display name. */
    displayName?: string | undefined;
    /** Gets or sets the external identifier. */
    externalId?: string | undefined;
    /** Gets or sets the send mode. */
    sendMode?: string | undefined;
    /** Gets or sets the name of the driver. */
    driverName?: string | undefined;
    /** Gets or sets the protocol. */
    protocol!: StationProtocolsEnum;
    /** Gets or sets the type of the station. */
    stationType!: string;
    /** Gets or sets the manufacturer. */
    manufacturer?: string | undefined;
    /** Gets or sets the address Value specified which can either be a PMPP Address or COMM Address. */
    address?: XmlBase | undefined;
    /** Gets or sets the type of Address that the Address property is. */
    addressType!: StationAddressType;
    /** Gets or sets the PMPP address. */
    pmppAddress?: PmppAddress | undefined;
    /** Gets or sets the communication address. */
    commAddress?: CommAddress | undefined;
    /** Gets or sets the HTTP address. */
    httpAddress?: HttpAddressClass | undefined;
    /** Gets or sets the location. */
    location?: EquipmentLocation | undefined;
    /** Gets or sets the associated beacon identifiers. */
    associatedBeacons?: Id[] | undefined;
    /** Gets or sets the beacon proximity (in miles). */
    beaconProximity!: number;
    /** Gets or sets the associated region. */
    associatedRegion?: IdWrapper | undefined;
    /** Gets or sets the height of the roadway. */
    roadwayHeight!: number;
    /** Gets or sets the status. */
    status?: StationStatus | undefined;

    constructor(data?: IStation) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            this.displayName = _data["displayName"];
            this.externalId = _data["externalId"];
            this.sendMode = _data["sendMode"];
            this.driverName = _data["driverName"];
            this.protocol = _data["protocol"];
            this.stationType = _data["stationType"];
            this.manufacturer = _data["manufacturer"];
            this.address = _data["address"] ? XmlBase.fromJS(_data["address"]) : <any>undefined;
            this.addressType = _data["addressType"];
            this.pmppAddress = _data["pmppAddress"] ? PmppAddress.fromJS(_data["pmppAddress"]) : <any>undefined;
            this.commAddress = _data["commAddress"] ? CommAddress.fromJS(_data["commAddress"]) : <any>undefined;
            this.httpAddress = _data["httpAddress"] ? HttpAddressClass.fromJS(_data["httpAddress"]) : <any>undefined;
            this.location = _data["location"] ? EquipmentLocation.fromJS(_data["location"]) : <any>undefined;
            if (Array.isArray(_data["associatedBeacons"])) {
                this.associatedBeacons = [] as any;
                for (let item of _data["associatedBeacons"])
                    this.associatedBeacons!.push(Id.fromJS(item));
            }
            this.beaconProximity = _data["beaconProximity"];
            this.associatedRegion = _data["associatedRegion"] ? IdWrapper.fromJS(_data["associatedRegion"]) : <any>undefined;
            this.roadwayHeight = _data["roadwayHeight"];
            this.status = _data["status"] ? StationStatus.fromJS(_data["status"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Station {
        data = typeof data === 'object' ? data : {};
        let result = new Station();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["displayName"] = this.displayName;
        data["externalId"] = this.externalId;
        data["sendMode"] = this.sendMode;
        data["driverName"] = this.driverName;
        data["protocol"] = this.protocol;
        data["stationType"] = this.stationType;
        data["manufacturer"] = this.manufacturer;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["addressType"] = this.addressType;
        data["pmppAddress"] = this.pmppAddress ? this.pmppAddress.toJSON() : <any>undefined;
        data["commAddress"] = this.commAddress ? this.commAddress.toJSON() : <any>undefined;
        data["httpAddress"] = this.httpAddress ? this.httpAddress.toJSON() : <any>undefined;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        if (Array.isArray(this.associatedBeacons)) {
            data["associatedBeacons"] = [];
            for (let item of this.associatedBeacons)
                data["associatedBeacons"].push(item.toJSON());
        }
        data["beaconProximity"] = this.beaconProximity;
        data["associatedRegion"] = this.associatedRegion ? this.associatedRegion.toJSON() : <any>undefined;
        data["roadwayHeight"] = this.roadwayHeight;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

/** A class representing the XML making up an RWIS station object. */
export interface IStation extends IXmlBase {
    /** Gets or sets the identifier. */
    id?: Id | undefined;
    /** Gets or sets the display name. */
    displayName?: string | undefined;
    /** Gets or sets the external identifier. */
    externalId?: string | undefined;
    /** Gets or sets the send mode. */
    sendMode?: string | undefined;
    /** Gets or sets the name of the driver. */
    driverName?: string | undefined;
    /** Gets or sets the protocol. */
    protocol: StationProtocolsEnum;
    /** Gets or sets the type of the station. */
    stationType: string;
    /** Gets or sets the manufacturer. */
    manufacturer?: string | undefined;
    /** Gets or sets the address Value specified which can either be a PMPP Address or COMM Address. */
    address?: XmlBase | undefined;
    /** Gets or sets the type of Address that the Address property is. */
    addressType: StationAddressType;
    /** Gets or sets the PMPP address. */
    pmppAddress?: PmppAddress | undefined;
    /** Gets or sets the communication address. */
    commAddress?: CommAddress | undefined;
    /** Gets or sets the HTTP address. */
    httpAddress?: HttpAddressClass | undefined;
    /** Gets or sets the location. */
    location?: EquipmentLocation | undefined;
    /** Gets or sets the associated beacon identifiers. */
    associatedBeacons?: Id[] | undefined;
    /** Gets or sets the beacon proximity (in miles). */
    beaconProximity: number;
    /** Gets or sets the associated region. */
    associatedRegion?: IdWrapper | undefined;
    /** Gets or sets the height of the roadway. */
    roadwayHeight: number;
    /** Gets or sets the status. */
    status?: StationStatus | undefined;
}

/** Types of station protocols */
export enum StationProtocolsEnum {
    UdpNtcipVersion1 = 0,
    UdpNtcipVersion2 = 1,
    UdpNtcipVersion3 = 2,
    TxDOT = 3,
    Navigator = 4,
    WeatherReport = 5,
    Madis = 6,
    KDOT = 7,
    Atc = 8,
    Vaisala = 9,
}

/** Types of station addresses */
export enum StationAddressType {
    PmppAddress = 0,
    CommAddress = 1,
    HttpAddress = 2,
}

/** A class representing XML of a station's status. */
export class StationStatus extends XmlStatusBase implements IStationStatus {
    /** Gets or sets the op status. */
    opStatus!: OpStatus;
    /** Gets or sets the last successful poll. */
    timestamp?: Date | undefined;
    /** Gets or sets the reporter. */
    reporter?: string | undefined;
    /** Gets or sets the report comment. */
    reportComment?: string | undefined;
    /** Gets or sets the air status. */
    airStatus?: AirStatus | undefined;
    /** Gets or sets the wind status. */
    windStatus?: WindStatus | undefined;
    /** Gets or sets the temperature status. */
    tempStatus?: TempStatus | undefined;
    /** Gets or sets the precipitation status. */
    precipStatus?: PrecipStatus | undefined;
    /** Gets or sets the visibility status. */
    visibilityStatus?: VisibilityStatus | undefined;
    /** Gets or sets the pavement status. */
    pavementStatus?: PavementStatus | undefined;

    constructor(data?: IStationStatus) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.opStatus = _data["opStatus"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.reporter = _data["reporter"];
            this.reportComment = _data["reportComment"];
            this.airStatus = _data["airStatus"] ? AirStatus.fromJS(_data["airStatus"]) : <any>undefined;
            this.windStatus = _data["windStatus"] ? WindStatus.fromJS(_data["windStatus"]) : <any>undefined;
            this.tempStatus = _data["tempStatus"] ? TempStatus.fromJS(_data["tempStatus"]) : <any>undefined;
            this.precipStatus = _data["precipStatus"] ? PrecipStatus.fromJS(_data["precipStatus"]) : <any>undefined;
            this.visibilityStatus = _data["visibilityStatus"] ? VisibilityStatus.fromJS(_data["visibilityStatus"]) : <any>undefined;
            this.pavementStatus = _data["pavementStatus"] ? PavementStatus.fromJS(_data["pavementStatus"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StationStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StationStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["opStatus"] = this.opStatus;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["reporter"] = this.reporter;
        data["reportComment"] = this.reportComment;
        data["airStatus"] = this.airStatus ? this.airStatus.toJSON() : <any>undefined;
        data["windStatus"] = this.windStatus ? this.windStatus.toJSON() : <any>undefined;
        data["tempStatus"] = this.tempStatus ? this.tempStatus.toJSON() : <any>undefined;
        data["precipStatus"] = this.precipStatus ? this.precipStatus.toJSON() : <any>undefined;
        data["visibilityStatus"] = this.visibilityStatus ? this.visibilityStatus.toJSON() : <any>undefined;
        data["pavementStatus"] = this.pavementStatus ? this.pavementStatus.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

/** A class representing XML of a station's status. */
export interface IStationStatus extends IXmlStatusBase {
    /** Gets or sets the op status. */
    opStatus: OpStatus;
    /** Gets or sets the last successful poll. */
    timestamp?: Date | undefined;
    /** Gets or sets the reporter. */
    reporter?: string | undefined;
    /** Gets or sets the report comment. */
    reportComment?: string | undefined;
    /** Gets or sets the air status. */
    airStatus?: AirStatus | undefined;
    /** Gets or sets the wind status. */
    windStatus?: WindStatus | undefined;
    /** Gets or sets the temperature status. */
    tempStatus?: TempStatus | undefined;
    /** Gets or sets the precipitation status. */
    precipStatus?: PrecipStatus | undefined;
    /** Gets or sets the visibility status. */
    visibilityStatus?: VisibilityStatus | undefined;
    /** Gets or sets the pavement status. */
    pavementStatus?: PavementStatus | undefined;
}

/** A class representing XML for air status reported by a RWIS station. */
export class AirStatus extends XmlBase implements IAirStatus {
    /** Gets or sets the atmospheric pressure in inches of mercury */
    atmPressure?: number | undefined;
    /** Sets the atmospheric pressure in tenths of millibars */
    atmPressureInTenthsOfMillibars!: number;
    /** Sets the atmospheric pressure in tenths of hectoPascals. */
    atmPressureInHectoPascals?: number | undefined;
    atmPressureSpecified!: boolean;

    constructor(data?: IAirStatus) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.atmPressure = _data["atmPressure"];
            this.atmPressureInTenthsOfMillibars = _data["atmPressureInTenthsOfMillibars"];
            this.atmPressureInHectoPascals = _data["atmPressureInHectoPascals"];
            this.atmPressureSpecified = _data["atmPressureSpecified"];
        }
    }

    static fromJS(data: any): AirStatus {
        data = typeof data === 'object' ? data : {};
        let result = new AirStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["atmPressure"] = this.atmPressure;
        data["atmPressureInTenthsOfMillibars"] = this.atmPressureInTenthsOfMillibars;
        data["atmPressureInHectoPascals"] = this.atmPressureInHectoPascals;
        data["atmPressureSpecified"] = this.atmPressureSpecified;
        super.toJSON(data);
        return data; 
    }
}

/** A class representing XML for air status reported by a RWIS station. */
export interface IAirStatus extends IXmlBase {
    /** Gets or sets the atmospheric pressure in inches of mercury */
    atmPressure?: number | undefined;
    /** Sets the atmospheric pressure in tenths of millibars */
    atmPressureInTenthsOfMillibars: number;
    /** Sets the atmospheric pressure in tenths of hectoPascals. */
    atmPressureInHectoPascals?: number | undefined;
    atmPressureSpecified: boolean;
}

/** A class representing XML with the wind status reported by a RWIS station. */
export class WindStatus extends XmlBase implements IWindStatus {
    /** Gets or sets the wind sensors. */
    windSensors?: WindSensor[] | undefined;
    /** Gets or sets the average wind status. */
    averageWindStatus?: AverageWindStatus | undefined;

    constructor(data?: IWindStatus) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["windSensors"])) {
                this.windSensors = [] as any;
                for (let item of _data["windSensors"])
                    this.windSensors!.push(WindSensor.fromJS(item));
            }
            this.averageWindStatus = _data["averageWindStatus"] ? AverageWindStatus.fromJS(_data["averageWindStatus"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WindStatus {
        data = typeof data === 'object' ? data : {};
        let result = new WindStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.windSensors)) {
            data["windSensors"] = [];
            for (let item of this.windSensors)
                data["windSensors"].push(item.toJSON());
        }
        data["averageWindStatus"] = this.averageWindStatus ? this.averageWindStatus.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

/** A class representing XML with the wind status reported by a RWIS station. */
export interface IWindStatus extends IXmlBase {
    /** Gets or sets the wind sensors. */
    windSensors?: WindSensor[] | undefined;
    /** Gets or sets the average wind status. */
    averageWindStatus?: AverageWindStatus | undefined;
}

/** Represents a wind sensor's status */
export class WindSensor extends XmlBase implements IWindSensor {
    /** Gets or sets the index. */
    index!: number;
    /** Gets or sets the average wind direction in compass degrees. */
    averageWindDirection?: number | undefined;
    /** Sets the average wind direction degrees and checks whether the value is valid. */
    averageWindDirectionDegrees!: number;
    /** Gets a string version of average wind direction */
    averageWindDirectionName?: string | undefined;
    /** Gets or sets the average wind speed in miles per hour. */
    averageWindSpeed?: number | undefined;
    /** Sets the average wind speed in tenths of meters per second */
    averageWindSpeedTenthsMetersPerSecond!: number;
    /** Gets or sets the wind direction in compass degrees. */
    windDirection?: number | undefined;
    /** Sets the wind direction degrees and checks whether the value is valid. */
    windDirectionDegrees!: number;
    /** Gets a string version of wind direction */
    windDirectionName?: string | undefined;
    /** Gets or sets the wind speed in miles per hour. */
    windSpeed?: number | undefined;
    /** Sets the wind speed in tenths of meters per second */
    windSpeedTenthsMetersPerSecond!: number;
    /** Sets the wind speed in meters per second */
    windSpeedMetersPerSecond?: number | undefined;
    /** Gets or sets the wind situation. */
    situation?: WindSituationEnum | undefined;
    /** Gets or sets the maximum wind gust speed in miles per hour. */
    maxWindGustSpeed?: number | undefined;
    /** Sets the max wind gust speed in tenths of meters per second */
    maxWindGustSpeedTenthsMetersPerSecond!: number;
    /** Sets the max wind gust speed in meters per second */
    maxWindGustSpeedMetersPerSecond?: number | undefined;
    /** Gets or sets the maximum wind gust direction in compass degrees. */
    maxWindGustDirection?: number | undefined;
    /** Sets the wind direction degrees and checks whether the value is valid. */
    maxWindGustDirectionDegrees!: number;
    /** Gets a string version of max wind gust direction */
    maxWindGustDirectionName?: string | undefined;
    averageWindDirectionSpecified!: boolean;
    averageWindSpeedSpecified!: boolean;
    windDirectionSpecified!: boolean;
    windSpeedSpecified!: boolean;
    situationSpecified!: boolean;
    maxWindGustSpeedSpecified!: boolean;
    maxWindGustDirectionSpecified!: boolean;

    constructor(data?: IWindSensor) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.index = _data["index"];
            this.averageWindDirection = _data["averageWindDirection"];
            this.averageWindDirectionDegrees = _data["averageWindDirectionDegrees"];
            this.averageWindDirectionName = _data["averageWindDirectionName"];
            this.averageWindSpeed = _data["averageWindSpeed"];
            this.averageWindSpeedTenthsMetersPerSecond = _data["averageWindSpeedTenthsMetersPerSecond"];
            this.windDirection = _data["windDirection"];
            this.windDirectionDegrees = _data["windDirectionDegrees"];
            this.windDirectionName = _data["windDirectionName"];
            this.windSpeed = _data["windSpeed"];
            this.windSpeedTenthsMetersPerSecond = _data["windSpeedTenthsMetersPerSecond"];
            this.windSpeedMetersPerSecond = _data["windSpeedMetersPerSecond"];
            this.situation = _data["situation"];
            this.maxWindGustSpeed = _data["maxWindGustSpeed"];
            this.maxWindGustSpeedTenthsMetersPerSecond = _data["maxWindGustSpeedTenthsMetersPerSecond"];
            this.maxWindGustSpeedMetersPerSecond = _data["maxWindGustSpeedMetersPerSecond"];
            this.maxWindGustDirection = _data["maxWindGustDirection"];
            this.maxWindGustDirectionDegrees = _data["maxWindGustDirectionDegrees"];
            this.maxWindGustDirectionName = _data["maxWindGustDirectionName"];
            this.averageWindDirectionSpecified = _data["averageWindDirectionSpecified"];
            this.averageWindSpeedSpecified = _data["averageWindSpeedSpecified"];
            this.windDirectionSpecified = _data["windDirectionSpecified"];
            this.windSpeedSpecified = _data["windSpeedSpecified"];
            this.situationSpecified = _data["situationSpecified"];
            this.maxWindGustSpeedSpecified = _data["maxWindGustSpeedSpecified"];
            this.maxWindGustDirectionSpecified = _data["maxWindGustDirectionSpecified"];
        }
    }

    static fromJS(data: any): WindSensor {
        data = typeof data === 'object' ? data : {};
        let result = new WindSensor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index;
        data["averageWindDirection"] = this.averageWindDirection;
        data["averageWindDirectionDegrees"] = this.averageWindDirectionDegrees;
        data["averageWindDirectionName"] = this.averageWindDirectionName;
        data["averageWindSpeed"] = this.averageWindSpeed;
        data["averageWindSpeedTenthsMetersPerSecond"] = this.averageWindSpeedTenthsMetersPerSecond;
        data["windDirection"] = this.windDirection;
        data["windDirectionDegrees"] = this.windDirectionDegrees;
        data["windDirectionName"] = this.windDirectionName;
        data["windSpeed"] = this.windSpeed;
        data["windSpeedTenthsMetersPerSecond"] = this.windSpeedTenthsMetersPerSecond;
        data["windSpeedMetersPerSecond"] = this.windSpeedMetersPerSecond;
        data["situation"] = this.situation;
        data["maxWindGustSpeed"] = this.maxWindGustSpeed;
        data["maxWindGustSpeedTenthsMetersPerSecond"] = this.maxWindGustSpeedTenthsMetersPerSecond;
        data["maxWindGustSpeedMetersPerSecond"] = this.maxWindGustSpeedMetersPerSecond;
        data["maxWindGustDirection"] = this.maxWindGustDirection;
        data["maxWindGustDirectionDegrees"] = this.maxWindGustDirectionDegrees;
        data["maxWindGustDirectionName"] = this.maxWindGustDirectionName;
        data["averageWindDirectionSpecified"] = this.averageWindDirectionSpecified;
        data["averageWindSpeedSpecified"] = this.averageWindSpeedSpecified;
        data["windDirectionSpecified"] = this.windDirectionSpecified;
        data["windSpeedSpecified"] = this.windSpeedSpecified;
        data["situationSpecified"] = this.situationSpecified;
        data["maxWindGustSpeedSpecified"] = this.maxWindGustSpeedSpecified;
        data["maxWindGustDirectionSpecified"] = this.maxWindGustDirectionSpecified;
        super.toJSON(data);
        return data; 
    }
}

/** Represents a wind sensor's status */
export interface IWindSensor extends IXmlBase {
    /** Gets or sets the index. */
    index: number;
    /** Gets or sets the average wind direction in compass degrees. */
    averageWindDirection?: number | undefined;
    /** Sets the average wind direction degrees and checks whether the value is valid. */
    averageWindDirectionDegrees: number;
    /** Gets a string version of average wind direction */
    averageWindDirectionName?: string | undefined;
    /** Gets or sets the average wind speed in miles per hour. */
    averageWindSpeed?: number | undefined;
    /** Sets the average wind speed in tenths of meters per second */
    averageWindSpeedTenthsMetersPerSecond: number;
    /** Gets or sets the wind direction in compass degrees. */
    windDirection?: number | undefined;
    /** Sets the wind direction degrees and checks whether the value is valid. */
    windDirectionDegrees: number;
    /** Gets a string version of wind direction */
    windDirectionName?: string | undefined;
    /** Gets or sets the wind speed in miles per hour. */
    windSpeed?: number | undefined;
    /** Sets the wind speed in tenths of meters per second */
    windSpeedTenthsMetersPerSecond: number;
    /** Sets the wind speed in meters per second */
    windSpeedMetersPerSecond?: number | undefined;
    /** Gets or sets the wind situation. */
    situation?: WindSituationEnum | undefined;
    /** Gets or sets the maximum wind gust speed in miles per hour. */
    maxWindGustSpeed?: number | undefined;
    /** Sets the max wind gust speed in tenths of meters per second */
    maxWindGustSpeedTenthsMetersPerSecond: number;
    /** Sets the max wind gust speed in meters per second */
    maxWindGustSpeedMetersPerSecond?: number | undefined;
    /** Gets or sets the maximum wind gust direction in compass degrees. */
    maxWindGustDirection?: number | undefined;
    /** Sets the wind direction degrees and checks whether the value is valid. */
    maxWindGustDirectionDegrees: number;
    /** Gets a string version of max wind gust direction */
    maxWindGustDirectionName?: string | undefined;
    averageWindDirectionSpecified: boolean;
    averageWindSpeedSpecified: boolean;
    windDirectionSpecified: boolean;
    windSpeedSpecified: boolean;
    situationSpecified: boolean;
    maxWindGustSpeedSpecified: boolean;
    maxWindGustDirectionSpecified: boolean;
}

/** An enumeration of acceptable wind situations. */
export enum WindSituationEnum {
    InvalidValue = 0,
    Other = 1,
    Unknown = 2,
    Calm = 3,
    LightBreeze = 4,
    ModerateBreeze = 5,
    StrongBreeze = 6,
    Gale = 7,
    ModerateGale = 8,
    StrongGale = 9,
    StormWinds = 10,
    HurricaneForceWinds = 11,
    GustyWinds = 12,
}

/** A class representing the average values reported by RWIS sensors associated with a station. */
export class AverageWindStatus extends XmlBase implements IAverageWindStatus {
    /** Gets or sets the average wind speed in miles per hour. */
    averageWindSpeed?: number | undefined;
    /** Gets or sets the average wind direction in compass degrees. */
    averageWindDirection?: number | undefined;
    /** Gets a string version of average wind direction */
    averageWindDirectionName?: string | undefined;
    /** Gets or sets the wind speed in miles per hour. */
    windSpeed?: number | undefined;
    /** Gets or sets the wind direction in compass degrees. */
    windDirection?: number | undefined;
    /** Gets a string version of wind direction */
    windDirectionName?: string | undefined;
    /** Gets or sets the maximum wind gust speed in miles per hour. */
    maxWindGustSpeed?: number | undefined;
    /** Gets or sets the maximum wind gust direction in compass degrees. */
    maxWindGustDirection?: number | undefined;
    /** Gets a string version of max wind gust direction */
    maxWindGustDirectionName?: string | undefined;
    /** Gets or sets the wind situation. */
    windSituation?: string | undefined;
    averageWindSpeedSpecified!: boolean;
    averageWindDirectionSpecified!: boolean;
    windSpeedSpecified!: boolean;
    windDirectionSpecified!: boolean;
    maxWindGustSpeedSpecified!: boolean;
    maxWindGustDirectionSpecified!: boolean;

    constructor(data?: IAverageWindStatus) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.averageWindSpeed = _data["averageWindSpeed"];
            this.averageWindDirection = _data["averageWindDirection"];
            this.averageWindDirectionName = _data["averageWindDirectionName"];
            this.windSpeed = _data["windSpeed"];
            this.windDirection = _data["windDirection"];
            this.windDirectionName = _data["windDirectionName"];
            this.maxWindGustSpeed = _data["maxWindGustSpeed"];
            this.maxWindGustDirection = _data["maxWindGustDirection"];
            this.maxWindGustDirectionName = _data["maxWindGustDirectionName"];
            this.windSituation = _data["windSituation"];
            this.averageWindSpeedSpecified = _data["averageWindSpeedSpecified"];
            this.averageWindDirectionSpecified = _data["averageWindDirectionSpecified"];
            this.windSpeedSpecified = _data["windSpeedSpecified"];
            this.windDirectionSpecified = _data["windDirectionSpecified"];
            this.maxWindGustSpeedSpecified = _data["maxWindGustSpeedSpecified"];
            this.maxWindGustDirectionSpecified = _data["maxWindGustDirectionSpecified"];
        }
    }

    static fromJS(data: any): AverageWindStatus {
        data = typeof data === 'object' ? data : {};
        let result = new AverageWindStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["averageWindSpeed"] = this.averageWindSpeed;
        data["averageWindDirection"] = this.averageWindDirection;
        data["averageWindDirectionName"] = this.averageWindDirectionName;
        data["windSpeed"] = this.windSpeed;
        data["windDirection"] = this.windDirection;
        data["windDirectionName"] = this.windDirectionName;
        data["maxWindGustSpeed"] = this.maxWindGustSpeed;
        data["maxWindGustDirection"] = this.maxWindGustDirection;
        data["maxWindGustDirectionName"] = this.maxWindGustDirectionName;
        data["windSituation"] = this.windSituation;
        data["averageWindSpeedSpecified"] = this.averageWindSpeedSpecified;
        data["averageWindDirectionSpecified"] = this.averageWindDirectionSpecified;
        data["windSpeedSpecified"] = this.windSpeedSpecified;
        data["windDirectionSpecified"] = this.windDirectionSpecified;
        data["maxWindGustSpeedSpecified"] = this.maxWindGustSpeedSpecified;
        data["maxWindGustDirectionSpecified"] = this.maxWindGustDirectionSpecified;
        super.toJSON(data);
        return data; 
    }
}

/** A class representing the average values reported by RWIS sensors associated with a station. */
export interface IAverageWindStatus extends IXmlBase {
    /** Gets or sets the average wind speed in miles per hour. */
    averageWindSpeed?: number | undefined;
    /** Gets or sets the average wind direction in compass degrees. */
    averageWindDirection?: number | undefined;
    /** Gets a string version of average wind direction */
    averageWindDirectionName?: string | undefined;
    /** Gets or sets the wind speed in miles per hour. */
    windSpeed?: number | undefined;
    /** Gets or sets the wind direction in compass degrees. */
    windDirection?: number | undefined;
    /** Gets a string version of wind direction */
    windDirectionName?: string | undefined;
    /** Gets or sets the maximum wind gust speed in miles per hour. */
    maxWindGustSpeed?: number | undefined;
    /** Gets or sets the maximum wind gust direction in compass degrees. */
    maxWindGustDirection?: number | undefined;
    /** Gets a string version of max wind gust direction */
    maxWindGustDirectionName?: string | undefined;
    /** Gets or sets the wind situation. */
    windSituation?: string | undefined;
    averageWindSpeedSpecified: boolean;
    averageWindDirectionSpecified: boolean;
    windSpeedSpecified: boolean;
    windDirectionSpecified: boolean;
    maxWindGustSpeedSpecified: boolean;
    maxWindGustDirectionSpecified: boolean;
}

/** A class representing XML of the temperature status returned by an RWIS station. */
export class TempStatus extends XmlBase implements ITempStatus {
    /** Gets or sets the temperature sensor. */
    sensors?: TempSensor[] | undefined;
    /** Gets or sets the average temperature status. */
    averageTempStatus?: AverageTempStatus | undefined;
    /** Gets or sets the dew point temperature in degrees F. */
    dewPointTemp?: number | undefined;
    /** Sets the dew point temperature in tenths of degrees C */
    dewPointTempTenthDegreesC!: number;
    /** Sets the dew point temperature degrees C */
    dewPointTempDegreesC?: number | undefined;
    dewPointTempSpecified!: boolean;

    constructor(data?: ITempStatus) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["sensors"])) {
                this.sensors = [] as any;
                for (let item of _data["sensors"])
                    this.sensors!.push(TempSensor.fromJS(item));
            }
            this.averageTempStatus = _data["averageTempStatus"] ? AverageTempStatus.fromJS(_data["averageTempStatus"]) : <any>undefined;
            this.dewPointTemp = _data["dewPointTemp"];
            this.dewPointTempTenthDegreesC = _data["dewPointTempTenthDegreesC"];
            this.dewPointTempDegreesC = _data["dewPointTempDegreesC"];
            this.dewPointTempSpecified = _data["dewPointTempSpecified"];
        }
    }

    static fromJS(data: any): TempStatus {
        data = typeof data === 'object' ? data : {};
        let result = new TempStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sensors)) {
            data["sensors"] = [];
            for (let item of this.sensors)
                data["sensors"].push(item.toJSON());
        }
        data["averageTempStatus"] = this.averageTempStatus ? this.averageTempStatus.toJSON() : <any>undefined;
        data["dewPointTemp"] = this.dewPointTemp;
        data["dewPointTempTenthDegreesC"] = this.dewPointTempTenthDegreesC;
        data["dewPointTempDegreesC"] = this.dewPointTempDegreesC;
        data["dewPointTempSpecified"] = this.dewPointTempSpecified;
        super.toJSON(data);
        return data; 
    }
}

/** A class representing XML of the temperature status returned by an RWIS station. */
export interface ITempStatus extends IXmlBase {
    /** Gets or sets the temperature sensor. */
    sensors?: TempSensor[] | undefined;
    /** Gets or sets the average temperature status. */
    averageTempStatus?: AverageTempStatus | undefined;
    /** Gets or sets the dew point temperature in degrees F. */
    dewPointTemp?: number | undefined;
    /** Sets the dew point temperature in tenths of degrees C */
    dewPointTempTenthDegreesC: number;
    /** Sets the dew point temperature degrees C */
    dewPointTempDegreesC?: number | undefined;
    dewPointTempSpecified: boolean;
}

/** A class representing the temperature sensor information returned by an RWIS station. */
export class TempSensor extends XmlBase implements ITempSensor {
    /** Gets or sets the index. */
    index!: number;
    /** Gets or sets the dry bulb temperature in degrees F */
    dryBulbTemp?: number | undefined;
    /** Sets the dry bulb temperature in tenths of degrees C */
    dryBulbTempTenthDegreesC!: number;
    /** Sets the dry bulb temperature in degrees C */
    dryBulbTempDegreesC?: number | undefined;
    dryBulbTempSpecified!: boolean;

    constructor(data?: ITempSensor) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.index = _data["index"];
            this.dryBulbTemp = _data["dryBulbTemp"];
            this.dryBulbTempTenthDegreesC = _data["dryBulbTempTenthDegreesC"];
            this.dryBulbTempDegreesC = _data["dryBulbTempDegreesC"];
            this.dryBulbTempSpecified = _data["dryBulbTempSpecified"];
        }
    }

    static fromJS(data: any): TempSensor {
        data = typeof data === 'object' ? data : {};
        let result = new TempSensor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index;
        data["dryBulbTemp"] = this.dryBulbTemp;
        data["dryBulbTempTenthDegreesC"] = this.dryBulbTempTenthDegreesC;
        data["dryBulbTempDegreesC"] = this.dryBulbTempDegreesC;
        data["dryBulbTempSpecified"] = this.dryBulbTempSpecified;
        super.toJSON(data);
        return data; 
    }
}

/** A class representing the temperature sensor information returned by an RWIS station. */
export interface ITempSensor extends IXmlBase {
    /** Gets or sets the index. */
    index: number;
    /** Gets or sets the dry bulb temperature in degrees F */
    dryBulbTemp?: number | undefined;
    /** Sets the dry bulb temperature in tenths of degrees C */
    dryBulbTempTenthDegreesC: number;
    /** Sets the dry bulb temperature in degrees C */
    dryBulbTempDegreesC?: number | undefined;
    dryBulbTempSpecified: boolean;
}

/** A class containing the average values reported by temperature sensors associated with a RWIS station. */
export class AverageTempStatus extends XmlBase implements IAverageTempStatus {
    /** Gets or sets the dry bulb temperature in degrees F */
    dryBulbTemp?: number | undefined;
    dryBulbTempSpecified!: boolean;

    constructor(data?: IAverageTempStatus) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dryBulbTemp = _data["dryBulbTemp"];
            this.dryBulbTempSpecified = _data["dryBulbTempSpecified"];
        }
    }

    static fromJS(data: any): AverageTempStatus {
        data = typeof data === 'object' ? data : {};
        let result = new AverageTempStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dryBulbTemp"] = this.dryBulbTemp;
        data["dryBulbTempSpecified"] = this.dryBulbTempSpecified;
        super.toJSON(data);
        return data; 
    }
}

/** A class containing the average values reported by temperature sensors associated with a RWIS station. */
export interface IAverageTempStatus extends IXmlBase {
    /** Gets or sets the dry bulb temperature in degrees F */
    dryBulbTemp?: number | undefined;
    dryBulbTempSpecified: boolean;
}

/** A class representing XML for the precipitation status reported by an RWIS station. */
export class PrecipStatus extends XmlBase implements IPrecipStatus {
    /** Gets or sets the water level sensors. */
    waterLevelSensors?: WaterLevelSensor[] | undefined;
    /** Gets or sets the average water level status. */
    averageWaterLevelStatus?: AverageWaterLevelStatus | undefined;
    /** Gets or sets the relative humidity as a percentage. */
    relativeHumidity?: number | undefined;
    /** Sets the exposure as a percentage, or null if the value is not in the valid range (0-100) */
    relativeHumidityPercent!: number;
    /** Gets or sets the adjacent depth in inches */
    adjacentSnowDepth?: number | undefined;
    /** Sets the adjacent depth in centimeters. */
    adjacentSnowDepthCentimeters!: number;
    /** Sets the adjacent depth in millimeters. */
    adjacentSnowDepthMillimeters?: number | undefined;
    /** Gets or sets the road depth in inches */
    roadwaySnowDepth?: number | undefined;
    /** Sets the road depth in centimeters. */
    roadwaySnowDepthCentimeters!: number;
    /** Gets or sets the packed depth in inches. */
    roadwaySnowPackedDepth?: number | undefined;
    /** Sets the packed depth in inches. */
    roadwaySnowPackedDepthCentimeters!: number;
    /** Gets or sets the precipitation rate in inches per hour. */
    precipitationRate?: number | undefined;
    /** Sets the precipitation rate in tenths of grams per square meter. */
    precipitationRateTenthGramsPerSquareMeterPerSecond!: number;
    /** Sets the precipitation rate in millimeters per hour. */
    precipitationRateMillimetersPerHour?: number | undefined;
    /** Gets or sets the snow accumulation rate in inches per hour */
    snowAccumulationRate?: number | undefined;
    /** Sets the snow accumulation rate in tenths of micrometers per second. */
    snowAccumulationRateTenthMicrometersPerSecond!: number;
    /** Gets or sets the precipitation situation. */
    precipitationSituation?: PrecipitationSituationEnum | undefined;
    /** Gets the precipitation situation as a simple string. */
    precipitationSituationString?: string | undefined;
    /** Gets the flooding state as a simple string. */
    floodingStateString?: string | undefined;
    /** Gets or sets the ice deposit thickness in inches. */
    iceDeposit?: number | undefined;
    /** Sets the ice thickness in millimeters. */
    iceDepositMm!: number;
    /** Gets or sets the flooding state of the device as a whole by using worst case of all sensors' flooding state. */
    floodingState?: FloodingStateEnum | undefined;
    relativeHumiditySpecified!: boolean;
    adjacentSnowDepthSpecified!: boolean;
    roadwaySnowDepthSpecified!: boolean;
    roadwaySnowPackedDepthSpecified!: boolean;
    precipitationRateSpecified!: boolean;
    snowAccumulationRateSpecified!: boolean;
    precipitationSituationSpecified!: boolean;
    iceDepositSpecified!: boolean;
    floodingStateSpecified!: boolean;

    constructor(data?: IPrecipStatus) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["waterLevelSensors"])) {
                this.waterLevelSensors = [] as any;
                for (let item of _data["waterLevelSensors"])
                    this.waterLevelSensors!.push(WaterLevelSensor.fromJS(item));
            }
            this.averageWaterLevelStatus = _data["averageWaterLevelStatus"] ? AverageWaterLevelStatus.fromJS(_data["averageWaterLevelStatus"]) : <any>undefined;
            this.relativeHumidity = _data["relativeHumidity"];
            this.relativeHumidityPercent = _data["relativeHumidityPercent"];
            this.adjacentSnowDepth = _data["adjacentSnowDepth"];
            this.adjacentSnowDepthCentimeters = _data["adjacentSnowDepthCentimeters"];
            this.adjacentSnowDepthMillimeters = _data["adjacentSnowDepthMillimeters"];
            this.roadwaySnowDepth = _data["roadwaySnowDepth"];
            this.roadwaySnowDepthCentimeters = _data["roadwaySnowDepthCentimeters"];
            this.roadwaySnowPackedDepth = _data["roadwaySnowPackedDepth"];
            this.roadwaySnowPackedDepthCentimeters = _data["roadwaySnowPackedDepthCentimeters"];
            this.precipitationRate = _data["precipitationRate"];
            this.precipitationRateTenthGramsPerSquareMeterPerSecond = _data["precipitationRateTenthGramsPerSquareMeterPerSecond"];
            this.precipitationRateMillimetersPerHour = _data["precipitationRateMillimetersPerHour"];
            this.snowAccumulationRate = _data["snowAccumulationRate"];
            this.snowAccumulationRateTenthMicrometersPerSecond = _data["snowAccumulationRateTenthMicrometersPerSecond"];
            this.precipitationSituation = _data["precipitationSituation"];
            this.precipitationSituationString = _data["precipitationSituationString"];
            this.floodingStateString = _data["floodingStateString"];
            this.iceDeposit = _data["iceDeposit"];
            this.iceDepositMm = _data["iceDepositMm"];
            this.floodingState = _data["floodingState"];
            this.relativeHumiditySpecified = _data["relativeHumiditySpecified"];
            this.adjacentSnowDepthSpecified = _data["adjacentSnowDepthSpecified"];
            this.roadwaySnowDepthSpecified = _data["roadwaySnowDepthSpecified"];
            this.roadwaySnowPackedDepthSpecified = _data["roadwaySnowPackedDepthSpecified"];
            this.precipitationRateSpecified = _data["precipitationRateSpecified"];
            this.snowAccumulationRateSpecified = _data["snowAccumulationRateSpecified"];
            this.precipitationSituationSpecified = _data["precipitationSituationSpecified"];
            this.iceDepositSpecified = _data["iceDepositSpecified"];
            this.floodingStateSpecified = _data["floodingStateSpecified"];
        }
    }

    static fromJS(data: any): PrecipStatus {
        data = typeof data === 'object' ? data : {};
        let result = new PrecipStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.waterLevelSensors)) {
            data["waterLevelSensors"] = [];
            for (let item of this.waterLevelSensors)
                data["waterLevelSensors"].push(item.toJSON());
        }
        data["averageWaterLevelStatus"] = this.averageWaterLevelStatus ? this.averageWaterLevelStatus.toJSON() : <any>undefined;
        data["relativeHumidity"] = this.relativeHumidity;
        data["relativeHumidityPercent"] = this.relativeHumidityPercent;
        data["adjacentSnowDepth"] = this.adjacentSnowDepth;
        data["adjacentSnowDepthCentimeters"] = this.adjacentSnowDepthCentimeters;
        data["adjacentSnowDepthMillimeters"] = this.adjacentSnowDepthMillimeters;
        data["roadwaySnowDepth"] = this.roadwaySnowDepth;
        data["roadwaySnowDepthCentimeters"] = this.roadwaySnowDepthCentimeters;
        data["roadwaySnowPackedDepth"] = this.roadwaySnowPackedDepth;
        data["roadwaySnowPackedDepthCentimeters"] = this.roadwaySnowPackedDepthCentimeters;
        data["precipitationRate"] = this.precipitationRate;
        data["precipitationRateTenthGramsPerSquareMeterPerSecond"] = this.precipitationRateTenthGramsPerSquareMeterPerSecond;
        data["precipitationRateMillimetersPerHour"] = this.precipitationRateMillimetersPerHour;
        data["snowAccumulationRate"] = this.snowAccumulationRate;
        data["snowAccumulationRateTenthMicrometersPerSecond"] = this.snowAccumulationRateTenthMicrometersPerSecond;
        data["precipitationSituation"] = this.precipitationSituation;
        data["precipitationSituationString"] = this.precipitationSituationString;
        data["floodingStateString"] = this.floodingStateString;
        data["iceDeposit"] = this.iceDeposit;
        data["iceDepositMm"] = this.iceDepositMm;
        data["floodingState"] = this.floodingState;
        data["relativeHumiditySpecified"] = this.relativeHumiditySpecified;
        data["adjacentSnowDepthSpecified"] = this.adjacentSnowDepthSpecified;
        data["roadwaySnowDepthSpecified"] = this.roadwaySnowDepthSpecified;
        data["roadwaySnowPackedDepthSpecified"] = this.roadwaySnowPackedDepthSpecified;
        data["precipitationRateSpecified"] = this.precipitationRateSpecified;
        data["snowAccumulationRateSpecified"] = this.snowAccumulationRateSpecified;
        data["precipitationSituationSpecified"] = this.precipitationSituationSpecified;
        data["iceDepositSpecified"] = this.iceDepositSpecified;
        data["floodingStateSpecified"] = this.floodingStateSpecified;
        super.toJSON(data);
        return data; 
    }
}

/** A class representing XML for the precipitation status reported by an RWIS station. */
export interface IPrecipStatus extends IXmlBase {
    /** Gets or sets the water level sensors. */
    waterLevelSensors?: WaterLevelSensor[] | undefined;
    /** Gets or sets the average water level status. */
    averageWaterLevelStatus?: AverageWaterLevelStatus | undefined;
    /** Gets or sets the relative humidity as a percentage. */
    relativeHumidity?: number | undefined;
    /** Sets the exposure as a percentage, or null if the value is not in the valid range (0-100) */
    relativeHumidityPercent: number;
    /** Gets or sets the adjacent depth in inches */
    adjacentSnowDepth?: number | undefined;
    /** Sets the adjacent depth in centimeters. */
    adjacentSnowDepthCentimeters: number;
    /** Sets the adjacent depth in millimeters. */
    adjacentSnowDepthMillimeters?: number | undefined;
    /** Gets or sets the road depth in inches */
    roadwaySnowDepth?: number | undefined;
    /** Sets the road depth in centimeters. */
    roadwaySnowDepthCentimeters: number;
    /** Gets or sets the packed depth in inches. */
    roadwaySnowPackedDepth?: number | undefined;
    /** Sets the packed depth in inches. */
    roadwaySnowPackedDepthCentimeters: number;
    /** Gets or sets the precipitation rate in inches per hour. */
    precipitationRate?: number | undefined;
    /** Sets the precipitation rate in tenths of grams per square meter. */
    precipitationRateTenthGramsPerSquareMeterPerSecond: number;
    /** Sets the precipitation rate in millimeters per hour. */
    precipitationRateMillimetersPerHour?: number | undefined;
    /** Gets or sets the snow accumulation rate in inches per hour */
    snowAccumulationRate?: number | undefined;
    /** Sets the snow accumulation rate in tenths of micrometers per second. */
    snowAccumulationRateTenthMicrometersPerSecond: number;
    /** Gets or sets the precipitation situation. */
    precipitationSituation?: PrecipitationSituationEnum | undefined;
    /** Gets the precipitation situation as a simple string. */
    precipitationSituationString?: string | undefined;
    /** Gets the flooding state as a simple string. */
    floodingStateString?: string | undefined;
    /** Gets or sets the ice deposit thickness in inches. */
    iceDeposit?: number | undefined;
    /** Sets the ice thickness in millimeters. */
    iceDepositMm: number;
    /** Gets or sets the flooding state of the device as a whole by using worst case of all sensors' flooding state. */
    floodingState?: FloodingStateEnum | undefined;
    relativeHumiditySpecified: boolean;
    adjacentSnowDepthSpecified: boolean;
    roadwaySnowDepthSpecified: boolean;
    roadwaySnowPackedDepthSpecified: boolean;
    precipitationRateSpecified: boolean;
    snowAccumulationRateSpecified: boolean;
    precipitationSituationSpecified: boolean;
    iceDepositSpecified: boolean;
    floodingStateSpecified: boolean;
}

/** Represents a water level sensor */
export class WaterLevelSensor extends XmlBase implements IWaterLevelSensor {
    /** Gets or sets the index. */
    index!: number;
    /** Gets or sets the water depth in inches */
    waterDepth?: number | undefined;
    /** Sets the water depth in centimeters. */
    waterDepthCentimeters!: number;
    /** Gets or sets the flooding state of the sensor. */
    floodingState?: FloodingStateEnum | undefined;
    /** Gets or sets the height of the roadway in inches. */
    roadwayHeight?: number | undefined;
    /** Sets the roadway height in centimeters. */
    roadwayHeightCentimeters!: number;
    waterDepthSpecified!: boolean;
    floodingStateSpecified!: boolean;
    roadwayHeightSpecified!: boolean;

    constructor(data?: IWaterLevelSensor) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.index = _data["index"];
            this.waterDepth = _data["waterDepth"];
            this.waterDepthCentimeters = _data["waterDepthCentimeters"];
            this.floodingState = _data["floodingState"];
            this.roadwayHeight = _data["roadwayHeight"];
            this.roadwayHeightCentimeters = _data["roadwayHeightCentimeters"];
            this.waterDepthSpecified = _data["waterDepthSpecified"];
            this.floodingStateSpecified = _data["floodingStateSpecified"];
            this.roadwayHeightSpecified = _data["roadwayHeightSpecified"];
        }
    }

    static fromJS(data: any): WaterLevelSensor {
        data = typeof data === 'object' ? data : {};
        let result = new WaterLevelSensor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index;
        data["waterDepth"] = this.waterDepth;
        data["waterDepthCentimeters"] = this.waterDepthCentimeters;
        data["floodingState"] = this.floodingState;
        data["roadwayHeight"] = this.roadwayHeight;
        data["roadwayHeightCentimeters"] = this.roadwayHeightCentimeters;
        data["waterDepthSpecified"] = this.waterDepthSpecified;
        data["floodingStateSpecified"] = this.floodingStateSpecified;
        data["roadwayHeightSpecified"] = this.roadwayHeightSpecified;
        super.toJSON(data);
        return data; 
    }
}

/** Represents a water level sensor */
export interface IWaterLevelSensor extends IXmlBase {
    /** Gets or sets the index. */
    index: number;
    /** Gets or sets the water depth in inches */
    waterDepth?: number | undefined;
    /** Sets the water depth in centimeters. */
    waterDepthCentimeters: number;
    /** Gets or sets the flooding state of the sensor. */
    floodingState?: FloodingStateEnum | undefined;
    /** Gets or sets the height of the roadway in inches. */
    roadwayHeight?: number | undefined;
    /** Sets the roadway height in centimeters. */
    roadwayHeightCentimeters: number;
    waterDepthSpecified: boolean;
    floodingStateSpecified: boolean;
    roadwayHeightSpecified: boolean;
}

export enum FloodingStateEnum {
    Clear = 0,
    PreFlood = 1,
    Flooded = 2,
    Unknown = 3,
}

/** The average water level sensor status for all sensors attached to an RWIS station. */
export class AverageWaterLevelStatus extends XmlBase implements IAverageWaterLevelStatus {
    /** Gets or sets the water depth in inches */
    waterDepth?: number | undefined;
    waterDepthSpecified!: boolean;

    constructor(data?: IAverageWaterLevelStatus) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.waterDepth = _data["waterDepth"];
            this.waterDepthSpecified = _data["waterDepthSpecified"];
        }
    }

    static fromJS(data: any): AverageWaterLevelStatus {
        data = typeof data === 'object' ? data : {};
        let result = new AverageWaterLevelStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["waterDepth"] = this.waterDepth;
        data["waterDepthSpecified"] = this.waterDepthSpecified;
        super.toJSON(data);
        return data; 
    }
}

/** The average water level sensor status for all sensors attached to an RWIS station. */
export interface IAverageWaterLevelStatus extends IXmlBase {
    /** Gets or sets the water depth in inches */
    waterDepth?: number | undefined;
    waterDepthSpecified: boolean;
}

/** A list of the different types of precipitation. */
export enum PrecipitationSituationEnum {
    InvalidValue = 0,
    Other = 1,
    Unknown = 2,
    NoPrecipitation = 3,
    UnidentifiedSlight = 4,
    UnidentifiedModerate = 5,
    UnidentifiedHeavy = 6,
    SnowSlight = 7,
    SnowModerate = 8,
    SnowHeavy = 9,
    RainSlight = 10,
    RainModerate = 11,
    RainHeavy = 12,
    FrozenPrecipitationSlight = 13,
    FrozenPrecipitationModerate = 14,
    FrozenPrecipitationHeavy = 15,
    Rain = 16,
    Snow = 17,
    MixedRainAndSnow = 18,
    FreezingRain = 19,
    Sleet = 20,
    Hail = 21,
    Unidentified = 22,
    Frozen = 23,
    IcePellets = 24,
    Recent = 25,
}

/** A class representing XML for the visibility status reported by an RWIS station. */
export class VisibilityStatus extends XmlBase implements IVisibilityStatus {
    /** Gets or sets the surface visibility in miles. */
    visibility?: number | undefined;
    /** Sets the surface visibility in tenths of meters */
    visibilityTenthMeters!: number;
    /** Sets the surface visibility in meters */
    visibilityMeters?: number | undefined;
    /** Gets or sets the visibility situation. */
    situation?: VisibilitySituationEnum | undefined;
    visibilitySpecified!: boolean;
    situationSpecified!: boolean;

    constructor(data?: IVisibilityStatus) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.visibility = _data["visibility"];
            this.visibilityTenthMeters = _data["visibilityTenthMeters"];
            this.visibilityMeters = _data["visibilityMeters"];
            this.situation = _data["situation"];
            this.visibilitySpecified = _data["visibilitySpecified"];
            this.situationSpecified = _data["situationSpecified"];
        }
    }

    static fromJS(data: any): VisibilityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new VisibilityStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["visibility"] = this.visibility;
        data["visibilityTenthMeters"] = this.visibilityTenthMeters;
        data["visibilityMeters"] = this.visibilityMeters;
        data["situation"] = this.situation;
        data["visibilitySpecified"] = this.visibilitySpecified;
        data["situationSpecified"] = this.situationSpecified;
        super.toJSON(data);
        return data; 
    }
}

/** A class representing XML for the visibility status reported by an RWIS station. */
export interface IVisibilityStatus extends IXmlBase {
    /** Gets or sets the surface visibility in miles. */
    visibility?: number | undefined;
    /** Sets the surface visibility in tenths of meters */
    visibilityTenthMeters: number;
    /** Sets the surface visibility in meters */
    visibilityMeters?: number | undefined;
    /** Gets or sets the visibility situation. */
    situation?: VisibilitySituationEnum | undefined;
    visibilitySpecified: boolean;
    situationSpecified: boolean;
}

/** An enumeration of acceptable Visibility Situations. */
export enum VisibilitySituationEnum {
    InvalidValue = 0,
    Other = 1,
    Unknown = 2,
    Clear = 3,
    FogNotPatchy = 4,
    PatchyFog = 5,
    BlowingSnow = 6,
    Smoke = 7,
    SeaSpray = 8,
    VehicleSpray = 9,
    BlowingDustOrSand = 10,
    SunGlare = 11,
    SwarmsOfInsects = 12,
}

/** A class representing XML of the pavement status reported by an RWIS station. */
export class PavementStatus extends XmlBase implements IPavementStatus {
    /** Gets or sets the pavement sensor status. */
    sensors?: PavementSensor[] | undefined;
    /** Gets or sets the average pavement status. */
    averagePavementStatus?: AveragePavementStatus | undefined;
    /** Gets or sets the treatment of the pavement. */
    treatments?: PavementTreatement[] | undefined;
    /** Gets or sets the amount of treatment being applied in lbs/mi. */
    amount?: number | undefined;
    /** Sets the amount of treatment being applied in kgs/km. */
    amountKilogramsPerKilometer!: number;
    /** Gets or sets the width of the treatment in feet. */
    width?: number | undefined;
    /** Sets the width of treatment in meters. */
    widthMeters!: number;
    amountSpecified!: boolean;
    widthSpecified!: boolean;

    constructor(data?: IPavementStatus) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["sensors"])) {
                this.sensors = [] as any;
                for (let item of _data["sensors"])
                    this.sensors!.push(PavementSensor.fromJS(item));
            }
            this.averagePavementStatus = _data["averagePavementStatus"] ? AveragePavementStatus.fromJS(_data["averagePavementStatus"]) : <any>undefined;
            if (Array.isArray(_data["treatments"])) {
                this.treatments = [] as any;
                for (let item of _data["treatments"])
                    this.treatments!.push(PavementTreatement.fromJS(item));
            }
            this.amount = _data["amount"];
            this.amountKilogramsPerKilometer = _data["amountKilogramsPerKilometer"];
            this.width = _data["width"];
            this.widthMeters = _data["widthMeters"];
            this.amountSpecified = _data["amountSpecified"];
            this.widthSpecified = _data["widthSpecified"];
        }
    }

    static fromJS(data: any): PavementStatus {
        data = typeof data === 'object' ? data : {};
        let result = new PavementStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sensors)) {
            data["sensors"] = [];
            for (let item of this.sensors)
                data["sensors"].push(item.toJSON());
        }
        data["averagePavementStatus"] = this.averagePavementStatus ? this.averagePavementStatus.toJSON() : <any>undefined;
        if (Array.isArray(this.treatments)) {
            data["treatments"] = [];
            for (let item of this.treatments)
                data["treatments"].push(item.toJSON());
        }
        data["amount"] = this.amount;
        data["amountKilogramsPerKilometer"] = this.amountKilogramsPerKilometer;
        data["width"] = this.width;
        data["widthMeters"] = this.widthMeters;
        data["amountSpecified"] = this.amountSpecified;
        data["widthSpecified"] = this.widthSpecified;
        super.toJSON(data);
        return data; 
    }
}

/** A class representing XML of the pavement status reported by an RWIS station. */
export interface IPavementStatus extends IXmlBase {
    /** Gets or sets the pavement sensor status. */
    sensors?: PavementSensor[] | undefined;
    /** Gets or sets the average pavement status. */
    averagePavementStatus?: AveragePavementStatus | undefined;
    /** Gets or sets the treatment of the pavement. */
    treatments?: PavementTreatement[] | undefined;
    /** Gets or sets the amount of treatment being applied in lbs/mi. */
    amount?: number | undefined;
    /** Sets the amount of treatment being applied in kgs/km. */
    amountKilogramsPerKilometer: number;
    /** Gets or sets the width of the treatment in feet. */
    width?: number | undefined;
    /** Sets the width of treatment in meters. */
    widthMeters: number;
    amountSpecified: boolean;
    widthSpecified: boolean;
}

/** A class representing the XML for a pavement sensor status. */
export class PavementSensor extends XmlBase implements IPavementSensor {
    /** Gets or sets the index of the sensor. */
    index!: number;
    /** Gets or sets the exposure as a percentage. */
    exposure?: number | undefined;
    /** Sets the exposure as a percentage, or null if the value is not in the valid range (0-100) */
    exposurePercent!: number;
    /** Gets or sets the surface status information. */
    surfaceStatus?: SurfaceStatusEnum | undefined;
    /** Gets or sets the surface friction information as a percentage. */
    surfaceFriction?: number | undefined;
    /** Sets the surface friction as a integer percent out of a hundred. */
    surfaceFrictionPercent!: number;
    /** Gets or sets the temperature in degrees F. */
    temperature?: number | undefined;
    /** Sets the temperature in tenths of degrees C */
    temperatureTenthDegreesC!: number;
    /** Sets the temperature in degrees C */
    temperatureDegreesC?: number | undefined;
    /** Gets or sets the subsurface temperature in degrees F. */
    subsurfaceTemperature?: number | undefined;
    /** Sets the subsurface temperature in tenths of degrees C. */
    subsurfaceTempTenthDegreesC!: number;
    /** Sets the subsurface temperature in degrees C. */
    subsurfaceTempDegreesC?: number | undefined;
    /** Gets or sets the salinity in the pavement in parts per thousand. */
    salinity?: number | undefined;
    /** Sets the salinity in the pavement in grams per 100,000 grams of solution */
    salinityPartsPerHundredThousand!: number;
    /** Gets or sets the freezing point in degrees F. */
    freezingPoint?: number | undefined;
    /** Sets the freezing point in tenths of degrees C */
    freezingPointTenthDegreesC!: number;
    /** Sets the freezing point in degrees C */
    freezingPointDegreesC?: number | undefined;
    /** Gets or sets the conductivity in millimhos/cm. */
    conductivity?: number | undefined;
    /** Sets the conductivity in tenths of millimhos/cm. */
    conductivityTenthsOfMilliMhosPerCm!: number;
    /** Sets the conductivity in mhos/cm. */
    conductivityMhosPerCm!: number;
    /** Sets the conductivity in millimhos/cm. */
    conductivityMilliMhosPerCm?: number | undefined;
    /** Gets or sets the black ice status. */
    blackIce?: BlackIceEnum | undefined;
    /** Gets or sets the ice or water depth in inches */
    iceOrWaterDepth?: number | undefined;
    /** Sets the ice or water depth in tenths of millimeters. */
    iceOrWaterDepthTenthsOfMm!: number;
    /** Sets the ice or water depth in millimeters. */
    iceOrWaterDepthMmV1!: number;
    /** Sets the ice or water depth in millimeters. */
    iceOrWaterDepthMm?: number | undefined;
    /** Gets or sets the sensor error. */
    sensorError?: SensorErrorEnum | undefined;
    /** Gets or sets the pavement sensor visibility, in miles. */
    visibility?: number | undefined;
    /** Sets the pavement sensor visibility, in meters */
    visibilityMeters!: number;
    exposureSpecified!: boolean;
    surfaceStatusSpecified!: boolean;
    surfaceFrictionSpecified!: boolean;
    temperatureSpecified!: boolean;
    subsurfaceTemperatureSpecified!: boolean;
    salinitySpecified!: boolean;
    freezingPointSpecified!: boolean;
    conductivitySpecified!: boolean;
    blackIceSpecified!: boolean;
    iceOrWaterDepthSpecified!: boolean;
    sensorErrorSpecified!: boolean;
    visibilitySpecified!: boolean;

    constructor(data?: IPavementSensor) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.index = _data["index"];
            this.exposure = _data["exposure"];
            this.exposurePercent = _data["exposurePercent"];
            this.surfaceStatus = _data["surfaceStatus"];
            this.surfaceFriction = _data["surfaceFriction"];
            this.surfaceFrictionPercent = _data["surfaceFrictionPercent"];
            this.temperature = _data["temperature"];
            this.temperatureTenthDegreesC = _data["temperatureTenthDegreesC"];
            this.temperatureDegreesC = _data["temperatureDegreesC"];
            this.subsurfaceTemperature = _data["subsurfaceTemperature"];
            this.subsurfaceTempTenthDegreesC = _data["subsurfaceTempTenthDegreesC"];
            this.subsurfaceTempDegreesC = _data["subsurfaceTempDegreesC"];
            this.salinity = _data["salinity"];
            this.salinityPartsPerHundredThousand = _data["salinityPartsPerHundredThousand"];
            this.freezingPoint = _data["freezingPoint"];
            this.freezingPointTenthDegreesC = _data["freezingPointTenthDegreesC"];
            this.freezingPointDegreesC = _data["freezingPointDegreesC"];
            this.conductivity = _data["conductivity"];
            this.conductivityTenthsOfMilliMhosPerCm = _data["conductivityTenthsOfMilliMhosPerCm"];
            this.conductivityMhosPerCm = _data["conductivityMhosPerCm"];
            this.conductivityMilliMhosPerCm = _data["conductivityMilliMhosPerCm"];
            this.blackIce = _data["blackIce"];
            this.iceOrWaterDepth = _data["iceOrWaterDepth"];
            this.iceOrWaterDepthTenthsOfMm = _data["iceOrWaterDepthTenthsOfMm"];
            this.iceOrWaterDepthMmV1 = _data["iceOrWaterDepthMmV1"];
            this.iceOrWaterDepthMm = _data["iceOrWaterDepthMm"];
            this.sensorError = _data["sensorError"];
            this.visibility = _data["visibility"];
            this.visibilityMeters = _data["visibilityMeters"];
            this.exposureSpecified = _data["exposureSpecified"];
            this.surfaceStatusSpecified = _data["surfaceStatusSpecified"];
            this.surfaceFrictionSpecified = _data["surfaceFrictionSpecified"];
            this.temperatureSpecified = _data["temperatureSpecified"];
            this.subsurfaceTemperatureSpecified = _data["subsurfaceTemperatureSpecified"];
            this.salinitySpecified = _data["salinitySpecified"];
            this.freezingPointSpecified = _data["freezingPointSpecified"];
            this.conductivitySpecified = _data["conductivitySpecified"];
            this.blackIceSpecified = _data["blackIceSpecified"];
            this.iceOrWaterDepthSpecified = _data["iceOrWaterDepthSpecified"];
            this.sensorErrorSpecified = _data["sensorErrorSpecified"];
            this.visibilitySpecified = _data["visibilitySpecified"];
        }
    }

    static fromJS(data: any): PavementSensor {
        data = typeof data === 'object' ? data : {};
        let result = new PavementSensor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index;
        data["exposure"] = this.exposure;
        data["exposurePercent"] = this.exposurePercent;
        data["surfaceStatus"] = this.surfaceStatus;
        data["surfaceFriction"] = this.surfaceFriction;
        data["surfaceFrictionPercent"] = this.surfaceFrictionPercent;
        data["temperature"] = this.temperature;
        data["temperatureTenthDegreesC"] = this.temperatureTenthDegreesC;
        data["temperatureDegreesC"] = this.temperatureDegreesC;
        data["subsurfaceTemperature"] = this.subsurfaceTemperature;
        data["subsurfaceTempTenthDegreesC"] = this.subsurfaceTempTenthDegreesC;
        data["subsurfaceTempDegreesC"] = this.subsurfaceTempDegreesC;
        data["salinity"] = this.salinity;
        data["salinityPartsPerHundredThousand"] = this.salinityPartsPerHundredThousand;
        data["freezingPoint"] = this.freezingPoint;
        data["freezingPointTenthDegreesC"] = this.freezingPointTenthDegreesC;
        data["freezingPointDegreesC"] = this.freezingPointDegreesC;
        data["conductivity"] = this.conductivity;
        data["conductivityTenthsOfMilliMhosPerCm"] = this.conductivityTenthsOfMilliMhosPerCm;
        data["conductivityMhosPerCm"] = this.conductivityMhosPerCm;
        data["conductivityMilliMhosPerCm"] = this.conductivityMilliMhosPerCm;
        data["blackIce"] = this.blackIce;
        data["iceOrWaterDepth"] = this.iceOrWaterDepth;
        data["iceOrWaterDepthTenthsOfMm"] = this.iceOrWaterDepthTenthsOfMm;
        data["iceOrWaterDepthMmV1"] = this.iceOrWaterDepthMmV1;
        data["iceOrWaterDepthMm"] = this.iceOrWaterDepthMm;
        data["sensorError"] = this.sensorError;
        data["visibility"] = this.visibility;
        data["visibilityMeters"] = this.visibilityMeters;
        data["exposureSpecified"] = this.exposureSpecified;
        data["surfaceStatusSpecified"] = this.surfaceStatusSpecified;
        data["surfaceFrictionSpecified"] = this.surfaceFrictionSpecified;
        data["temperatureSpecified"] = this.temperatureSpecified;
        data["subsurfaceTemperatureSpecified"] = this.subsurfaceTemperatureSpecified;
        data["salinitySpecified"] = this.salinitySpecified;
        data["freezingPointSpecified"] = this.freezingPointSpecified;
        data["conductivitySpecified"] = this.conductivitySpecified;
        data["blackIceSpecified"] = this.blackIceSpecified;
        data["iceOrWaterDepthSpecified"] = this.iceOrWaterDepthSpecified;
        data["sensorErrorSpecified"] = this.sensorErrorSpecified;
        data["visibilitySpecified"] = this.visibilitySpecified;
        super.toJSON(data);
        return data; 
    }
}

/** A class representing the XML for a pavement sensor status. */
export interface IPavementSensor extends IXmlBase {
    /** Gets or sets the index of the sensor. */
    index: number;
    /** Gets or sets the exposure as a percentage. */
    exposure?: number | undefined;
    /** Sets the exposure as a percentage, or null if the value is not in the valid range (0-100) */
    exposurePercent: number;
    /** Gets or sets the surface status information. */
    surfaceStatus?: SurfaceStatusEnum | undefined;
    /** Gets or sets the surface friction information as a percentage. */
    surfaceFriction?: number | undefined;
    /** Sets the surface friction as a integer percent out of a hundred. */
    surfaceFrictionPercent: number;
    /** Gets or sets the temperature in degrees F. */
    temperature?: number | undefined;
    /** Sets the temperature in tenths of degrees C */
    temperatureTenthDegreesC: number;
    /** Sets the temperature in degrees C */
    temperatureDegreesC?: number | undefined;
    /** Gets or sets the subsurface temperature in degrees F. */
    subsurfaceTemperature?: number | undefined;
    /** Sets the subsurface temperature in tenths of degrees C. */
    subsurfaceTempTenthDegreesC: number;
    /** Sets the subsurface temperature in degrees C. */
    subsurfaceTempDegreesC?: number | undefined;
    /** Gets or sets the salinity in the pavement in parts per thousand. */
    salinity?: number | undefined;
    /** Sets the salinity in the pavement in grams per 100,000 grams of solution */
    salinityPartsPerHundredThousand: number;
    /** Gets or sets the freezing point in degrees F. */
    freezingPoint?: number | undefined;
    /** Sets the freezing point in tenths of degrees C */
    freezingPointTenthDegreesC: number;
    /** Sets the freezing point in degrees C */
    freezingPointDegreesC?: number | undefined;
    /** Gets or sets the conductivity in millimhos/cm. */
    conductivity?: number | undefined;
    /** Sets the conductivity in tenths of millimhos/cm. */
    conductivityTenthsOfMilliMhosPerCm: number;
    /** Sets the conductivity in mhos/cm. */
    conductivityMhosPerCm: number;
    /** Sets the conductivity in millimhos/cm. */
    conductivityMilliMhosPerCm?: number | undefined;
    /** Gets or sets the black ice status. */
    blackIce?: BlackIceEnum | undefined;
    /** Gets or sets the ice or water depth in inches */
    iceOrWaterDepth?: number | undefined;
    /** Sets the ice or water depth in tenths of millimeters. */
    iceOrWaterDepthTenthsOfMm: number;
    /** Sets the ice or water depth in millimeters. */
    iceOrWaterDepthMmV1: number;
    /** Sets the ice or water depth in millimeters. */
    iceOrWaterDepthMm?: number | undefined;
    /** Gets or sets the sensor error. */
    sensorError?: SensorErrorEnum | undefined;
    /** Gets or sets the pavement sensor visibility, in miles. */
    visibility?: number | undefined;
    /** Sets the pavement sensor visibility, in meters */
    visibilityMeters: number;
    exposureSpecified: boolean;
    surfaceStatusSpecified: boolean;
    surfaceFrictionSpecified: boolean;
    temperatureSpecified: boolean;
    subsurfaceTemperatureSpecified: boolean;
    salinitySpecified: boolean;
    freezingPointSpecified: boolean;
    conductivitySpecified: boolean;
    blackIceSpecified: boolean;
    iceOrWaterDepthSpecified: boolean;
    sensorErrorSpecified: boolean;
    visibilitySpecified: boolean;
}

/** An enumeration specifying the different types of surface status values. */
export enum SurfaceStatusEnum {
    InvalidValue = 0,
    Other = 1,
    Error = 2,
    Dry = 3,
    TraceMoisture = 4,
    Wet = 5,
    ChemicallyWet = 6,
    IceWarning = 7,
    IceWatch = 8,
    SnowWarning = 9,
    SnowWatch = 10,
    Absorption = 11,
    Dew = 12,
    Frost = 13,
    AbsorptionAtDewpoint = 14,
    Slushy = 15,
    Trace = 16,
    Alert = 17,
    Critical = 18,
    FrostAtDewpoint = 19,
    ProbableDrying = 20,
    NoReport = 21,
    ChemicallyMoist = 22,
    Ice = 23,
    Snow = 24,
    SnowOrIceWatch = 25,
    SnowOrIceWarning = 26,
    WetAboveFreezing = 27,
    WetBelowFreezing = 28,
    BlackIceWarning = 29,
}

/** An enumeration specifying the different types of black ice. */
export enum BlackIceEnum {
    InvalidValue = 0,
    Other = 1,
    NoIce = 2,
    BlackIce = 3,
    DetectorError = 4,
}

/** An enumeration specifying the different types of sensor errors. */
export enum SensorErrorEnum {
    InvalidValue = 0,
    Other = 1,
    None = 2,
    NoResponse = 3,
    CutCable = 4,
    ShortCircuit = 5,
    DirtyLens = 6,
}

/** The average values reported by pavement sensors attached to a RWIS station. */
export class AveragePavementStatus extends XmlBase implements IAveragePavementStatus {
    /** Gets or sets the exposure as a percentage. */
    exposure?: number | undefined;
    /** Gets or sets the temperature in degrees F. */
    temperature?: number | undefined;
    /** Gets or sets the temperature in degrees F. */
    subsurfaceTemperature?: number | undefined;
    /** Gets or sets the salinity in the pavement in parts per thousand. */
    salinity?: number | undefined;
    /** Gets or sets the freezing point in degrees F. */
    freezingPoint?: number | undefined;
    /** Gets or sets the conductivity in millimhos/cm. */
    conductivity?: number | undefined;
    /** Gets or sets the ice or water depth in inches */
    iceOrWaterDepth?: number | undefined;
    /** Gets or sets the surface friction as a percentage. */
    surfaceFriction?: number | undefined;
    /** Gets or sets the pavement sensor visibility, in miles. */
    visibility?: number | undefined;
    exposureSpecified!: boolean;
    temperatureSpecified!: boolean;
    subsurfaceTemperatureSpecified!: boolean;
    salinitySpecified!: boolean;
    freezingPointSpecified!: boolean;
    conductivitySpecified!: boolean;
    iceOrWaterDepthSpecified!: boolean;
    surfaceFrictionSpecified!: boolean;
    visibilitySpecified!: boolean;

    constructor(data?: IAveragePavementStatus) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.exposure = _data["exposure"];
            this.temperature = _data["temperature"];
            this.subsurfaceTemperature = _data["subsurfaceTemperature"];
            this.salinity = _data["salinity"];
            this.freezingPoint = _data["freezingPoint"];
            this.conductivity = _data["conductivity"];
            this.iceOrWaterDepth = _data["iceOrWaterDepth"];
            this.surfaceFriction = _data["surfaceFriction"];
            this.visibility = _data["visibility"];
            this.exposureSpecified = _data["exposureSpecified"];
            this.temperatureSpecified = _data["temperatureSpecified"];
            this.subsurfaceTemperatureSpecified = _data["subsurfaceTemperatureSpecified"];
            this.salinitySpecified = _data["salinitySpecified"];
            this.freezingPointSpecified = _data["freezingPointSpecified"];
            this.conductivitySpecified = _data["conductivitySpecified"];
            this.iceOrWaterDepthSpecified = _data["iceOrWaterDepthSpecified"];
            this.surfaceFrictionSpecified = _data["surfaceFrictionSpecified"];
            this.visibilitySpecified = _data["visibilitySpecified"];
        }
    }

    static fromJS(data: any): AveragePavementStatus {
        data = typeof data === 'object' ? data : {};
        let result = new AveragePavementStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exposure"] = this.exposure;
        data["temperature"] = this.temperature;
        data["subsurfaceTemperature"] = this.subsurfaceTemperature;
        data["salinity"] = this.salinity;
        data["freezingPoint"] = this.freezingPoint;
        data["conductivity"] = this.conductivity;
        data["iceOrWaterDepth"] = this.iceOrWaterDepth;
        data["surfaceFriction"] = this.surfaceFriction;
        data["visibility"] = this.visibility;
        data["exposureSpecified"] = this.exposureSpecified;
        data["temperatureSpecified"] = this.temperatureSpecified;
        data["subsurfaceTemperatureSpecified"] = this.subsurfaceTemperatureSpecified;
        data["salinitySpecified"] = this.salinitySpecified;
        data["freezingPointSpecified"] = this.freezingPointSpecified;
        data["conductivitySpecified"] = this.conductivitySpecified;
        data["iceOrWaterDepthSpecified"] = this.iceOrWaterDepthSpecified;
        data["surfaceFrictionSpecified"] = this.surfaceFrictionSpecified;
        data["visibilitySpecified"] = this.visibilitySpecified;
        super.toJSON(data);
        return data; 
    }
}

/** The average values reported by pavement sensors attached to a RWIS station. */
export interface IAveragePavementStatus extends IXmlBase {
    /** Gets or sets the exposure as a percentage. */
    exposure?: number | undefined;
    /** Gets or sets the temperature in degrees F. */
    temperature?: number | undefined;
    /** Gets or sets the temperature in degrees F. */
    subsurfaceTemperature?: number | undefined;
    /** Gets or sets the salinity in the pavement in parts per thousand. */
    salinity?: number | undefined;
    /** Gets or sets the freezing point in degrees F. */
    freezingPoint?: number | undefined;
    /** Gets or sets the conductivity in millimhos/cm. */
    conductivity?: number | undefined;
    /** Gets or sets the ice or water depth in inches */
    iceOrWaterDepth?: number | undefined;
    /** Gets or sets the surface friction as a percentage. */
    surfaceFriction?: number | undefined;
    /** Gets or sets the pavement sensor visibility, in miles. */
    visibility?: number | undefined;
    exposureSpecified: boolean;
    temperatureSpecified: boolean;
    subsurfaceTemperatureSpecified: boolean;
    salinitySpecified: boolean;
    freezingPointSpecified: boolean;
    conductivitySpecified: boolean;
    iceOrWaterDepthSpecified: boolean;
    surfaceFrictionSpecified: boolean;
    visibilitySpecified: boolean;
}

/** A class representing XML for pavement treatment reported by an RWIS sensor. */
export class PavementTreatement extends XmlBase implements IPavementTreatement {
    /** Gets or sets the index number of the sensor. */
    index!: number;
    /** Gets or sets the type of the treatment. */
    type?: PavementTreatmentTypeEnum | undefined;
    /** Gets or sets the form of the treatment. */
    form?: PavementTreatmentFormEnum | undefined;
    /** Gets or sets the percentage of treatment type in the mix. */
    mix?: number | undefined;
    /** Sets the mix percentage, , or null if the value is not in the valid range (0-100) */
    mixPercent!: number;
    typeSpecified!: boolean;
    formSpecified!: boolean;
    mixSpecified!: boolean;

    constructor(data?: IPavementTreatement) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.index = _data["index"];
            this.type = _data["type"];
            this.form = _data["form"];
            this.mix = _data["mix"];
            this.mixPercent = _data["mixPercent"];
            this.typeSpecified = _data["typeSpecified"];
            this.formSpecified = _data["formSpecified"];
            this.mixSpecified = _data["mixSpecified"];
        }
    }

    static fromJS(data: any): PavementTreatement {
        data = typeof data === 'object' ? data : {};
        let result = new PavementTreatement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index;
        data["type"] = this.type;
        data["form"] = this.form;
        data["mix"] = this.mix;
        data["mixPercent"] = this.mixPercent;
        data["typeSpecified"] = this.typeSpecified;
        data["formSpecified"] = this.formSpecified;
        data["mixSpecified"] = this.mixSpecified;
        super.toJSON(data);
        return data; 
    }
}

/** A class representing XML for pavement treatment reported by an RWIS sensor. */
export interface IPavementTreatement extends IXmlBase {
    /** Gets or sets the index number of the sensor. */
    index: number;
    /** Gets or sets the type of the treatment. */
    type?: PavementTreatmentTypeEnum | undefined;
    /** Gets or sets the form of the treatment. */
    form?: PavementTreatmentFormEnum | undefined;
    /** Gets or sets the percentage of treatment type in the mix. */
    mix?: number | undefined;
    /** Sets the mix percentage, , or null if the value is not in the valid range (0-100) */
    mixPercent: number;
    typeSpecified: boolean;
    formSpecified: boolean;
    mixSpecified: boolean;
}

/** An enumeration representing the different types of treatment pavement can receive. */
export enum PavementTreatmentTypeEnum {
    InvalidValue = 0,
    Other = 1,
    Sand = 2,
    Dirt = 3,
    Gravel = 4,
    Cinders = 5,
    Water = 6,
    EnhancedSalts = 7,
    NaCl = 8,
    CaCl = 9,
    MgCl = 10,
    CMa = 11,
    KAc = 12,
    NaFormate = 13,
    NaA = 14,
}

/** An enumeration representing the different types of treatment forms available. */
export enum PavementTreatmentFormEnum {
    InvalidValue = 0,
    Other = 1,
    Dry = 2,
    Prewet = 3,
    Liquid = 4,
}

export class RetrieveDataResponseOfStringAndSchedule extends BaseResponse implements IRetrieveDataResponseOfStringAndSchedule {
    data?: { [key: string]: Schedule; } | undefined;

    constructor(data?: IRetrieveDataResponseOfStringAndSchedule) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        this.data![key] = _data["data"][key] ? Schedule.fromJS(_data["data"][key]) : new Schedule();
                }
            }
        }
    }

    static fromJS(data: any): RetrieveDataResponseOfStringAndSchedule {
        data = typeof data === 'object' ? data : {};
        let result = new RetrieveDataResponseOfStringAndSchedule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    data["data"][key] = this.data[key] ? this.data[key].toJSON() : <any>undefined;
            }
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IRetrieveDataResponseOfStringAndSchedule extends IBaseResponse {
    data?: { [key: string]: Schedule; } | undefined;
}

/** A schedule that acts like an Outlook calendar. Has ScheduledItems (by ScheduledItem reference). */
export class Schedule extends XmlBase implements ISchedule {
    id?: Id | undefined;
    scheduleConfig?: ScheduleConfig | undefined;
    scheduleStatus?: ScheduleStatus | undefined;
    /** Gets the current status of the object */
    status?: ScheduleStatus | undefined;

    constructor(data?: ISchedule) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            this.scheduleConfig = _data["scheduleConfig"] ? ScheduleConfig.fromJS(_data["scheduleConfig"]) : <any>undefined;
            this.scheduleStatus = _data["scheduleStatus"] ? ScheduleStatus.fromJS(_data["scheduleStatus"]) : <any>undefined;
            this.status = _data["status"] ? ScheduleStatus.fromJS(_data["status"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Schedule {
        data = typeof data === 'object' ? data : {};
        let result = new Schedule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["scheduleConfig"] = this.scheduleConfig ? this.scheduleConfig.toJSON() : <any>undefined;
        data["scheduleStatus"] = this.scheduleStatus ? this.scheduleStatus.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

/** A schedule that acts like an Outlook calendar. Has ScheduledItems (by ScheduledItem reference). */
export interface ISchedule extends IXmlBase {
    id?: Id | undefined;
    scheduleConfig?: ScheduleConfig | undefined;
    scheduleStatus?: ScheduleStatus | undefined;
    /** Gets the current status of the object */
    status?: ScheduleStatus | undefined;
}

/** A schedule's config options */
export class ScheduleConfig extends XmlBase implements IScheduleConfig {
    name?: string | undefined;

    constructor(data?: IScheduleConfig) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ScheduleConfig {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        super.toJSON(data);
        return data; 
    }
}

/** A schedule's config options */
export interface IScheduleConfig extends IXmlBase {
    name?: string | undefined;
}

/** A schedule's status */
export class ScheduleStatus extends XmlStatusBase implements IScheduleStatus {
    enabled!: boolean;

    constructor(data?: IScheduleStatus) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): ScheduleStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        super.toJSON(data);
        return data; 
    }
}

/** A schedule's status */
export interface IScheduleStatus extends IXmlStatusBase {
    enabled: boolean;
}

export class RetrieveDataResponseOfStringAndScheduledItem extends BaseResponse implements IRetrieveDataResponseOfStringAndScheduledItem {
    data?: { [key: string]: ScheduledItem; } | undefined;

    constructor(data?: IRetrieveDataResponseOfStringAndScheduledItem) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        this.data![key] = _data["data"][key] ? ScheduledItem.fromJS(_data["data"][key]) : new ScheduledItem();
                }
            }
        }
    }

    static fromJS(data: any): RetrieveDataResponseOfStringAndScheduledItem {
        data = typeof data === 'object' ? data : {};
        let result = new RetrieveDataResponseOfStringAndScheduledItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    data["data"][key] = this.data[key] ? this.data[key].toJSON() : <any>undefined;
            }
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IRetrieveDataResponseOfStringAndScheduledItem extends IBaseResponse {
    data?: { [key: string]: ScheduledItem; } | undefined;
}

export class RetrieveDataResponseOfStringAndDevice extends BaseResponse implements IRetrieveDataResponseOfStringAndDevice {
    data?: { [key: string]: Device; } | undefined;

    constructor(data?: IRetrieveDataResponseOfStringAndDevice) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        this.data![key] = _data["data"][key] ? Device.fromJS(_data["data"][key]) : new Device();
                }
            }
        }
    }

    static fromJS(data: any): RetrieveDataResponseOfStringAndDevice {
        data = typeof data === 'object' ? data : {};
        let result = new RetrieveDataResponseOfStringAndDevice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    data["data"][key] = this.data[key] ? this.data[key].toJSON() : <any>undefined;
            }
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IRetrieveDataResponseOfStringAndDevice extends IBaseResponse {
    data?: { [key: string]: Device; } | undefined;
}

export class Device extends XmlBase implements IDevice {
    dbId!: number;
    deviceId?: IdWrapper | undefined;
    enabled!: boolean;

    constructor(data?: IDevice) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dbId = _data["dbId"];
            this.deviceId = _data["deviceId"] ? IdWrapper.fromJS(_data["deviceId"]) : <any>undefined;
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): Device {
        data = typeof data === 'object' ? data : {};
        let result = new Device();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dbId"] = this.dbId;
        data["deviceId"] = this.deviceId ? this.deviceId.toJSON() : <any>undefined;
        data["enabled"] = this.enabled;
        super.toJSON(data);
        return data; 
    }
}

export interface IDevice extends IXmlBase {
    dbId: number;
    deviceId?: IdWrapper | undefined;
    enabled: boolean;
}

export class RetrieveDataResponseOfStringAndDetectorMap extends BaseResponse implements IRetrieveDataResponseOfStringAndDetectorMap {
    data?: { [key: string]: DetectorMap; } | undefined;

    constructor(data?: IRetrieveDataResponseOfStringAndDetectorMap) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        this.data![key] = _data["data"][key] ? DetectorMap.fromJS(_data["data"][key]) : new DetectorMap();
                }
            }
        }
    }

    static fromJS(data: any): RetrieveDataResponseOfStringAndDetectorMap {
        data = typeof data === 'object' ? data : {};
        let result = new RetrieveDataResponseOfStringAndDetectorMap();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    data["data"][key] = this.data[key] ? this.data[key].toJSON() : <any>undefined;
            }
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IRetrieveDataResponseOfStringAndDetectorMap extends IBaseResponse {
    data?: { [key: string]: DetectorMap; } | undefined;
}

export class DetectorMap extends XmlBase implements IDetectorMap {
    id?: Id | undefined;
    links?: Link[] | undefined;

    constructor(data?: IDetectorMap) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            if (Array.isArray(_data["links"])) {
                this.links = [] as any;
                for (let item of _data["links"])
                    this.links!.push(Link.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DetectorMap {
        data = typeof data === 'object' ? data : {};
        let result = new DetectorMap();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        if (Array.isArray(this.links)) {
            data["links"] = [];
            for (let item of this.links)
                data["links"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IDetectorMap extends IXmlBase {
    id?: Id | undefined;
    links?: Link[] | undefined;
}

export class Link extends XmlBase implements ILink {
    id?: Id | undefined;
    displayName?: string | undefined;
    arterialLink!: boolean;
    lanes?: Lane[] | undefined;
    speedLimit!: number;
    canPublish!: boolean;
    length?: number | undefined;
    numLanes?: number | undefined;
    probeConfigurationParameters?: ProbeConfigurationParameters | undefined;
    lengthSpecified!: boolean;
    numLanesSpecified!: boolean;

    constructor(data?: ILink) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            this.displayName = _data["displayName"];
            this.arterialLink = _data["arterialLink"];
            if (Array.isArray(_data["lanes"])) {
                this.lanes = [] as any;
                for (let item of _data["lanes"])
                    this.lanes!.push(Lane.fromJS(item));
            }
            this.speedLimit = _data["speedLimit"];
            this.canPublish = _data["canPublish"];
            this.length = _data["length"];
            this.numLanes = _data["numLanes"];
            this.probeConfigurationParameters = _data["probeConfigurationParameters"] ? ProbeConfigurationParameters.fromJS(_data["probeConfigurationParameters"]) : <any>undefined;
            this.lengthSpecified = _data["lengthSpecified"];
            this.numLanesSpecified = _data["numLanesSpecified"];
        }
    }

    static fromJS(data: any): Link {
        data = typeof data === 'object' ? data : {};
        let result = new Link();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["displayName"] = this.displayName;
        data["arterialLink"] = this.arterialLink;
        if (Array.isArray(this.lanes)) {
            data["lanes"] = [];
            for (let item of this.lanes)
                data["lanes"].push(item.toJSON());
        }
        data["speedLimit"] = this.speedLimit;
        data["canPublish"] = this.canPublish;
        data["length"] = this.length;
        data["numLanes"] = this.numLanes;
        data["probeConfigurationParameters"] = this.probeConfigurationParameters ? this.probeConfigurationParameters.toJSON() : <any>undefined;
        data["lengthSpecified"] = this.lengthSpecified;
        data["numLanesSpecified"] = this.numLanesSpecified;
        super.toJSON(data);
        return data; 
    }
}

export interface ILink extends IXmlBase {
    id?: Id | undefined;
    displayName?: string | undefined;
    arterialLink: boolean;
    lanes?: Lane[] | undefined;
    speedLimit: number;
    canPublish: boolean;
    length?: number | undefined;
    numLanes?: number | undefined;
    probeConfigurationParameters?: ProbeConfigurationParameters | undefined;
    lengthSpecified: boolean;
    numLanesSpecified: boolean;
}

export class Lane extends XmlBase implements ILane {
    id?: Id | undefined;
    displayName?: string | undefined;
    detectionZone?: DetectionZone | undefined;

    constructor(data?: ILane) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            this.displayName = _data["displayName"];
            this.detectionZone = _data["detectionZone"] ? DetectionZone.fromJS(_data["detectionZone"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Lane {
        data = typeof data === 'object' ? data : {};
        let result = new Lane();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["displayName"] = this.displayName;
        data["detectionZone"] = this.detectionZone ? this.detectionZone.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface ILane extends IXmlBase {
    id?: Id | undefined;
    displayName?: string | undefined;
    detectionZone?: DetectionZone | undefined;
}

/** The class that contains the data for a detection zone */
export class DetectionZone extends XmlBase implements IDetectionZone {
    /** Gets or sets the zone number. */
    zoneNumber!: number;
    /** Zone number(s) used by this lane */
    zoneNumbers?: number[] | undefined;
    /** Detector paired to this one to create a zone for AVI/LPR links. */
    pairedDetector?: PairedDetector | undefined;
    /** Gets or sets the zone description. */
    zoneDescription?: string | undefined;

    constructor(data?: IDetectionZone) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.zoneNumber = _data["zoneNumber"];
            if (Array.isArray(_data["zoneNumbers"])) {
                this.zoneNumbers = [] as any;
                for (let item of _data["zoneNumbers"])
                    this.zoneNumbers!.push(item);
            }
            this.pairedDetector = _data["pairedDetector"] ? PairedDetector.fromJS(_data["pairedDetector"]) : <any>undefined;
            this.zoneDescription = _data["zoneDescription"];
        }
    }

    static fromJS(data: any): DetectionZone {
        data = typeof data === 'object' ? data : {};
        let result = new DetectionZone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zoneNumber"] = this.zoneNumber;
        if (Array.isArray(this.zoneNumbers)) {
            data["zoneNumbers"] = [];
            for (let item of this.zoneNumbers)
                data["zoneNumbers"].push(item);
        }
        data["pairedDetector"] = this.pairedDetector ? this.pairedDetector.toJSON() : <any>undefined;
        data["zoneDescription"] = this.zoneDescription;
        super.toJSON(data);
        return data; 
    }
}

/** The class that contains the data for a detection zone */
export interface IDetectionZone extends IXmlBase {
    /** Gets or sets the zone number. */
    zoneNumber: number;
    /** Zone number(s) used by this lane */
    zoneNumbers?: number[] | undefined;
    /** Detector paired to this one to create a zone for AVI/LPR links. */
    pairedDetector?: PairedDetector | undefined;
    /** Gets or sets the zone description. */
    zoneDescription?: string | undefined;
}

/** Represents a detector pairing for AVI/LPR links */
export class PairedDetector extends XmlBase implements IPairedDetector {
    /** Identifer of the paired detector */
    id?: Id | undefined;
    /** Zone numbers to match on the paired detector */
    zoneNumbers?: number[] | undefined;

    constructor(data?: IPairedDetector) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            if (Array.isArray(_data["zoneNumbers"])) {
                this.zoneNumbers = [] as any;
                for (let item of _data["zoneNumbers"])
                    this.zoneNumbers!.push(item);
            }
        }
    }

    static fromJS(data: any): PairedDetector {
        data = typeof data === 'object' ? data : {};
        let result = new PairedDetector();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        if (Array.isArray(this.zoneNumbers)) {
            data["zoneNumbers"] = [];
            for (let item of this.zoneNumbers)
                data["zoneNumbers"].push(item);
        }
        super.toJSON(data);
        return data; 
    }
}

/** Represents a detector pairing for AVI/LPR links */
export interface IPairedDetector extends IXmlBase {
    /** Identifer of the paired detector */
    id?: Id | undefined;
    /** Zone numbers to match on the paired detector */
    zoneNumbers?: number[] | undefined;
}

/** The configuration parameters for a probe link to assist in data quality and filtering invalid reads. */
export class ProbeConfigurationParameters extends XmlBase implements IProbeConfigurationParameters {
    /** Gets or sets the amount of time before a tag read is no longer used when making matches. */
    tagHorizon?: number | undefined;
    /** Gets or sets the minimum number of matches needed to calculate a speed. */
    sampleSize?: number | undefined;
    /** Gets or sets the maximum speed to use when calculating the average. */
    maxSpeed?: number | undefined;
    /** Gets or sets the speed at which tags are automatically thrown out of matches when calculating speeds. */
    anomalySpeed?: number | undefined;
    /** Gets or sets the maximum value that a speed can change between poll cycles. */
    deltaSpeedThreshold?: number | undefined;
    /** Gets or sets the historical tag match timeout to use when making tag matches. */
    historicalTagMatchTimeout?: number | undefined;
    /** Gets or sets the algorithm to use when calculating the speed of a link. */
    speedCalcAlgorithm?: SpeedCalcAlgorithm | undefined;
    tagHorizonSpecified!: boolean;
    sampleSizeSpecified!: boolean;
    maxSpeedSpecified!: boolean;
    anomalySpeedSpecified!: boolean;
    deltaSpeedThresholdSpecified!: boolean;
    historicalTagMatchTimeoutSpecified!: boolean;
    speedCalcAlgorithmSpecified!: boolean;

    constructor(data?: IProbeConfigurationParameters) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tagHorizon = _data["tagHorizon"];
            this.sampleSize = _data["sampleSize"];
            this.maxSpeed = _data["maxSpeed"];
            this.anomalySpeed = _data["anomalySpeed"];
            this.deltaSpeedThreshold = _data["deltaSpeedThreshold"];
            this.historicalTagMatchTimeout = _data["historicalTagMatchTimeout"];
            this.speedCalcAlgorithm = _data["speedCalcAlgorithm"];
            this.tagHorizonSpecified = _data["tagHorizonSpecified"];
            this.sampleSizeSpecified = _data["sampleSizeSpecified"];
            this.maxSpeedSpecified = _data["maxSpeedSpecified"];
            this.anomalySpeedSpecified = _data["anomalySpeedSpecified"];
            this.deltaSpeedThresholdSpecified = _data["deltaSpeedThresholdSpecified"];
            this.historicalTagMatchTimeoutSpecified = _data["historicalTagMatchTimeoutSpecified"];
            this.speedCalcAlgorithmSpecified = _data["speedCalcAlgorithmSpecified"];
        }
    }

    static fromJS(data: any): ProbeConfigurationParameters {
        data = typeof data === 'object' ? data : {};
        let result = new ProbeConfigurationParameters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagHorizon"] = this.tagHorizon;
        data["sampleSize"] = this.sampleSize;
        data["maxSpeed"] = this.maxSpeed;
        data["anomalySpeed"] = this.anomalySpeed;
        data["deltaSpeedThreshold"] = this.deltaSpeedThreshold;
        data["historicalTagMatchTimeout"] = this.historicalTagMatchTimeout;
        data["speedCalcAlgorithm"] = this.speedCalcAlgorithm;
        data["tagHorizonSpecified"] = this.tagHorizonSpecified;
        data["sampleSizeSpecified"] = this.sampleSizeSpecified;
        data["maxSpeedSpecified"] = this.maxSpeedSpecified;
        data["anomalySpeedSpecified"] = this.anomalySpeedSpecified;
        data["deltaSpeedThresholdSpecified"] = this.deltaSpeedThresholdSpecified;
        data["historicalTagMatchTimeoutSpecified"] = this.historicalTagMatchTimeoutSpecified;
        data["speedCalcAlgorithmSpecified"] = this.speedCalcAlgorithmSpecified;
        super.toJSON(data);
        return data; 
    }
}

/** The configuration parameters for a probe link to assist in data quality and filtering invalid reads. */
export interface IProbeConfigurationParameters extends IXmlBase {
    /** Gets or sets the amount of time before a tag read is no longer used when making matches. */
    tagHorizon?: number | undefined;
    /** Gets or sets the minimum number of matches needed to calculate a speed. */
    sampleSize?: number | undefined;
    /** Gets or sets the maximum speed to use when calculating the average. */
    maxSpeed?: number | undefined;
    /** Gets or sets the speed at which tags are automatically thrown out of matches when calculating speeds. */
    anomalySpeed?: number | undefined;
    /** Gets or sets the maximum value that a speed can change between poll cycles. */
    deltaSpeedThreshold?: number | undefined;
    /** Gets or sets the historical tag match timeout to use when making tag matches. */
    historicalTagMatchTimeout?: number | undefined;
    /** Gets or sets the algorithm to use when calculating the speed of a link. */
    speedCalcAlgorithm?: SpeedCalcAlgorithm | undefined;
    tagHorizonSpecified: boolean;
    sampleSizeSpecified: boolean;
    maxSpeedSpecified: boolean;
    anomalySpeedSpecified: boolean;
    deltaSpeedThresholdSpecified: boolean;
    historicalTagMatchTimeoutSpecified: boolean;
    speedCalcAlgorithmSpecified: boolean;
}

/** The algorithm to use when calculating speeds from tag matches. */
export enum SpeedCalcAlgorithm {
    Average = 0,
    Median = 1,
}

export class RetrieveDataResponseOfStringAndNode extends BaseResponse implements IRetrieveDataResponseOfStringAndNode {
    data?: { [key: string]: Node; } | undefined;

    constructor(data?: IRetrieveDataResponseOfStringAndNode) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        this.data![key] = _data["data"][key] ? Node.fromJS(_data["data"][key]) : new Node();
                }
            }
        }
    }

    static fromJS(data: any): RetrieveDataResponseOfStringAndNode {
        data = typeof data === 'object' ? data : {};
        let result = new RetrieveDataResponseOfStringAndNode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    data["data"][key] = this.data[key] ? this.data[key].toJSON() : <any>undefined;
            }
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IRetrieveDataResponseOfStringAndNode extends IBaseResponse {
    data?: { [key: string]: Node; } | undefined;
}

export class Node extends XmlBase implements INode {
    id?: Id | undefined;
    latitude!: number;
    longitude!: number;

    constructor(data?: INode) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): Node {
        data = typeof data === 'object' ? data : {};
        let result = new Node();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        super.toJSON(data);
        return data; 
    }
}

export interface INode extends IXmlBase {
    id?: Id | undefined;
    latitude: number;
    longitude: number;
}

export class RetrieveDataResponseOfStringAndLinkGeometry extends BaseResponse implements IRetrieveDataResponseOfStringAndLinkGeometry {
    data?: { [key: string]: LinkGeometry; } | undefined;

    constructor(data?: IRetrieveDataResponseOfStringAndLinkGeometry) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        this.data![key] = _data["data"][key] ? LinkGeometry.fromJS(_data["data"][key]) : new LinkGeometry();
                }
            }
        }
    }

    static fromJS(data: any): RetrieveDataResponseOfStringAndLinkGeometry {
        data = typeof data === 'object' ? data : {};
        let result = new RetrieveDataResponseOfStringAndLinkGeometry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    data["data"][key] = this.data[key] ? this.data[key].toJSON() : <any>undefined;
            }
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IRetrieveDataResponseOfStringAndLinkGeometry extends IBaseResponse {
    data?: { [key: string]: LinkGeometry; } | undefined;
}

export class LinkGeometry extends XmlBase implements ILinkGeometry {
    id?: Id | undefined;
    displayName?: string | undefined;
    startNode?: IdWrapper | undefined;
    endNode?: IdWrapper | undefined;
    roadway?: IdWrapper | undefined;
    direction?: string | undefined;
    numberOfLanes!: number;
    midpoints?: Midpoint[] | undefined;

    constructor(data?: ILinkGeometry) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            this.displayName = _data["displayName"];
            this.startNode = _data["startNode"] ? IdWrapper.fromJS(_data["startNode"]) : <any>undefined;
            this.endNode = _data["endNode"] ? IdWrapper.fromJS(_data["endNode"]) : <any>undefined;
            this.roadway = _data["roadway"] ? IdWrapper.fromJS(_data["roadway"]) : <any>undefined;
            this.direction = _data["direction"];
            this.numberOfLanes = _data["numberOfLanes"];
            if (Array.isArray(_data["midpoints"])) {
                this.midpoints = [] as any;
                for (let item of _data["midpoints"])
                    this.midpoints!.push(Midpoint.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LinkGeometry {
        data = typeof data === 'object' ? data : {};
        let result = new LinkGeometry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["displayName"] = this.displayName;
        data["startNode"] = this.startNode ? this.startNode.toJSON() : <any>undefined;
        data["endNode"] = this.endNode ? this.endNode.toJSON() : <any>undefined;
        data["roadway"] = this.roadway ? this.roadway.toJSON() : <any>undefined;
        data["direction"] = this.direction;
        data["numberOfLanes"] = this.numberOfLanes;
        if (Array.isArray(this.midpoints)) {
            data["midpoints"] = [];
            for (let item of this.midpoints)
                data["midpoints"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

export interface ILinkGeometry extends IXmlBase {
    id?: Id | undefined;
    displayName?: string | undefined;
    startNode?: IdWrapper | undefined;
    endNode?: IdWrapper | undefined;
    roadway?: IdWrapper | undefined;
    direction?: string | undefined;
    numberOfLanes: number;
    midpoints?: Midpoint[] | undefined;
}

export class Midpoint extends XmlBase implements IMidpoint {
    latitude!: number;
    longitude!: number;

    constructor(data?: IMidpoint) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): Midpoint {
        data = typeof data === 'object' ? data : {};
        let result = new Midpoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        super.toJSON(data);
        return data; 
    }
}

export interface IMidpoint extends IXmlBase {
    latitude: number;
    longitude: number;
}

export class RetrieveDataResponseOfStringAndIdAndStatusOfLinkPollStatus extends BaseResponse implements IRetrieveDataResponseOfStringAndIdAndStatusOfLinkPollStatus {
    data?: { [key: string]: IdAndStatusOfLinkPollStatus; } | undefined;

    constructor(data?: IRetrieveDataResponseOfStringAndIdAndStatusOfLinkPollStatus) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        this.data![key] = _data["data"][key] ? IdAndStatusOfLinkPollStatus.fromJS(_data["data"][key]) : new IdAndStatusOfLinkPollStatus();
                }
            }
        }
    }

    static fromJS(data: any): RetrieveDataResponseOfStringAndIdAndStatusOfLinkPollStatus {
        data = typeof data === 'object' ? data : {};
        let result = new RetrieveDataResponseOfStringAndIdAndStatusOfLinkPollStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    data["data"][key] = this.data[key] ? this.data[key].toJSON() : <any>undefined;
            }
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IRetrieveDataResponseOfStringAndIdAndStatusOfLinkPollStatus extends IBaseResponse {
    data?: { [key: string]: IdAndStatusOfLinkPollStatus; } | undefined;
}

export class IdAndStatusOfLinkPollStatus extends IdAndStatusBase implements IIdAndStatusOfLinkPollStatus {
    status?: LinkPollStatus | undefined;

    constructor(data?: IIdAndStatusOfLinkPollStatus) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"] ? LinkPollStatus.fromJS(_data["status"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IdAndStatusOfLinkPollStatus {
        data = typeof data === 'object' ? data : {};
        let result = new IdAndStatusOfLinkPollStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IIdAndStatusOfLinkPollStatus extends IIdAndStatusBase {
    status?: LinkPollStatus | undefined;
}

export class LinkPollStatus extends XmlStatusBase implements ILinkPollStatus {
    linkData?: LinkData | undefined;

    constructor(data?: ILinkPollStatus) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.linkData = _data["linkData"] ? LinkData.fromJS(_data["linkData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LinkPollStatus {
        data = typeof data === 'object' ? data : {};
        let result = new LinkPollStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linkData"] = this.linkData ? this.linkData.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface ILinkPollStatus extends IXmlStatusBase {
    linkData?: LinkData | undefined;
}

export class LinkData extends XmlBase implements ILinkData {
    timestamp?: Date | undefined;
    latency?: number | undefined;
    dynamicLinking?: boolean | undefined;
    lanePollData?: LanePollData[] | undefined;
    linkAverageData?: LinkAverageData | undefined;
    restrictedUse?: boolean | undefined;
    timestampSpecified!: boolean;
    latencySpecified!: boolean;
    dynamicLinkingSpecified!: boolean;
    restrictedUseSpecified!: boolean;

    constructor(data?: ILinkData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.latency = _data["latency"];
            this.dynamicLinking = _data["dynamicLinking"];
            if (Array.isArray(_data["lanePollData"])) {
                this.lanePollData = [] as any;
                for (let item of _data["lanePollData"])
                    this.lanePollData!.push(LanePollData.fromJS(item));
            }
            this.linkAverageData = _data["linkAverageData"] ? LinkAverageData.fromJS(_data["linkAverageData"]) : <any>undefined;
            this.restrictedUse = _data["restrictedUse"];
            this.timestampSpecified = _data["timestampSpecified"];
            this.latencySpecified = _data["latencySpecified"];
            this.dynamicLinkingSpecified = _data["dynamicLinkingSpecified"];
            this.restrictedUseSpecified = _data["restrictedUseSpecified"];
        }
    }

    static fromJS(data: any): LinkData {
        data = typeof data === 'object' ? data : {};
        let result = new LinkData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["latency"] = this.latency;
        data["dynamicLinking"] = this.dynamicLinking;
        if (Array.isArray(this.lanePollData)) {
            data["lanePollData"] = [];
            for (let item of this.lanePollData)
                data["lanePollData"].push(item.toJSON());
        }
        data["linkAverageData"] = this.linkAverageData ? this.linkAverageData.toJSON() : <any>undefined;
        data["restrictedUse"] = this.restrictedUse;
        data["timestampSpecified"] = this.timestampSpecified;
        data["latencySpecified"] = this.latencySpecified;
        data["dynamicLinkingSpecified"] = this.dynamicLinkingSpecified;
        data["restrictedUseSpecified"] = this.restrictedUseSpecified;
        super.toJSON(data);
        return data; 
    }
}

export interface ILinkData extends IXmlBase {
    timestamp?: Date | undefined;
    latency?: number | undefined;
    dynamicLinking?: boolean | undefined;
    lanePollData?: LanePollData[] | undefined;
    linkAverageData?: LinkAverageData | undefined;
    restrictedUse?: boolean | undefined;
    timestampSpecified: boolean;
    latencySpecified: boolean;
    dynamicLinkingSpecified: boolean;
    restrictedUseSpecified: boolean;
}

export class LanePollData extends XmlBase implements ILanePollData {
    id?: Id | undefined;
    rawData?: RawLanePollData | undefined;
    smoothedData?: SmoothedLaneData | undefined;
    historicalData?: DataPeriod[] | undefined;
    /** Gets or sets the historical median data for this lane. */
    historicalMedianData?: HistoricalMedianLaneData | undefined;

    constructor(data?: ILanePollData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            this.rawData = _data["rawData"] ? RawLanePollData.fromJS(_data["rawData"]) : <any>undefined;
            this.smoothedData = _data["smoothedData"] ? SmoothedLaneData.fromJS(_data["smoothedData"]) : <any>undefined;
            if (Array.isArray(_data["historicalData"])) {
                this.historicalData = [] as any;
                for (let item of _data["historicalData"])
                    this.historicalData!.push(DataPeriod.fromJS(item));
            }
            this.historicalMedianData = _data["historicalMedianData"] ? HistoricalMedianLaneData.fromJS(_data["historicalMedianData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LanePollData {
        data = typeof data === 'object' ? data : {};
        let result = new LanePollData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["rawData"] = this.rawData ? this.rawData.toJSON() : <any>undefined;
        data["smoothedData"] = this.smoothedData ? this.smoothedData.toJSON() : <any>undefined;
        if (Array.isArray(this.historicalData)) {
            data["historicalData"] = [];
            for (let item of this.historicalData)
                data["historicalData"].push(item.toJSON());
        }
        data["historicalMedianData"] = this.historicalMedianData ? this.historicalMedianData.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface ILanePollData extends IXmlBase {
    id?: Id | undefined;
    rawData?: RawLanePollData | undefined;
    smoothedData?: SmoothedLaneData | undefined;
    historicalData?: DataPeriod[] | undefined;
    /** Gets or sets the historical median data for this lane. */
    historicalMedianData?: HistoricalMedianLaneData | undefined;
}

export class RawLaneData extends XmlBase implements IRawLaneData {
    speed?: number | undefined;
    occupancy?: number | undefined;
    volume?: number | undefined;
    travelTime?: number | undefined;
    delay?: number | undefined;
    speedSpecified!: boolean;
    occupancySpecified!: boolean;
    volumeSpecified!: boolean;
    travelTimeSpecified!: boolean;
    delaySpecified!: boolean;

    constructor(data?: IRawLaneData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.speed = _data["speed"];
            this.occupancy = _data["occupancy"];
            this.volume = _data["volume"];
            this.travelTime = _data["travelTime"];
            this.delay = _data["delay"];
            this.speedSpecified = _data["speedSpecified"];
            this.occupancySpecified = _data["occupancySpecified"];
            this.volumeSpecified = _data["volumeSpecified"];
            this.travelTimeSpecified = _data["travelTimeSpecified"];
            this.delaySpecified = _data["delaySpecified"];
        }
    }

    static fromJS(data: any): RawLaneData {
        data = typeof data === 'object' ? data : {};
        let result = new RawLaneData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["speed"] = this.speed;
        data["occupancy"] = this.occupancy;
        data["volume"] = this.volume;
        data["travelTime"] = this.travelTime;
        data["delay"] = this.delay;
        data["speedSpecified"] = this.speedSpecified;
        data["occupancySpecified"] = this.occupancySpecified;
        data["volumeSpecified"] = this.volumeSpecified;
        data["travelTimeSpecified"] = this.travelTimeSpecified;
        data["delaySpecified"] = this.delaySpecified;
        super.toJSON(data);
        return data; 
    }
}

export interface IRawLaneData extends IXmlBase {
    speed?: number | undefined;
    occupancy?: number | undefined;
    volume?: number | undefined;
    travelTime?: number | undefined;
    delay?: number | undefined;
    speedSpecified: boolean;
    occupancySpecified: boolean;
    volumeSpecified: boolean;
    travelTimeSpecified: boolean;
    delaySpecified: boolean;
}

export class RawLanePollData extends RawLaneData implements IRawLanePollData {
    binClass?: Class | undefined;
    suspectData?: RawLaneSuspectData | undefined;
    wrongWayDriverDetected?: boolean | undefined;
    wrongWayDriverDetectedSpecified!: boolean;

    constructor(data?: IRawLanePollData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.binClass = _data["binClass"] ? Class.fromJS(_data["binClass"]) : <any>undefined;
            this.suspectData = _data["suspectData"] ? RawLaneSuspectData.fromJS(_data["suspectData"]) : <any>undefined;
            this.wrongWayDriverDetected = _data["wrongWayDriverDetected"];
            this.wrongWayDriverDetectedSpecified = _data["wrongWayDriverDetectedSpecified"];
        }
    }

    static fromJS(data: any): RawLanePollData {
        data = typeof data === 'object' ? data : {};
        let result = new RawLanePollData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["binClass"] = this.binClass ? this.binClass.toJSON() : <any>undefined;
        data["suspectData"] = this.suspectData ? this.suspectData.toJSON() : <any>undefined;
        data["wrongWayDriverDetected"] = this.wrongWayDriverDetected;
        data["wrongWayDriverDetectedSpecified"] = this.wrongWayDriverDetectedSpecified;
        super.toJSON(data);
        return data; 
    }
}

export interface IRawLanePollData extends IRawLaneData {
    binClass?: Class | undefined;
    suspectData?: RawLaneSuspectData | undefined;
    wrongWayDriverDetected?: boolean | undefined;
    wrongWayDriverDetectedSpecified: boolean;
}

export class Class extends XmlBase implements IClass {
    bin1!: number;
    bin2!: number;
    bin3!: number;
    bin4!: number;
    bin5!: number;
    bin6!: number;
    bin7!: number;
    bin8!: number;

    constructor(data?: IClass) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.bin1 = _data["bin1"];
            this.bin2 = _data["bin2"];
            this.bin3 = _data["bin3"];
            this.bin4 = _data["bin4"];
            this.bin5 = _data["bin5"];
            this.bin6 = _data["bin6"];
            this.bin7 = _data["bin7"];
            this.bin8 = _data["bin8"];
        }
    }

    static fromJS(data: any): Class {
        data = typeof data === 'object' ? data : {};
        let result = new Class();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bin1"] = this.bin1;
        data["bin2"] = this.bin2;
        data["bin3"] = this.bin3;
        data["bin4"] = this.bin4;
        data["bin5"] = this.bin5;
        data["bin6"] = this.bin6;
        data["bin7"] = this.bin7;
        data["bin8"] = this.bin8;
        super.toJSON(data);
        return data; 
    }
}

export interface IClass extends IXmlBase {
    bin1: number;
    bin2: number;
    bin3: number;
    bin4: number;
    bin5: number;
    bin6: number;
    bin7: number;
    bin8: number;
}

export class RawLaneSuspectData extends XmlBase implements IRawLaneSuspectData {
    speedSuspect?: boolean | undefined;
    occupancySuspect?: boolean | undefined;
    volumeSuspect?: boolean | undefined;
    speedSuspectSpecified!: boolean;
    occupancySuspectSpecified!: boolean;
    volumeSuspectSpecified!: boolean;

    constructor(data?: IRawLaneSuspectData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.speedSuspect = _data["speedSuspect"];
            this.occupancySuspect = _data["occupancySuspect"];
            this.volumeSuspect = _data["volumeSuspect"];
            this.speedSuspectSpecified = _data["speedSuspectSpecified"];
            this.occupancySuspectSpecified = _data["occupancySuspectSpecified"];
            this.volumeSuspectSpecified = _data["volumeSuspectSpecified"];
        }
    }

    static fromJS(data: any): RawLaneSuspectData {
        data = typeof data === 'object' ? data : {};
        let result = new RawLaneSuspectData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["speedSuspect"] = this.speedSuspect;
        data["occupancySuspect"] = this.occupancySuspect;
        data["volumeSuspect"] = this.volumeSuspect;
        data["speedSuspectSpecified"] = this.speedSuspectSpecified;
        data["occupancySuspectSpecified"] = this.occupancySuspectSpecified;
        data["volumeSuspectSpecified"] = this.volumeSuspectSpecified;
        super.toJSON(data);
        return data; 
    }
}

export interface IRawLaneSuspectData extends IXmlBase {
    speedSuspect?: boolean | undefined;
    occupancySuspect?: boolean | undefined;
    volumeSuspect?: boolean | undefined;
    speedSuspectSpecified: boolean;
    occupancySuspectSpecified: boolean;
    volumeSuspectSpecified: boolean;
}

export class SmoothedLaneData extends XmlBase implements ISmoothedLaneData {
    speed?: number | undefined;
    occupancy?: number | undefined;
    travelTime?: number | undefined;
    delay?: number | undefined;
    speedSpecified!: boolean;
    occupancySpecified!: boolean;
    travelTimeSpecified!: boolean;
    delaySpecified!: boolean;

    constructor(data?: ISmoothedLaneData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.speed = _data["speed"];
            this.occupancy = _data["occupancy"];
            this.travelTime = _data["travelTime"];
            this.delay = _data["delay"];
            this.speedSpecified = _data["speedSpecified"];
            this.occupancySpecified = _data["occupancySpecified"];
            this.travelTimeSpecified = _data["travelTimeSpecified"];
            this.delaySpecified = _data["delaySpecified"];
        }
    }

    static fromJS(data: any): SmoothedLaneData {
        data = typeof data === 'object' ? data : {};
        let result = new SmoothedLaneData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["speed"] = this.speed;
        data["occupancy"] = this.occupancy;
        data["travelTime"] = this.travelTime;
        data["delay"] = this.delay;
        data["speedSpecified"] = this.speedSpecified;
        data["occupancySpecified"] = this.occupancySpecified;
        data["travelTimeSpecified"] = this.travelTimeSpecified;
        data["delaySpecified"] = this.delaySpecified;
        super.toJSON(data);
        return data; 
    }
}

export interface ISmoothedLaneData extends IXmlBase {
    speed?: number | undefined;
    occupancy?: number | undefined;
    travelTime?: number | undefined;
    delay?: number | undefined;
    speedSpecified: boolean;
    occupancySpecified: boolean;
    travelTimeSpecified: boolean;
    delaySpecified: boolean;
}

export class DataPeriod extends XmlBase implements IDataPeriod {
    partial!: boolean;
    startTime!: Date;
    endTime!: Date;
    volume!: number;

    constructor(data?: IDataPeriod) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.partial = _data["partial"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.volume = _data["volume"];
        }
    }

    static fromJS(data: any): DataPeriod {
        data = typeof data === 'object' ? data : {};
        let result = new DataPeriod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partial"] = this.partial;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["volume"] = this.volume;
        super.toJSON(data);
        return data; 
    }
}

export interface IDataPeriod extends IXmlBase {
    partial: boolean;
    startTime: Date;
    endTime: Date;
    volume: number;
}

/** Class that holds historical median data for a lane in a TSS link. */
export class HistoricalMedianLaneData extends XmlBase implements IHistoricalMedianLaneData {
    /** Gets or sets the hour of day (0-23) that this historical data corresponds to. */
    hourOfDay?: number | undefined;
    /** Gets or sets the speed of the lane during this historical time period. */
    speed?: number | undefined;
    /** Gets or sets the occupancy of the lane during this historical time period. */
    occupancy?: number | undefined;
    /** Gets or sets the travel time of the lane during this historical time period. */
    travelTime?: number | undefined;
    /** Gets or sets the delay of the lane during this historical time period. */
    delay?: number | undefined;
    hourOfDaySpecified!: boolean;
    speedSpecified!: boolean;
    occupancySpecified!: boolean;
    travelTimeSpecified!: boolean;
    delaySpecified!: boolean;

    constructor(data?: IHistoricalMedianLaneData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.hourOfDay = _data["hourOfDay"];
            this.speed = _data["speed"];
            this.occupancy = _data["occupancy"];
            this.travelTime = _data["travelTime"];
            this.delay = _data["delay"];
            this.hourOfDaySpecified = _data["hourOfDaySpecified"];
            this.speedSpecified = _data["speedSpecified"];
            this.occupancySpecified = _data["occupancySpecified"];
            this.travelTimeSpecified = _data["travelTimeSpecified"];
            this.delaySpecified = _data["delaySpecified"];
        }
    }

    static fromJS(data: any): HistoricalMedianLaneData {
        data = typeof data === 'object' ? data : {};
        let result = new HistoricalMedianLaneData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hourOfDay"] = this.hourOfDay;
        data["speed"] = this.speed;
        data["occupancy"] = this.occupancy;
        data["travelTime"] = this.travelTime;
        data["delay"] = this.delay;
        data["hourOfDaySpecified"] = this.hourOfDaySpecified;
        data["speedSpecified"] = this.speedSpecified;
        data["occupancySpecified"] = this.occupancySpecified;
        data["travelTimeSpecified"] = this.travelTimeSpecified;
        data["delaySpecified"] = this.delaySpecified;
        super.toJSON(data);
        return data; 
    }
}

/** Class that holds historical median data for a lane in a TSS link. */
export interface IHistoricalMedianLaneData extends IXmlBase {
    /** Gets or sets the hour of day (0-23) that this historical data corresponds to. */
    hourOfDay?: number | undefined;
    /** Gets or sets the speed of the lane during this historical time period. */
    speed?: number | undefined;
    /** Gets or sets the occupancy of the lane during this historical time period. */
    occupancy?: number | undefined;
    /** Gets or sets the travel time of the lane during this historical time period. */
    travelTime?: number | undefined;
    /** Gets or sets the delay of the lane during this historical time period. */
    delay?: number | undefined;
    hourOfDaySpecified: boolean;
    speedSpecified: boolean;
    occupancySpecified: boolean;
    travelTimeSpecified: boolean;
    delaySpecified: boolean;
}

export class LinkAverageData extends XmlBase implements ILinkAverageData {
    rawData?: RawLaneData | undefined;
    smoothedData?: SmoothedLaneData | undefined;

    constructor(data?: ILinkAverageData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.rawData = _data["rawData"] ? RawLaneData.fromJS(_data["rawData"]) : <any>undefined;
            this.smoothedData = _data["smoothedData"] ? SmoothedLaneData.fromJS(_data["smoothedData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LinkAverageData {
        data = typeof data === 'object' ? data : {};
        let result = new LinkAverageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rawData"] = this.rawData ? this.rawData.toJSON() : <any>undefined;
        data["smoothedData"] = this.smoothedData ? this.smoothedData.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface ILinkAverageData extends IXmlBase {
    rawData?: RawLaneData | undefined;
    smoothedData?: SmoothedLaneData | undefined;
}

export class RetrieveDataResponseOfStringAndDetectorConfig extends BaseResponse implements IRetrieveDataResponseOfStringAndDetectorConfig {
    data?: { [key: string]: DetectorConfig; } | undefined;

    constructor(data?: IRetrieveDataResponseOfStringAndDetectorConfig) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        this.data![key] = _data["data"][key] ? DetectorConfig.fromJS(_data["data"][key]) : new DetectorConfig();
                }
            }
        }
    }

    static fromJS(data: any): RetrieveDataResponseOfStringAndDetectorConfig {
        data = typeof data === 'object' ? data : {};
        let result = new RetrieveDataResponseOfStringAndDetectorConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    data["data"][key] = this.data[key] ? this.data[key].toJSON() : <any>undefined;
            }
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IRetrieveDataResponseOfStringAndDetectorConfig extends IBaseResponse {
    data?: { [key: string]: DetectorConfig; } | undefined;
}

/** Class that contains the configuration items for a detector. */
export class DetectorConfig extends XmlBase implements IDetectorConfig {
    /** Gets or sets the id. */
    id?: Id | undefined;
    /** Gets or sets the displayName. */
    displayName?: string | undefined;
    /** Gets or sets the type. */
    type!: DetectorTypeEnum;
    /** Gets or sets the address. */
    address?: Address | undefined;
    /** Gets or sets the equipment location. */
    equipmentLocation?: EquipmentLocation | undefined;
    /** Gets or sets the poll cycle. */
    pollCycle!: number;
    /** Gets or sets the protocol. */
    protocol!: DetectorProtocolName;
    /** Gets or sets the length of time to wait from the initial tag read to collect duplicates. */
    duplicateTagTimeout?: number | undefined;
    /** Gets or sets the algorithm to use when selecting a tag from a group of duplicate reads. */
    tagSelectionAlgorithm?: TagSelectionAlgorithm | undefined;
    /** Gets or sets the detector status. */
    detectorStatus?: TssEquipmentStatus | undefined;
    /** Gets or sets the detector status. */
    detectorStatusInt!: number;
    /** Gets or sets the status reported for the detector */
    status?: DetectorStatusListStatus | undefined;
    /** Gets or sets the name of the driver. */
    driverId?: Id | undefined;
    duplicateTagTimeoutSpecified!: boolean;
    tagSelectionAlgorithmSpecified!: boolean;

    constructor(data?: IDetectorConfig) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            this.displayName = _data["displayName"];
            this.type = _data["type"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.equipmentLocation = _data["equipmentLocation"] ? EquipmentLocation.fromJS(_data["equipmentLocation"]) : <any>undefined;
            this.pollCycle = _data["pollCycle"];
            this.protocol = _data["protocol"];
            this.duplicateTagTimeout = _data["duplicateTagTimeout"];
            this.tagSelectionAlgorithm = _data["tagSelectionAlgorithm"];
            this.detectorStatus = _data["detectorStatus"] ? TssEquipmentStatus.fromJS(_data["detectorStatus"]) : <any>undefined;
            this.detectorStatusInt = _data["detectorStatusInt"];
            this.status = _data["status"] ? DetectorStatusListStatus.fromJS(_data["status"]) : <any>undefined;
            this.driverId = _data["driverId"] ? Id.fromJS(_data["driverId"]) : <any>undefined;
            this.duplicateTagTimeoutSpecified = _data["duplicateTagTimeoutSpecified"];
            this.tagSelectionAlgorithmSpecified = _data["tagSelectionAlgorithmSpecified"];
        }
    }

    static fromJS(data: any): DetectorConfig {
        data = typeof data === 'object' ? data : {};
        let result = new DetectorConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["displayName"] = this.displayName;
        data["type"] = this.type;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["equipmentLocation"] = this.equipmentLocation ? this.equipmentLocation.toJSON() : <any>undefined;
        data["pollCycle"] = this.pollCycle;
        data["protocol"] = this.protocol;
        data["duplicateTagTimeout"] = this.duplicateTagTimeout;
        data["tagSelectionAlgorithm"] = this.tagSelectionAlgorithm;
        data["detectorStatus"] = this.detectorStatus ? this.detectorStatus.toJSON() : <any>undefined;
        data["detectorStatusInt"] = this.detectorStatusInt;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["driverId"] = this.driverId ? this.driverId.toJSON() : <any>undefined;
        data["duplicateTagTimeoutSpecified"] = this.duplicateTagTimeoutSpecified;
        data["tagSelectionAlgorithmSpecified"] = this.tagSelectionAlgorithmSpecified;
        super.toJSON(data);
        return data; 
    }
}

/** Class that contains the configuration items for a detector. */
export interface IDetectorConfig extends IXmlBase {
    /** Gets or sets the id. */
    id?: Id | undefined;
    /** Gets or sets the displayName. */
    displayName?: string | undefined;
    /** Gets or sets the type. */
    type: DetectorTypeEnum;
    /** Gets or sets the address. */
    address?: Address | undefined;
    /** Gets or sets the equipment location. */
    equipmentLocation?: EquipmentLocation | undefined;
    /** Gets or sets the poll cycle. */
    pollCycle: number;
    /** Gets or sets the protocol. */
    protocol: DetectorProtocolName;
    /** Gets or sets the length of time to wait from the initial tag read to collect duplicates. */
    duplicateTagTimeout?: number | undefined;
    /** Gets or sets the algorithm to use when selecting a tag from a group of duplicate reads. */
    tagSelectionAlgorithm?: TagSelectionAlgorithm | undefined;
    /** Gets or sets the detector status. */
    detectorStatus?: TssEquipmentStatus | undefined;
    /** Gets or sets the detector status. */
    detectorStatusInt: number;
    /** Gets or sets the status reported for the detector */
    status?: DetectorStatusListStatus | undefined;
    /** Gets or sets the name of the driver. */
    driverId?: Id | undefined;
    duplicateTagTimeoutSpecified: boolean;
    tagSelectionAlgorithmSpecified: boolean;
}

/** Different types of detectors. */
export enum DetectorTypeEnum {
    Radar = 0,
    Loop = 1,
    Avi = 2,
    Lpr = 3,
    Obe = 4,
}

export class Address extends XmlBase implements IAddress {
    addressBase?: AddressBase | undefined;
    addressChoice!: AddressChoice;
    directAddress?: DirectAddressClass | undefined;
    portServerAddress?: PortServerAddressClass | undefined;
    urlAddress?: UrlClass | undefined;
    /** Gets or sets the community name. */
    communityName?: string | undefined;

    constructor(data?: IAddress) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.addressBase = _data["addressBase"] ? AddressBase.fromJS(_data["addressBase"]) : <any>undefined;
            this.addressChoice = _data["addressChoice"];
            this.directAddress = _data["directAddress"] ? DirectAddressClass.fromJS(_data["directAddress"]) : <any>undefined;
            this.portServerAddress = _data["portServerAddress"] ? PortServerAddressClass.fromJS(_data["portServerAddress"]) : <any>undefined;
            this.urlAddress = _data["urlAddress"] ? UrlClass.fromJS(_data["urlAddress"]) : <any>undefined;
            this.communityName = _data["communityName"];
        }
    }

    static fromJS(data: any): Address {
        data = typeof data === 'object' ? data : {};
        let result = new Address();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressBase"] = this.addressBase ? this.addressBase.toJSON() : <any>undefined;
        data["addressChoice"] = this.addressChoice;
        data["directAddress"] = this.directAddress ? this.directAddress.toJSON() : <any>undefined;
        data["portServerAddress"] = this.portServerAddress ? this.portServerAddress.toJSON() : <any>undefined;
        data["urlAddress"] = this.urlAddress ? this.urlAddress.toJSON() : <any>undefined;
        data["communityName"] = this.communityName;
        super.toJSON(data);
        return data; 
    }
}

export interface IAddress extends IXmlBase {
    addressBase?: AddressBase | undefined;
    addressChoice: AddressChoice;
    directAddress?: DirectAddressClass | undefined;
    portServerAddress?: PortServerAddressClass | undefined;
    urlAddress?: UrlClass | undefined;
    /** Gets or sets the community name. */
    communityName?: string | undefined;
}

export enum AddressChoice {
    DirectAddress = 0,
    PortServerAddress = 1,
    UrlAddress = 2,
}

/** Defines allowed detector protocol names. */
export enum DetectorProtocolName {
    EIS = 0,
    Wavetronix = 1,
    WavetronixHD = 2,
    BiTrans = 3,
    Canoga = 4,
    TranscoreAllegro = 5,
    TranscoreAllegroTcp = 6,
    SiritFlex = 7,
    SercoPips = 8,
    InexZamirZap = 9,
    CvProtocol = 10,
    IssG4 = 11,
    TtiAwam = 12,
    SiritIdentityFlex = 13,
    BlueMacDirect = 14,
    BlueMacMiddleware = 15,
    GovComm = 16,
    IpSens = 17,
    Snaps = 18,
    NtcipV2Tcp = 19,
    NtcipV2Udp = 20,
    StopwatchPlus = 21,
    Bluetoad = 22,
    Flir = 23,
    CivicSmart = 24,
}

/** The algorithm to use when selecting tags to make matches. */
export enum TagSelectionAlgorithm {
    FirstTagRead = 0,
    TemporalMidpoint = 1,
    SignalStrength = 2,
}

/** Equipment status with override for TSS */
export class TssEquipmentStatus extends EquipmentStatus implements ITssEquipmentStatus {

    constructor(data?: ITssEquipmentStatus) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): TssEquipmentStatus {
        data = typeof data === 'object' ? data : {};
        let result = new TssEquipmentStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

/** Equipment status with override for TSS */
export interface ITssEquipmentStatus extends IEquipmentStatus {
}

export class DetectorStatusListStatus extends XmlStatusBase implements IDetectorStatusListStatus {
    detectorStatus!: number;
    degraded!: boolean;
    /** Gets or sets the op status. */
    opStatus!: OpStatus;

    constructor(data?: IDetectorStatusListStatus) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.detectorStatus = _data["detectorStatus"];
            this.degraded = _data["degraded"];
            this.opStatus = _data["opStatus"];
        }
    }

    static fromJS(data: any): DetectorStatusListStatus {
        data = typeof data === 'object' ? data : {};
        let result = new DetectorStatusListStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["detectorStatus"] = this.detectorStatus;
        data["degraded"] = this.degraded;
        data["opStatus"] = this.opStatus;
        super.toJSON(data);
        return data; 
    }
}

export interface IDetectorStatusListStatus extends IXmlStatusBase {
    detectorStatus: number;
    degraded: boolean;
    /** Gets or sets the op status. */
    opStatus: OpStatus;
}

export class SaveUserPreferencesResponse extends BaseResponse implements ISaveUserPreferencesResponse {

    constructor(data?: ISaveUserPreferencesResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SaveUserPreferencesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveUserPreferencesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface ISaveUserPreferencesResponse extends IBaseResponse {
}

export class SaveUserPreferenceRequest extends Request implements ISaveUserPreferenceRequest {
    dialogName?: string | undefined;
    savedDialogPreference?: string | undefined;

    constructor(data?: ISaveUserPreferenceRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dialogName = _data["dialogName"];
            this.savedDialogPreference = _data["savedDialogPreference"];
        }
    }

    static fromJS(data: any): SaveUserPreferenceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveUserPreferenceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dialogName"] = this.dialogName;
        data["savedDialogPreference"] = this.savedDialogPreference;
        super.toJSON(data);
        return data; 
    }
}

export interface ISaveUserPreferenceRequest extends IRequest {
    dialogName?: string | undefined;
    savedDialogPreference?: string | undefined;
}

export class RetrieveDataResponseOfString extends BaseResponse implements IRetrieveDataResponseOfString {
    data?: string[] | undefined;

    constructor(data?: IRetrieveDataResponseOfString) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(item);
            }
        }
    }

    static fromJS(data: any): RetrieveDataResponseOfString {
        data = typeof data === 'object' ? data : {};
        let result = new RetrieveDataResponseOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IRetrieveDataResponseOfString extends IBaseResponse {
    data?: string[] | undefined;
}

export class GetUserPreferenceRequest extends Request implements IGetUserPreferenceRequest {
    dialogName?: string | undefined;

    constructor(data?: IGetUserPreferenceRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dialogName = _data["dialogName"];
        }
    }

    static fromJS(data: any): GetUserPreferenceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserPreferenceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dialogName"] = this.dialogName;
        super.toJSON(data);
        return data; 
    }
}

export interface IGetUserPreferenceRequest extends IRequest {
    dialogName?: string | undefined;
}

export class RetrievePermissionsResponse extends BaseResponse implements IRetrievePermissionsResponse {
    data?: PermissionsData | undefined;

    constructor(data?: IRetrievePermissionsResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? PermissionsData.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RetrievePermissionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RetrievePermissionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IRetrievePermissionsResponse extends IBaseResponse {
    data?: PermissionsData | undefined;
}

export class PermissionsData extends BaseResponse implements IPermissionsData {
    allGroups?: Group[] | undefined;
    privileges?: { [key: string]: PrivilegeBase; } | undefined;
    userData?: UserData | undefined;

    constructor(data?: IPermissionsData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["allGroups"])) {
                this.allGroups = [] as any;
                for (let item of _data["allGroups"])
                    this.allGroups!.push(Group.fromJS(item));
            }
            if (_data["privileges"]) {
                this.privileges = {} as any;
                for (let key in _data["privileges"]) {
                    if (_data["privileges"].hasOwnProperty(key))
                        this.privileges![key] = _data["privileges"][key] ? PrivilegeBase.fromJS(_data["privileges"][key]) : <any>undefined;
                }
            }
            this.userData = _data["userData"] ? UserData.fromJS(_data["userData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PermissionsData {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionsData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.allGroups)) {
            data["allGroups"] = [];
            for (let item of this.allGroups)
                data["allGroups"].push(item.toJSON());
        }
        if (this.privileges) {
            data["privileges"] = {};
            for (let key in this.privileges) {
                if (this.privileges.hasOwnProperty(key))
                    data["privileges"][key] = this.privileges[key] ? this.privileges[key].toJSON() : <any>undefined;
            }
        }
        data["userData"] = this.userData ? this.userData.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IPermissionsData extends IBaseResponse {
    allGroups?: Group[] | undefined;
    privileges?: { [key: string]: PrivilegeBase; } | undefined;
    userData?: UserData | undefined;
}

/** Class used to parse/create group object. Reflects group element in group.xsd schema. */
export class Group extends XmlObject implements IGroup {
    id?: Id | undefined;
    /** Gets or sets name of group. */
    name?: string | undefined;
    /** Gets or sets priority of group. */
    priority!: number;
    /** Gets or sets a flag indicating whether or not new pieces of equipment should be added to the group. */
    autoAddDevices!: boolean;
    /** Gets or sets collection of group permissions. */
    permissions?: Permission[] | undefined;
    /** Gets or sets the collection of group associations. */
    associations?: Id[] | undefined;
    /** Gets or sets the collection of group associations. */
    equipmentPermissions?: EquipmentPermission[] | undefined;

    constructor(data?: IGroup) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            this.name = _data["name"];
            this.priority = _data["priority"];
            this.autoAddDevices = _data["autoAddDevices"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(Permission.fromJS(item));
            }
            if (Array.isArray(_data["associations"])) {
                this.associations = [] as any;
                for (let item of _data["associations"])
                    this.associations!.push(Id.fromJS(item));
            }
            if (Array.isArray(_data["equipmentPermissions"])) {
                this.equipmentPermissions = [] as any;
                for (let item of _data["equipmentPermissions"])
                    this.equipmentPermissions!.push(EquipmentPermission.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Group {
        data = typeof data === 'object' ? data : {};
        let result = new Group();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["priority"] = this.priority;
        data["autoAddDevices"] = this.autoAddDevices;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.associations)) {
            data["associations"] = [];
            for (let item of this.associations)
                data["associations"].push(item.toJSON());
        }
        if (Array.isArray(this.equipmentPermissions)) {
            data["equipmentPermissions"] = [];
            for (let item of this.equipmentPermissions)
                data["equipmentPermissions"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

/** Class used to parse/create group object. Reflects group element in group.xsd schema. */
export interface IGroup extends IXmlObject {
    id?: Id | undefined;
    /** Gets or sets name of group. */
    name?: string | undefined;
    /** Gets or sets priority of group. */
    priority: number;
    /** Gets or sets a flag indicating whether or not new pieces of equipment should be added to the group. */
    autoAddDevices: boolean;
    /** Gets or sets collection of group permissions. */
    permissions?: Permission[] | undefined;
    /** Gets or sets the collection of group associations. */
    associations?: Id[] | undefined;
    /** Gets or sets the collection of group associations. */
    equipmentPermissions?: EquipmentPermission[] | undefined;
}

export abstract class BasePermission extends XmlObject implements IBasePermission {
    /** Gets or sets the subsystem the permission belongs to */
    subsystem?: string | undefined;
    /** Gets or sets a value indicating whether the permission is from a group */
    fromGroup!: boolean;
    /** Gets or sets a value indicating whether the permission is from a user */
    fromUser!: boolean;
    /** Gets or sets a value indicating whether the permission has been chosen for a user
Not used in xml requests/responses */
    checked!: boolean;

    constructor(data?: IBasePermission) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.subsystem = _data["subsystem"];
            this.fromGroup = _data["fromGroup"];
            this.fromUser = _data["fromUser"];
            this.checked = _data["checked"];
        }
    }

    static fromJS(data: any): BasePermission {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BasePermission' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subsystem"] = this.subsystem;
        data["fromGroup"] = this.fromGroup;
        data["fromUser"] = this.fromUser;
        data["checked"] = this.checked;
        super.toJSON(data);
        return data; 
    }
}

export interface IBasePermission extends IXmlObject {
    /** Gets or sets the subsystem the permission belongs to */
    subsystem?: string | undefined;
    /** Gets or sets a value indicating whether the permission is from a group */
    fromGroup: boolean;
    /** Gets or sets a value indicating whether the permission is from a user */
    fromUser: boolean;
    /** Gets or sets a value indicating whether the permission has been chosen for a user
Not used in xml requests/responses */
    checked: boolean;
}

/** Class used to define what a permission looks like. */
export class Permission extends BasePermission implements IPermission {
    /** Gets or sets the name of the permission */
    name?: string | undefined;
    /** Gets or sets a description of the permission */
    description?: string | undefined;
    /** Gets the unique key to identify this permission. */
    key?: string | undefined;

    constructor(data?: IPermission) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.key = _data["key"];
        }
    }

    static fromJS(data: any): Permission {
        data = typeof data === 'object' ? data : {};
        let result = new Permission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["key"] = this.key;
        super.toJSON(data);
        return data; 
    }
}

/** Class used to define what a permission looks like. */
export interface IPermission extends IBasePermission {
    /** Gets or sets the name of the permission */
    name?: string | undefined;
    /** Gets or sets a description of the permission */
    description?: string | undefined;
    /** Gets the unique key to identify this permission. */
    key?: string | undefined;
}

/** Class used to parse/create equipment permissions object. Reflects equipmentPermission element in equipmentPermission.xsd schema. */
export class EquipmentPermission extends BasePermission implements IEquipmentPermission {
    /** Gets or sets identifier. */
    id?: Id | undefined;
    /** Gets or sets a value indicating whether the permission is from a device group. */
    fromDeviceGroup!: boolean;

    constructor(data?: IEquipmentPermission) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] ? Id.fromJS(_data["id"]) : <any>undefined;
            this.fromDeviceGroup = _data["fromDeviceGroup"];
        }
    }

    static fromJS(data: any): EquipmentPermission {
        data = typeof data === 'object' ? data : {};
        let result = new EquipmentPermission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["fromDeviceGroup"] = this.fromDeviceGroup;
        super.toJSON(data);
        return data; 
    }
}

/** Class used to parse/create equipment permissions object. Reflects equipmentPermission element in equipmentPermission.xsd schema. */
export interface IEquipmentPermission extends IBasePermission {
    /** Gets or sets identifier. */
    id?: Id | undefined;
    /** Gets or sets a value indicating whether the permission is from a device group. */
    fromDeviceGroup: boolean;
}

/** Provides a base for all provider privilege collections */
export abstract class PrivilegeBase extends XmlObject implements IPrivilegeBase {

    constructor(data?: IPrivilegeBase) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): PrivilegeBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'PrivilegeBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

/** Provides a base for all provider privilege collections */
export interface IPrivilegeBase extends IXmlObject {
}

export class UserData implements IUserData {
    name?: string | undefined;
    groups?: string[] | undefined;

    constructor(data?: IUserData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(item);
            }
        }
    }

    static fromJS(data: any): UserData {
        data = typeof data === 'object' ? data : {};
        let result = new UserData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        return data; 
    }
}

export interface IUserData {
    name?: string | undefined;
    groups?: string[] | undefined;
}

/** Class ApiPrivilegeBase. Implements the PrivilegeBase class in order to correctly expose unique privilege names for NSwag to generate correct object matching. */
export abstract class ApiPrivilegeBase extends PrivilegeBase implements IApiPrivilegeBase {

    protected _discriminator: string;

    constructor(data?: IApiPrivilegeBase) {
        super(data);
        this._discriminator = "ApiPrivilegeBase";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ApiPrivilegeBase {
        data = typeof data === 'object' ? data : {};
        if (data["Privilege"] === "CctvPrivileges") {
            let result = new CctvPrivileges();
            result.init(data);
            return result;
        }
        if (data["Privilege"] === "DmsPrivileges") {
            let result = new DmsPrivileges();
            result.init(data);
            return result;
        }
        if (data["Privilege"] === "SaaPrivileges") {
            let result = new SaaPrivileges();
            result.init(data);
            return result;
        }
        if (data["Privilege"] === "EmPrivileges") {
            let result = new EmPrivileges();
            result.init(data);
            return result;
        }
        if (data["Privilege"] === "RwisPrivileges") {
            let result = new RwisPrivileges();
            result.init(data);
            return result;
        }
        if (data["Privilege"] === "MasPrivileges") {
            let result = new MasPrivileges();
            result.init(data);
            return result;
        }
        if (data["Privilege"] === "TssPrivileges") {
            let result = new TssPrivileges();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'ApiPrivilegeBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Privilege"] = this._discriminator; 
        super.toJSON(data);
        return data; 
    }
}

/** Class ApiPrivilegeBase. Implements the PrivilegeBase class in order to correctly expose unique privilege names for NSwag to generate correct object matching. */
export interface IApiPrivilegeBase extends IPrivilegeBase {
}

/** Used to expose a unique class name for CCTV Privileges from ActiveIts DataLibrary. Implements the ApiPrivilegeBase */
export class CctvPrivileges extends ApiPrivilegeBase implements ICctvPrivileges {
    /** Gets or sets a value indicating whether the user has access to camera status data. */
    cameraStatus!: boolean;
    /** Gets or sets a value indicating whether the user can receive camera data. */
    cameraData!: boolean;
    /** Gets or sets a value indicating whether the user can receive camera group data. */
    cameraGroupData!: boolean;
    /** Gets or sets a value indicating whether the user can receive user data. */
    userData!: boolean;
    /** Gets or sets a value indicating whether the user can configure cameras. */
    configCamera!: boolean;
    /** Gets or sets a value indicating whether the user can configure camera groups. */
    configCameraGroup!: boolean;
    /** Gets or sets a value indicating whether the user can control a camera. */
    controlCamera!: boolean;
    /** Gets or sets a value indicating whether the user can override a camera lock. */
    overrideLock!: boolean;
    /** Gets or sets a value indicating whether the user can perform advanced camera functions. */
    advFunctions!: boolean;
    /** Gets or sets a value indicating whether the user can acquire a manual camera lock. */
    acquireManualLock!: boolean;
    /** Gets or sets a value indicating whether the user can change locked presets. */
    modifyLockedPresets!: boolean;
    /** Gets or sets a value indicating whether the user can configure camera presets. */
    modifyCameraPresets!: boolean;
    /** Gets or sets a value indicating whether the user can change the op status of a camera. */
    setCameraOpStatus!: boolean;
    /** Gets or sets a value indicating whether the user can change the blocked state. */
    setCameraBlockedStatus!: boolean;

    constructor(data?: ICctvPrivileges) {
        super(data);
        this._discriminator = "CctvPrivileges";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.cameraStatus = _data["cameraStatus"];
            this.cameraData = _data["cameraData"];
            this.cameraGroupData = _data["cameraGroupData"];
            this.userData = _data["userData"];
            this.configCamera = _data["configCamera"];
            this.configCameraGroup = _data["configCameraGroup"];
            this.controlCamera = _data["controlCamera"];
            this.overrideLock = _data["overrideLock"];
            this.advFunctions = _data["advFunctions"];
            this.acquireManualLock = _data["acquireManualLock"];
            this.modifyLockedPresets = _data["modifyLockedPresets"];
            this.modifyCameraPresets = _data["modifyCameraPresets"];
            this.setCameraOpStatus = _data["setCameraOpStatus"];
            this.setCameraBlockedStatus = _data["setCameraBlockedStatus"];
        }
    }

    static fromJS(data: any): CctvPrivileges {
        data = typeof data === 'object' ? data : {};
        let result = new CctvPrivileges();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cameraStatus"] = this.cameraStatus;
        data["cameraData"] = this.cameraData;
        data["cameraGroupData"] = this.cameraGroupData;
        data["userData"] = this.userData;
        data["configCamera"] = this.configCamera;
        data["configCameraGroup"] = this.configCameraGroup;
        data["controlCamera"] = this.controlCamera;
        data["overrideLock"] = this.overrideLock;
        data["advFunctions"] = this.advFunctions;
        data["acquireManualLock"] = this.acquireManualLock;
        data["modifyLockedPresets"] = this.modifyLockedPresets;
        data["modifyCameraPresets"] = this.modifyCameraPresets;
        data["setCameraOpStatus"] = this.setCameraOpStatus;
        data["setCameraBlockedStatus"] = this.setCameraBlockedStatus;
        super.toJSON(data);
        return data; 
    }
}

/** Used to expose a unique class name for CCTV Privileges from ActiveIts DataLibrary. Implements the ApiPrivilegeBase */
export interface ICctvPrivileges extends IApiPrivilegeBase {
    /** Gets or sets a value indicating whether the user has access to camera status data. */
    cameraStatus: boolean;
    /** Gets or sets a value indicating whether the user can receive camera data. */
    cameraData: boolean;
    /** Gets or sets a value indicating whether the user can receive camera group data. */
    cameraGroupData: boolean;
    /** Gets or sets a value indicating whether the user can receive user data. */
    userData: boolean;
    /** Gets or sets a value indicating whether the user can configure cameras. */
    configCamera: boolean;
    /** Gets or sets a value indicating whether the user can configure camera groups. */
    configCameraGroup: boolean;
    /** Gets or sets a value indicating whether the user can control a camera. */
    controlCamera: boolean;
    /** Gets or sets a value indicating whether the user can override a camera lock. */
    overrideLock: boolean;
    /** Gets or sets a value indicating whether the user can perform advanced camera functions. */
    advFunctions: boolean;
    /** Gets or sets a value indicating whether the user can acquire a manual camera lock. */
    acquireManualLock: boolean;
    /** Gets or sets a value indicating whether the user can change locked presets. */
    modifyLockedPresets: boolean;
    /** Gets or sets a value indicating whether the user can configure camera presets. */
    modifyCameraPresets: boolean;
    /** Gets or sets a value indicating whether the user can change the op status of a camera. */
    setCameraOpStatus: boolean;
    /** Gets or sets a value indicating whether the user can change the blocked state. */
    setCameraBlockedStatus: boolean;
}

/** Used to expose a unique class name for Dms Privileges from ActiveIts DataLibrary. Implements the ApiPrivilegeBase */
export class DmsPrivileges extends ApiPrivilegeBase implements IDmsPrivileges {
    /** Gets or sets a value indicating whether the user has permission to retrieve DMS data */
    dmsData!: boolean;
    /** Gets or sets a value indicating whether the user has permission to retrieve DMS groups */
    dmsGroupData!: boolean;
    /** Gets or sets a value indicating whether the user has permission to retrieve message libraries */
    messageData!: boolean;
    /** Gets or sets a value indicating whether the user has permission to retrieve approved words */
    approvedWordsData!: boolean;
    /** Gets or sets a value indicating whether the user has permission to retrieve system configuration data */
    configurationData!: boolean;
    /** Gets or sets a value indicating whether the user has permission to retrieve user permissions */
    userPrivData!: boolean;
    /** Gets or sets a value indicating whether the user has permission to retrieve DMS status */
    dmsStatus!: boolean;
    /** Gets or sets a value indicating whether the user has permission to retrieve DMS message status data */
    dmsMessage!: boolean;
    /** Gets or sets a value indicating whether the user has permission to retrieve DMS op status data. */
    dmsOpStatus!: boolean;
    /** Gets or sets a value indicating whether the user has permission to retrieve font information */
    fontData!: boolean;
    /** Gets or sets a value indicating whether the user has permission to retrieve graphic library data */
    graphicData!: boolean;
    /** Gets or sets a value indicating whether the user has permission to modify DMS groups */
    modifyGroups!: boolean;
    /** Gets or sets a value indicating whether the user has permission to modify message libraries */
    modifyMessages!: boolean;
    /** Gets or sets a value indicating whether the user has permission to modify approved words */
    modifyAWL!: boolean;
    /** Gets or sets a value indicating whether the user has permission to modify system configuration */
    modifyConfig!: boolean;
    /** Gets or sets a value indicating whether the user has permission to modify library graphics */
    modifyGraphics!: boolean;
    /** Gets or sets a value indicating whether the user has permission to set DMS status */
    setDmsStatus!: boolean;
    /** Gets or sets a value indicating whether the user has permission to set DMS brightness */
    setBrightness!: boolean;
    /** Gets or sets a value indicating whether the user has permission to override higher priority messages */
    overrideMessage!: boolean;
    /** Gets or sets a value indicating whether the user has permission to poll for DMS message */
    echoMsg!: boolean;
    /** Gets or sets a value indicating whether the user has permission to send messages to DMSs */
    sendMsg!: boolean;
    /** Gets or sets a value indicating whether the user has permission to blank DMSs */
    terminateMsg!: boolean;
    /** Gets or sets a value indicating whether the user has permission to reset DMS controllers */
    resetController!: boolean;
    /** Gets or sets a value indicating whether the user has permission to resolve spelling conflicts */
    spellingConflicts!: boolean;
    /** Gets or sets a value indicating whether the user has permission to access the system */
    systemAccess!: boolean;
    /** Gets or sets a value indicating whether the user has permission to modify DMS configuration */
    modifyDms!: boolean;
    /** Gets or sets a value indicating whether the user has permission to control DMSs designated as toll signs */
    tollSignControl!: boolean;
    /** Gets or sets a value indicating whether the user has permission to set the op status of a DMS. */
    setDmsOpStatus!: boolean;
    /** Gets or sets a value indicating whether the user can perform advanced MULTI editing operations. */
    canEditAdvancedMulti!: boolean;

    constructor(data?: IDmsPrivileges) {
        super(data);
        this._discriminator = "DmsPrivileges";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dmsData = _data["dmsData"];
            this.dmsGroupData = _data["dmsGroupData"];
            this.messageData = _data["messageData"];
            this.approvedWordsData = _data["approvedWordsData"];
            this.configurationData = _data["configurationData"];
            this.userPrivData = _data["userPrivData"];
            this.dmsStatus = _data["dmsStatus"];
            this.dmsMessage = _data["dmsMessage"];
            this.dmsOpStatus = _data["dmsOpStatus"];
            this.fontData = _data["fontData"];
            this.graphicData = _data["graphicData"];
            this.modifyGroups = _data["modifyGroups"];
            this.modifyMessages = _data["modifyMessages"];
            this.modifyAWL = _data["modifyAWL"];
            this.modifyConfig = _data["modifyConfig"];
            this.modifyGraphics = _data["modifyGraphics"];
            this.setDmsStatus = _data["setDmsStatus"];
            this.setBrightness = _data["setBrightness"];
            this.overrideMessage = _data["overrideMessage"];
            this.echoMsg = _data["echoMsg"];
            this.sendMsg = _data["sendMsg"];
            this.terminateMsg = _data["terminateMsg"];
            this.resetController = _data["resetController"];
            this.spellingConflicts = _data["spellingConflicts"];
            this.systemAccess = _data["systemAccess"];
            this.modifyDms = _data["modifyDms"];
            this.tollSignControl = _data["tollSignControl"];
            this.setDmsOpStatus = _data["setDmsOpStatus"];
            this.canEditAdvancedMulti = _data["canEditAdvancedMulti"];
        }
    }

    static fromJS(data: any): DmsPrivileges {
        data = typeof data === 'object' ? data : {};
        let result = new DmsPrivileges();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dmsData"] = this.dmsData;
        data["dmsGroupData"] = this.dmsGroupData;
        data["messageData"] = this.messageData;
        data["approvedWordsData"] = this.approvedWordsData;
        data["configurationData"] = this.configurationData;
        data["userPrivData"] = this.userPrivData;
        data["dmsStatus"] = this.dmsStatus;
        data["dmsMessage"] = this.dmsMessage;
        data["dmsOpStatus"] = this.dmsOpStatus;
        data["fontData"] = this.fontData;
        data["graphicData"] = this.graphicData;
        data["modifyGroups"] = this.modifyGroups;
        data["modifyMessages"] = this.modifyMessages;
        data["modifyAWL"] = this.modifyAWL;
        data["modifyConfig"] = this.modifyConfig;
        data["modifyGraphics"] = this.modifyGraphics;
        data["setDmsStatus"] = this.setDmsStatus;
        data["setBrightness"] = this.setBrightness;
        data["overrideMessage"] = this.overrideMessage;
        data["echoMsg"] = this.echoMsg;
        data["sendMsg"] = this.sendMsg;
        data["terminateMsg"] = this.terminateMsg;
        data["resetController"] = this.resetController;
        data["spellingConflicts"] = this.spellingConflicts;
        data["systemAccess"] = this.systemAccess;
        data["modifyDms"] = this.modifyDms;
        data["tollSignControl"] = this.tollSignControl;
        data["setDmsOpStatus"] = this.setDmsOpStatus;
        data["canEditAdvancedMulti"] = this.canEditAdvancedMulti;
        super.toJSON(data);
        return data; 
    }
}

/** Used to expose a unique class name for Dms Privileges from ActiveIts DataLibrary. Implements the ApiPrivilegeBase */
export interface IDmsPrivileges extends IApiPrivilegeBase {
    /** Gets or sets a value indicating whether the user has permission to retrieve DMS data */
    dmsData: boolean;
    /** Gets or sets a value indicating whether the user has permission to retrieve DMS groups */
    dmsGroupData: boolean;
    /** Gets or sets a value indicating whether the user has permission to retrieve message libraries */
    messageData: boolean;
    /** Gets or sets a value indicating whether the user has permission to retrieve approved words */
    approvedWordsData: boolean;
    /** Gets or sets a value indicating whether the user has permission to retrieve system configuration data */
    configurationData: boolean;
    /** Gets or sets a value indicating whether the user has permission to retrieve user permissions */
    userPrivData: boolean;
    /** Gets or sets a value indicating whether the user has permission to retrieve DMS status */
    dmsStatus: boolean;
    /** Gets or sets a value indicating whether the user has permission to retrieve DMS message status data */
    dmsMessage: boolean;
    /** Gets or sets a value indicating whether the user has permission to retrieve DMS op status data. */
    dmsOpStatus: boolean;
    /** Gets or sets a value indicating whether the user has permission to retrieve font information */
    fontData: boolean;
    /** Gets or sets a value indicating whether the user has permission to retrieve graphic library data */
    graphicData: boolean;
    /** Gets or sets a value indicating whether the user has permission to modify DMS groups */
    modifyGroups: boolean;
    /** Gets or sets a value indicating whether the user has permission to modify message libraries */
    modifyMessages: boolean;
    /** Gets or sets a value indicating whether the user has permission to modify approved words */
    modifyAWL: boolean;
    /** Gets or sets a value indicating whether the user has permission to modify system configuration */
    modifyConfig: boolean;
    /** Gets or sets a value indicating whether the user has permission to modify library graphics */
    modifyGraphics: boolean;
    /** Gets or sets a value indicating whether the user has permission to set DMS status */
    setDmsStatus: boolean;
    /** Gets or sets a value indicating whether the user has permission to set DMS brightness */
    setBrightness: boolean;
    /** Gets or sets a value indicating whether the user has permission to override higher priority messages */
    overrideMessage: boolean;
    /** Gets or sets a value indicating whether the user has permission to poll for DMS message */
    echoMsg: boolean;
    /** Gets or sets a value indicating whether the user has permission to send messages to DMSs */
    sendMsg: boolean;
    /** Gets or sets a value indicating whether the user has permission to blank DMSs */
    terminateMsg: boolean;
    /** Gets or sets a value indicating whether the user has permission to reset DMS controllers */
    resetController: boolean;
    /** Gets or sets a value indicating whether the user has permission to resolve spelling conflicts */
    spellingConflicts: boolean;
    /** Gets or sets a value indicating whether the user has permission to access the system */
    systemAccess: boolean;
    /** Gets or sets a value indicating whether the user has permission to modify DMS configuration */
    modifyDms: boolean;
    /** Gets or sets a value indicating whether the user has permission to control DMSs designated as toll signs */
    tollSignControl: boolean;
    /** Gets or sets a value indicating whether the user has permission to set the op status of a DMS. */
    setDmsOpStatus: boolean;
    /** Gets or sets a value indicating whether the user can perform advanced MULTI editing operations. */
    canEditAdvancedMulti: boolean;
}

/** Used to expose a unique class name for Saa Privileges from ActiveIts DataLibrary. Implements the ApiPrivilegeBase */
export class SaaPrivileges extends ApiPrivilegeBase implements ISaaPrivileges {
    /** Access to user name subscription */
    userName!: boolean;
    /** Access to user data subscription */
    userData!: boolean;
    /** Access to group data subscription. */
    groupData!: boolean;
    /** Access to operation data subscription */
    operationData!: boolean;
    /** Ability to modify user, group, and system information */
    administrator!: boolean;
    /** System access */
    systemAccess!: boolean;
    /** Ability to modify one's meta data */
    modifySelf!: boolean;
    /** Allow user to subscribe to display location mapping data */
    displayLocationData!: boolean;
    /** Allow the user to modify the displayed location of icons */
    modifyDisplayLocationData!: boolean;
    /** Access to roadway data subscription */
    roadwayData!: boolean;
    /** Access to roadway intersection data subscription */
    roadwayIntersectionData!: boolean;
    /** Allow user to manage roadway data in the system. */
    manageRoadwayData!: boolean;
    /** Allow user to receive system settings updates */
    systemSettingsData!: boolean;
    /** Access to word data */
    wordData!: boolean;
    /** Ability to modify word data */
    modifyWordData!: boolean;
    /** Ability to clear a user's meta data */
    clearMetaData!: boolean;
    /** Ability to log out another user */
    logOutUser!: boolean;
    /** Gets or sets a value indicating whether the user can receive icon group data. */
    iconGroupData!: boolean;
    /** Gets or sets a value indicating whether the user can manage icon groups. */
    manageIconGroups!: boolean;

    constructor(data?: ISaaPrivileges) {
        super(data);
        this._discriminator = "SaaPrivileges";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userName = _data["userName"];
            this.userData = _data["userData"];
            this.groupData = _data["groupData"];
            this.operationData = _data["operationData"];
            this.administrator = _data["administrator"];
            this.systemAccess = _data["systemAccess"];
            this.modifySelf = _data["modifySelf"];
            this.displayLocationData = _data["displayLocationData"];
            this.modifyDisplayLocationData = _data["modifyDisplayLocationData"];
            this.roadwayData = _data["roadwayData"];
            this.roadwayIntersectionData = _data["roadwayIntersectionData"];
            this.manageRoadwayData = _data["manageRoadwayData"];
            this.systemSettingsData = _data["systemSettingsData"];
            this.wordData = _data["wordData"];
            this.modifyWordData = _data["modifyWordData"];
            this.clearMetaData = _data["clearMetaData"];
            this.logOutUser = _data["logOutUser"];
            this.iconGroupData = _data["iconGroupData"];
            this.manageIconGroups = _data["manageIconGroups"];
        }
    }

    static fromJS(data: any): SaaPrivileges {
        data = typeof data === 'object' ? data : {};
        let result = new SaaPrivileges();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["userData"] = this.userData;
        data["groupData"] = this.groupData;
        data["operationData"] = this.operationData;
        data["administrator"] = this.administrator;
        data["systemAccess"] = this.systemAccess;
        data["modifySelf"] = this.modifySelf;
        data["displayLocationData"] = this.displayLocationData;
        data["modifyDisplayLocationData"] = this.modifyDisplayLocationData;
        data["roadwayData"] = this.roadwayData;
        data["roadwayIntersectionData"] = this.roadwayIntersectionData;
        data["manageRoadwayData"] = this.manageRoadwayData;
        data["systemSettingsData"] = this.systemSettingsData;
        data["wordData"] = this.wordData;
        data["modifyWordData"] = this.modifyWordData;
        data["clearMetaData"] = this.clearMetaData;
        data["logOutUser"] = this.logOutUser;
        data["iconGroupData"] = this.iconGroupData;
        data["manageIconGroups"] = this.manageIconGroups;
        super.toJSON(data);
        return data; 
    }
}

/** Used to expose a unique class name for Saa Privileges from ActiveIts DataLibrary. Implements the ApiPrivilegeBase */
export interface ISaaPrivileges extends IApiPrivilegeBase {
    /** Access to user name subscription */
    userName: boolean;
    /** Access to user data subscription */
    userData: boolean;
    /** Access to group data subscription. */
    groupData: boolean;
    /** Access to operation data subscription */
    operationData: boolean;
    /** Ability to modify user, group, and system information */
    administrator: boolean;
    /** System access */
    systemAccess: boolean;
    /** Ability to modify one's meta data */
    modifySelf: boolean;
    /** Allow user to subscribe to display location mapping data */
    displayLocationData: boolean;
    /** Allow the user to modify the displayed location of icons */
    modifyDisplayLocationData: boolean;
    /** Access to roadway data subscription */
    roadwayData: boolean;
    /** Access to roadway intersection data subscription */
    roadwayIntersectionData: boolean;
    /** Allow user to manage roadway data in the system. */
    manageRoadwayData: boolean;
    /** Allow user to receive system settings updates */
    systemSettingsData: boolean;
    /** Access to word data */
    wordData: boolean;
    /** Ability to modify word data */
    modifyWordData: boolean;
    /** Ability to clear a user's meta data */
    clearMetaData: boolean;
    /** Ability to log out another user */
    logOutUser: boolean;
    /** Gets or sets a value indicating whether the user can receive icon group data. */
    iconGroupData: boolean;
    /** Gets or sets a value indicating whether the user can manage icon groups. */
    manageIconGroups: boolean;
}

/** Privilege data for an EM user. */
export class EmPrivileges extends ApiPrivilegeBase implements IEmPrivileges {
    /** Gets or sets a value indicating whether the user has privileges to activity data. */
    activityData!: boolean;
    /** Gets or sets a value indicating whether the user has privileges to agency data. */
    agencyData!: boolean;
    /** Gets or sets a value indicating whether the user has privileges to county data. */
    countyData!: boolean;
    /** Gets or sets a value indicating whether the user has privileges to event type data. */
    eventTypeData!: boolean;
    /** Gets or sets a value indicating whether the user has privileges to event status data. */
    eventStatusData!: boolean;
    /** Gets or sets a value indicating whether the user has privileges to injury type data. */
    injuryTypeData!: boolean;
    /** Gets or sets a value indicating whether the user has privileges to offset type data. */
    offsetTypeData!: boolean;
    /** Gets or sets a value indicating whether the user has privileges to organization data. */
    organizationData!: boolean;
    /** Gets or sets a value indicating whether the user has privileges to lane map data. */
    laneMapData!: boolean;
    /** Gets or sets a value indicating whether the user has privileges to lane type data. */
    laneTypeData!: boolean;
    /** Gets or sets a value indicating whether the user has privileges to weather condition data. */
    weatherConditionData!: boolean;
    /** Gets or sets a value indicating whether the user has privileges to vehicle type data. */
    vehicleTypeData!: boolean;
    /** Gets or sets a value indicating whether the user has privileges to vehicle make data. */
    vehicleMakeData!: boolean;
    /** Gets or sets a value indicating whether the user has privileges to roadway data. */
    roadwayData!: boolean;
    /** Gets or sets a value indicating whether the user has privileges to reference point data. */
    referencePointData!: boolean;
    /** Gets or sets a value indicating whether the user has privileges to location data. */
    locationData!: boolean;
    /** Gets or sets a value indicating whether the user has privileges to comment type data. */
    commentTypeData!: boolean;
    /** Gets or sets a value indicating whether the user has privileges to state data. */
    stateData!: boolean;
    /** Gets or sets a value indicating whether the user has privileges to procedural error data. */
    proceduralErrorData!: boolean;
    /** Gets or sets a value indicating whether the user has privileges to color data. */
    colorData!: boolean;
    /** Gets or sets a value indicating whether the user has privileges to user data. */
    userData!: boolean;
    /** Gets or sets a value indicating whether the user has privileges to event data. */
    eventData!: boolean;
    /** Gets or sets a value indicating whether the user has privileges to event vehicle data. */
    eventVehicleData!: boolean;
    /** Gets or sets a value indicating whether the user has privileges to plan data. */
    planData!: boolean;
    /** Gets or sets a value indicating whether the user has privileges to template data. */
    templateData!: boolean;
    /** Gets or sets a value indicating whether the user has privileges to device linking data. */
    deviceLinkingData!: boolean;
    /** Gets or sets a value indicating whether the user has privileges to manage response data. */
    manageRespPlans!: boolean;
    /** Gets or sets a value indicating whether the user has privileges to access event viewer data. */
    accessEventViewerData!: boolean;
    /** Gets or sets a value indicating whether the user has privileges to access restricted event viewer data. */
    accessRestrictedEventViewerData!: boolean;
    /** Gets or sets a value indicating whether the user has privileges to audit data. */
    auditData!: boolean;
    /** Gets or sets a value indicating whether the user has privileges to configure plans. */
    configPlans!: boolean;
    /** Gets or sets a value indicating whether the user has privileges to configure templates. */
    configTemplates!: boolean;
    /** Gets or sets a value indicating whether the user has privileges to generate response plan suggestions. */
    generateResponsePlanSuggestions!: boolean;
    /** Gets or sets a value indicating whether the user has privileges to modify device linking data. */
    modifyDeviceLinkingData!: boolean;
    /** Gets or sets a value indicating whether the user can configure system data. */
    configureSystemData!: boolean;
    /** Gets or sets a value indicating whether the user can create and edit executive notifications. */
    canEditExecutiveNotifications!: boolean;
    /** Gets or sets a value indicating whether the user can approve and send executive notifications. */
    canSendExecutiveNotification!: boolean;
    /** Gets or sets a value indicating whether the user has privileges to plan data. */
    addPlannedEvent!: boolean;
    /** Gets or sets a value indicating whether the user has privileges to plan data. */
    approvePlannedEvent!: boolean;
    /** Gets or sets a value indicating whether the user can manage traffic signal response plan items. */
    canManageSignalResponsePlanItems!: boolean;
    /** Gets or sets a value indicating whether the user has permission to activate response plans with traffic signal response plan items. */
    canManageSignalResponsePlans!: boolean;
    /** Gets or sets a value indicating whether the user has permission to manage events. */
    canManageEvents!: boolean;
    /** Gets or sets a value indicating whether the user has permission to assign event ownership. */
    canAssignEventOwnership!: boolean;
    /** Gets or sets a value indicating whether the user can receive updates to abbreviation data. */
    abbreviationData!: boolean;

    constructor(data?: IEmPrivileges) {
        super(data);
        this._discriminator = "EmPrivileges";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityData = _data["activityData"];
            this.agencyData = _data["agencyData"];
            this.countyData = _data["countyData"];
            this.eventTypeData = _data["eventTypeData"];
            this.eventStatusData = _data["eventStatusData"];
            this.injuryTypeData = _data["injuryTypeData"];
            this.offsetTypeData = _data["offsetTypeData"];
            this.organizationData = _data["organizationData"];
            this.laneMapData = _data["laneMapData"];
            this.laneTypeData = _data["laneTypeData"];
            this.weatherConditionData = _data["weatherConditionData"];
            this.vehicleTypeData = _data["vehicleTypeData"];
            this.vehicleMakeData = _data["vehicleMakeData"];
            this.roadwayData = _data["roadwayData"];
            this.referencePointData = _data["referencePointData"];
            this.locationData = _data["locationData"];
            this.commentTypeData = _data["commentTypeData"];
            this.stateData = _data["stateData"];
            this.proceduralErrorData = _data["proceduralErrorData"];
            this.colorData = _data["colorData"];
            this.userData = _data["userData"];
            this.eventData = _data["eventData"];
            this.eventVehicleData = _data["eventVehicleData"];
            this.planData = _data["planData"];
            this.templateData = _data["templateData"];
            this.deviceLinkingData = _data["deviceLinkingData"];
            this.manageRespPlans = _data["manageRespPlans"];
            this.accessEventViewerData = _data["accessEventViewerData"];
            this.accessRestrictedEventViewerData = _data["accessRestrictedEventViewerData"];
            this.auditData = _data["auditData"];
            this.configPlans = _data["configPlans"];
            this.configTemplates = _data["configTemplates"];
            this.generateResponsePlanSuggestions = _data["generateResponsePlanSuggestions"];
            this.modifyDeviceLinkingData = _data["modifyDeviceLinkingData"];
            this.configureSystemData = _data["configureSystemData"];
            this.canEditExecutiveNotifications = _data["canEditExecutiveNotifications"];
            this.canSendExecutiveNotification = _data["canSendExecutiveNotification"];
            this.addPlannedEvent = _data["addPlannedEvent"];
            this.approvePlannedEvent = _data["approvePlannedEvent"];
            this.canManageSignalResponsePlanItems = _data["canManageSignalResponsePlanItems"];
            this.canManageSignalResponsePlans = _data["canManageSignalResponsePlans"];
            this.canManageEvents = _data["canManageEvents"];
            this.canAssignEventOwnership = _data["canAssignEventOwnership"];
            this.abbreviationData = _data["abbreviationData"];
        }
    }

    static fromJS(data: any): EmPrivileges {
        data = typeof data === 'object' ? data : {};
        let result = new EmPrivileges();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityData"] = this.activityData;
        data["agencyData"] = this.agencyData;
        data["countyData"] = this.countyData;
        data["eventTypeData"] = this.eventTypeData;
        data["eventStatusData"] = this.eventStatusData;
        data["injuryTypeData"] = this.injuryTypeData;
        data["offsetTypeData"] = this.offsetTypeData;
        data["organizationData"] = this.organizationData;
        data["laneMapData"] = this.laneMapData;
        data["laneTypeData"] = this.laneTypeData;
        data["weatherConditionData"] = this.weatherConditionData;
        data["vehicleTypeData"] = this.vehicleTypeData;
        data["vehicleMakeData"] = this.vehicleMakeData;
        data["roadwayData"] = this.roadwayData;
        data["referencePointData"] = this.referencePointData;
        data["locationData"] = this.locationData;
        data["commentTypeData"] = this.commentTypeData;
        data["stateData"] = this.stateData;
        data["proceduralErrorData"] = this.proceduralErrorData;
        data["colorData"] = this.colorData;
        data["userData"] = this.userData;
        data["eventData"] = this.eventData;
        data["eventVehicleData"] = this.eventVehicleData;
        data["planData"] = this.planData;
        data["templateData"] = this.templateData;
        data["deviceLinkingData"] = this.deviceLinkingData;
        data["manageRespPlans"] = this.manageRespPlans;
        data["accessEventViewerData"] = this.accessEventViewerData;
        data["accessRestrictedEventViewerData"] = this.accessRestrictedEventViewerData;
        data["auditData"] = this.auditData;
        data["configPlans"] = this.configPlans;
        data["configTemplates"] = this.configTemplates;
        data["generateResponsePlanSuggestions"] = this.generateResponsePlanSuggestions;
        data["modifyDeviceLinkingData"] = this.modifyDeviceLinkingData;
        data["configureSystemData"] = this.configureSystemData;
        data["canEditExecutiveNotifications"] = this.canEditExecutiveNotifications;
        data["canSendExecutiveNotification"] = this.canSendExecutiveNotification;
        data["addPlannedEvent"] = this.addPlannedEvent;
        data["approvePlannedEvent"] = this.approvePlannedEvent;
        data["canManageSignalResponsePlanItems"] = this.canManageSignalResponsePlanItems;
        data["canManageSignalResponsePlans"] = this.canManageSignalResponsePlans;
        data["canManageEvents"] = this.canManageEvents;
        data["canAssignEventOwnership"] = this.canAssignEventOwnership;
        data["abbreviationData"] = this.abbreviationData;
        super.toJSON(data);
        return data; 
    }
}

/** Privilege data for an EM user. */
export interface IEmPrivileges extends IApiPrivilegeBase {
    /** Gets or sets a value indicating whether the user has privileges to activity data. */
    activityData: boolean;
    /** Gets or sets a value indicating whether the user has privileges to agency data. */
    agencyData: boolean;
    /** Gets or sets a value indicating whether the user has privileges to county data. */
    countyData: boolean;
    /** Gets or sets a value indicating whether the user has privileges to event type data. */
    eventTypeData: boolean;
    /** Gets or sets a value indicating whether the user has privileges to event status data. */
    eventStatusData: boolean;
    /** Gets or sets a value indicating whether the user has privileges to injury type data. */
    injuryTypeData: boolean;
    /** Gets or sets a value indicating whether the user has privileges to offset type data. */
    offsetTypeData: boolean;
    /** Gets or sets a value indicating whether the user has privileges to organization data. */
    organizationData: boolean;
    /** Gets or sets a value indicating whether the user has privileges to lane map data. */
    laneMapData: boolean;
    /** Gets or sets a value indicating whether the user has privileges to lane type data. */
    laneTypeData: boolean;
    /** Gets or sets a value indicating whether the user has privileges to weather condition data. */
    weatherConditionData: boolean;
    /** Gets or sets a value indicating whether the user has privileges to vehicle type data. */
    vehicleTypeData: boolean;
    /** Gets or sets a value indicating whether the user has privileges to vehicle make data. */
    vehicleMakeData: boolean;
    /** Gets or sets a value indicating whether the user has privileges to roadway data. */
    roadwayData: boolean;
    /** Gets or sets a value indicating whether the user has privileges to reference point data. */
    referencePointData: boolean;
    /** Gets or sets a value indicating whether the user has privileges to location data. */
    locationData: boolean;
    /** Gets or sets a value indicating whether the user has privileges to comment type data. */
    commentTypeData: boolean;
    /** Gets or sets a value indicating whether the user has privileges to state data. */
    stateData: boolean;
    /** Gets or sets a value indicating whether the user has privileges to procedural error data. */
    proceduralErrorData: boolean;
    /** Gets or sets a value indicating whether the user has privileges to color data. */
    colorData: boolean;
    /** Gets or sets a value indicating whether the user has privileges to user data. */
    userData: boolean;
    /** Gets or sets a value indicating whether the user has privileges to event data. */
    eventData: boolean;
    /** Gets or sets a value indicating whether the user has privileges to event vehicle data. */
    eventVehicleData: boolean;
    /** Gets or sets a value indicating whether the user has privileges to plan data. */
    planData: boolean;
    /** Gets or sets a value indicating whether the user has privileges to template data. */
    templateData: boolean;
    /** Gets or sets a value indicating whether the user has privileges to device linking data. */
    deviceLinkingData: boolean;
    /** Gets or sets a value indicating whether the user has privileges to manage response data. */
    manageRespPlans: boolean;
    /** Gets or sets a value indicating whether the user has privileges to access event viewer data. */
    accessEventViewerData: boolean;
    /** Gets or sets a value indicating whether the user has privileges to access restricted event viewer data. */
    accessRestrictedEventViewerData: boolean;
    /** Gets or sets a value indicating whether the user has privileges to audit data. */
    auditData: boolean;
    /** Gets or sets a value indicating whether the user has privileges to configure plans. */
    configPlans: boolean;
    /** Gets or sets a value indicating whether the user has privileges to configure templates. */
    configTemplates: boolean;
    /** Gets or sets a value indicating whether the user has privileges to generate response plan suggestions. */
    generateResponsePlanSuggestions: boolean;
    /** Gets or sets a value indicating whether the user has privileges to modify device linking data. */
    modifyDeviceLinkingData: boolean;
    /** Gets or sets a value indicating whether the user can configure system data. */
    configureSystemData: boolean;
    /** Gets or sets a value indicating whether the user can create and edit executive notifications. */
    canEditExecutiveNotifications: boolean;
    /** Gets or sets a value indicating whether the user can approve and send executive notifications. */
    canSendExecutiveNotification: boolean;
    /** Gets or sets a value indicating whether the user has privileges to plan data. */
    addPlannedEvent: boolean;
    /** Gets or sets a value indicating whether the user has privileges to plan data. */
    approvePlannedEvent: boolean;
    /** Gets or sets a value indicating whether the user can manage traffic signal response plan items. */
    canManageSignalResponsePlanItems: boolean;
    /** Gets or sets a value indicating whether the user has permission to activate response plans with traffic signal response plan items. */
    canManageSignalResponsePlans: boolean;
    /** Gets or sets a value indicating whether the user has permission to manage events. */
    canManageEvents: boolean;
    /** Gets or sets a value indicating whether the user has permission to assign event ownership. */
    canAssignEventOwnership: boolean;
    /** Gets or sets a value indicating whether the user can receive updates to abbreviation data. */
    abbreviationData: boolean;
}

/** Used to expose a unique class name for Rwis Privileges from ActiveIts DataLibrary. Implements the ApiPrivilegeBase */
export class RwisPrivileges extends ApiPrivilegeBase implements IRwisPrivileges {
    /** Gets or sets a value indicating whether the user can receive station data. */
    stationData!: boolean;
    /** Gets or sets a value indicating whether the user can receive status updates. */
    statusUpdate!: boolean;
    /** Gets or sets a value indicating whether a user can configure a station. */
    configStation!: boolean;
    /** Gets or sets a value indicating whether the user has permission to user data. */
    userData!: boolean;
    /** Gets or sets a value indicating whether the user has permission to alarm configuration data. */
    alarmConfigData!: boolean;
    /** Gets or sets a value indicating whether the user can configure alarms. */
    configAlarms!: boolean;
    /** Gets or sets a value indicating whether the user has permissions to report weather status. */
    reportStatus!: boolean;
    /** Gets or sets a value indicating whether the user can set the op status of a user. */
    setStationOpStatus!: boolean;

    constructor(data?: IRwisPrivileges) {
        super(data);
        this._discriminator = "RwisPrivileges";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.stationData = _data["stationData"];
            this.statusUpdate = _data["statusUpdate"];
            this.configStation = _data["configStation"];
            this.userData = _data["userData"];
            this.alarmConfigData = _data["alarmConfigData"];
            this.configAlarms = _data["configAlarms"];
            this.reportStatus = _data["reportStatus"];
            this.setStationOpStatus = _data["setStationOpStatus"];
        }
    }

    static fromJS(data: any): RwisPrivileges {
        data = typeof data === 'object' ? data : {};
        let result = new RwisPrivileges();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stationData"] = this.stationData;
        data["statusUpdate"] = this.statusUpdate;
        data["configStation"] = this.configStation;
        data["userData"] = this.userData;
        data["alarmConfigData"] = this.alarmConfigData;
        data["configAlarms"] = this.configAlarms;
        data["reportStatus"] = this.reportStatus;
        data["setStationOpStatus"] = this.setStationOpStatus;
        super.toJSON(data);
        return data; 
    }
}

/** Used to expose a unique class name for Rwis Privileges from ActiveIts DataLibrary. Implements the ApiPrivilegeBase */
export interface IRwisPrivileges extends IApiPrivilegeBase {
    /** Gets or sets a value indicating whether the user can receive station data. */
    stationData: boolean;
    /** Gets or sets a value indicating whether the user can receive status updates. */
    statusUpdate: boolean;
    /** Gets or sets a value indicating whether a user can configure a station. */
    configStation: boolean;
    /** Gets or sets a value indicating whether the user has permission to user data. */
    userData: boolean;
    /** Gets or sets a value indicating whether the user has permission to alarm configuration data. */
    alarmConfigData: boolean;
    /** Gets or sets a value indicating whether the user can configure alarms. */
    configAlarms: boolean;
    /** Gets or sets a value indicating whether the user has permissions to report weather status. */
    reportStatus: boolean;
    /** Gets or sets a value indicating whether the user can set the op status of a user. */
    setStationOpStatus: boolean;
}

/** The MAS Privileges Implements the ApiPrivilegeBase */
export class MasPrivileges extends ApiPrivilegeBase implements IMasPrivileges {
    /** Permission to retrieve queue data */
    queueData!: boolean;
    /** Permission to receive queue notices */
    queueNotice!: boolean;
    /** Permission to receive queue state updates */
    queueState!: boolean;
    /** Permission to receive queue failure notifications */
    queueFailure!: boolean;
    /** Permission to receive all users' permission information */
    userData!: boolean;
    /** Permission to blank device queues. */
    blankQueue!: boolean;
    /** Permission to modify device queues. */
    modifyQueue!: boolean;
    /** Permission to access the system without other permissions */
    systemAccess!: boolean;
    /** Gets or sets a value indicating whether the user can set the mas options */
    setMasOptions!: boolean;
    /** Gets or sets a value indicating whether the user can set the mas options */
    masOptionsData!: boolean;

    constructor(data?: IMasPrivileges) {
        super(data);
        this._discriminator = "MasPrivileges";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.queueData = _data["queueData"];
            this.queueNotice = _data["queueNotice"];
            this.queueState = _data["queueState"];
            this.queueFailure = _data["queueFailure"];
            this.userData = _data["userData"];
            this.blankQueue = _data["blankQueue"];
            this.modifyQueue = _data["modifyQueue"];
            this.systemAccess = _data["systemAccess"];
            this.setMasOptions = _data["setMasOptions"];
            this.masOptionsData = _data["masOptionsData"];
        }
    }

    static fromJS(data: any): MasPrivileges {
        data = typeof data === 'object' ? data : {};
        let result = new MasPrivileges();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["queueData"] = this.queueData;
        data["queueNotice"] = this.queueNotice;
        data["queueState"] = this.queueState;
        data["queueFailure"] = this.queueFailure;
        data["userData"] = this.userData;
        data["blankQueue"] = this.blankQueue;
        data["modifyQueue"] = this.modifyQueue;
        data["systemAccess"] = this.systemAccess;
        data["setMasOptions"] = this.setMasOptions;
        data["masOptionsData"] = this.masOptionsData;
        super.toJSON(data);
        return data; 
    }
}

/** The MAS Privileges Implements the ApiPrivilegeBase */
export interface IMasPrivileges extends IApiPrivilegeBase {
    /** Permission to retrieve queue data */
    queueData: boolean;
    /** Permission to receive queue notices */
    queueNotice: boolean;
    /** Permission to receive queue state updates */
    queueState: boolean;
    /** Permission to receive queue failure notifications */
    queueFailure: boolean;
    /** Permission to receive all users' permission information */
    userData: boolean;
    /** Permission to blank device queues. */
    blankQueue: boolean;
    /** Permission to modify device queues. */
    modifyQueue: boolean;
    /** Permission to access the system without other permissions */
    systemAccess: boolean;
    /** Gets or sets a value indicating whether the user can set the mas options */
    setMasOptions: boolean;
    /** Gets or sets a value indicating whether the user can set the mas options */
    masOptionsData: boolean;
}

/** The user privileges for TSS. */
export class TssPrivileges extends ApiPrivilegeBase implements ITssPrivileges {
    /** Gets or sets a value indicating whether the user can receive detector data. */
    detectorData!: boolean;
    /** Gets or sets a value indicating whether the user can receive detector map data. */
    mapDetectorData!: boolean;
    /** Gets or sets a value indicating whether a user can receive threshold data. */
    thresholdData!: boolean;
    /** Gets or sets a value indicating whether the user can receive link status updates. */
    linkUpdate!: boolean;
    /** Gets or sets a value indicating whether the user can receive tag read data. */
    tagReadData!: boolean;
    /** Gets or sets a value indicating whether the user can receive detector status updates. */
    onlineStatusUpdate!: boolean;
    /** Gets or sets a value indicating whether the user can receive roadway geometry data. */
    roadwayGeometryData!: boolean;
    /** Gets or sets a value indicating whether the user can receive system configuration data. */
    systemConfigurationData!: boolean;
    /** Gets or sets a value indicating whether the user should receive user notification messages. */
    receiveUserNotifications!: boolean;
    /** Gets or sets a value indicating whether the user should receive user data. */
    userData!: boolean;
    /** Gets or sets a value indicating whether the user can modify roadway geometry data. */
    modifyRoadwayGeometry!: boolean;
    /** Gets or sets a value indicating whether the user has permission to configure dynamic linking. */
    configureDynamicLinking!: boolean;
    /** Gets or sets a value indicating whether the user can modify system configuration. */
    modifySystemConfiguration!: boolean;
    /** Gets or sets a value indicating whether the user can receive detector failure emails. */
    receiveDetectorFailureEmails!: boolean;
    /** Gets or sets a value indicating whether the user should receive system failure emails. */
    receiveSystemWideFailureEmails!: boolean;
    /** Gets or sets a value indicating whether the user should receive invalid detector data emails. */
    receiveInvalidDetectorDataEmails!: boolean;
    /** Gets or sets a value indicating whether the user can configure detectors. */
    configDetector!: boolean;
    /** Gets or sets a value indicating whether the user can configure detector maps. */
    configDetectorMap!: boolean;
    /** Gets or sets a value indicating whether the user can configure threshold data. */
    configThreshold!: boolean;
    /** Gets or sets a value indicating whether the user can change the op status of a detector. */
    setDetectorOpStatus!: boolean;

    constructor(data?: ITssPrivileges) {
        super(data);
        this._discriminator = "TssPrivileges";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.detectorData = _data["detectorData"];
            this.mapDetectorData = _data["mapDetectorData"];
            this.thresholdData = _data["thresholdData"];
            this.linkUpdate = _data["linkUpdate"];
            this.tagReadData = _data["tagReadData"];
            this.onlineStatusUpdate = _data["onlineStatusUpdate"];
            this.roadwayGeometryData = _data["roadwayGeometryData"];
            this.systemConfigurationData = _data["systemConfigurationData"];
            this.receiveUserNotifications = _data["receiveUserNotifications"];
            this.userData = _data["userData"];
            this.modifyRoadwayGeometry = _data["modifyRoadwayGeometry"];
            this.configureDynamicLinking = _data["configureDynamicLinking"];
            this.modifySystemConfiguration = _data["modifySystemConfiguration"];
            this.receiveDetectorFailureEmails = _data["receiveDetectorFailureEmails"];
            this.receiveSystemWideFailureEmails = _data["receiveSystemWideFailureEmails"];
            this.receiveInvalidDetectorDataEmails = _data["receiveInvalidDetectorDataEmails"];
            this.configDetector = _data["configDetector"];
            this.configDetectorMap = _data["configDetectorMap"];
            this.configThreshold = _data["configThreshold"];
            this.setDetectorOpStatus = _data["setDetectorOpStatus"];
        }
    }

    static fromJS(data: any): TssPrivileges {
        data = typeof data === 'object' ? data : {};
        let result = new TssPrivileges();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["detectorData"] = this.detectorData;
        data["mapDetectorData"] = this.mapDetectorData;
        data["thresholdData"] = this.thresholdData;
        data["linkUpdate"] = this.linkUpdate;
        data["tagReadData"] = this.tagReadData;
        data["onlineStatusUpdate"] = this.onlineStatusUpdate;
        data["roadwayGeometryData"] = this.roadwayGeometryData;
        data["systemConfigurationData"] = this.systemConfigurationData;
        data["receiveUserNotifications"] = this.receiveUserNotifications;
        data["userData"] = this.userData;
        data["modifyRoadwayGeometry"] = this.modifyRoadwayGeometry;
        data["configureDynamicLinking"] = this.configureDynamicLinking;
        data["modifySystemConfiguration"] = this.modifySystemConfiguration;
        data["receiveDetectorFailureEmails"] = this.receiveDetectorFailureEmails;
        data["receiveSystemWideFailureEmails"] = this.receiveSystemWideFailureEmails;
        data["receiveInvalidDetectorDataEmails"] = this.receiveInvalidDetectorDataEmails;
        data["configDetector"] = this.configDetector;
        data["configDetectorMap"] = this.configDetectorMap;
        data["configThreshold"] = this.configThreshold;
        data["setDetectorOpStatus"] = this.setDetectorOpStatus;
        super.toJSON(data);
        return data; 
    }
}

/** The user privileges for TSS. */
export interface ITssPrivileges extends IApiPrivilegeBase {
    /** Gets or sets a value indicating whether the user can receive detector data. */
    detectorData: boolean;
    /** Gets or sets a value indicating whether the user can receive detector map data. */
    mapDetectorData: boolean;
    /** Gets or sets a value indicating whether a user can receive threshold data. */
    thresholdData: boolean;
    /** Gets or sets a value indicating whether the user can receive link status updates. */
    linkUpdate: boolean;
    /** Gets or sets a value indicating whether the user can receive tag read data. */
    tagReadData: boolean;
    /** Gets or sets a value indicating whether the user can receive detector status updates. */
    onlineStatusUpdate: boolean;
    /** Gets or sets a value indicating whether the user can receive roadway geometry data. */
    roadwayGeometryData: boolean;
    /** Gets or sets a value indicating whether the user can receive system configuration data. */
    systemConfigurationData: boolean;
    /** Gets or sets a value indicating whether the user should receive user notification messages. */
    receiveUserNotifications: boolean;
    /** Gets or sets a value indicating whether the user should receive user data. */
    userData: boolean;
    /** Gets or sets a value indicating whether the user can modify roadway geometry data. */
    modifyRoadwayGeometry: boolean;
    /** Gets or sets a value indicating whether the user has permission to configure dynamic linking. */
    configureDynamicLinking: boolean;
    /** Gets or sets a value indicating whether the user can modify system configuration. */
    modifySystemConfiguration: boolean;
    /** Gets or sets a value indicating whether the user can receive detector failure emails. */
    receiveDetectorFailureEmails: boolean;
    /** Gets or sets a value indicating whether the user should receive system failure emails. */
    receiveSystemWideFailureEmails: boolean;
    /** Gets or sets a value indicating whether the user should receive invalid detector data emails. */
    receiveInvalidDetectorDataEmails: boolean;
    /** Gets or sets a value indicating whether the user can configure detectors. */
    configDetector: boolean;
    /** Gets or sets a value indicating whether the user can configure detector maps. */
    configDetectorMap: boolean;
    /** Gets or sets a value indicating whether the user can configure threshold data. */
    configThreshold: boolean;
    /** Gets or sets a value indicating whether the user can change the op status of a detector. */
    setDetectorOpStatus: boolean;
}

/** Privileges for MAS users */
export class Privileges extends PrivilegeBase implements IPrivileges {
    /** Permission to retrieve queue data */
    queueData!: boolean;
    /** Permission to receive queue notices */
    queueNotice!: boolean;
    /** Permission to receive queue state updates */
    queueState!: boolean;
    /** Permission to receive queue failure notifications */
    queueFailure!: boolean;
    /** Permission to receive all users' permission information */
    userData!: boolean;
    /** Permission to blank device queues. */
    blankQueue!: boolean;
    /** Permission to modify device queues. */
    modifyQueue!: boolean;
    /** Permission to access the system without other permissions */
    systemAccess!: boolean;
    /** Gets or sets a value indicating whether the user can set the mas options */
    setMasOptions!: boolean;
    /** Gets or sets a value indicating whether the user can set the mas options */
    masOptionsData!: boolean;

    constructor(data?: IPrivileges) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.queueData = _data["queueData"];
            this.queueNotice = _data["queueNotice"];
            this.queueState = _data["queueState"];
            this.queueFailure = _data["queueFailure"];
            this.userData = _data["userData"];
            this.blankQueue = _data["blankQueue"];
            this.modifyQueue = _data["modifyQueue"];
            this.systemAccess = _data["systemAccess"];
            this.setMasOptions = _data["setMasOptions"];
            this.masOptionsData = _data["masOptionsData"];
        }
    }

    static fromJS(data: any): Privileges {
        data = typeof data === 'object' ? data : {};
        let result = new Privileges();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["queueData"] = this.queueData;
        data["queueNotice"] = this.queueNotice;
        data["queueState"] = this.queueState;
        data["queueFailure"] = this.queueFailure;
        data["userData"] = this.userData;
        data["blankQueue"] = this.blankQueue;
        data["modifyQueue"] = this.modifyQueue;
        data["systemAccess"] = this.systemAccess;
        data["setMasOptions"] = this.setMasOptions;
        data["masOptionsData"] = this.masOptionsData;
        super.toJSON(data);
        return data; 
    }
}

/** Privileges for MAS users */
export interface IPrivileges extends IPrivilegeBase {
    /** Permission to retrieve queue data */
    queueData: boolean;
    /** Permission to receive queue notices */
    queueNotice: boolean;
    /** Permission to receive queue state updates */
    queueState: boolean;
    /** Permission to receive queue failure notifications */
    queueFailure: boolean;
    /** Permission to receive all users' permission information */
    userData: boolean;
    /** Permission to blank device queues. */
    blankQueue: boolean;
    /** Permission to modify device queues. */
    modifyQueue: boolean;
    /** Permission to access the system without other permissions */
    systemAccess: boolean;
    /** Gets or sets a value indicating whether the user can set the mas options */
    setMasOptions: boolean;
    /** Gets or sets a value indicating whether the user can set the mas options */
    masOptionsData: boolean;
}

/** Privileges for SAS */
export class Privileges2 extends PrivilegeBase implements IPrivileges2 {
    actionListData!: boolean;
    scheduleData!: boolean;
    scheduledItemData!: boolean;
    deviceData!: boolean;
    userData!: boolean;
    modifyDeviceState!: boolean;
    modifyScheduleState!: boolean;
    modifyScheduledItemsState!: boolean;
    modifyConfiguration!: boolean;

    constructor(data?: IPrivileges2) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.actionListData = _data["actionListData"];
            this.scheduleData = _data["scheduleData"];
            this.scheduledItemData = _data["scheduledItemData"];
            this.deviceData = _data["deviceData"];
            this.userData = _data["userData"];
            this.modifyDeviceState = _data["modifyDeviceState"];
            this.modifyScheduleState = _data["modifyScheduleState"];
            this.modifyScheduledItemsState = _data["modifyScheduledItemsState"];
            this.modifyConfiguration = _data["modifyConfiguration"];
        }
    }

    static fromJS(data: any): Privileges2 {
        data = typeof data === 'object' ? data : {};
        let result = new Privileges2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionListData"] = this.actionListData;
        data["scheduleData"] = this.scheduleData;
        data["scheduledItemData"] = this.scheduledItemData;
        data["deviceData"] = this.deviceData;
        data["userData"] = this.userData;
        data["modifyDeviceState"] = this.modifyDeviceState;
        data["modifyScheduleState"] = this.modifyScheduleState;
        data["modifyScheduledItemsState"] = this.modifyScheduledItemsState;
        data["modifyConfiguration"] = this.modifyConfiguration;
        super.toJSON(data);
        return data; 
    }
}

/** Privileges for SAS */
export interface IPrivileges2 extends IPrivilegeBase {
    actionListData: boolean;
    scheduleData: boolean;
    scheduledItemData: boolean;
    deviceData: boolean;
    userData: boolean;
    modifyDeviceState: boolean;
    modifyScheduleState: boolean;
    modifyScheduledItemsState: boolean;
    modifyConfiguration: boolean;
}

export class ApiException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}